// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328a745%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/boxicons@2.0.5/css/boxicons.min.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap v4.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 The Bootstrap Authors
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
:root {
  --blue:#007bff;
  --indigo:#6610f2;
  --purple:#6f42c1;
  --pink:#e83e8c;
  --red:#dc3545;
  --orange:#fd7e14;
  --yellow:#ffc107;
  --green:#28a745;
  --teal:#20c997;
  --cyan:#17a2b8;
  --white:#fff;
  --gray:#6c757d;
  --gray-dark:#343a40;
  --primary:#007bff;
  --secondary:#6c757d;
  --success:#28a745;
  --info:#17a2b8;
  --warning:#ffc107;
  --danger:#dc3545;
  --light:#f8f9fa;
  --dark:#343a40;
  --breakpoint-xs:0;
  --breakpoint-sm:576px;
  --breakpoint-md:768px;
  --breakpoint-lg:992px;
  --breakpoint-xl:1200px;
  --font-family-sans-serif:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  --font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
}

*, ::after, ::before {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[data-original-title], abbr[title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

dl, ol, ul {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol, ol ul, ul ol, ul ul {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b, strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub, sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}

a:hover {
  color: #0056b3;
  text-decoration: underline;
}

a:not([href]) {
  color: inherit;
  text-decoration: none;
}

a:not([href]):hover {
  color: inherit;
  text-decoration: none;
}

code, kbd, pre, samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

button, input, optgroup, select, textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button, input {
  overflow: visible;
}

button, select {
  text-transform: none;
}

select {
  word-wrap: normal;
}

[type=button], [type=reset], [type=submit], button {
  -webkit-appearance: button;
}

[type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled), button:not(:disabled) {
  cursor: pointer;
}

[type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner, button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=checkbox], input[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

input[type=date], input[type=datetime-local], input[type=month], input[type=time] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

.h1, h1 {
  font-size: 2.5rem;
}

.h2, h2 {
  font-size: 2rem;
}

.h3, h3 {
  font-size: 1.75rem;
}

.h4, h4 {
  font-size: 1.5rem;
}

.h5, h5 {
  font-size: 1.25rem;
}

.h6, h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.small, small {
  font-size: 80%;
  font-weight: 400;
}

.mark, mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}

kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
.container-fluid, .container-lg, .container-md, .container-sm, .container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container, .container-md, .container-sm {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container, .container-lg, .container-md, .container-sm {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col, .no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col, .col-1, .col-10, .col-11, .col-12, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-auto, .col-lg, .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.333333%;
  max-width: 8.333333%;
}

.col-2 {
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.col-5 {
  flex: 0 0 41.666667%;
  max-width: 41.666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.333333%;
  max-width: 58.333333%;
}

.col-8 {
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.333333%;
  max-width: 83.333333%;
}

.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.333333%;
}

.offset-2 {
  margin-left: 16.666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.333333%;
}

.offset-5 {
  margin-left: 41.666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.333333%;
}

.offset-8 {
  margin-left: 66.666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.333333%;
}

.offset-11 {
  margin-left: 91.666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.333333%;
  }
  .offset-sm-2 {
    margin-left: 16.666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.333333%;
  }
  .offset-sm-5 {
    margin-left: 41.666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.333333%;
  }
  .offset-sm-8 {
    margin-left: 66.666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.333333%;
  }
  .offset-sm-11 {
    margin-left: 91.666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
  .col-md-2 {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-md-5 {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
  .col-md-8 {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }
  .col-md-11 {
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.333333%;
  }
  .offset-md-2 {
    margin-left: 16.666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.333333%;
  }
  .offset-md-5 {
    margin-left: 41.666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.333333%;
  }
  .offset-md-8 {
    margin-left: 66.666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.333333%;
  }
  .offset-md-11 {
    margin-left: 91.666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.333333%;
  }
  .offset-lg-2 {
    margin-left: 16.666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.333333%;
  }
  .offset-lg-5 {
    margin-left: 41.666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.333333%;
  }
  .offset-lg-8 {
    margin-left: 66.666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.333333%;
  }
  .offset-lg-11 {
    margin-left: 91.666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.333333%;
  }
  .offset-xl-2 {
    margin-left: 16.666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.333333%;
  }
  .offset-xl-5 {
    margin-left: 41.666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.333333%;
  }
  .offset-xl-8 {
    margin-left: 66.666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.333333%;
  }
  .offset-xl-11 {
    margin-left: 91.666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table td, .table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table-sm td, .table-sm th {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table-bordered td, .table-bordered th {
  border: 1px solid #dee2e6;
}

.table-bordered thead td, .table-bordered thead th {
  border-bottom-width: 2px;
}

.table-borderless tbody + tbody, .table-borderless td, .table-borderless th, .table-borderless thead th {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary, .table-primary > td, .table-primary > th {
  background-color: #b8daff;
}

.table-primary tbody + tbody, .table-primary td, .table-primary th, .table-primary thead th {
  border-color: #7abaff;
}

.table-hover .table-primary:hover {
  background-color: #9fcdff;
}

.table-hover .table-primary:hover > td, .table-hover .table-primary:hover > th {
  background-color: #9fcdff;
}

.table-secondary, .table-secondary > td, .table-secondary > th {
  background-color: #d6d8db;
}

.table-secondary tbody + tbody, .table-secondary td, .table-secondary th, .table-secondary thead th {
  border-color: #b3b7bb;
}

.table-hover .table-secondary:hover {
  background-color: #c8cbcf;
}

.table-hover .table-secondary:hover > td, .table-hover .table-secondary:hover > th {
  background-color: #c8cbcf;
}

.table-success, .table-success > td, .table-success > th {
  background-color: #c3e6cb;
}

.table-success tbody + tbody, .table-success td, .table-success th, .table-success thead th {
  border-color: #8fd19e;
}

.table-hover .table-success:hover {
  background-color: #b1dfbb;
}

.table-hover .table-success:hover > td, .table-hover .table-success:hover > th {
  background-color: #b1dfbb;
}

.table-info, .table-info > td, .table-info > th {
  background-color: #bee5eb;
}

.table-info tbody + tbody, .table-info td, .table-info th, .table-info thead th {
  border-color: #86cfda;
}

.table-hover .table-info:hover {
  background-color: #abdde5;
}

.table-hover .table-info:hover > td, .table-hover .table-info:hover > th {
  background-color: #abdde5;
}

.table-warning, .table-warning > td, .table-warning > th {
  background-color: #ffeeba;
}

.table-warning tbody + tbody, .table-warning td, .table-warning th, .table-warning thead th {
  border-color: #ffdf7e;
}

.table-hover .table-warning:hover {
  background-color: #ffe8a1;
}

.table-hover .table-warning:hover > td, .table-hover .table-warning:hover > th {
  background-color: #ffe8a1;
}

.table-danger, .table-danger > td, .table-danger > th {
  background-color: #f5c6cb;
}

.table-danger tbody + tbody, .table-danger td, .table-danger th, .table-danger thead th {
  border-color: #ed969e;
}

.table-hover .table-danger:hover {
  background-color: #f1b0b7;
}

.table-hover .table-danger:hover > td, .table-hover .table-danger:hover > th {
  background-color: #f1b0b7;
}

.table-light, .table-light > td, .table-light > th {
  background-color: #fdfdfe;
}

.table-light tbody + tbody, .table-light td, .table-light th, .table-light thead th {
  border-color: #fbfcfc;
}

.table-hover .table-light:hover {
  background-color: #ececf6;
}

.table-hover .table-light:hover > td, .table-hover .table-light:hover > th {
  background-color: #ececf6;
}

.table-dark, .table-dark > td, .table-dark > th {
  background-color: #c6c8ca;
}

.table-dark tbody + tbody, .table-dark td, .table-dark th, .table-dark thead th {
  border-color: #95999c;
}

.table-hover .table-dark:hover {
  background-color: #b9bbbe;
}

.table-hover .table-dark:hover > td, .table-hover .table-dark:hover > th {
  background-color: #b9bbbe;
}

.table-active, .table-active > td, .table-active > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover > td, .table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}

.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}

.table-dark td, .table-dark th, .table-dark thead th {
  border-color: #454d55;
}

.table-dark.table-bordered {
  border: 0;
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}

.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file, .form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext.form-control-lg, .form-control-plaintext.form-control-sm {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[multiple], select.form-control[size] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.form-row > .col, .form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}

.form-check-input:disabled ~ .form-check-label, .form-check-input[disabled] ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}

.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #28a745;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem;
}

.is-valid ~ .valid-feedback, .is-valid ~ .valid-tooltip, .was-validated :valid ~ .valid-feedback, .was-validated :valid ~ .valid-tooltip {
  display: block;
}

.form-control.is-valid, .was-validated .form-control:valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-control.is-valid:focus, .was-validated .form-control:valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.custom-select.is-valid, .was-validated .custom-select:valid {
  border-color: #28a745;
  padding-right: calc(0.75em + 2.3125rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_0___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.custom-select.is-valid:focus, .was-validated .custom-select:valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.form-check-input.is-valid ~ .form-check-label, .was-validated .form-check-input:valid ~ .form-check-label {
  color: #28a745;
}

.form-check-input.is-valid ~ .valid-feedback, .form-check-input.is-valid ~ .valid-tooltip, .was-validated .form-check-input:valid ~ .valid-feedback, .was-validated .form-check-input:valid ~ .valid-tooltip {
  display: block;
}

.custom-control-input.is-valid ~ .custom-control-label, .was-validated .custom-control-input:valid ~ .custom-control-label {
  color: #28a745;
}

.custom-control-input.is-valid ~ .custom-control-label::before, .was-validated .custom-control-input:valid ~ .custom-control-label::before {
  border-color: #28a745;
}

.custom-control-input.is-valid:checked ~ .custom-control-label::before, .was-validated .custom-control-input:valid:checked ~ .custom-control-label::before {
  border-color: #34ce57;
  background-color: #34ce57;
}

.custom-control-input.is-valid:focus ~ .custom-control-label::before, .was-validated .custom-control-input:valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before, .was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28a745;
}

.custom-file-input.is-valid ~ .custom-file-label, .was-validated .custom-file-input:valid ~ .custom-file-label {
  border-color: #28a745;
}

.custom-file-input.is-valid:focus ~ .custom-file-label, .was-validated .custom-file-input:valid:focus ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem;
}

.is-invalid ~ .invalid-feedback, .is-invalid ~ .invalid-tooltip, .was-validated :invalid ~ .invalid-feedback, .was-validated :invalid ~ .invalid-tooltip {
  display: block;
}

.form-control.is-invalid, .was-validated .form-control:invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-control.is-invalid:focus, .was-validated .form-control:invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.custom-select.is-invalid, .was-validated .custom-select:invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_2___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.custom-select.is-invalid:focus, .was-validated .custom-select:invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-check-input.is-invalid ~ .form-check-label, .was-validated .form-check-input:invalid ~ .form-check-label {
  color: #dc3545;
}

.form-check-input.is-invalid ~ .invalid-feedback, .form-check-input.is-invalid ~ .invalid-tooltip, .was-validated .form-check-input:invalid ~ .invalid-feedback, .was-validated .form-check-input:invalid ~ .invalid-tooltip {
  display: block;
}

.custom-control-input.is-invalid ~ .custom-control-label, .was-validated .custom-control-input:invalid ~ .custom-control-label {
  color: #dc3545;
}

.custom-control-input.is-invalid ~ .custom-control-label::before, .was-validated .custom-control-input:invalid ~ .custom-control-label::before {
  border-color: #dc3545;
}

.custom-control-input.is-invalid:checked ~ .custom-control-label::before, .was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before {
  border-color: #e4606d;
  background-color: #e4606d;
}

.custom-control-input.is-invalid:focus ~ .custom-control-label::before, .was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before, .was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545;
}

.custom-file-input.is-invalid ~ .custom-file-label, .was-validated .custom-file-input:invalid ~ .custom-file-label {
  border-color: #dc3545;
}

.custom-file-input.is-invalid:focus ~ .custom-file-label, .was-validated .custom-file-input:invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.form-inline .form-check {
  width: 100%;
}

@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .custom-select, .form-inline .input-group {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}
.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #212529;
  text-decoration: none;
}

.btn.focus, .btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn.disabled, .btn:disabled {
  opacity: 0.65;
}

a.btn.disabled, fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #0069d9;
  border-color: #0062cc;
}

.btn-primary.focus, .btn-primary:focus {
  color: #fff;
  background-color: #0069d9;
  border-color: #0062cc;
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}

.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #0062cc;
  border-color: #005cbf;
}

.btn-primary:not(:disabled):not(.disabled).active:focus, .btn-primary:not(:disabled):not(.disabled):active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
}

.btn-secondary.focus, .btn-secondary:focus {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}

.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
}

.btn-secondary:not(:disabled):not(.disabled).active:focus, .btn-secondary:not(:disabled):not(.disabled):active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-success:hover {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
}

.btn-success.focus, .btn-success:focus {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}

.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #1e7e34;
  border-color: #1c7430;
}

.btn-success:not(:disabled):not(.disabled).active:focus, .btn-success:not(:disabled):not(.disabled):active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.btn-info:hover {
  color: #fff;
  background-color: #138496;
  border-color: #117a8b;
}

.btn-info.focus, .btn-info:focus {
  color: #fff;
  background-color: #138496;
  border-color: #117a8b;
  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
}

.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.btn-info:not(:disabled):not(.disabled).active, .btn-info:not(:disabled):not(.disabled):active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #117a8b;
  border-color: #10707f;
}

.btn-info:not(:disabled):not(.disabled).active:focus, .btn-info:not(:disabled):not(.disabled):active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}

.btn-warning:hover {
  color: #212529;
  background-color: #e0a800;
  border-color: #d39e00;
}

.btn-warning.focus, .btn-warning:focus {
  color: #212529;
  background-color: #e0a800;
  border-color: #d39e00;
  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
}

.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}

.btn-warning:not(:disabled):not(.disabled).active, .btn-warning:not(:disabled):not(.disabled):active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: #d39e00;
  border-color: #c69500;
}

.btn-warning:not(:disabled):not(.disabled).active:focus, .btn-warning:not(:disabled):not(.disabled):active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-danger:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}

.btn-danger.focus, .btn-danger:focus {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}

.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-danger:not(:disabled):not(.disabled).active, .btn-danger:not(:disabled):not(.disabled):active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #bd2130;
  border-color: #b21f2d;
}

.btn-danger:not(:disabled):not(.disabled).active:focus, .btn-danger:not(:disabled):not(.disabled):active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}

.btn-light:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}

.btn-light.focus, .btn-light:focus {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}

.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}

.btn-light:not(:disabled):not(.disabled).active, .btn-light:not(:disabled):not(.disabled):active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: #dae0e5;
  border-color: #d3d9df;
}

.btn-light:not(:disabled):not(.disabled).active:focus, .btn-light:not(:disabled):not(.disabled):active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-dark:hover {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
}

.btn-dark.focus, .btn-dark:focus {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}

.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-dark:not(:disabled):not(.disabled).active, .btn-dark:not(:disabled):not(.disabled):active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #1d2124;
  border-color: #171a1d;
}

.btn-dark:not(:disabled):not(.disabled).active:focus, .btn-dark:not(:disabled):not(.disabled):active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}

.btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-outline-primary.focus, .btn-outline-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #007bff;
  background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled).active, .btn-outline-primary:not(:disabled):not(.disabled):active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-outline-secondary.focus, .btn-outline-secondary:focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}

.btn-outline-secondary:not(:disabled):not(.disabled).active, .btn-outline-secondary:not(:disabled):not(.disabled):active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-outline-success {
  color: #28a745;
  border-color: #28a745;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-outline-success.focus, .btn-outline-success:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #28a745;
  background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled).active, .btn-outline-success:not(:disabled):not(.disabled):active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-outline-success:not(:disabled):not(.disabled).active:focus, .btn-outline-success:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8;
}

.btn-outline-info:hover {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.btn-outline-info.focus, .btn-outline-info:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #17a2b8;
  background-color: transparent;
}

.btn-outline-info:not(:disabled):not(.disabled).active, .btn-outline-info:not(:disabled):not(.disabled):active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.btn-outline-info:not(:disabled):not(.disabled).active:focus, .btn-outline-info:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107;
}

.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}

.btn-outline-warning.focus, .btn-outline-warning:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ffc107;
  background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled).active, .btn-outline-warning:not(:disabled):not(.disabled):active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}

.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-danger.focus, .btn-outline-danger:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #dc3545;
  background-color: transparent;
}

.btn-outline-danger:not(:disabled):not(.disabled).active, .btn-outline-danger:not(:disabled):not(.disabled):active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}

.btn-outline-light:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}

.btn-outline-light.focus, .btn-outline-light:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f8f9fa;
  background-color: transparent;
}

.btn-outline-light:not(:disabled):not(.disabled).active, .btn-outline-light:not(:disabled):not(.disabled):active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}

.btn-outline-light:not(:disabled):not(.disabled).active:focus, .btn-outline-light:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}

.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-outline-dark.focus, .btn-outline-dark:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}

.btn-outline-dark:not(:disabled):not(.disabled).active, .btn-outline-dark:not(:disabled):not(.disabled):active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #007bff;
  text-decoration: none;
}

.btn-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.btn-link.focus, .btn-link:focus {
  text-decoration: underline;
  box-shadow: none;
}

.btn-link.disabled, .btn-link:disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-group-lg > .btn, .btn-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-group-sm > .btn, .btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=button].btn-block, input[type=reset].btn-block, input[type=submit].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.dropdown, .dropleft, .dropright, .dropup {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}

.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}

.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropleft .dropdown-toggle::after {
  display: none;
}

.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=top] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:focus, .dropdown-item:hover {
  color: #16181b;
  text-decoration: none;
  background-color: #f8f9fa;
}

.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
}

.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group, .btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group-vertical > .btn, .btn-group > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group-vertical > .btn:hover, .btn-group > .btn:hover {
  z-index: 1;
}

.btn-group-vertical > .btn.active, .btn-group-vertical > .btn:active, .btn-group-vertical > .btn:focus, .btn-group > .btn.active, .btn-group > .btn:active, .btn-group > .btn:focus {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn-group:not(:first-child), .btn-group > .btn:not(:first-child) {
  margin-left: -1px;
}

.btn-group > .btn-group:not(:last-child) > .btn, .btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn-group:not(:first-child) > .btn, .btn-group > .btn:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-group-sm > .btn + .dropdown-toggle-split, .btn-sm + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-group-lg > .btn + .dropdown-toggle-split, .btn-lg + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn, .btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn-group:not(:first-child), .btn-group-vertical > .btn:not(:first-child) {
  margin-top: -1px;
}

.btn-group-vertical > .btn-group:not(:last-child) > .btn, .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn-group:not(:first-child) > .btn, .btn-group-vertical > .btn:not(:first-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn, .btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}

.btn-group-toggle > .btn input[type=checkbox], .btn-group-toggle > .btn input[type=radio], .btn-group-toggle > .btn-group > .btn input[type=checkbox], .btn-group-toggle > .btn-group > .btn input[type=radio] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .custom-file, .input-group > .custom-select, .input-group > .form-control, .input-group > .form-control-plaintext {
  position: relative;
  flex: 1 1;
  min-width: 0;
  margin-bottom: 0;
}

.input-group > .custom-file + .custom-file, .input-group > .custom-file + .custom-select, .input-group > .custom-file + .form-control, .input-group > .custom-select + .custom-file, .input-group > .custom-select + .custom-select, .input-group > .custom-select + .form-control, .input-group > .form-control + .custom-file, .input-group > .form-control + .custom-select, .input-group > .form-control + .form-control, .input-group > .form-control-plaintext + .custom-file, .input-group > .form-control-plaintext + .custom-select, .input-group > .form-control-plaintext + .form-control {
  margin-left: -1px;
}

.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label, .input-group > .custom-select:focus, .input-group > .form-control:focus {
  z-index: 3;
}

.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}

.input-group > .custom-select:not(:last-child), .input-group > .form-control:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .custom-select:not(:first-child), .input-group > .form-control:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .custom-file {
  display: flex;
  align-items: center;
}

.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-append, .input-group-prepend {
  display: flex;
}

.input-group-append .btn, .input-group-prepend .btn {
  position: relative;
  z-index: 2;
}

.input-group-append .btn:focus, .input-group-prepend .btn:focus {
  z-index: 3;
}

.input-group-append .btn + .btn, .input-group-append .btn + .input-group-text, .input-group-append .input-group-text + .btn, .input-group-append .input-group-text + .input-group-text, .input-group-prepend .btn + .btn, .input-group-prepend .btn + .input-group-text, .input-group-prepend .input-group-text + .btn, .input-group-prepend .input-group-text + .input-group-text {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-group-text input[type=checkbox], .input-group-text input[type=radio] {
  margin-top: 0;
}

.input-group-lg > .custom-select, .input-group-lg > .form-control:not(textarea) {
  height: calc(1.5em + 1rem + 2px);
}

.input-group-lg > .custom-select, .input-group-lg > .form-control, .input-group-lg > .input-group-append > .btn, .input-group-lg > .input-group-append > .input-group-text, .input-group-lg > .input-group-prepend > .btn, .input-group-lg > .input-group-prepend > .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm > .custom-select, .input-group-sm > .form-control:not(textarea) {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .custom-select, .input-group-sm > .form-control, .input-group-sm > .input-group-append > .btn, .input-group-sm > .input-group-append > .input-group-text, .input-group-sm > .input-group-prepend > .btn, .input-group-sm > .input-group-prepend > .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg > .custom-select, .input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle), .input-group > .input-group-append:last-child > .input-group-text:not(:last-child), .input-group > .input-group-append:not(:last-child) > .btn, .input-group > .input-group-append:not(:last-child) > .input-group-text, .input-group > .input-group-prepend > .btn, .input-group > .input-group-prepend > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn, .input-group > .input-group-append > .input-group-text, .input-group > .input-group-prepend:first-child > .btn:not(:first-child), .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child), .input-group > .input-group-prepend:not(:first-child) > .btn, .input-group > .input-group-prepend:not(:first-child) > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
}

.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #80bdff;
}

.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #b3d7ff;
  border-color: #b3d7ff;
}

.custom-control-input:disabled ~ .custom-control-label, .custom-control-input[disabled] ~ .custom-control-label {
  color: #6c757d;
}

.custom-control-input:disabled ~ .custom-control-label::before, .custom-control-input[disabled] ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #adb5bd solid 1px;
}

.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #007bff;
  background-color: #007bff;
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}

.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
  top: calc(0.25rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}

.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}

.custom-select:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}

.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}

.custom-select::-ms-expand {
  display: none;
}

.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  opacity: 0;
}

.custom-file-input:focus ~ .custom-file-label {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-file-input:disabled ~ .custom-file-label, .custom-file-input[disabled] ~ .custom-file-label {
  background-color: #e9ecef;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}

.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}

.custom-range:focus {
  outline: 0;
}

.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-range::-moz-focus-outer {
  border: 0;
}

.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: #b3d7ff;
}

.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: #b3d7ff;
}

.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #007bff;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: #b3d7ff;
}

.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}

.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}

.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}

.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}

.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}

.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.custom-range:disabled::-moz-range-track {
  cursor: default;
}

.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before, .custom-file-label, .custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before, .custom-file-label, .custom-select {
    transition: none;
  }
}
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

.nav-link:focus, .nav-link:hover {
  text-decoration: none;
}

.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
  border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.25rem;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  color: #fff;
  background-color: #007bff;
}

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}

.navbar .container, .navbar .container-fluid, .navbar .container-lg, .navbar .container-md, .navbar .container-sm, .navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}

.navbar-brand:focus, .navbar-brand:hover {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.navbar-toggler:focus, .navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container, .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container, .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container, .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-md, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container, .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-md, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container, .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container, .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container, .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container, .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.navbar-expand > .container, .navbar-expand > .container-fluid, .navbar-expand > .container-lg, .navbar-expand > .container-md, .navbar-expand > .container-sm, .navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.navbar-expand > .container, .navbar-expand > .container-fluid, .navbar-expand > .container-lg, .navbar-expand > .container-md, .navbar-expand > .container-sm, .navbar-expand > .container-xl {
  flex-wrap: nowrap;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:focus, .navbar-light .navbar-brand:hover {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover {
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .active > .nav-link, .navbar-light .navbar-nav .nav-link.active, .navbar-light .navbar-nav .nav-link.show, .navbar-light .navbar-nav .show > .nav-link {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-text a:focus, .navbar-light .navbar-text a:hover {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}

.navbar-dark .navbar-brand:focus, .navbar-dark .navbar-brand:hover {
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-nav .nav-link:focus, .navbar-dark .navbar-nav .nav-link:hover {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .active > .nav-link, .navbar-dark .navbar-nav .nav-link.active, .navbar-dark .navbar-nav .nav-link.show, .navbar-dark .navbar-nav .show > .nav-link {
  color: #fff;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-text a {
  color: #fff;
}

.navbar-dark .navbar-text a:focus, .navbar-dark .navbar-text a:hover {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group:first-child .list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.card > .list-group:last-child .list-group-item:last-child {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}

.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
}

.card-img, .card-img-bottom, .card-img-top {
  flex-shrink: 0;
  width: 100%;
}

.card-img, .card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img, .card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}
.card-group > .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-header, .card-group > .card:not(:last-child) .card-img-top {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-footer, .card-group > .card:not(:last-child) .card-img-bottom {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-header, .card-group > .card:not(:first-child) .card-img-top {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-footer, .card-group > .card:not(:first-child) .card-img-bottom {
    border-bottom-left-radius: 0;
  }
}
.card-columns .card {
  margin-bottom: 0.75rem;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}
.accordion > .card {
  overflow: hidden;
}

.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}

.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.page-link:hover {
  z-index: 2;
  color: #0056b3;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:focus, a.badge:hover {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #007bff;
}

a.badge-primary:focus, a.badge-primary:hover {
  color: #fff;
  background-color: #0062cc;
}

a.badge-primary.focus, a.badge-primary:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}

a.badge-secondary:focus, a.badge-secondary:hover {
  color: #fff;
  background-color: #545b62;
}

a.badge-secondary.focus, a.badge-secondary:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #28a745;
}

a.badge-success:focus, a.badge-success:hover {
  color: #fff;
  background-color: #1e7e34;
}

a.badge-success.focus, a.badge-success:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #17a2b8;
}

a.badge-info:focus, a.badge-info:hover {
  color: #fff;
  background-color: #117a8b;
}

a.badge-info.focus, a.badge-info:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #ffc107;
}

a.badge-warning:focus, a.badge-warning:hover {
  color: #212529;
  background-color: #d39e00;
}

a.badge-warning.focus, a.badge-warning:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #dc3545;
}

a.badge-danger:focus, a.badge-danger:hover {
  color: #fff;
  background-color: #bd2130;
}

a.badge-danger.focus, a.badge-danger:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #f8f9fa;
}

a.badge-light:focus, a.badge-light:hover {
  color: #212529;
  background-color: #dae0e5;
}

a.badge-light.focus, a.badge-light:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}

a.badge-dark:focus, a.badge-dark:hover {
  color: #fff;
  background-color: #1d2124;
}

a.badge-dark.focus, a.badge-dark:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}

@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}
.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}

.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #004085;
  background-color: #cce5ff;
  border-color: #b8daff;
}

.alert-primary hr {
  border-top-color: #9fcdff;
}

.alert-primary .alert-link {
  color: #002752;
}

.alert-secondary {
  color: #383d41;
  background-color: #e2e3e5;
  border-color: #d6d8db;
}

.alert-secondary hr {
  border-top-color: #c8cbcf;
}

.alert-secondary .alert-link {
  color: #202326;
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.alert-success hr {
  border-top-color: #b1dfbb;
}

.alert-success .alert-link {
  color: #0b2e13;
}

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}

.alert-info hr {
  border-top-color: #abdde5;
}

.alert-info .alert-link {
  color: #062c33;
}

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}

.alert-warning hr {
  border-top-color: #ffe8a1;
}

.alert-warning .alert-link {
  color: #533f03;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.alert-danger hr {
  border-top-color: #f1b0b7;
}

.alert-danger .alert-link {
  color: #491217;
}

.alert-light {
  color: #818182;
  background-color: #fefefe;
  border-color: #fdfdfe;
}

.alert-light hr {
  border-top-color: #ececf6;
}

.alert-light .alert-link {
  color: #686868;
}

.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca;
}

.alert-dark hr {
  border-top-color: #b9bbbe;
}

.alert-dark .alert-link {
  color: #040505;
}
@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}
.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}

.list-group-item-action:focus, .list-group-item-action:hover {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}

.list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.list-group-item:last-child {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}

.list-group-horizontal .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}

.list-group-horizontal .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}

.list-group-horizontal .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush .list-group-item {
  border-right-width: 0;
  border-left-width: 0;
  border-radius: 0;
}

.list-group-flush .list-group-item:first-child {
  border-top-width: 0;
}

.list-group-flush:last-child .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #004085;
  background-color: #b8daff;
}

.list-group-item-primary.list-group-item-action:focus, .list-group-item-primary.list-group-item-action:hover {
  color: #004085;
  background-color: #9fcdff;
}

.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #004085;
  border-color: #004085;
}

.list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db;
}

.list-group-item-secondary.list-group-item-action:focus, .list-group-item-secondary.list-group-item-action:hover {
  color: #383d41;
  background-color: #c8cbcf;
}

.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #383d41;
  border-color: #383d41;
}

.list-group-item-success {
  color: #155724;
  background-color: #c3e6cb;
}

.list-group-item-success.list-group-item-action:focus, .list-group-item-success.list-group-item-action:hover {
  color: #155724;
  background-color: #b1dfbb;
}

.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #155724;
  border-color: #155724;
}

.list-group-item-info {
  color: #0c5460;
  background-color: #bee5eb;
}

.list-group-item-info.list-group-item-action:focus, .list-group-item-info.list-group-item-action:hover {
  color: #0c5460;
  background-color: #abdde5;
}

.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #0c5460;
  border-color: #0c5460;
}

.list-group-item-warning {
  color: #856404;
  background-color: #ffeeba;
}

.list-group-item-warning.list-group-item-action:focus, .list-group-item-warning.list-group-item-action:hover {
  color: #856404;
  background-color: #ffe8a1;
}

.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #856404;
  border-color: #856404;
}

.list-group-item-danger {
  color: #721c24;
  background-color: #f5c6cb;
}

.list-group-item-danger.list-group-item-action:focus, .list-group-item-danger.list-group-item-action:hover {
  color: #721c24;
  background-color: #f1b0b7;
}

.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #721c24;
  border-color: #721c24;
}

.list-group-item-light {
  color: #818182;
  background-color: #fdfdfe;
}

.list-group-item-light.list-group-item-action:focus, .list-group-item-light.list-group-item-action:hover {
  color: #818182;
  background-color: #ececf6;
}

.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #818182;
  border-color: #818182;
}

.list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca;
}

.list-group-item-dark.list-group-item-action:focus, .list-group-item-dark.list-group-item-action:hover {
  color: #1b1e21;
  background-color: #b9bbbe;
}

.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #1b1e21;
  border-color: #1b1e21;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}

.close:hover {
  color: #000;
  text-decoration: none;
}

.close:not(:disabled):not(.disabled):focus, .close:not(:disabled):not(.disabled):hover {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  appearance: none;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  max-width: 350px;
  overflow: hidden;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  opacity: 0;
  border-radius: 0.25rem;
}

.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast.showing {
  opacity: 1;
}

.toast.show {
  display: block;
  opacity: 1;
}

.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}

.modal-dialog-scrollable .modal-footer, .modal-dialog-scrollable .modal-header {
  flex-shrink: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  content: "";
}

.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}

.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg, .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: 0.9;
}

.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}

.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-auto[x-placement^=top], .bs-tooltip-top {
  padding: 0.4rem 0;
}

.bs-tooltip-auto[x-placement^=top] .arrow, .bs-tooltip-top .arrow {
  bottom: 0;
}

.bs-tooltip-auto[x-placement^=top] .arrow::before, .bs-tooltip-top .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-auto[x-placement^=right], .bs-tooltip-right {
  padding: 0 0.4rem;
}

.bs-tooltip-auto[x-placement^=right] .arrow, .bs-tooltip-right .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-auto[x-placement^=right] .arrow::before, .bs-tooltip-right .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-auto[x-placement^=bottom], .bs-tooltip-bottom {
  padding: 0.4rem 0;
}

.bs-tooltip-auto[x-placement^=bottom] .arrow, .bs-tooltip-bottom .arrow {
  top: 0;
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::before, .bs-tooltip-bottom .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-auto[x-placement^=left], .bs-tooltip-left {
  padding: 0 0.4rem;
}

.bs-tooltip-auto[x-placement^=left] .arrow, .bs-tooltip-left .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-auto[x-placement^=left] .arrow::before, .bs-tooltip-left .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}

.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}

.popover .arrow::after, .popover .arrow::before {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-auto[x-placement^=top], .bs-popover-top {
  margin-bottom: 0.5rem;
}

.bs-popover-auto[x-placement^=top] > .arrow, .bs-popover-top > .arrow {
  bottom: calc(-0.5rem - 1px);
}

.bs-popover-auto[x-placement^=top] > .arrow::before, .bs-popover-top > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-auto[x-placement^=top] > .arrow::after, .bs-popover-top > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-auto[x-placement^=right], .bs-popover-right {
  margin-left: 0.5rem;
}

.bs-popover-auto[x-placement^=right] > .arrow, .bs-popover-right > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}

.bs-popover-auto[x-placement^=right] > .arrow::before, .bs-popover-right > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-auto[x-placement^=right] > .arrow::after, .bs-popover-right > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-auto[x-placement^=bottom], .bs-popover-bottom {
  margin-top: 0.5rem;
}

.bs-popover-auto[x-placement^=bottom] > .arrow, .bs-popover-bottom > .arrow {
  top: calc(-0.5rem - 1px);
}

.bs-popover-auto[x-placement^=bottom] > .arrow::before, .bs-popover-bottom > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-auto[x-placement^=bottom] > .arrow::after, .bs-popover-bottom > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}

.bs-popover-auto[x-placement^=bottom] .popover-header::before, .bs-popover-bottom .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f7f7f7;
}

.bs-popover-auto[x-placement^=left], .bs-popover-left {
  margin-right: 0.5rem;
}

.bs-popover-auto[x-placement^=left] > .arrow, .bs-popover-left > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}

.bs-popover-auto[x-placement^=left] > .arrow::before, .bs-popover-left > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-auto[x-placement^=left] > .arrow::after, .bs-popover-left > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}
.carousel-item-next, .carousel-item-prev, .carousel-item.active {
  display: block;
}

.active.carousel-item-right, .carousel-item-next:not(.carousel-item-left) {
  transform: translateX(100%);
}

.active.carousel-item-left, .carousel-item-prev:not(.carousel-item-right) {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item-next.carousel-item-left, .carousel-fade .carousel-item-prev.carousel-item-right, .carousel-fade .carousel-item.active {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-left, .carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left, .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}
.carousel-control-next, .carousel-control-prev {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-next, .carousel-control-prev {
    transition: none;
  }
}
.carousel-control-next:focus, .carousel-control-next:hover, .carousel-control-prev:focus, .carousel-control-prev:hover {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-next-icon, .carousel-control-prev-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50%/100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: spinner-grow 0.75s linear infinite;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #007bff !important;
}

a.bg-primary:focus, a.bg-primary:hover, button.bg-primary:focus, button.bg-primary:hover {
  background-color: #0062cc !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

a.bg-secondary:focus, a.bg-secondary:hover, button.bg-secondary:focus, button.bg-secondary:hover {
  background-color: #545b62 !important;
}

.bg-success {
  background-color: #28a745 !important;
}

a.bg-success:focus, a.bg-success:hover, button.bg-success:focus, button.bg-success:hover {
  background-color: #1e7e34 !important;
}

.bg-info {
  background-color: #17a2b8 !important;
}

a.bg-info:focus, a.bg-info:hover, button.bg-info:focus, button.bg-info:hover {
  background-color: #117a8b !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

a.bg-warning:focus, a.bg-warning:hover, button.bg-warning:focus, button.bg-warning:hover {
  background-color: #d39e00 !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}

a.bg-danger:focus, a.bg-danger:hover, button.bg-danger:focus, button.bg-danger:hover {
  background-color: #bd2130 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

a.bg-light:focus, a.bg-light:hover, button.bg-light:focus, button.bg-light:hover {
  background-color: #dae0e5 !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:focus, a.bg-dark:hover, button.bg-dark:focus, button.bg-dark:hover {
  background-color: #1d2124 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
  border-left: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #007bff !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #28a745 !important;
}

.border-info {
  border-color: #17a2b8 !important;
}

.border-warning {
  border-color: #ffc107 !important;
}

.border-danger {
  border-color: #dc3545 !important;
}

.border-light {
  border-color: #f8f9fa !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}

.embed-responsive::before {
  display: block;
  content: "";
}

.embed-responsive .embed-responsive-item, .embed-responsive embed, .embed-responsive iframe, .embed-responsive object, .embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.857143%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.m-0 {
  margin: 0 !important;
}

.mt-0, .my-0 {
  margin-top: 0 !important;
}

.mr-0, .mx-0 {
  margin-right: 0 !important;
}

.mb-0, .my-0 {
  margin-bottom: 0 !important;
}

.ml-0, .mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1, .my-1 {
  margin-top: 0.25rem !important;
}

.mr-1, .mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1, .my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1, .mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2, .my-2 {
  margin-top: 0.5rem !important;
}

.mr-2, .mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2, .my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2, .mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3, .my-3 {
  margin-top: 1rem !important;
}

.mr-3, .mx-3 {
  margin-right: 1rem !important;
}

.mb-3, .my-3 {
  margin-bottom: 1rem !important;
}

.ml-3, .mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4, .my-4 {
  margin-top: 1.5rem !important;
}

.mr-4, .mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4, .my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4, .mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5, .my-5 {
  margin-top: 3rem !important;
}

.mr-5, .mx-5 {
  margin-right: 3rem !important;
}

.mb-5, .my-5 {
  margin-bottom: 3rem !important;
}

.ml-5, .mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0, .py-0 {
  padding-top: 0 !important;
}

.pr-0, .px-0 {
  padding-right: 0 !important;
}

.pb-0, .py-0 {
  padding-bottom: 0 !important;
}

.pl-0, .px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1, .py-1 {
  padding-top: 0.25rem !important;
}

.pr-1, .px-1 {
  padding-right: 0.25rem !important;
}

.pb-1, .py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1, .px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2, .py-2 {
  padding-top: 0.5rem !important;
}

.pr-2, .px-2 {
  padding-right: 0.5rem !important;
}

.pb-2, .py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2, .px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3, .py-3 {
  padding-top: 1rem !important;
}

.pr-3, .px-3 {
  padding-right: 1rem !important;
}

.pb-3, .py-3 {
  padding-bottom: 1rem !important;
}

.pl-3, .px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4, .py-4 {
  padding-top: 1.5rem !important;
}

.pr-4, .px-4 {
  padding-right: 1.5rem !important;
}

.pb-4, .py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4, .px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5, .py-5 {
  padding-top: 3rem !important;
}

.pr-5, .px-5 {
  padding-right: 3rem !important;
}

.pb-5, .py-5 {
  padding-bottom: 3rem !important;
}

.pl-5, .px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1, .my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1, .mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1, .my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1, .mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2, .my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2, .mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2, .my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2, .mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3, .my-n3 {
  margin-top: -1rem !important;
}

.mr-n3, .mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3, .my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3, .mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4, .my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4, .mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4, .my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4, .mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5, .my-n5 {
  margin-top: -3rem !important;
}

.mr-n5, .mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5, .my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5, .mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto, .my-auto {
  margin-top: auto !important;
}

.mr-auto, .mx-auto {
  margin-right: auto !important;
}

.mb-auto, .my-auto {
  margin-bottom: auto !important;
}

.ml-auto, .mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0, .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0, .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0, .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0, .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1, .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1, .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1, .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1, .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2, .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2, .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2, .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2, .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3, .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3, .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3, .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3, .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4, .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4, .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4, .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4, .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5, .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5, .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5, .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5, .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0, .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0, .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0, .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0, .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1, .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1, .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1, .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1, .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2, .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2, .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2, .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2, .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3, .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3, .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3, .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3, .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4, .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4, .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4, .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4, .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5, .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5, .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5, .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5, .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1, .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1, .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1, .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1, .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2, .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2, .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2, .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2, .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3, .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3, .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3, .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3, .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4, .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4, .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4, .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4, .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5, .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5, .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5, .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5, .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto, .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto, .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto, .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto, .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0, .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0, .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0, .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0, .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1, .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1, .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1, .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1, .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2, .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2, .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2, .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2, .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3, .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3, .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3, .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3, .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4, .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4, .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4, .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4, .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5, .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5, .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5, .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5, .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0, .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0, .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0, .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0, .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1, .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1, .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1, .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1, .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2, .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2, .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2, .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2, .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3, .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3, .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3, .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3, .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4, .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4, .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4, .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4, .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5, .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5, .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5, .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5, .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1, .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1, .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1, .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1, .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2, .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2, .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2, .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2, .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3, .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3, .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3, .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3, .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4, .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4, .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4, .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4, .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5, .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5, .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5, .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5, .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto, .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto, .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto, .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto, .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0, .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0, .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0, .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0, .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1, .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1, .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1, .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1, .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2, .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2, .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2, .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2, .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3, .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3, .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3, .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3, .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4, .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4, .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4, .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4, .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5, .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5, .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5, .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5, .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0, .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0, .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0, .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0, .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1, .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1, .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1, .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1, .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2, .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2, .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2, .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2, .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3, .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3, .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3, .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3, .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4, .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4, .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4, .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4, .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5, .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5, .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5, .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5, .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1, .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1, .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1, .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1, .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2, .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2, .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2, .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2, .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3, .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3, .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3, .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3, .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4, .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4, .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4, .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4, .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5, .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5, .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5, .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5, .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto, .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto, .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto, .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto, .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0, .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0, .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0, .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0, .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1, .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1, .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1, .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1, .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2, .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2, .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2, .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2, .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3, .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3, .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3, .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3, .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4, .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4, .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4, .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4, .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5, .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5, .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5, .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5, .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0, .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0, .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0, .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0, .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1, .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1, .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1, .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1, .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2, .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2, .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2, .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2, .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3, .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3, .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3, .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3, .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4, .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4, .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4, .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4, .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5, .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5, .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5, .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5, .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1, .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1, .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1, .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1, .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2, .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2, .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2, .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2, .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3, .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3, .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3, .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3, .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4, .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4, .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4, .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4, .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5, .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5, .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5, .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5, .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto, .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto, .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto, .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto, .mx-xl-auto {
    margin-left: auto !important;
  }
}
.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #007bff !important;
}

a.text-primary:focus, a.text-primary:hover {
  color: #0056b3 !important;
}

.text-secondary {
  color: #6c757d !important;
}

a.text-secondary:focus, a.text-secondary:hover {
  color: #494f54 !important;
}

.text-success {
  color: #28a745 !important;
}

a.text-success:focus, a.text-success:hover {
  color: #19692c !important;
}

.text-info {
  color: #17a2b8 !important;
}

a.text-info:focus, a.text-info:hover {
  color: #0f6674 !important;
}

.text-warning {
  color: #ffc107 !important;
}

a.text-warning:focus, a.text-warning:hover {
  color: #ba8b00 !important;
}

.text-danger {
  color: #dc3545 !important;
}

a.text-danger:focus, a.text-danger:hover {
  color: #a71d2a !important;
}

.text-light {
  color: #f8f9fa !important;
}

a.text-light:focus, a.text-light:hover {
  color: #cbd3da !important;
}

.text-dark {
  color: #343a40 !important;
}

a.text-dark:focus, a.text-dark:hover {
  color: #121416 !important;
}

.text-body {
  color: #212529 !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *, ::after, ::before {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  blockquote, pre {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  img, tr {
    page-break-inside: avoid;
  }
  h2, h3, p {
    orphans: 3;
    widows: 3;
  }
  h2, h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td, .table th {
    background-color: #fff !important;
  }
  .table-bordered td, .table-bordered th {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark tbody + tbody, .table-dark td, .table-dark th, .table-dark thead th {
    border-color: #dee2e6;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #dee2e6;
  }
}

html,
body {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 400;
}

body {
  overflow-x: hidden;
  background: #fff;
  color: #4D4F5C;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#wrapper {
  display: flex;
}

#wrapper #content-wrapper {
  overflow-x: hidden;
  width: 100%;
  /* padding: 35px 20px; */
}

/* section {} */
body * {
  /* color: #000000; */
  color: #555B6D;
}

ul li {
  list-style-type: none;
}

ul {
  padding: 0;
}

button:focus {
  outline: 0;
}

.nopadding {
  padding: 0px !important;
}

/* a {
	transition: all 0.3s;
} */
a,
a:hover,
a:active {
  text-decoration: none;
}

.form-control:focus {
  box-shadow: none;
  border-color: #dedede;
}

.form-control {
  height: 38px;
}

input:focus {
  outline: none;
  box-shadow: none;
}

*:focus {
  outline: none;
  box-shadow: none;
}

.btn.focus,
.btn:focus {
  box-shadow: none;
}

.btn {
  background-color: #43425D;
  font-size: 18px;
  color: #fff;
  padding: 12px 15px;
  font-weight: 500;
  border: 1px solid #43425D;
  border-radius: 5px;
}

.btn-default {
  color: #43425D !important;
  background-color: #fff !important;
}

.btn:hover {
  color: #fff;
}

.new-btn {
  position: absolute;
  right: 15px;
  top: -10px;
  min-width: 130px;
  padding: 8px 10px;
  font-size: 12px;
}

.my-new-button {
  position: absolute !important;
  top: 162px !important;
  right: 1035px !important;
}

.ViewButton {
  width: 50px !important;
}

.Total {
  display: flex !important;
  align-items: center !important;
}

.table thead th {
  border: 0px;
  color: #A3A6B4;
  font-size: 13px;
  font-weight: 700;
  color: #495057;
}

table.dataTable tr th.select-checkbox.selected::after, table.dataTable tr.selected td.select-checkbox:after {
  margin-top: -10px !important;
  margin-left: -6px !important;
  text-align: center;
  text-shadow: none !important;
}

table.dataTable td.select-checkbox:before, table.dataTable th.select-checkbox:before {
  content: " ";
  margin-top: -6px;
  margin-left: -6px;
  border: 1px solid black;
  border-radius: 3px;
}

th.sorting_asc::after,
th.sorting_desc::after {
  content: " " !important;
}

th.selected::after {
  content: "✔" !important;
}

.listButton {
  border: none;
  background-color: rgba(255, 255, 255, 0);
}

@media only screen and (max-width: 767px) {
  .imgRes {
    max-width: 25%;
  }
}
@media (min-width: 768px) {
  .sidebar {
    width: 250px !important;
  }
}
table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;
}

table.dataTable td,
table.dataTable th {
  box-sizing: content-box;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length select {
  width: 75px;
  display: inline-block;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}

div.dataTables_wrapper div.dataTables_filter label {
  font-weight: normal;
  white-space: nowrap;
  text-align: left;
}

div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 0.85em;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_paginate {
  margin: 0;
  white-space: nowrap;
  text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin: 2px 0;
  white-space: nowrap;
  justify-content: flex-end;
}

div.dataTables_wrapper div.dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  margin-left: -100px;
  margin-top: -26px;
  text-align: center;
  padding: 1em 0;
}

table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting {
  padding-right: 30px;
}

table.dataTable thead > tr > th:active,
table.dataTable thead > tr > td:active {
  outline: none;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
  cursor: pointer;
  position: relative;
}

table.dataTable thead .sorting:before, table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  bottom: 0.9em;
  display: block;
  opacity: 0.3;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:before {
  right: 1em;
  content: "↑";
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  right: 0.5em;
  content: "↓";
}

table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:after {
  opacity: 1;
}

table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
  opacity: 0;
}

div.dataTables_scrollHead table.dataTable {
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
  border-top: none;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
  display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
  border-top: none;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner {
  box-sizing: content-box;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner > table {
  margin-top: 0 !important;
  border-top: none;
}

@media screen and (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_length,
  div.dataTables_wrapper div.dataTables_filter,
  div.dataTables_wrapper div.dataTables_info,
  div.dataTables_wrapper div.dataTables_paginate {
    text-align: center;
  }
}
table.dataTable.table-sm > thead > tr > th {
  padding-right: 20px;
}

table.dataTable.table-sm .sorting:before,
table.dataTable.table-sm .sorting_asc:before,
table.dataTable.table-sm .sorting_desc:before {
  top: 5px;
  right: 0.85em;
}

table.dataTable.table-sm .sorting:after,
table.dataTable.table-sm .sorting_asc:after,
table.dataTable.table-sm .sorting_desc:after {
  top: 5px;
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
  border-left-width: 0;
}

table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
  border-right-width: 0;
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
  border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
  border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-left: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
}

/*!
* Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)
*
* Copyright 2013-2017 bootstrap-select
* Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
*/
select.bs-select-hidden, select.selectpicker {
  display: none !important;
}

.bootstrap-select {
  width: 220px\\9 ;
}

.bootstrap-select > .dropdown-toggle {
  width: 100%;
  padding-right: 25px;
  z-index: 1;
}

.bootstrap-select > .dropdown-toggle.bs-placeholder, .bootstrap-select > .dropdown-toggle.bs-placeholder:active, .bootstrap-select > .dropdown-toggle.bs-placeholder:focus, .bootstrap-select > .dropdown-toggle.bs-placeholder:hover {
  color: #999;
}

.bootstrap-select > select {
  position: absolute !important;
  bottom: 0;
  left: 50%;
  display: block !important;
  width: 0.5px !important;
  height: 100% !important;
  padding: 0 !important;
  opacity: 0 !important;
  border: none;
}

.bootstrap-select > select.mobile-device {
  top: 0;
  left: 0;
  display: block !important;
  width: 100% !important;
  z-index: 2;
}

.error .bootstrap-select .dropdown-toggle, .has-error .bootstrap-select .dropdown-toggle {
  border-color: #b94a48;
}

.bootstrap-select.fit-width {
  width: auto !important;
}

.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {
  width: 220px;
}

.bootstrap-select .dropdown-toggle:focus {
  outline: thin dotted #333 !important;
  outline: 5px auto -webkit-focus-ring-color !important;
  outline-offset: -2px;
}

.bootstrap-select.form-control {
  margin-bottom: 0;
  padding: 0;
  border: none;
}

.bootstrap-select.form-control:not([class*=col-]) {
  width: 100%;
}

.bootstrap-select.form-control.input-group-btn {
  z-index: auto;
}

.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}

.bootstrap-select.btn-group:not(.input-group-btn), .bootstrap-select.btn-group[class*=col-] {
  float: none;
  display: inline-block;
  margin-left: 0;
}

.bootstrap-select.btn-group.dropdown-menu-right, .bootstrap-select.btn-group[class*=col-].dropdown-menu-right, .row .bootstrap-select.btn-group[class*=col-].dropdown-menu-right {
  float: right;
}

.form-group .bootstrap-select.btn-group, .form-horizontal .bootstrap-select.btn-group, .form-inline .bootstrap-select.btn-group {
  margin-bottom: 0;
}

.form-group-lg .bootstrap-select.btn-group.form-control, .form-group-sm .bootstrap-select.btn-group.form-control {
  padding: 0;
}

.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle, .form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {
  height: 100%;
  font-size: inherit;
  line-height: inherit;
  border-radius: inherit;
}

.form-inline .bootstrap-select.btn-group .form-control {
  width: 100%;
}

.bootstrap-select.btn-group.disabled, .bootstrap-select.btn-group > .disabled {
  cursor: not-allowed;
}

.bootstrap-select.btn-group.disabled:focus, .bootstrap-select.btn-group > .disabled:focus {
  outline: 0 !important;
}

.bootstrap-select.btn-group.bs-container {
  position: absolute;
  height: 0 !important;
  padding: 0 !important;
}

.bootstrap-select.btn-group.bs-container .dropdown-menu {
  z-index: 1060;
}

.bootstrap-select.btn-group .dropdown-toggle .filter-option {
  display: inline-block;
  overflow: hidden;
  width: 100%;
  text-align: left;
}

.bootstrap-select.btn-group .dropdown-toggle .caret {
  position: absolute;
  top: 50%;
  right: 12px;
  margin-top: -2px;
  vertical-align: middle;
}

.bootstrap-select.btn-group[class*=col-] .dropdown-toggle {
  width: 100%;
}

.bootstrap-select.btn-group .dropdown-menu {
  min-width: 100%;
  box-sizing: border-box;
}

.bootstrap-select.btn-group .dropdown-menu.inner {
  position: static;
  float: none;
  border: 0;
  padding: 0;
  margin: 0;
  border-radius: 0;
  box-shadow: none;
}

.bootstrap-select.btn-group .dropdown-menu li {
  position: relative;
}

.bootstrap-select.btn-group .dropdown-menu li.active small {
  color: #fff;
}

.bootstrap-select.btn-group .dropdown-menu li.disabled a {
  cursor: not-allowed;
}

.bootstrap-select.btn-group .dropdown-menu li a {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.bootstrap-select.btn-group .dropdown-menu li a.opt {
  position: relative;
  padding-left: 2.25em;
}

.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {
  display: none;
}

.bootstrap-select.btn-group .dropdown-menu li a span.text {
  display: inline-block;
}

.bootstrap-select.btn-group .dropdown-menu li small {
  padding-left: 0.5em;
}

.bootstrap-select.btn-group .dropdown-menu .notify {
  position: absolute;
  bottom: 5px;
  width: 96%;
  margin: 0 2%;
  min-height: 26px;
  padding: 3px 5px;
  background: #f5f5f5;
  border: 1px solid #e3e3e3;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  pointer-events: none;
  opacity: 0.9;
  box-sizing: border-box;
}

.bootstrap-select.btn-group .no-results {
  padding: 3px;
  background: #f5f5f5;
  margin: 0 5px;
  white-space: nowrap;
}

.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {
  position: static;
}

.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret {
  position: static;
  top: auto;
  margin-top: -1px;
}

.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark {
  position: absolute;
  display: inline-block;
  right: 15px;
  margin-top: 5px;
}

.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {
  margin-right: 34px;
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle {
  z-index: 1061;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle:before {
  content: "";
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(204, 204, 204, 0.2);
  position: absolute;
  bottom: -4px;
  left: 9px;
  display: none;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle:after {
  content: "";
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  position: absolute;
  bottom: -4px;
  left: 10px;
  display: none;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {
  bottom: auto;
  top: -3px;
  border-top: 7px solid rgba(204, 204, 204, 0.2);
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {
  bottom: auto;
  top: -3px;
  border-top: 6px solid #fff;
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {
  right: 12px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {
  right: 13px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle:after, .bootstrap-select.show-menu-arrow.open > .dropdown-toggle:before {
  display: block;
}

.bs-actionsbox, .bs-donebutton, .bs-searchbox {
  padding: 4px 8px;
}

.bs-actionsbox {
  width: 100%;
  box-sizing: border-box;
}

.bs-actionsbox .btn-group button {
  width: 50%;
}

.bs-donebutton {
  float: left;
  width: 100%;
  box-sizing: border-box;
}

.bs-donebutton .btn-group button {
  width: 100%;
}

.bs-searchbox + .bs-actionsbox {
  padding: 0 8px 4px;
}

.bs-searchbox .form-control {
  margin-bottom: 0;
  width: 100%;
  float: none;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child, table.dataTable.dtr-inline.collapsed > tbody > tr > th.child, table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {
  cursor: default !important;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before, table.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before, table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {
  display: none !important;
}

table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child, table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}

table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before, table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before {
  top: 12px;
  left: 4px;
  height: 14px;
  width: 14px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  text-indent: 0 !important;
  font-family: "Courier New", Courier, monospace;
  line-height: 14px;
  content: "+";
  background-color: #0275d8;
}

table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before, table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child, table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {
  padding-left: 27px;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child:before, table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child:before {
  top: 5px;
  left: 4px;
  height: 14px;
  width: 14px;
  border-radius: 14px;
  line-height: 14px;
  text-indent: 3px;
}

table.dataTable.dtr-column > tbody > tr > td.control, table.dataTable.dtr-column > tbody > tr > th.control {
  position: relative;
  cursor: pointer;
}

table.dataTable.dtr-column > tbody > tr > td.control:before, table.dataTable.dtr-column > tbody > tr > th.control:before {
  top: 50%;
  left: 50%;
  height: 16px;
  width: 16px;
  margin-top: -10px;
  margin-left: -10px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  text-indent: 0 !important;
  font-family: "Courier New", Courier, monospace;
  line-height: 14px;
  content: "+";
  background-color: #0275d8;
}

table.dataTable.dtr-column > tbody > tr.parent td.control:before, table.dataTable.dtr-column > tbody > tr.parent th.control:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable > tbody > tr.child {
  padding: 0.5em 1em;
}

table.dataTable > tbody > tr.child:hover {
  background: transparent !important;
}

table.dataTable > tbody > tr.child ul.dtr-details {
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

table.dataTable > tbody > tr.child ul.dtr-details > li {
  border-bottom: 1px solid #efefef;
  padding: 0.5em 0;
}

table.dataTable > tbody > tr.child ul.dtr-details > li:first-child {
  padding-top: 0;
}

table.dataTable > tbody > tr.child ul.dtr-details > li:last-child {
  border-bottom: none;
}

table.dataTable > tbody > tr.child span.dtr-title {
  display: inline-block;
  min-width: 75px;
  font-weight: bold;
}

div.dtr-modal {
  position: fixed;
  box-sizing: border-box;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  padding: 10em 1em;
}

div.dtr-modal div.dtr-modal-display {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 50%;
  overflow: auto;
  margin: auto;
  z-index: 102;
  overflow: auto;
  background-color: #f5f5f7;
  border: 1px solid black;
  border-radius: 0.5em;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}

div.dtr-modal div.dtr-modal-content {
  position: relative;
  padding: 1em;
}

div.dtr-modal div.dtr-modal-close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border: 1px solid #eaeaea;
  background-color: #f9f9f9;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  z-index: 12;
}

div.dtr-modal div.dtr-modal-close:hover {
  background-color: #eaeaea;
}

div.dtr-modal div.dtr-modal-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(0, 0, 0, 0.6);
}

@media screen and (max-width: 767px) {
  div.dtr-modal div.dtr-modal-display {
    width: 95%;
  }
}
div.dtr-bs-modal table.table tr:first-child td {
  border-top: none;
}

table.dataTable tbody > tr.selected, table.dataTable tbody > tr > .selected {
  background-color: #B0BED9;
}

table.dataTable.stripe tbody > tr.odd.selected, table.dataTable.stripe tbody > tr.odd > .selected, table.dataTable.display tbody > tr.odd.selected, table.dataTable.display tbody > tr.odd > .selected {
  background-color: #acbad4;
}

table.dataTable.hover tbody > tr.selected:hover, table.dataTable.hover tbody > tr > .selected:hover, table.dataTable.display tbody > tr.selected:hover, table.dataTable.display tbody > tr > .selected:hover {
  background-color: #aab7d1;
}

table.dataTable.order-column tbody > tr.selected > .sorting_1, table.dataTable.order-column tbody > tr.selected > .sorting_2, table.dataTable.order-column tbody > tr.selected > .sorting_3, table.dataTable.order-column tbody > tr > .selected, table.dataTable.display tbody > tr.selected > .sorting_1, table.dataTable.display tbody > tr.selected > .sorting_2, table.dataTable.display tbody > tr.selected > .sorting_3, table.dataTable.display tbody > tr > .selected {
  background-color: #acbad5;
}

table.dataTable.display tbody > tr.odd.selected > .sorting_1, table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_1 {
  background-color: #a6b4cd;
}

table.dataTable.display tbody > tr.odd.selected > .sorting_2, table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_2 {
  background-color: #a8b5cf;
}

table.dataTable.display tbody > tr.odd.selected > .sorting_3, table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_3 {
  background-color: #a9b7d1;
}

table.dataTable.display tbody > tr.even.selected > .sorting_1, table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_1 {
  background-color: #acbad5;
}

table.dataTable.display tbody > tr.even.selected > .sorting_2, table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_2 {
  background-color: #aebcd6;
}

table.dataTable.display tbody > tr.even.selected > .sorting_3, table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_3 {
  background-color: #afbdd8;
}

table.dataTable.display tbody > tr.odd > .selected, table.dataTable.order-column.stripe tbody > tr.odd > .selected {
  background-color: #a6b4cd;
}

table.dataTable.display tbody > tr.even > .selected, table.dataTable.order-column.stripe tbody > tr.even > .selected {
  background-color: #acbad5;
}

table.dataTable.display tbody > tr.selected:hover > .sorting_1, table.dataTable.order-column.hover tbody > tr.selected:hover > .sorting_1 {
  background-color: #a2aec7;
}

table.dataTable.display tbody > tr.selected:hover > .sorting_2, table.dataTable.order-column.hover tbody > tr.selected:hover > .sorting_2 {
  background-color: #a3b0c9;
}

table.dataTable.display tbody > tr.selected:hover > .sorting_3, table.dataTable.order-column.hover tbody > tr.selected:hover > .sorting_3 {
  background-color: #a5b2cb;
}

table.dataTable.display tbody > tr:hover > .selected, table.dataTable.display tbody > tr > .selected:hover, table.dataTable.order-column.hover tbody > tr:hover > .selected, table.dataTable.order-column.hover tbody > tr > .selected:hover {
  background-color: #a2aec7;
}

table.dataTable td.select-checkbox, table.dataTable th.select-checkbox {
  position: relative;
}

table.dataTable td.select-checkbox:before, table.dataTable td.select-checkbox:after, table.dataTable th.select-checkbox:before, table.dataTable th.select-checkbox:after {
  display: block;
  position: absolute;
  top: 1.7em;
  left: 50%;
  width: 12px;
  height: 12px;
  box-sizing: border-box;
}

table.dataTable td.select-checkbox:before, table.dataTable th.select-checkbox:before {
  content: " ";
  margin-top: -6px;
  margin-left: -6px;
  border: 1px solid black;
  border-radius: 3px;
}

table.dataTable tr.selected td.select-checkbox:after, table.dataTable tr.selected th.select-checkbox:after {
  content: "✔";
  margin-top: -11px;
  margin-left: -4px;
  text-align: center;
  text-shadow: 1px 1px #B0BED9, -1px -1px #B0BED9, 1px -1px #B0BED9, -1px 1px #B0BED9;
}

div.dataTables_wrapper span.select-info, div.dataTables_wrapper span.select-item {
  margin-left: 0.5em;
}

@media screen and (max-width: 640px) {
  div.dataTables_wrapper span.select-info, div.dataTables_wrapper span.select-item {
    margin-left: 0;
    display: block;
  }
}
.paginate_button {
  padding: 5px 10px;
  cursor: pointer;
}

/* Login start */
.login-row {
  overflow: hidden;
}

.login-leftimg {
  width: 100%;
  height: 100%;
}

.login-right {
  position: relative;
  background: #fff;
}

.login-main {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  padding: 0px;
  width: 60%;
  max-width: 450px;
}

.login {
  text-align: center;
}

.login-main h6 {
  font-size: 18px;
  opacity: 0.5;
  margin: 26px 0px 30px;
}

.login-main form {
  margin-top: 30px;
}

.login-main .btn {
  background-color: #43425D;
  font-size: 13px;
  color: #fefefe;
  /* padding:10px 15px; */
  width: 100%;
  margin: 0px 0px 10px;
}

.form-check-label {
  line-height: unset !important;
  font-size: 14px !important;
  margin-bottom: 0px !important;
}

.forgot-password {
  float: right;
  color: #524fa1;
  cursor: pointer;
  font-size: 14px;
}

.copy-text {
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 13px;
  text-align: center;
}

.forget-pass p {
  font-size: 14px;
  font-weight: 300;
}

.forget-pass,
.reset-pass {
  display: none;
}

/* form start */
.login-main .form-group {
  margin-bottom: 25px;
}

.login-main .form-control {
  border-color: #e9e9f0 !important;
  font-size: 15px;
  padding: 23px 5px;
  border: 0px;
  border-bottom: 1px solid;
  border-radius: 0;
}

.login-check {
  display: table;
  width: 100%;
}

.login-main .custom-checkbox {
  float: left;
}

.login-check .custom-control-label {
  margin-bottom: 0px !important;
  line-height: 23px !important;
  font-size: 14px !important;
}

.login-check .custom-control-label::before {
  background-color: #e0ebed;
}

.login-check .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #adb5bd;
  background-color: #adb5bd;
}

.login-check .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
}

.login-check .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #adb5bd;
}

.login-main input::placeholder {
  color: #2d2d2d;
}

.login-main input:-ms-input-placeholder {
  color: #2d2d2d;
}

.login-main input::-ms-input-placeholder {
  color: #2d2d2d;
}

/* form start */
.login .btn {
  margin: 5px;
}

/* Login end */
.register-main {
  position: relative;
  margin: auto;
  padding: 0px;
  width: 60%;
  max-width: 650px;
}

.regreqbox {
  margin-top: 30px;
}

.register-main .form-control {
  line-height: 1.1;
}

/* nav and sidebar start */
#wrapper {
  background: #F4F4F4;
}

.sidebar {
  background-color: #5C2E91;
  padding-top: 15px;
  min-height: 1000px;
}

.profile-name {
  background: #000;
  color: #fff;
  font-size: 12px;
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 40px;
  display: inline-block;
  vertical-align: middle;
  line-height: 40px;
  margin: 0px 20px 0px 0px;
}

.navbar-nav .fa {
  color: #666666;
}

i.fas.fa.fa-bell-o {
  margin: 10px 15px 0px 0px;
}

.fa-angle-down {
  font-size: 18px;
}

.sidebar .nav-item .nav-link {
  padding: 15px 20px !important;
  font-size: 16px;
}

.sidebar .menu-text {
  float: left;
  color: #FFFFFF;
  line-height: 16px;
  font-weight: 600;
  font-size: 13px;
  opacity: 50%;
  margin: 15px 20px 6px;
}

.btn-secondary:focus {
  color: #fff;
  background-color: transparent;
  border-color: transparent;
}

.btn-secondary:hover {
  color: #fff;
  background-color: transparent;
  border-color: transparent;
}

.btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: transparent;
  border-color: transparent;
  border: none !important;
  border-width: 0;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none !important;
  border-width: 0;
}

.sidebar span {
  color: #FFFFFF;
  opacity: 0.5;
  display: inline-block !important;
  font-size: 13px;
}

.sidebar .bx {
  color: #FFFFFF;
  opacity: 0.5;
  display: inline-block;
  font-size: 18px;
}

.sidebar .active span {
  color: #fff;
  opacity: 1;
}

.sidebar .active .bx {
  color: #fff;
  opacity: 1;
}

.sidebar .nav-link:hover span,
.sidebar .nav-link:hover .bx {
  opacity: 1;
}

.dropdown-toggle::after {
  display: none;
}

.static-top {
  background: #fff;
}

.nav-right-ul li {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.nav-right-ul li .bx-bell,
.nav-right-ul li .bx-cog {
  color: #555B6D;
  font-size: 18px;
}

.sec-header {
  font-size: 15px;
  font-weight: 700;
  margin: 5px 0px 20px;
  color: #555B6D;
}

.box-row {
  margin: 0px 0px 25px;
}

.box-row .card {
  border-radius: 0px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.0392156863);
  border: 0px;
}

.box-row .card-header {
  background: #fff;
  border: 0px;
  color: #4D4F5C;
  /* font-size:18px; */
}

.card-header-title {
  font-size: 15px;
  font-weight: bold;
}

.box-row .card-body.gatepass-saveoutput {
  padding-top: 5px;
}

/* DASHBOARD start */
.navbar {
  padding: 0.7rem 1rem;
}

.dropdown-divider {
  border: none;
}

.dash-num-card p {
  opacity: 1;
  font-size: 13px;
  color: #495057;
}

.dash-num-card i img {
  margin-bottom: 1.3rem;
}

.number {
  color: #495057;
  font-size: 20px;
  font-weight: 700;
  margin-top: 16px;
}

.number-txt {
  font-size: 11px;
  font-weight: 700;
}

.rate-up {
  color: #3CC480;
}

.rate-up1 {
  color: #00B6BD;
  font-size: 14px;
  font-weight: bold;
}

.rate-down {
  color: #FF4141;
}

.number-txt .fa-arrow-up {
  color: #3CC480;
  font-size: 11px;
  margin-right: 5px;
}

.number-txt .fa-arrow-down {
  color: #FF4141;
  font-size: 11px;
  margin-right: 5px;
}

div#published-table_length,
div#published-table_filter,
div#published-table_info {
  display: none;
}

thead {
  background: #F5F6FA;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}

.table thead th {
  border: 0px;
  /* color:#A3A6B4; */
  font-size: 13px;
  font-weight: 700;
  color: #495057;
}

.table td {
  /* color:#4D4F5C; */
  font-size: 13px;
  font-weight: 400;
  color: #495057;
}

.card-profile {
  /* width: 30%; */
  background-color: rgba(92, 46, 145, 0.2);
  padding: 10px;
  border-radius: 5px;
  padding-bottom: 17px;
  height: 100%;
  /* position: absolute; */
  /* left: 15px; */
}

.card-profile p {
  margin: 0px;
  font-size: 11px;
  color: #5C2E91;
}

.designation {
  color: #495057;
  font-size: 10px;
}

.custom-card {
  padding: 1rem;
}

/* .dash-num-card .card-body{
	padding:0px !important;
} */
.card1 {
  font-size: 14px;
  padding: 1.25rem;
}

.card1 p {
  font-size: 14px;
}

.card1 div {
  font-size: 13px;
  margin-top: 16px;
}

.active1 {
  color: #00B6BD !important;
  font-size: 14px !important;
}

.search-box input {
  height: 30px;
}

.reports #brands-table_length,
.reports #product-table_length {
  float: left !important;
}

.reports select {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #CED4DA;
  border-radius: 3px;
  opacity: 1;
  margin: 0px 10px;
  font-size: 13px;
}

.reports label,
#product-table_info,
.paginate_button,
.reports input {
  color: #495057;
  font-size: 13px;
}

.reports input {
  border: 1px solid #CED4DA;
}

.current {
  background-color: #5C2E91;
  color: #fff !important;
  padding: 5px 10px;
  border-radius: 15px;
  margin: 0px 10px;
}

/* DASHBOARD end */
.product-active {
  color: green;
}

.product-inactive {
  color: red;
}

.brand-active {
  color: green;
}

.brand-inactive {
  color: red;
}

.merchant-active {
  color: green;
}

.merchant-inactive {
  color: red;
}

/* Preethi new design */
/* .sidebar li:first-child{

} */
.bold {
  font-weight: bold !important;
}

.file-active {
  background-color: #5C2E91;
  opacity: 0.1;
  color: #000 !important;
}

.dropdown-list1 a {
  color: #495057;
}

.user-name {
  color: #555B6D;
  font-size: 13px;
}

.pink-alert,
.green-alert, .info-alert {
  border-radius: 5px !important;
  margin-right: 8px;
  font-size: 13px;
}

.pink-alert {
  background-color: #FDE1E1;
  color: #7F3737;
}

.info-alert {
  background-color: #5c2e91;
  color: #ffffff;
}

.green-alert {
  background-color: #D6F3E9;
  color: #1B654A;
}

.scrollable {
  overflow-y: auto;
  max-height: 300px;
}

.card-height {
  box-shadow: 0px 3px 6px rgba(92, 46, 145, 0.1019607843);
  border: 0 !important;
}

.report-btn ul li {
  display: inline-block;
  margin: 0px 10px;
  font-size: 13px;
  color: #495057;
}

.report-btn .btn-active {
  background-color: #5C2E91;
  color: #fff;
  padding: 8px;
  border-radius: 3px;
}

.view-btn p, .btn {
  background-color: #5C2E91;
  padding: 5px;
  border-radius: 20px;
  font-size: 12px;
  color: #fff;
  margin: 0px;
  text-align: center;
  width: 99px;
  cursor: pointer;
}

.btn {
  width: auto;
}

.btn-danger {
  background-color: #c54040;
  border-color: transparent;
}

.view-btn i {
  cursor: pointer;
}

.pay-status-pending,
.pay-complete {
  padding-top: 17px !important;
}

.pay-status-pending span {
  color: #F46A6A;
  background-color: #FDE4E4;
  padding: 8px;
  border-radius: 25px;
  font-size: 12px;
}

.pay-complete span {
  color: #34C38F;
  background-color: #DAF4EB;
  padding: 8px;
  border-radius: 25px;
  font-size: 12px;
}

.scrollable::-webkit-scrollbar {
  width: 4px;
}

/* Track */
.scrollable::-webkit-scrollbar-track {
  background: #E9E9E9 0% 0% no-repeat padding-box;
  border-radius: 10px;
}

/* Handle */
.scrollable::-webkit-scrollbar-thumb {
  background: #E9E9E9 0% 0% no-repeat padding-box;
  border-radius: 10px;
}

/* Handle on hover */
.scrollable::-webkit-scrollbar-thumb:hover {
  background: #555;
}

p {
  margin: 0;
}

.show-more p {
  color: #3B86FF;
  font-size: 13px;
}

footer p {
  color: #74788D;
  font-size: 13px;
}

.Active span {
  color: green !important;
}

.Inactive span {
  color: red !important;
}

/* Products.html */
.card-table {
  width: 100%;
}

.table-head {
  margin-top: 20px;
}

.new-btn-top {
  font-size: 13px;
  background-color: #5C2E91;
  margin-bottom: 15px;
  padding: 5px 10px !important;
  border-radius: 3px;
  width: auto;
}

.font-size {
  font-size: 18px;
}

#ReportInput {
  width: 20%;
}

#ReportInput option,
#ReportInput {
  border: 1px solid #B1BBC4;
  font-size: 13px;
  color: #555B6D;
}

.arrow-up {
  color: #00CF37;
  font-size: 16px;
}

.arrow-down {
  font-size: 16px;
  color: #FF0000;
}

/* Login new usman */
.welcome {
  background: #ded5e9;
  padding: 25px;
  color: #5C2E91;
}

.welcome h5 {
  font-size: 16px;
  color: #5C2E91;
}

.welcome p {
  font-size: 13px;
  color: #5C2E91;
  margin-bottom: 20px;
}

.login-main .card-body {
  padding: 25px;
}

.login-main .card-body {
  padding: 25px;
}

.login-logo {
  margin-top: -50px;
}

.login-main .form-horizontal {
  margin: 25px 0px 10px;
}

.login-main label {
  font-size: 13px;
}

.login-main .form-control {
  height: 36px;
  border: 1px solid #B1BBC4;
}

.login-main .form-group {
  margin-bottom: 15px;
}

.copy-text1 {
  font-size: 13px;
  margin: 0px auto 0px;
}

.login-btn1 {
  background-color: #5C2E91 !important;
  font-size: 13px;
  color: #fff;
  /* height: 36px; */
  padding: 5px 12px;
  font-weight: 400;
  border: 1px solid #5C2E91 !important;
  border-radius: 3px;
}

.forgot a {
  margin: 25px auto 0px;
  color: #74788D;
  font-size: 13px;
  display: table;
}

.forgot .bx:before {
  content: "\\edbf";
  color: #74788D;
}

/* modal start */
.modal-header {
  background: #5C2E91;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  height: 50px;
  padding: 18px 20px;
  line-height: 14px;
}

button.close {
  position: absolute;
  right: 25px;
  top: 7px;
  color: #fff;
  opacity: 1;
  font-size: 30px;
  font-weight: 300;
}

.modal-up div {
  color: #495057;
  font-size: 14px;
}

#Restock input {
  font-size: 13px;
}

.model-box {
  width: 602px;
  margin: 0 auto;
}

.card-header-title1 {
  background-color: #fff !important;
  border-bottom: 0px !important;
}

/* modal end */
.sub-heading {
  color: #495057;
  font-size: 13px;
}

.dropdown-active1 {
  background-color: #F6F6F6;
  color: #495057;
}

.dropdown-menu-right ul {
  list-style-type: circle;
}

.dropdown-menu-right ul li {
  font-size: 10px;
}

.change-property {
  font-size: 12px;
}

.gatepass-saveoutput .table-responsive {
  display: table;
}

#log-table_wrapper .dataTables_length {
  float: left;
}

/* Chekcbox */
.custom-control-label {
  padding: 3px 0px 0px 5px;
  font-size: 12px;
}

.custom-control-label::before {
  width: 16px;
  height: 16px;
}

.custom-control-label::after {
  width: 16px;
  height: 16px;
}

.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  background-color: transparent;
  border-color: #adb5bd;
}

.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
}

.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #adb5bd;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #5C2E91;
  background-color: #5C2E91;
}

/* checkbox end */
@media (min-width: 992px) {
  #sidebarToggle {
    display: none;
  }
}
@media (max-width: 991px) {
  .gatepass-saveoutput .table-responsive {
    display: block;
  }
}
@media (max-width: 767px) {
  #product-table_filter label,
  #log-table_filter label {
    float: left;
  }
  .login-row .h-100 {
    height: auto !important;
  }
  .login-row {
    background: #fff;
    overflow: auto;
  }
  .login-right {
    position: relative;
    background: #fff;
  }
  .login-main {
    width: 90%;
    position: relative;
    transform: unset;
    left: unset;
    top: unset;
    margin: 25px auto;
  }
  .copy-text {
    width: 100%;
    position: relative;
    transform: unset;
    bottom: unset;
    left: unset;
    padding: 25px 0px;
  }
  .navbar-brand img {
    width: 100px;
  }
  .profile-name {
    margin: 0px 15px 0px 0px;
  }
  i.fas.fa.fa-bell-o {
    margin: 10px 10px 0px 0px;
  }
  button#sidebarToggle {
    background: transparent;
    padding: 5px;
    border-radius: 0px;
    line-height: 0px;
    margin-right: 5px;
  }
  .navbar-brand {
    display: none;
  }
  .navbar-expand {
    padding: 10px 10px;
  }
  .sidebar {
    padding-top: 10px;
  }
  .sidebar .nav-item .nav-link {
    padding: 13px 20px !important;
    font-size: 13px;
    width: 100% !important;
    display: flex;
    text-align: left;
  }
  /* .sidebar .bx {} */
  .sidebar .dot {
    width: 7px;
    height: 7px;
    margin: 3px 5px 0px 0px;
  }
  .sidebar div {
    line-height: 14px;
    margin: 15px 20px;
  }
  .sidebar {
    position: absolute;
    z-index: 999;
    top: 55px;
    display: none;
  }
  .sidebar.toggled {
    width: 90% !important;
    overflow: hidden;
    display: block;
  }
  #wrapper #content-wrapper {
    padding: 0px 0px;
  }
  .dashboard-row .col-sm-6 {
    margin-bottom: 15px;
  }
  /*New Medai CSS*/
  .card1 .float-rgt {
    float: none !important;
    text-align: center !important;
  }
  .card1 .float-lft {
    float: none !important;
    text-align: center !important;
  }
}
/* style1 */
.box-row .new-merchant .form-group label,
.box-row .new-merchant .form-group input,
.box-row .new-merchant .form-group select {
  font-size: 13px;
  line-height: 25px;
  letter-spacing: 0;
  color: #495057;
  border-radius: 0;
}

.box-row .section-header {
  font-size: 15px;
  font-weight: 700;
  margin: 5px 0px 20px;
  color: #555B6D;
  width: 100%;
}

.box-row .new-merchant .form-control {
  font-size: 13px;
  line-height: 25px;
  color: #495057;
  width: 95%;
  height: 36px;
}

.custom-file-upload {
  display: inline-block;
  cursor: pointer;
}

::-webkit-file-upload-button {
  background-color: #555B6D;
  color: #fff;
  padding: 2px 28px;
  border-color: #555B6D;
  box-shadow: none;
  border-radius: 25px;
}

.submit-btn {
  font-size: 13px;
  line-height: 25px;
  padding: 6px 25px;
  background: #5C2E91;
}

#chart {
  /* height: 300px; */
  margin-top: 65px;
}

.highcharts-figure,
.highcharts-data-table table {
  margin: 1em auto;
}

.highcharts-data-table table {
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  border: 1px solid #EBEBEB;
  margin: 10px auto;
  text-align: center;
  width: 100%;
}

.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}

.highcharts-data-table th {
  font-weight: 600;
  padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}

.highcharts-data-table tr:hover {
  background: #f1f7ff;
}

.select2-container {
  width: 95% !important;
}

.select2-container--default .select2-selection--multiple .select2-selection__rendered li {
  font-size: 11px;
}

.select2-container--default.select2-container--focus .select2-selection--multiple,
.select2-container--default .select2-selection--multiple {
  border: 1px solid #ced4da;
  border-radius: 0px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  float: right;
  margin-left: 5px;
  color: #fff;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  background-color: #5C2E91;
  border: 1px solid #5C2E91;
  color: #fff;
  border-radius: 0px;
}

.fileUpload {
  position: relative;
  overflow: hidden;
  margin: 10px;
  padding: 2px 28px;
  border-radius: 25px;
}

.fileUpload input.upload {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
}

.fileUpload span {
  font-size: 13px;
  color: #fff;
  line-height: 25px;
}

#uploadFile {
  border: none;
  background: transparent;
}

.fileUpload:hover {
  background: #555B6D;
  border-color: #555B6D;
}

/* End of style1 */
/*new*/
.box-row .settings-form label {
  font-size: 15px;
  line-height: 25px;
  color: #43425D;
}

.box-row .settings-form .form-control {
  font-size: 13px;
  line-height: 13px;
  color: #000000;
  width: 95%;
  height: 40px;
}

.box-row .settings-form {
  padding-left: 10px;
}

.box-row .settings-form .btn {
  padding: 10px 65px;
}

.edit-btn {
  position: absolute;
  right: 15px;
  top: 14px;
  min-width: 130px;
  padding: 8px 10px;
  font-size: 12px;
}

.box-row .vendor-form label {
  font-size: 15px;
  line-height: 25px;
  color: #43425D;
}

.box-row .vendor-form .form-control {
  font-size: 13px;
  line-height: 13px;
  color: #000000;
  width: 95%;
  height: 40px;
}

.box-row .vendor-form {
  padding-left: 10px;
}

.box-row .vendor-form .btn {
  padding: 10px 65px;
}

.box-row .new-agent label {
  font-size: 15px;
  line-height: 25px;
  color: #43425D;
}

.box-row .new-agent .form-control {
  font-size: 13px;
  line-height: 13px;
  color: #000000;
  width: 95%;
  height: 40px;
}

.box-row .new-agent {
  padding-left: 10px;
}

.box-row .new-agent .btn {
  padding: 10px 65px;
}

#report-table_filter,
#report-table_length {
  display: none;
}

/*New CSS*/
.card1 .float-rgt {
  float: right;
}

.card1 .float-lft {
  float: left;
}

.Toastify__toast-container {
  z-index: 9999;
  -webkit-transform: translateZ(9999px);
  position: fixed;
  padding: 4px;
  width: 320px;
  box-sizing: border-box;
  color: #fff;
}

.Toastify__toast-container--top-left {
  top: 1em;
  left: 1em;
}

.Toastify__toast-container--top-center {
  top: 1em;
  left: 50%;
  transform: translateX(-50%);
}

.Toastify__toast-container--top-right {
  top: 1em;
  right: 1em;
}

.Toastify__toast-container--bottom-left {
  bottom: 1em;
  left: 1em;
}

.Toastify__toast-container--bottom-center {
  bottom: 1em;
  left: 50%;
  transform: translateX(-50%);
}

.Toastify__toast-container--bottom-right {
  bottom: 1em;
  right: 1em;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
  }
  .Toastify__toast-container--top-center, .Toastify__toast-container--top-left, .Toastify__toast-container--top-right {
    top: 0;
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-right {
    bottom: 0;
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: 0;
    left: auto;
  }
}
.Toastify__toast {
  position: relative;
  min-height: 64px;
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: 8px;
  border-radius: 1px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  max-height: 800px;
  overflow: hidden;
  font-family: sans-serif;
  cursor: pointer;
  direction: ltr;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--dark {
  background: #121212;
  color: #fff;
}

.Toastify__toast--default {
  background: #fff;
  color: #aaa;
}

.Toastify__toast--info {
  background: #3498db;
}

.Toastify__toast--success {
  background: #07bc0c;
}

.Toastify__toast--warning {
  background: #f1c40f;
}

.Toastify__toast--error {
  background: #e74c3c;
}

.Toastify__toast-body {
  margin: auto 0;
  flex: 1 1 auto;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast {
    margin-bottom: 0;
  }
}
.Toastify__close-button {
  color: #fff;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  align-self: flex-start;
}

.Toastify__close-button--default {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:focus, .Toastify__close-button:hover {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}
.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  z-index: 9999;
  opacity: 0.7;
  background-color: hsla(0, 0%, 100%, 0.7);
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: auto;
  transform-origin: right;
}

.Toastify__progress-bar--default {
  background: linear-gradient(90deg, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
}

.Toastify__progress-bar--dark {
  background: #bb86fc;
}

@keyframes Toastify__bounceInRight {
  0%, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInLeft {
  0%, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInUp {
  0%, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translateZ(0);
  }
}
@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes Toastify__bounceInDown {
  0%, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.Toastify__bounce-enter--bottom-left, .Toastify__bounce-enter--top-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--bottom-right, .Toastify__bounce-enter--top-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--bottom-left, .Toastify__bounce-exit--top-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--bottom-right, .Toastify__bounce-exit--top-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes Toastify__zoomOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  0% {
    transform: perspective(400px) rotateX(90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotateX(-20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotateX(10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotateX(-5deg);
  }
  to {
    transform: perspective(400px);
  }
}
@keyframes Toastify__flipOut {
  0% {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotateX(-20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotateX(90deg);
    opacity: 0;
  }
}
.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  0% {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translateZ(0);
  }
}
@keyframes Toastify__slideInLeft {
  0% {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translateZ(0);
  }
}
@keyframes Toastify__slideInUp {
  0% {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translateZ(0);
  }
}
@keyframes Toastify__slideInDown {
  0% {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translateZ(0);
  }
}
@keyframes Toastify__slideOutRight {
  0% {
    transform: translateZ(0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, 0, 0);
  }
}
@keyframes Toastify__slideOutLeft {
  0% {
    transform: translateZ(0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, 0, 0);
  }
}
@keyframes Toastify__slideOutDown {
  0% {
    transform: translateZ(0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}
@keyframes Toastify__slideOutUp {
  0% {
    transform: translateZ(0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}
.Toastify__slide-enter--bottom-left, .Toastify__slide-enter--top-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--bottom-right, .Toastify__slide-enter--top-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--bottom-left, .Toastify__slide-exit--top-left {
  animation-name: Toastify__slideOutLeft;
}

.Toastify__slide-exit--bottom-right, .Toastify__slide-exit--top-right {
  animation-name: Toastify__slideOutRight;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
}

.password-toggle {
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 90%;
  z-index: 3;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/styles/bootstrap.scss","webpack://./src/styles/GlobalStyles.scss","webpack://./src/styles/DataTable.scss","webpack://./src/styles/Login_Form.scss","webpack://./src/styles/Nav_SIdebar.scss","webpack://./src/styles/Dashboard.scss","webpack://./src/styles/New_Design.scss","webpack://./src/styles/Products_Modal.scss","webpack://./src/styles/Sub_Checkbox.scss","webpack://./src/styles/Media.scss","webpack://./src/styles/toast.scss","webpack://./src/styles/passwordToggle.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;EAAA;AAKG;EAAM,cAAA;EAAe,gBAAA;EAAiB,gBAAA;EAAiB,cAAA;EAAe,aAAA;EAAc,gBAAA;EAAiB,gBAAA;EAAiB,eAAA;EAAgB,cAAA;EAAe,cAAA;EAAe,YAAA;EAAa,cAAA;EAAe,mBAAA;EAAoB,iBAAA;EAAkB,mBAAA;EAAoB,iBAAA;EAAkB,cAAA;EAAe,iBAAA;EAAkB,gBAAA;EAAiB,eAAA;EAAgB,cAAA;EAAe,iBAAA;EAAkB,qBAAA;EAAsB,qBAAA;EAAsB,qBAAA;EAAsB,sBAAA;EAAuB,mMAAA;EAAoM,sGAAA;ADmC/oB;;ACnCsvB;EAAmB,sBAAA;ADuCzwB;;ACvC+xB;EAAK,uBAAA;EAAuB,iBAAA;EAAiB,8BAAA;EAA8B,wCAAA;AD8C12B;;AC9Ck5B;EAAsE,cAAA;ADkDx9B;;AClDs+B;EAAK,SAAA;EAAS,kMAAA;EAAuL,eAAA;EAAe,gBAAA;EAAgB,gBAAA;EAAgB,cAAA;EAAc,gBAAA;EAAgB,sBAAA;AD6DxvC;;AC7D8wC;EAA0C,qBAAA;ADiExzC;;ACjE40C;EAAG,uBAAA;EAAuB,SAAA;EAAS,iBAAA;ADuE/2C;;ACvEg4C;EAAkB,aAAA;EAAa,qBAAA;AD4E/5C;;AC5Em7C;EAAE,aAAA;EAAa,mBAAA;ADiFl8C;;ACjFq9C;EAAsC,0BAAA;EAA0B,yCAAA;EAAyC,iCAAA;EAAiC,YAAA;EAAY,gBAAA;EAAsD,8BAAA;AD2FjqD;;AC3F+rD;EAAQ,mBAAA;EAAmB,kBAAA;EAAkB,oBAAA;ADiG5uD;;ACjGgwD;EAAS,aAAA;EAAa,mBAAA;ADsGtxD;;ACtGyyD;EAAwB,gBAAA;AD0Gj0D;;AC1Gi1D;EAAG,gBAAA;AD8Gp1D;;AC9Go2D;EAAG,qBAAA;EAAoB,cAAA;ADmH33D;;ACnHy4D;EAAW,gBAAA;ADuHp5D;;ACvHo6D;EAAS,mBAAA;AD2H76D;;AC3Hg8D;EAAM,cAAA;AD+Ht8D;;AC/Ho9D;EAAQ,kBAAA;EAAkB,cAAA;EAAc,cAAA;EAAc,wBAAA;ADsI1gE;;ACtIkiE;EAAI,eAAA;AD0ItiE;;AC1IojE;EAAI,WAAA;AD8IxjE;;AC9IkkE;EAAE,cAAA;EAAc,qBAAA;EAAqB,6BAAA;ADoJvmE;;ACpJooE;EAAQ,cAAA;EAAc,0BAAA;ADyJ1pE;;ACzJorE;EAAc,cAAA;EAAc,qBAAA;AD8JhtE;;AC9JquE;EAAoB,cAAA;EAAc,qBAAA;ADmKvwE;;ACnK4xE;EAAkB,iGAAA;EAA2F,cAAA;ADwKz4E;;ACxKu5E;EAAI,aAAA;EAAa,mBAAA;EAAmB,cAAA;AD8K37E;;AC9Ky8E;EAAO,gBAAA;ADkLh9E;;AClLg+E;EAAI,sBAAA;EAAsB,kBAAA;ADuL1/E;;ACvL4gF;EAAI,gBAAA;EAAgB,sBAAA;AD4LhiF;;AC5LsjF;EAAM,yBAAA;ADgM5jF;;AChMqlF;EAAQ,oBAAA;EAAmB,uBAAA;EAAsB,cAAA;EAAc,gBAAA;EAAgB,oBAAA;ADwMpqF;;ACxMwrF;EAAG,mBAAA;AD4M3rF;;AC5M8sF;EAAM,qBAAA;EAAqB,qBAAA;ADiNzuF;;ACjN6vF;EAAO,gBAAA;ADqNpwF;;ACrNoxF;EAAa,mBAAA;EAAmB,0CAAA;AD0NpzF;;AC1N81F;EAAsC,SAAA;EAAS,oBAAA;EAAoB,kBAAA;EAAkB,oBAAA;ADiOn7F;;ACjOu8F;EAAa,iBAAA;ADqOp9F;;ACrOq+F;EAAc,oBAAA;ADyOn/F;;ACzOugG;EAAO,iBAAA;AD6O9gG;;AC7O+hG;EAAgD,0BAAA;ADiP/kG;;ACjPymG;EAA4G,eAAA;ADqPrtG;;ACrPouG;EAAwH,UAAA;EAAU,kBAAA;AD0Pt2G;;AC1Pw3G;EAAuC,sBAAA;EAAsB,UAAA;AD+Pr7G;;AC/P+7G;EAA+E,2BAAA;ADmQ9gH;;ACnQyiH;EAAS,cAAA;EAAc,gBAAA;ADwQhkH;;ACxQglH;EAAS,YAAA;EAAY,UAAA;EAAU,SAAA;EAAS,SAAA;AD+QxnH;;AC/QioH;EAAO,cAAA;EAAc,WAAA;EAAW,eAAA;EAAe,UAAA;EAAU,qBAAA;EAAoB,iBAAA;EAAiB,oBAAA;EAAoB,cAAA;EAAc,mBAAA;AD2RjwH;;AC3RoxH;EAAS,wBAAA;AD+R7xH;;AC/RqzH;EAAkF,YAAA;ADmSv4H;;ACnSm5H;EAAc,oBAAA;EAAoB,wBAAA;ADwSr7H;;ACxS68H;EAAyC,wBAAA;AD4St/H;;AC5S8gI;EAA6B,aAAA;EAAa,0BAAA;ADiTxjI;;ACjTklI;EAAO,qBAAA;ADqTzlI;;ACrT8mI;EAAQ,kBAAA;EAAkB,eAAA;AD0TxoI;;AC1TupI;EAAS,aAAA;AD8ThqI;;AC9T6qI;EAAS,wBAAA;ADkUtrI;;AClU6sI;EAA0C,qBAAA;EAAoB,gBAAA;EAAgB,gBAAA;ADwU3xI;;ACxU2yI;EAAO,iBAAA;AD4UlzI;;AC5Um0I;EAAO,eAAA;ADgV10I;;AChVy1I;EAAO,kBAAA;ADoVh2I;;ACpVk3I;EAAO,iBAAA;ADwVz3I;;ACxV04I;EAAO,kBAAA;AD4Vj5I;;AC5Vm6I;EAAO,eAAA;ADgW16I;;AChWy7I;EAAM,kBAAA;EAAkB,gBAAA;ADqWj9I;;ACrWi+I;EAAW,eAAA;EAAe,gBAAA;EAAgB,gBAAA;AD2W3gJ;;AC3W2hJ;EAAW,iBAAA;EAAiB,gBAAA;EAAgB,gBAAA;ADiXvkJ;;ACjXulJ;EAAW,iBAAA;EAAiB,gBAAA;EAAgB,gBAAA;ADuXnoJ;;ACvXmpJ;EAAW,iBAAA;EAAiB,gBAAA;EAAgB,gBAAA;AD6X/rJ;;AC7X+sJ;EAAG,gBAAA;EAAgB,mBAAA;EAAmB,SAAA;EAAS,wCAAA;ADoY9vJ;;ACpYkyJ;EAAa,cAAA;EAAc,gBAAA;ADyY7zJ;;ACzY60J;EAAW,cAAA;EAAa,yBAAA;AD8Yr2J;;AC9Y83J;EAAe,eAAA;EAAe,gBAAA;ADmZ55J;;ACnZ46J;EAAa,eAAA;EAAe,gBAAA;ADwZx8J;;ACxZw9J;EAAkB,qBAAA;AD4Z1+J;;AC5Z+/J;EAAmC,oBAAA;ADgaliK;;AChaqjK;EAAY,cAAA;EAAc,yBAAA;ADqa/kK;;ACrawmK;EAAY,mBAAA;EAAmB,kBAAA;AD0avoK;;AC1aypK;EAAmB,cAAA;EAAc,cAAA;EAAc,cAAA;ADgbxsK;;AChbstK;EAA2B,aAAA;ADobjvK;;ACpbswK;EAAW,eAAA;EAAe,YAAA;ADybhyK;;ACzb4yK;EAAe,gBAAA;EAAe,sBAAA;EAAsB,yBAAA;EAAyB,sBAAA;EAAqB,eAAA;EAAe,YAAA;ADkc75K;;AClcy6K;EAAQ,qBAAA;ADscj7K;;ACtcs8K;EAAY,qBAAA;EAAoB,cAAA;AD2ct+K;;AC3co/K;EAAgB,cAAA;EAAc,cAAA;ADgdlhL;;AChdgiL;EAAK,gBAAA;EAAgB,cAAA;EAAc,qBAAA;ADsdnkL;;ACtdwlL;EAAO,cAAA;AD0d/lL;;AC1d6mL;EAAI,sBAAA;EAAoB,gBAAA;EAAgB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADkezrL;;ACle6sL;EAAQ,UAAA;EAAU,eAAA;EAAe,gBAAA;ADwe9uL;;ACxe8vL;EAAI,cAAA;EAAc,gBAAA;EAAgB,cAAA;AD8ehyL;;AC9e8yL;EAAS,kBAAA;EAAkB,cAAA;EAAc,kBAAA;ADofv1L;;ACpfy2L;EAAgB,iBAAA;EAAiB,kBAAA;ADyf14L;;ACzf45L;EAAW,WAAA;EAAW,mBAAA;EAAmB,kBAAA;EAAkB,kBAAA;EAAkB,iBAAA;ADigBz+L;;ACjgB0/L;EAAyB;IAAW,gBAAA;EDsgB5hM;AACF;ACvgB+iM;EAAyB;IAAW,gBAAA;ED2gBjlM;AACF;AC5gBomM;EAAyB;IAAW,gBAAA;EDghBtoM;AACF;ACjhBypM;EAA0B;IAAW,iBAAA;EDqhB5rM;AACF;ACthBgtM;EAAyE,WAAA;EAAW,mBAAA;EAAmB,kBAAA;EAAkB,kBAAA;EAAkB,iBAAA;AD6hB31M;;AC7hB42M;EAAyB;IAAyB,gBAAA;EDkiB55M;AACF;ACniB+6M;EAAyB;IAAuC,gBAAA;EDuiB7+M;AACF;ACxiBggN;EAAyB;IAAqD,gBAAA;ED4iB5kN;AACF;AC7iB+lN;EAA0B;IAAmE,iBAAA;EDijB1rN;AACF;ACljB8sN;EAAyB,aAAA;EAAgC,eAAA;EAAe,mBAAA;EAAmB,kBAAA;AD0jBzyN;;AC1jB2zN;EAAY,eAAA;EAAe,cAAA;AD+jBt1N;;AC/jBo2N;EAA2C,gBAAA;EAAgB,eAAA;ADokB/5N;;ACpkB86N;EAAsqB,kBAAA;EAAkB,WAAA;EAAW,mBAAA;EAAmB,kBAAA;AD2kBpoP;;AC3kBspP;EAA+B,aAAA;EAAiC,YAAA;EAAY,eAAA;ADmlBluP;;ACnlBivP;EAAgC,cAAA;EAAc,eAAA;ADylB/xP;;ACzlB8yP;EAA+B,aAAA;EAAa,cAAA;AD+lB11P;;AC/lBw2P;EAAsC,oBAAA;EAAoB,qBAAA;ADqmBl6P;;ACrmBu7P;EAA+B,aAAA;EAAa,cAAA;AD2mBn+P;;AC3mBi/P;EAA+B,aAAA;EAAa,cAAA;ADinB7hQ;;ACjnB2iQ;EAAsC,oBAAA;EAAoB,qBAAA;ADunBrmQ;;ACvnB0nQ;EAA4B,cAAA;EAAc,WAAA;EAAW,eAAA;AD8nB/qQ;;AC9nB8rQ;EAA8B,mBAAA;EAAmB,oBAAA;ADooB/uQ;;ACpoBmwQ;EAA+B,oBAAA;EAAoB,qBAAA;AD0oBtzQ;;AC1oB20Q;EAAwB,aAAA;EAAa,cAAA;ADgpBh3Q;;AChpB83Q;EAA+B,oBAAA;EAAoB,qBAAA;ADspBj7Q;;ACtpBs8Q;EAA+B,oBAAA;EAAoB,qBAAA;AD4pBz/Q;;AC5pB8gR;EAAwB,aAAA;EAAa,cAAA;ADkqBnjR;;AClqBikR;EAA+B,oBAAA;EAAoB,qBAAA;ADwqBpnR;;ACxqByoR;EAA+B,oBAAA;EAAoB,qBAAA;AD8qB5rR;;AC9qBitR;EAAwB,aAAA;EAAa,cAAA;ADorBtvR;;ACprBowR;EAAgC,oBAAA;EAAoB,qBAAA;AD0rBxzR;;AC1rB60R;EAAgC,oBAAA;EAAoB,qBAAA;ADgsBj4R;;AChsBs5R;EAA0B,cAAA;EAAc,eAAA;ADssB97R;;ACtsB68R;EAA+B,SAAA;AD2sB5+R;;AC3sBq/R;EAA8B,SAAA;ADgtBnhS;;AChtB4hS;EAA0B,QAAA;ADqtBtjS;;ACrtB8jS;EAA0B,QAAA;AD0tBxlS;;AC1tBgmS;EAA0B,QAAA;AD+tB1nS;;AC/tBkoS;EAA0B,QAAA;ADouB5pS;;ACpuBoqS;EAA0B,QAAA;ADyuB9rS;;ACzuBssS;EAA0B,QAAA;AD8uBhuS;;AC9uBwuS;EAA0B,QAAA;ADmvBlwS;;ACnvB0wS;EAA0B,QAAA;ADwvBpyS;;ACxvB4yS;EAA0B,QAAA;AD6vBt0S;;AC7vB80S;EAA0B,QAAA;ADkwBx2S;;AClwBg3S;EAA4B,SAAA;ADuwB54S;;ACvwBq5S;EAA4B,SAAA;AD4wBj7S;;AC5wB07S;EAA4B,SAAA;ADixBt9S;;ACjxB+9S;EAAU,sBAAA;ADqxBz+S;;ACrxB+/S;EAAU,uBAAA;ADyxBzgT;;ACzxBgiT;EAAU,gBAAA;AD6xB1iT;;AC7xB0jT;EAAU,uBAAA;ADiyBpkT;;ACjyB2lT;EAAU,uBAAA;ADqyBrmT;;ACryB4nT;EAAU,gBAAA;ADyyBtoT;;ACzyBspT;EAAU,uBAAA;AD6yBhqT;;AC7yBurT;EAAU,uBAAA;ADizBjsT;;ACjzBwtT;EAAU,gBAAA;ADqzBluT;;ACrzBkvT;EAAW,uBAAA;ADyzB7vT;;ACzzBoxT;EAAW,uBAAA;AD6zB/xT;;AC7zBszT;EAAyB;IAAkC,aAAA;IAAiC,YAAA;IAAY,eAAA;EDs0B55T;ECt0B26T;IAAmC,cAAA;IAAc,eAAA;ED20B59T;EC30B2+T;IAAkC,aAAA;IAAa,cAAA;EDg1B1hU;ECh1BwiU;IAAyC,oBAAA;IAAoB,qBAAA;EDq1BrmU;ECr1B0nU;IAAkC,aAAA;IAAa,cAAA;ED01BzqU;EC11BurU;IAAkC,aAAA;IAAa,cAAA;ED+1BtuU;EC/1BovU;IAAyC,oBAAA;IAAoB,qBAAA;EDo2BjzU;ECp2Bs0U;IAA+B,cAAA;IAAc,WAAA;IAAW,eAAA;ED02B93U;EC12B64U;IAAiC,mBAAA;IAAmB,oBAAA;ED+2Bj8U;EC/2Bq9U;IAAkC,oBAAA;IAAoB,qBAAA;EDo3B3gV;ECp3BgiV;IAA2B,aAAA;IAAa,cAAA;EDy3BxkV;ECz3BslV;IAAkC,oBAAA;IAAoB,qBAAA;ED83B5oV;EC93BiqV;IAAkC,oBAAA;IAAoB,qBAAA;EDm4BvtV;ECn4B4uV;IAA2B,aAAA;IAAa,cAAA;EDw4BpxV;ECx4BkyV;IAAkC,oBAAA;IAAoB,qBAAA;ED64Bx1V;EC74B62V;IAAkC,oBAAA;IAAoB,qBAAA;EDk5Bn6V;ECl5Bw7V;IAA2B,aAAA;IAAa,cAAA;EDu5Bh+V;ECv5B8+V;IAAmC,oBAAA;IAAoB,qBAAA;ED45BriW;EC55B0jW;IAAmC,oBAAA;IAAoB,qBAAA;EDi6BjnW;ECj6BsoW;IAA6B,cAAA;IAAc,eAAA;EDs6BjrW;ECt6BgsW;IAAkC,SAAA;ED06BluW;EC16B2uW;IAAiC,SAAA;ED86B5wW;EC96BqxW;IAA6B,QAAA;EDk7BlzW;ECl7B0zW;IAA6B,QAAA;EDs7Bv1W;ECt7B+1W;IAA6B,QAAA;ED07B53W;EC17Bo4W;IAA6B,QAAA;ED87Bj6W;EC97By6W;IAA6B,QAAA;EDk8Bt8W;ECl8B88W;IAA6B,QAAA;EDs8B3+W;ECt8Bm/W;IAA6B,QAAA;ED08BhhX;EC18BwhX;IAA6B,QAAA;ED88BrjX;EC98B6jX;IAA6B,QAAA;EDk9B1lX;ECl9BkmX;IAA6B,QAAA;EDs9B/nX;ECt9BuoX;IAA+B,SAAA;ED09BtqX;EC19B+qX;IAA+B,SAAA;ED89B9sX;EC99ButX;IAA+B,SAAA;EDk+BtvX;ECl+B+vX;IAAa,cAAA;EDq+B5wX;ECr+B0xX;IAAa,sBAAA;EDw+BvyX;ECx+B6zX;IAAa,uBAAA;ED2+B10X;EC3+Bi2X;IAAa,gBAAA;ED8+B92X;EC9+B83X;IAAa,uBAAA;EDi/B34X;ECj/Bk6X;IAAa,uBAAA;EDo/B/6X;ECp/Bs8X;IAAa,gBAAA;EDu/Bn9X;ECv/Bm+X;IAAa,uBAAA;ED0/Bh/X;EC1/BugY;IAAa,uBAAA;ED6/BphY;EC7/B2iY;IAAa,gBAAA;EDggCxjY;EChgCwkY;IAAc,uBAAA;EDmgCtlY;ECngC6mY;IAAc,uBAAA;EDsgC3nY;AACF;ACvgCqpY;EAAyB;IAAkC,aAAA;IAAiC,YAAA;IAAY,eAAA;ED+gC3vY;EC/gC0wY;IAAmC,cAAA;IAAc,eAAA;EDohC3zY;ECphC00Y;IAAkC,aAAA;IAAa,cAAA;EDyhCz3Y;ECzhCu4Y;IAAyC,oBAAA;IAAoB,qBAAA;ED8hCp8Y;EC9hCy9Y;IAAkC,aAAA;IAAa,cAAA;EDmiCxgZ;ECniCshZ;IAAkC,aAAA;IAAa,cAAA;EDwiCrkZ;ECxiCmlZ;IAAyC,oBAAA;IAAoB,qBAAA;ED6iChpZ;EC7iCqqZ;IAA+B,cAAA;IAAc,WAAA;IAAW,eAAA;EDmjC7tZ;ECnjC4uZ;IAAiC,mBAAA;IAAmB,oBAAA;EDwjChyZ;ECxjCozZ;IAAkC,oBAAA;IAAoB,qBAAA;ED6jC12Z;EC7jC+3Z;IAA2B,aAAA;IAAa,cAAA;EDkkCv6Z;EClkCq7Z;IAAkC,oBAAA;IAAoB,qBAAA;EDukC3+Z;ECvkCgga;IAAkC,oBAAA;IAAoB,qBAAA;ED4kCtja;EC5kC2ka;IAA2B,aAAA;IAAa,cAAA;EDilCnna;ECjlCioa;IAAkC,oBAAA;IAAoB,qBAAA;EDslCvra;ECtlC4sa;IAAkC,oBAAA;IAAoB,qBAAA;ED2lClwa;EC3lCuxa;IAA2B,aAAA;IAAa,cAAA;EDgmC/za;EChmC60a;IAAmC,oBAAA;IAAoB,qBAAA;EDqmCp4a;ECrmCy5a;IAAmC,oBAAA;IAAoB,qBAAA;ED0mCh9a;EC1mCq+a;IAA6B,cAAA;IAAc,eAAA;ED+mChhb;EC/mC+hb;IAAkC,SAAA;EDmnCjkb;ECnnC0kb;IAAiC,SAAA;EDunC3mb;ECvnConb;IAA6B,QAAA;ED2nCjpb;EC3nCypb;IAA6B,QAAA;ED+nCtrb;EC/nC8rb;IAA6B,QAAA;EDmoC3tb;ECnoCmub;IAA6B,QAAA;EDuoChwb;ECvoCwwb;IAA6B,QAAA;ED2oCryb;EC3oC6yb;IAA6B,QAAA;ED+oC10b;EC/oCk1b;IAA6B,QAAA;EDmpC/2b;ECnpCu3b;IAA6B,QAAA;EDupCp5b;ECvpC45b;IAA6B,QAAA;ED2pCz7b;EC3pCi8b;IAA6B,QAAA;ED+pC99b;EC/pCs+b;IAA+B,SAAA;EDmqCrgc;ECnqC8gc;IAA+B,SAAA;EDuqC7ic;ECvqCsjc;IAA+B,SAAA;ED2qCrlc;EC3qC8lc;IAAa,cAAA;ED8qC3mc;EC9qCync;IAAa,sBAAA;EDirCtoc;ECjrC4pc;IAAa,uBAAA;EDorCzqc;ECprCgsc;IAAa,gBAAA;EDurC7sc;ECvrC6tc;IAAa,uBAAA;ED0rC1uc;EC1rCiwc;IAAa,uBAAA;ED6rC9wc;EC7rCqyc;IAAa,gBAAA;EDgsClzc;EChsCk0c;IAAa,uBAAA;EDmsC/0c;ECnsCs2c;IAAa,uBAAA;EDssCn3c;ECtsC04c;IAAa,gBAAA;EDysCv5c;ECzsCu6c;IAAc,uBAAA;ED4sCr7c;EC5sC48c;IAAc,uBAAA;ED+sC19c;AACF;AChtCo/c;EAAyB;IAAkC,aAAA;IAAiC,YAAA;IAAY,eAAA;EDwtC1ld;ECxtCymd;IAAmC,cAAA;IAAc,eAAA;ED6tC1pd;EC7tCyqd;IAAkC,aAAA;IAAa,cAAA;EDkuCxtd;ECluCsud;IAAyC,oBAAA;IAAoB,qBAAA;EDuuCnyd;ECvuCwzd;IAAkC,aAAA;IAAa,cAAA;ED4uCv2d;EC5uCq3d;IAAkC,aAAA;IAAa,cAAA;EDivCp6d;ECjvCk7d;IAAyC,oBAAA;IAAoB,qBAAA;EDsvC/+d;ECtvCoge;IAA+B,cAAA;IAAc,WAAA;IAAW,eAAA;ED4vC5je;EC5vC2ke;IAAiC,mBAAA;IAAmB,oBAAA;EDiwC/ne;ECjwCmpe;IAAkC,oBAAA;IAAoB,qBAAA;EDswCzse;ECtwC8te;IAA2B,aAAA;IAAa,cAAA;ED2wCtwe;EC3wCoxe;IAAkC,oBAAA;IAAoB,qBAAA;EDgxC10e;EChxC+1e;IAAkC,oBAAA;IAAoB,qBAAA;EDqxCr5e;ECrxC06e;IAA2B,aAAA;IAAa,cAAA;ED0xCl9e;EC1xCg+e;IAAkC,oBAAA;IAAoB,qBAAA;ED+xCthf;EC/xC2if;IAAkC,oBAAA;IAAoB,qBAAA;EDoyCjmf;ECpyCsnf;IAA2B,aAAA;IAAa,cAAA;EDyyC9pf;ECzyC4qf;IAAmC,oBAAA;IAAoB,qBAAA;ED8yCnuf;EC9yCwvf;IAAmC,oBAAA;IAAoB,qBAAA;EDmzC/yf;ECnzCo0f;IAA6B,cAAA;IAAc,eAAA;EDwzC/2f;ECxzC83f;IAAkC,SAAA;ED4zCh6f;EC5zCy6f;IAAiC,SAAA;EDg0C18f;ECh0Cm9f;IAA6B,QAAA;EDo0Ch/f;ECp0Cw/f;IAA6B,QAAA;EDw0CrhgB;ECx0C6hgB;IAA6B,QAAA;ED40C1jgB;EC50CkkgB;IAA6B,QAAA;EDg1C/lgB;ECh1CumgB;IAA6B,QAAA;EDo1CpogB;ECp1C4ogB;IAA6B,QAAA;EDw1CzqgB;ECx1CirgB;IAA6B,QAAA;ED41C9sgB;EC51CstgB;IAA6B,QAAA;EDg2CnvgB;ECh2C2vgB;IAA6B,QAAA;EDo2CxxgB;ECp2CgygB;IAA6B,QAAA;EDw2C7zgB;ECx2Cq0gB;IAA+B,SAAA;ED42Cp2gB;EC52C62gB;IAA+B,SAAA;EDg3C54gB;ECh3Cq5gB;IAA+B,SAAA;EDo3Cp7gB;ECp3C67gB;IAAa,cAAA;EDu3C18gB;ECv3Cw9gB;IAAa,sBAAA;ED03Cr+gB;EC13C2/gB;IAAa,uBAAA;ED63CxghB;EC73C+hhB;IAAa,gBAAA;EDg4C5ihB;ECh4C4jhB;IAAa,uBAAA;EDm4CzkhB;ECn4CgmhB;IAAa,uBAAA;EDs4C7mhB;ECt4CoohB;IAAa,gBAAA;EDy4CjphB;ECz4CiqhB;IAAa,uBAAA;ED44C9qhB;EC54CqshB;IAAa,uBAAA;ED+4ClthB;EC/4CyuhB;IAAa,gBAAA;EDk5CtvhB;ECl5CswhB;IAAc,uBAAA;EDq5CpxhB;ECr5C2yhB;IAAc,uBAAA;EDw5CzzhB;AACF;ACz5Cm1hB;EAA0B;IAAkC,aAAA;IAAiC,YAAA;IAAY,eAAA;EDi6C17hB;ECj6Cy8hB;IAAmC,cAAA;IAAc,eAAA;EDs6C1/hB;ECt6CygiB;IAAkC,aAAA;IAAa,cAAA;ED26CxjiB;EC36CskiB;IAAyC,oBAAA;IAAoB,qBAAA;EDg7CnoiB;ECh7CwpiB;IAAkC,aAAA;IAAa,cAAA;EDq7CvsiB;ECr7CqtiB;IAAkC,aAAA;IAAa,cAAA;ED07CpwiB;EC17CkxiB;IAAyC,oBAAA;IAAoB,qBAAA;ED+7C/0iB;EC/7Co2iB;IAA+B,cAAA;IAAc,WAAA;IAAW,eAAA;EDq8C55iB;ECr8C26iB;IAAiC,mBAAA;IAAmB,oBAAA;ED08C/9iB;EC18Cm/iB;IAAkC,oBAAA;IAAoB,qBAAA;ED+8CzijB;EC/8C8jjB;IAA2B,aAAA;IAAa,cAAA;EDo9CtmjB;ECp9ConjB;IAAkC,oBAAA;IAAoB,qBAAA;EDy9C1qjB;ECz9C+rjB;IAAkC,oBAAA;IAAoB,qBAAA;ED89CrvjB;EC99C0wjB;IAA2B,aAAA;IAAa,cAAA;EDm+ClzjB;ECn+Cg0jB;IAAkC,oBAAA;IAAoB,qBAAA;EDw+Ct3jB;ECx+C24jB;IAAkC,oBAAA;IAAoB,qBAAA;ED6+Cj8jB;EC7+Cs9jB;IAA2B,aAAA;IAAa,cAAA;EDk/C9/jB;ECl/C4gkB;IAAmC,oBAAA;IAAoB,qBAAA;EDu/CnkkB;ECv/CwlkB;IAAmC,oBAAA;IAAoB,qBAAA;ED4/C/okB;EC5/CoqkB;IAA6B,cAAA;IAAc,eAAA;EDigD/skB;ECjgD8tkB;IAAkC,SAAA;EDqgDhwkB;ECrgDywkB;IAAiC,SAAA;EDygD1ykB;ECzgDmzkB;IAA6B,QAAA;ED6gDh1kB;EC7gDw1kB;IAA6B,QAAA;EDihDr3kB;ECjhD63kB;IAA6B,QAAA;EDqhD15kB;ECrhDk6kB;IAA6B,QAAA;EDyhD/7kB;ECzhDu8kB;IAA6B,QAAA;ED6hDp+kB;EC7hD4+kB;IAA6B,QAAA;EDiiDzglB;ECjiDihlB;IAA6B,QAAA;EDqiD9ilB;ECriDsjlB;IAA6B,QAAA;EDyiDnllB;ECziD2llB;IAA6B,QAAA;ED6iDxnlB;EC7iDgolB;IAA6B,QAAA;EDijD7plB;ECjjDqqlB;IAA+B,SAAA;EDqjDpslB;ECrjD6slB;IAA+B,SAAA;EDyjD5ulB;ECzjDqvlB;IAA+B,SAAA;ED6jDpxlB;EC7jD6xlB;IAAa,cAAA;EDgkD1ylB;EChkDwzlB;IAAa,sBAAA;EDmkDr0lB;ECnkD21lB;IAAa,uBAAA;EDskDx2lB;ECtkD+3lB;IAAa,gBAAA;EDykD54lB;ECzkD45lB;IAAa,uBAAA;ED4kDz6lB;EC5kDg8lB;IAAa,uBAAA;ED+kD78lB;EC/kDo+lB;IAAa,gBAAA;EDklDj/lB;ECllDigmB;IAAa,uBAAA;EDqlD9gmB;ECrlDqimB;IAAa,uBAAA;EDwlDljmB;ECxlDykmB;IAAa,gBAAA;ED2lDtlmB;EC3lDsmmB;IAAc,uBAAA;ED8lDpnmB;EC9lD2omB;IAAc,uBAAA;EDimDzpmB;AACF;AClmDmrmB;EAAO,WAAA;EAAW,mBAAA;EAAmB,cAAA;ADumDxtmB;;ACvmDsumB;EAAoB,gBAAA;EAAe,mBAAA;EAAmB,6BAAA;AD6mD5xmB;;AC7mDyzmB;EAAgB,sBAAA;EAAsB,gCAAA;ADknD/1mB;;AClnD+3mB;EAAmB,6BAAA;ADsnDl5mB;;ACtnD+6mB;EAA0B,eAAA;AD0nDz8mB;;AC1nDu9mB;EAAgB,yBAAA;AD8nDv+mB;;AC9nDggnB;EAAsC,yBAAA;ADkoDtinB;;ACloD+jnB;EAAkD,wBAAA;ADsoDjnnB;;ACtoDyonB;EAAmG,SAAA;AD0oD5unB;;AC1oDqvnB;EAAyC,qCAAA;AD8oD9xnB;;AC9oD+znB;EAA4B,cAAA;EAAc,sCAAA;ADmpDz2nB;;ACnpD24nB;EAAmD,yBAAA;ADupD97nB;;ACvpDu9nB;EAAuF,qBAAA;AD2pD9ioB;;AC3pDmkoB;EAAkC,yBAAA;AD+pDrmoB;;AC/pD8noB;EAA0E,yBAAA;ADmqDxsoB;;ACnqDiuoB;EAAyD,yBAAA;ADuqD1xoB;;ACvqDmzoB;EAA+F,qBAAA;AD2qDl5oB;;AC3qDu6oB;EAAoC,yBAAA;AD+qD38oB;;AC/qDo+oB;EAA8E,yBAAA;ADmrDljpB;;ACnrD2kpB;EAAmD,yBAAA;ADurD9npB;;ACvrDuppB;EAAuF,qBAAA;AD2rD9upB;;AC3rDmwpB;EAAkC,yBAAA;AD+rDrypB;;AC/rD8zpB;EAA0E,yBAAA;ADmsDx4pB;;ACnsDi6pB;EAA0C,yBAAA;ADusD38pB;;ACvsDo+pB;EAA2E,qBAAA;AD2sD/iqB;;AC3sDokqB;EAA+B,yBAAA;AD+sDnmqB;;AC/sD4nqB;EAAoE,yBAAA;ADmtDhsqB;;ACntDytqB;EAAmD,yBAAA;ADutD5wqB;;ACvtDqyqB;EAAuF,qBAAA;AD2tD53qB;;AC3tDi5qB;EAAkC,yBAAA;AD+tDn7qB;;AC/tD48qB;EAA0E,yBAAA;ADmuDthrB;;ACnuD+irB;EAAgD,yBAAA;ADuuD/lrB;;ACvuDwnrB;EAAmF,qBAAA;AD2uD3srB;;AC3uDgurB;EAAiC,yBAAA;AD+uDjwrB;;AC/uD0xrB;EAAwE,yBAAA;ADmvDl2rB;;ACnvD23rB;EAA6C,yBAAA;ADuvDx6rB;;ACvvDi8rB;EAA+E,qBAAA;AD2vDhhsB;;AC3vDqisB;EAAgC,yBAAA;AD+vDrksB;;AC/vD8lsB;EAAsE,yBAAA;ADmwDpqsB;;ACnwD6rsB;EAA0C,yBAAA;ADuwDvusB;;ACvwDgwsB;EAA2E,qBAAA;AD2wD30sB;;AC3wDg2sB;EAA+B,yBAAA;AD+wD/3sB;;AC/wDw5sB;EAAoE,yBAAA;ADmxD59sB;;ACnxDq/sB;EAAgD,sCAAA;ADuxDritB;;ACvxDuktB;EAAiC,sCAAA;AD2xDxmtB;;AC3xD0otB;EAAwE,sCAAA;AD+xDlttB;;AC/xDovtB;EAAsB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADqyD9ytB;;ACryDm0tB;EAAuB,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD2yDj4tB;;AC3yDs5tB;EAAY,WAAA;EAAW,yBAAA;ADgzD76tB;;AChzDs8tB;EAAmD,qBAAA;ADozDz/tB;;ACpzD8guB;EAA2B,SAAA;ADwzDziuB;;ACxzDkjuB;EAAoD,2CAAA;AD4zDtmuB;;AC5zD6ouB;EAAuC,WAAA;EAAW,4CAAA;ADi0D/ruB;;ACj0DuuuB;EAA4B;IAAqB,cAAA;IAAc,WAAA;IAAW,gBAAA;IAAgB,iCAAA;EDy0D/zuB;ECz0Dg2uB;IAAqC,SAAA;ED40Dr4uB;AACF;AC70Di5uB;EAA4B;IAAqB,cAAA;IAAc,WAAA;IAAW,gBAAA;IAAgB,iCAAA;EDo1Dz+uB;ECp1D0gvB;IAAqC,SAAA;EDu1D/ivB;AACF;ACx1D2jvB;EAA4B;IAAqB,cAAA;IAAc,WAAA;IAAW,gBAAA;IAAgB,iCAAA;ED+1DnpvB;EC/1DorvB;IAAqC,SAAA;EDk2DztvB;AACF;ACn2DquvB;EAA6B;IAAqB,cAAA;IAAc,WAAA;IAAW,gBAAA;IAAgB,iCAAA;ED02D9zvB;EC12D+1vB;IAAqC,SAAA;ED62Dp4vB;AACF;AC92Dg5vB;EAAkB,cAAA;EAAc,WAAA;EAAW,gBAAA;EAAgB,iCAAA;ADo3D38vB;;ACp3D4+vB;EAAkC,SAAA;ADw3D9gwB;;ACx3DuhwB;EAAc,cAAA;EAAc,WAAA;EAAW,mCAAA;EAAkC,yBAAA;EAAuB,eAAA;EAAe,gBAAA;EAAgB,gBAAA;EAAgB,cAAA;EAAc,sBAAA;EAAsB,4BAAA;EAA4B,yBAAA;EAAyB,sBAAA;EAAqB,wEAAA;ADw4DpxwB;;ACx4Dy1wB;EAAuC;IAAc,gBAAA;ED64D54wB;AACF;AC94D+5wB;EAA0B,6BAAA;EAA6B,SAAA;ADk5Dt9wB;;ACl5D+9wB;EAA6B,kBAAA;EAAkB,0BAAA;ADu5D9gxB;;ACv5DwixB;EAAoB,cAAA;EAAc,sBAAA;EAAsB,qBAAA;EAAqB,UAAA;EAAU,gDAAA;AD+5D/nxB;;AC/5D45xB;EAA2B,cAAA;EAAc,UAAA;ADw7Dr8xB;;ACx7D+8xB;EAA+C,yBAAA;EAAyB,UAAA;AD67DvhyB;;AC77DiiyB;EAAqC,cAAA;EAAc,sBAAA;ADk8DplyB;;ACl8D0myB;EAAuC,cAAA;EAAc,WAAA;ADu8D/pyB;;ACv8D0qyB;EAAgB,iCAAA;EAAgC,oCAAA;EAAmC,gBAAA;EAAgB,kBAAA;EAAkB,gBAAA;AD+8D/xyB;;AC/8D+yyB;EAAmB,+BAAA;EAA8B,kCAAA;EAAiC,kBAAA;EAAkB,gBAAA;ADs9Dn5yB;;ACt9Dm6yB;EAAmB,gCAAA;EAA+B,mCAAA;EAAkC,mBAAA;EAAkB,gBAAA;AD69DzgzB;;AC79DyhzB;EAAwB,cAAA;EAAc,WAAA;EAAW,mBAAA;EAAkB,gBAAA;EAAgB,eAAA;EAAe,gBAAA;EAAgB,cAAA;EAAc,6BAAA;EAA6B,yBAAA;EAAyB,mBAAA;AD0+D/szB;;AC1+DkuzB;EAAgF,gBAAA;EAAgB,eAAA;AD++Dl0zB;;AC/+Di1zB;EAAiB,kCAAA;EAAiC,uBAAA;EAAqB,mBAAA;EAAkB,gBAAA;EAAgB,qBAAA;ADu/D17zB;;ACv/D88zB;EAAiB,gCAAA;EAAgC,oBAAA;EAAmB,kBAAA;EAAkB,gBAAA;EAAgB,qBAAA;AD+/Dpj0B;;AC//Dwk0B;EAAwD,YAAA;ADmgEho0B;;ACngE4o0B;EAAsB,YAAA;ADugElq0B;;ACvgE8q0B;EAAY,mBAAA;AD2gE1r0B;;AC3gE6s0B;EAAW,cAAA;EAAc,mBAAA;ADghEtu0B;;AChhEwv0B;EAA8B,aAAA;EAAgC,eAAA;EAAe,kBAAA;EAAkB,iBAAA;ADyhEv10B;;ACzhEw20B;EAAuC,kBAAA;EAAkB,iBAAA;AD8hEj60B;;AC9hEk70B;EAAY,kBAAA;EAAkB,cAAA;EAAc,qBAAA;ADoiE990B;;ACpiEm/0B;EAAkB,kBAAA;EAAkB,kBAAA;EAAiB,qBAAA;AD0iExi1B;;AC1iE6j1B;EAA2F,cAAA;AD8iExp1B;;AC9iEsq1B;EAAkB,gBAAA;ADkjExr1B;;ACljEws1B;EAA8C,oBAAA;EAA0C,mBAAA;EAAmB,eAAA;EAAe,qBAAA;AD2jEl01B;;AC3jEs11B;EAAqC,gBAAA;EAAgB,aAAA;EAAa,uBAAA;EAAsB,cAAA;ADkkE961B;;AClkE471B;EAAgB,aAAA;EAAa,WAAA;EAAW,mBAAA;EAAkB,cAAA;EAAc,cAAA;AD0kEpg2B;;AC1kEkh2B;EAAe,kBAAA;EAAkB,SAAA;EAAS,UAAA;EAAU,aAAA;EAAa,eAAA;EAAe,uBAAA;EAAqB,kBAAA;EAAiB,mBAAA;EAAkB,gBAAA;EAAgB,WAAA;EAAW,wCAAA;EAAoC,sBAAA;ADylEzt2B;;ACzlE8u2B;EAA8H,cAAA;AD6lE522B;;AC7lE032B;EAA0D,qBAAA;EAAqB,oCAAA;EAAmC,yDAAA;EAAiR,4BAAA;EAA4B,2DAAA;EAAyD,gEAAA;ADsmEl13B;;ACtmE843B;EAAsE,qBAAA;EAAqB,gDAAA;AD2mEz+3B;;AC3mEoh4B;EAA0E,oCAAA;EAAmC,kFAAA;ADgnEjo4B;;AChnE+s4B;EAA4D,qBAAA;EAAqB,uCAAA;EAAsC,wNAAA;ADsnEt04B;;ACtnEu35B;EAAwE,qBAAA;EAAqB,gDAAA;AD2nEp95B;;AC3nE+/5B;EAAsG,cAAA;AD+nErm6B;;AC/nEmn6B;EAAkM,cAAA;ADmoErz6B;;ACnoEm06B;EAAsH,cAAA;ADuoEz76B;;ACvoEu86B;EAAsI,qBAAA;AD2oE7k7B;;AC3oEkm7B;EAAsJ,qBAAA;EAAqB,yBAAA;ADgpE7w7B;;AChpEsy7B;EAAkJ,gDAAA;ADopEx77B;;ACppEm+7B;EAA8K,qBAAA;ADwpEjp8B;;ACxpEsq8B;EAA0G,qBAAA;AD4pEhx8B;;AC5pEqy8B;EAAsH,qBAAA;EAAqB,gDAAA;ADiqEh78B;;ACjqE298B;EAAkB,aAAA;EAAa,WAAA;EAAW,mBAAA;EAAkB,cAAA;EAAc,cAAA;ADyqEri9B;;ACzqEmj9B;EAAiB,kBAAA;EAAkB,SAAA;EAAS,UAAA;EAAU,aAAA;EAAa,eAAA;EAAe,uBAAA;EAAqB,kBAAA;EAAiB,mBAAA;EAAkB,gBAAA;EAAgB,WAAA;EAAW,wCAAA;EAAoC,sBAAA;ADwrE5v9B;;ACxrEix9B;EAA8I,cAAA;AD4rE/59B;;AC5rE669B;EAA8D,qBAAA;EAAqB,oCAAA;EAAmC,yDAAA;EAA4U,4BAAA;EAA4B,2DAAA;EAAyD,gEAAA;ADqsEp8+B;;ACrsEgg/B;EAA0E,qBAAA;EAAqB,gDAAA;AD0sE/l/B;;AC1sE0o/B;EAA8E,oCAAA;EAAmC,kFAAA;AD+sE3v/B;;AC/sEy0/B;EAAgE,qBAAA;EAAqB,uCAAA;EAAsC,wNAAA;ADqtEp8/B;;ACrtEgjhC;EAA4E,qBAAA;EAAqB,gDAAA;AD0tEjphC;;AC1tE4rhC;EAA0G,cAAA;AD8tEtyhC;;AC9tEozhC;EAAkN,cAAA;ADkuEtgiC;;ACluEohiC;EAA0H,cAAA;ADsuE9oiC;;ACtuE4piC;EAA0I,qBAAA;AD0uEtyiC;;AC1uE2ziC;EAA0J,qBAAA;EAAqB,yBAAA;AD+uE1+iC;;AC/uEmgjC;EAAsJ,gDAAA;ADmvEzpjC;;ACnvEosjC;EAAkL,qBAAA;ADuvEt3jC;;ACvvE24jC;EAA8G,qBAAA;AD2vEz/jC;;AC3vE8gkC;EAA0H,qBAAA;EAAqB,gDAAA;ADgwE7pkC;;AChwEwskC;EAAiC,aAAA;EAAoC,mBAAA;EAAyC,mBAAA;ADywEtzkC;;ACzwEy0kC;EAAyB,WAAA;AD6wEl2kC;;AC7wE62kC;EAAyB;IAAuC,aAAA;IAAmC,mBAAA;IAAwC,uBAAA;IAAuB,gBAAA;EDwxE7glC;ECxxE6hlC;IAA6C,aAAA;IAA+B,cAAA;IAAqC,mBAAA;IAAyC,mBAAA;IAAmB,gBAAA;EDmyE1slC;ECnyE0tlC;IAA2B,qBAAA;IAAqB,WAAA;IAAW,sBAAA;EDwyErxlC;ECxyE2ylC;IAAqC,qBAAA;ED2yEh1lC;EC3yEq2lC;IAAsD,WAAA;ED8yE35lC;EC9yEs6lC;IAA6C,aAAA;IAAmC,mBAAA;IAAwC,uBAAA;IAAuB,WAAA;IAAW,eAAA;EDwzEhkmC;ECxzE+kmC;IAA+B,kBAAA;IAAsC,cAAA;IAAc,aAAA;IAAa,qBAAA;IAAoB,cAAA;EDg0EnsmC;ECh0EitmC;IAAmD,mBAAA;IAAwC,uBAAA;EDs0E5ymC;ECt0Em0mC;IAAmC,gBAAA;EDy0Et2mC;AACF;AC10Ey3mC;EAAK,qBAAA;EAAqB,gBAAA;EAAgB,cAAA;EAAc,kBAAA;EAAkB,sBAAA;EAAsB,eAAA;EAAe,yBAAA;EAAoE,iBAAA;EAAiB,6BAAA;EAA6B,6BAAA;EAA6B,yBAAA;EAAuB,eAAA;EAAe,gBAAA;EAAgB,sBAAA;EAAqB,qIAAA;AD61ElsnC;;AC71Eg0nC;EAAuC;IAAK,gBAAA;EDk2E12nC;AACF;ACn2E63nC;EAAW,cAAA;EAAc,qBAAA;ADu2Et5nC;;ACv2E26nC;EAAsB,UAAA;EAAU,gDAAA;AD42E38nC;;AC52Es/nC;EAA4B,aAAA;ADg3ElhoC;;ACh3E8hoC;EAAuC,oBAAA;ADo3ErkoC;;ACp3EyloC;EAAa,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD03E1ooC;;AC13E+poC;EAAmB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADg4EttoC;;ACh4E2uoC;EAAsC,WAAA;EAAW,yBAAA;EAAyB,qBAAA;EAAqB,gDAAA;ADu4E10oC;;ACv4Eq3oC;EAA4C,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD64Er8oC;;AC74E09oC;EAAuI,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADm5EropC;;ACn5E0ppC;EAAyJ,gDAAA;ADu5EnzpC;;ACv5E81pC;EAAe,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD65Ej5pC;;AC75Es6pC;EAAqB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADm6E/9pC;;ACn6Eo/pC;EAA0C,WAAA;EAAW,yBAAA;EAAyB,qBAAA;EAAqB,iDAAA;AD06EvlqC;;AC16EmoqC;EAAgD,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADg7EvtqC;;ACh7E4uqC;EAA6I,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADs7E75qC;;ACt7Ek7qC;EAA+J,iDAAA;AD07EjlrC;;AC17E6nrC;EAAa,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADg8E9qrC;;ACh8EmsrC;EAAmB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADs8E1vrC;;ACt8E+wrC;EAAsC,WAAA;EAAW,yBAAA;EAAyB,qBAAA;EAAqB,+CAAA;AD68E92rC;;AC78Ew5rC;EAA4C,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADm9Ex+rC;;ACn9E6/rC;EAAuI,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADy9ExqsC;;ACz9E6rsC;EAAyJ,+CAAA;AD69Et1sC;;AC79Eg4sC;EAAU,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADm+E96sC;;ACn+Em8sC;EAAgB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADy+Ev/sC;;ACz+E4gtC;EAAgC,WAAA;EAAW,yBAAA;EAAyB,qBAAA;EAAqB,gDAAA;ADg/ErmtC;;ACh/EgptC;EAAsC,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADs/E1ttC;;ACt/E+utC;EAA8H,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD4/Ej5tC;;AC5/Es6tC;EAAgJ,gDAAA;ADggFtjuC;;AChgFimuC;EAAa,cAAA;EAAc,yBAAA;EAAyB,qBAAA;ADsgFrpuC;;ACtgF0quC;EAAmB,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD4gFpuuC;;AC5gFyvuC;EAAsC,cAAA;EAAc,yBAAA;EAAyB,qBAAA;EAAqB,gDAAA;ADmhF31uC;;ACnhFs4uC;EAA4C,cAAA;EAAc,yBAAA;EAAyB,qBAAA;ADyhFz9uC;;ACzhF8+uC;EAAuI,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD+hF5pvC;;AC/hFirvC;EAAyJ,gDAAA;ADmiF10vC;;ACniFq3vC;EAAY,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADyiFr6vC;;ACziF07vC;EAAkB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD+iFh/vC;;AC/iFqgwC;EAAoC,WAAA;EAAW,yBAAA;EAAyB,qBAAA;EAAqB,+CAAA;ADsjFlmwC;;ACtjF4owC;EAA0C,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD4jF1twC;;AC5jF+uwC;EAAoI,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADkkFv5wC;;AClkF46wC;EAAsJ,+CAAA;ADskFlkxC;;ACtkF4mxC;EAAW,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD4kF9pxC;;AC5kFmrxC;EAAiB,cAAA;EAAc,yBAAA;EAAyB,qBAAA;ADklF3uxC;;ACllFgwxC;EAAkC,cAAA;EAAc,yBAAA;EAAyB,qBAAA;EAAqB,iDAAA;ADylF91xC;;ACzlF04xC;EAAwC,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD+lFz9xC;;AC/lF8+xC;EAAiI,cAAA;EAAc,yBAAA;EAAyB,qBAAA;ADqmFtpyC;;ACrmF2qyC;EAAmJ,iDAAA;ADymF9zyC;;ACzmF02yC;EAAU,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD+mFx5yC;;AC/mF66yC;EAAgB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADqnFj+yC;;ACrnFs/yC;EAAgC,WAAA;EAAW,yBAAA;EAAyB,qBAAA;EAAqB,8CAAA;AD4nF/kzC;;AC5nFwnzC;EAAsC,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADkoFlszC;;ACloFutzC;EAA8H,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADwoFz3zC;;ACxoF84zC;EAAgJ,8CAAA;AD4oF9h0C;;AC5oFuk0C;EAAqB,cAAA;EAAc,qBAAA;ADipF1m0C;;ACjpF+n0C;EAA2B,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADupF9r0C;;ACvpFmt0C;EAAsD,+CAAA;AD2pFzw0C;;AC3pFmz0C;EAA4D,cAAA;EAAc,6BAAA;ADgqF730C;;AChqF050C;EAA+J,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADsqF7l1C;;ACtqFkn1C;EAAiL,+CAAA;AD0qFny1C;;AC1qF601C;EAAuB,cAAA;EAAc,qBAAA;AD+qFl31C;;AC/qFu41C;EAA6B,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADqrFx81C;;ACrrF691C;EAA0D,iDAAA;ADyrFvh2C;;ACzrFmk2C;EAAgE,cAAA;EAAc,6BAAA;AD8rFjp2C;;AC9rF8q2C;EAAqK,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADosFv32C;;ACpsF442C;EAAuL,iDAAA;ADwsFnk3C;;ACxsF+m3C;EAAqB,cAAA;EAAc,qBAAA;AD6sFlp3C;;AC7sFuq3C;EAA2B,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADmtFtu3C;;ACntF2v3C;EAAsD,+CAAA;ADutFjz3C;;ACvtF213C;EAA4D,cAAA;EAAc,6BAAA;AD4tFr63C;;AC5tFk83C;EAA+J,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADkuFro4C;;ACluF0p4C;EAAiL,+CAAA;ADsuF304C;;ACtuFq34C;EAAkB,cAAA;EAAc,qBAAA;AD2uFr54C;;AC3uF064C;EAAwB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADivFt+4C;;ACjvF2/4C;EAAgD,gDAAA;ADqvF3i5C;;ACrvFsl5C;EAAsD,cAAA;EAAc,6BAAA;AD0vF1p5C;;AC1vFur5C;EAAsJ,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADgwFj35C;;AChwFs45C;EAAwK,gDAAA;ADowF9i6C;;ACpwFyl6C;EAAqB,cAAA;EAAc,qBAAA;ADywF5n6C;;ACzwFip6C;EAA2B,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD+wFnt6C;;AC/wFwu6C;EAAsD,+CAAA;ADmxF9x6C;;ACnxFw06C;EAA4D,cAAA;EAAc,6BAAA;ADwxFl56C;;ACxxF+66C;EAA+J,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD8xFrn7C;;AC9xF0o7C;EAAiL,+CAAA;ADkyF3z7C;;AClyFq27C;EAAoB,cAAA;EAAc,qBAAA;ADuyFv47C;;ACvyF457C;EAA0B,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD6yF197C;;AC7yF++7C;EAAoD,+CAAA;ADizFni8C;;ACjzF6k8C;EAA0D,cAAA;EAAc,6BAAA;ADszFrp8C;;ACtzFkr8C;EAA4J,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD4zFl38C;;AC5zFu48C;EAA8K,+CAAA;ADg0Frj9C;;ACh0F+l9C;EAAmB,cAAA;EAAc,qBAAA;ADq0Fho9C;;ACr0Fqp9C;EAAyB,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD20Frt9C;;AC30F0u9C;EAAkD,iDAAA;AD+0F5x9C;;AC/0Fw09C;EAAwD,cAAA;EAAc,6BAAA;ADo1F949C;;ACp1F269C;EAAyJ,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD01F3m+C;;AC11Fgo+C;EAA2K,iDAAA;AD81F3y+C;;AC91Fu1+C;EAAkB,cAAA;EAAc,qBAAA;ADm2Fv3+C;;ACn2F44+C;EAAwB,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADy2Fx8+C;;ACz2F69+C;EAAgD,8CAAA;AD62F7g/C;;AC72Fsj/C;EAAsD,cAAA;EAAc,6BAAA;ADk3F1n/C;;ACl3Fup/C;EAAsJ,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADw3Fj1/C;;ACx3Fs2/C;EAAwK,8CAAA;AD43F9ggD;;AC53FujgD;EAAU,gBAAA;EAAgB,cAAA;EAAc,qBAAA;ADk4F/lgD;;ACl4FongD;EAAgB,cAAA;EAAc,0BAAA;ADu4FlpgD;;ACv4F4qgD;EAAgC,0BAAA;EAA0B,gBAAA;AD44FtugD;;AC54FsvgD;EAAsC,cAAA;EAAc,oBAAA;ADi5F1ygD;;ACj5F8zgD;EAA2B,oBAAA;EAAmB,kBAAA;EAAkB,gBAAA;EAAgB,qBAAA;ADw5F94gD;;ACx5Fk6gD;EAA2B,uBAAA;EAAqB,mBAAA;EAAkB,gBAAA;EAAgB,qBAAA;AD+5Fp/gD;;AC/5FwghD;EAAW,cAAA;EAAc,WAAA;ADo6FjihD;;ACp6F4ihD;EAAsB,kBAAA;ADw6FlkhD;;ACx6FmlhD;EAAsF,WAAA;AD46FzqhD;;AC56ForhD;EAAM,gCAAA;ADg7F1rhD;;ACh7FythD;EAAuC;IAAM,gBAAA;EDq7FpwhD;AACF;ACt7FuxhD;EAAiB,UAAA;ADy7FxyhD;;ACz7FkzhD;EAAqB,aAAA;AD67Fv0hD;;AC77Fo1hD;EAAY,kBAAA;EAAkB,SAAA;EAAS,gBAAA;EAAgB,6BAAA;ADo8F34hD;;ACp8Fu6hD;EAAuC;IAAY,gBAAA;EDy8Fx9hD;AACF;AC18F2+hD;EAAuC,kBAAA;AD68FlhiD;;AC78FoiiD;EAAiB,mBAAA;ADi9FrjiD;;ACj9FwkiD;EAAwB,qBAAA;EAAqB,oBAAA;EAAmB,uBAAA;EAAsB,WAAA;EAAW,uBAAA;EAAsB,qCAAA;EAAoC,gBAAA;EAAgB,oCAAA;AD49FnviD;;AC59FsxiD;EAA8B,cAAA;ADg+FpziD;;ACh+Fk0iD;EAAe,kBAAA;EAAkB,SAAA;EAAS,OAAA;EAAO,aAAA;EAAa,aAAA;EAAa,WAAA;EAAW,gBAAA;EAAgB,iBAAA;EAAgB,oBAAA;EAAmB,eAAA;EAAe,cAAA;EAAc,gBAAA;EAAgB,gBAAA;EAAgB,sBAAA;EAAsB,4BAAA;EAA4B,qCAAA;EAAiC,sBAAA;ADo/F3ljD;;ACp/FgnjD;EAAoB,WAAA;EAAW,OAAA;ADy/F/ojD;;ACz/FspjD;EAAqB,QAAA;EAAQ,UAAA;AD8/FnrjD;;AC9/F6rjD;EAAyB;IAAuB,WAAA;IAAW,OAAA;EDogGtvjD;ECpgG6vjD;IAAwB,QAAA;IAAQ,UAAA;EDwgG7xjD;AACF;ACzgG0yjD;EAAyB;IAAuB,WAAA;IAAW,OAAA;ED8gGn2jD;EC9gG02jD;IAAwB,QAAA;IAAQ,UAAA;EDkhG14jD;AACF;ACnhGu5jD;EAAyB;IAAuB,WAAA;IAAW,OAAA;EDwhGh9jD;ECxhGu9jD;IAAwB,QAAA;IAAQ,UAAA;ED4hGv/jD;AACF;AC7hGogkD;EAA0B;IAAuB,WAAA;IAAW,OAAA;EDkiG9jkD;ECliGqkkD;IAAwB,QAAA;IAAQ,UAAA;EDsiGrmkD;AACF;ACviGknkD;EAAuB,SAAA;EAAS,YAAA;EAAY,aAAA;EAAa,uBAAA;AD6iG3qkD;;AC7iGiskD;EAAgC,qBAAA;EAAqB,oBAAA;EAAmB,uBAAA;EAAsB,WAAA;EAAW,aAAA;EAAa,qCAAA;EAAoC,0BAAA;EAAyB,oCAAA;ADwjGp3kD;;ACxjGu5kD;EAAsC,cAAA;AD4jG77kD;;AC5jG28kD;EAA0B,MAAA;EAAM,WAAA;EAAW,UAAA;EAAU,aAAA;EAAa,qBAAA;ADokG7glD;;ACpkGiilD;EAAmC,qBAAA;EAAqB,oBAAA;EAAmB,uBAAA;EAAsB,WAAA;EAAW,mCAAA;EAAkC,eAAA;EAAe,sCAAA;EAAqC,wBAAA;AD+kGnulD;;AC/kG0vlD;EAAyC,cAAA;ADmlGnylD;;ACnlGizlD;EAAmC,iBAAA;ADulGp1lD;;ACvlGq2lD;EAAyB,MAAA;EAAM,WAAA;EAAW,UAAA;EAAU,aAAA;EAAa,sBAAA;AD+lGt6lD;;AC/lG27lD;EAAkC,qBAAA;EAAqB,oBAAA;EAAmB,uBAAA;EAAsB,WAAA;ADsmG3hmD;;ACtmGsimD;EAAkC,aAAA;AD0mGxkmD;;AC1mGqlmD;EAAmC,qBAAA;EAAqB,qBAAA;EAAoB,uBAAA;EAAsB,WAAA;EAAW,mCAAA;EAAkC,yBAAA;EAAwB,sCAAA;ADonG5vmD;;ACpnGiymD;EAAwC,cAAA;ADwnGz0mD;;ACxnGu1mD;EAAmC,iBAAA;AD4nG13mD;;AC5nG24mD;EAA0I,WAAA;EAAW,YAAA;ADioGhinD;;ACjoG4inD;EAAkB,SAAA;EAAS,gBAAA;EAAe,gBAAA;EAAgB,6BAAA;ADwoGtmnD;;ACxoGmonD;EAAe,cAAA;EAAc,WAAA;EAAW,uBAAA;EAAsB,WAAA;EAAW,gBAAA;EAAgB,cAAA;EAAc,mBAAA;EAAmB,mBAAA;EAAmB,6BAAA;EAA6B,SAAA;ADqpG7ynD;;ACrpGsznD;EAA0C,cAAA;EAAc,qBAAA;EAAqB,yBAAA;AD2pGn4nD;;AC3pG45nD;EAA4C,WAAA;EAAW,qBAAA;EAAqB,yBAAA;ADiqGx+nD;;ACjqGigoD;EAAgD,cAAA;EAAc,oBAAA;EAAoB,6BAAA;ADuqGnloD;;ACvqGgnoD;EAAoB,cAAA;AD2qGpooD;;AC3qGkpoD;EAAiB,cAAA;EAAc,sBAAA;EAAqB,gBAAA;EAAgB,mBAAA;EAAkB,cAAA;EAAc,mBAAA;ADorGtvoD;;ACprGywoD;EAAoB,cAAA;EAAc,uBAAA;EAAsB,cAAA;AD0rGj0oD;;AC1rG+0oD;EAA+B,kBAAA;EAA6C,oBAAA;EAAoB,sBAAA;ADisG/6oD;;ACjsGq8oD;EAAyC,kBAAA;EAAoC,cAAA;ADusGlhpD;;ACvsGgipD;EAAqD,UAAA;AD2sGrlpD;;AC3sG+lpD;EAAmK,UAAA;AD+sGlwpD;;AC/sG4wpD;EAAiC,aAAA;EAAgC,eAAA;EAAmC,2BAAA;ADwtGh3pD;;ACxtG24pD;EAA0B,WAAA;AD4tGr6pD;;AC5tGg7pD;EAA0E,iBAAA;ADguG1/pD;;AChuG2gqD;EAAmG,0BAAA;EAA0B,6BAAA;ADquGxoqD;;ACruGqqqD;EAA+E,yBAAA;EAAyB,4BAAA;AD0uG7wqD;;AC1uGyyqD;EAAuB,wBAAA;EAAuB,uBAAA;AD+uGv1qD;;AC/uG62qD;EAA6G,cAAA;ADmvG19qD;;ACnvGw+qD;EAAyC,eAAA;ADuvGjhrD;;ACvvGgirD;EAAyE,uBAAA;EAAsB,sBAAA;AD4vG/nrD;;AC5vGoprD;EAAyE,sBAAA;EAAqB,qBAAA;ADiwGlvrD;;ACjwGswrD;EAA8C,sBAAA;EAA2C,uBAAA;EAA4C,uBAAA;AD0wG34rD;;AC1wGk6rD;EAAwD,WAAA;AD8wG19rD;;AC9wGq+rD;EAA4F,gBAAA;ADkxGjksD;;AClxGilsD;EAAqH,6BAAA;EAA6B,4BAAA;ADuxGnusD;;ACvxG+vsD;EAAiG,yBAAA;EAAyB,0BAAA;AD4xGz3sD;;AC5xGm5sD;EAAyD,gBAAA;ADgyG58sD;;AChyG49sD;EAAgM,kBAAA;EAAkB,sBAAA;EAAmB,oBAAA;ADsyGjstD;;ACtyGqttD;EAAa,kBAAA;EAAsC,aAAA;EAAgC,eAAA;EAAsC,oBAAA;EAAoB,WAAA;ADizGl2tD;;ACjzG62tD;EAAsH,kBAAA;EAAkC,SAAA;EAAY,YAAA;EAAY,gBAAA;ADyzG7huD;;ACzzG6iuD;EAA0gB,iBAAA;AD6zGvjvD;;AC7zGwkvD;EAAyI,UAAA;ADi0GjtvD;;ACj0G2tvD;EAAmD,UAAA;ADq0G9wvD;;ACr0GwxvD;EAAyF,0BAAA;EAA0B,6BAAA;AD00G34vD;;AC10Gw6vD;EAA2F,yBAAA;EAAyB,4BAAA;AD+0G5hwD;;AC/0GwjwD;EAA8C,aAAA;EAAmC,mBAAA;ADs1GzowD;;ACt1G4pwD;EAAmI,0BAAA;EAA0B,6BAAA;AD21GzzwD;;AC31Gs1wD;EAA+D,yBAAA;EAAyB,4BAAA;ADg2G96wD;;ACh2G08wD;EAA6D,aAAA;ADq2GvgxD;;ACr2GohxD;EAAmD,kBAAA;EAAkB,UAAA;AD02GzlxD;;AC12GmmxD;EAA+D,UAAA;AD82GlqxD;;AC92G4qxD;EAA4V,iBAAA;ADk3GxgyD;;ACl3GyhyD;EAAqB,kBAAA;ADs3G9iyD;;ACt3GgkyD;EAAoB,iBAAA;AD03GplyD;;AC13GqmyD;EAAsC,aAAA;EAAmC,mBAAA;EAAmB,yBAAA;EAAuB,gBAAA;EAAgB,eAAA;EAAe,gBAAA;EAAgB,gBAAA;EAAgB,cAAA;EAAc,kBAAA;EAAkB,mBAAA;EAAmB,yBAAA;EAAyB,yBAAA;EAAyB,sBAAA;AD44G53yD;;AC54Gi5yD;EAA2E,aAAA;ADg5G59yD;;ACh5Gy+yD;EAA2E,gCAAA;ADo5GpjzD;;ACp5GolzD;EAA6P,oBAAA;EAAmB,kBAAA;EAAkB,gBAAA;EAAgB,qBAAA;AD25Gt4zD;;AC35G05zD;EAA2E,kCAAA;AD+5Gr+zD;;AC/5Gsg0D;EAA6P,uBAAA;EAAqB,mBAAA;EAAkB,gBAAA;EAAgB,qBAAA;ADs6G1z0D;;ACt6G800D;EAA8D,sBAAA;AD06G540D;;AC16Gk60D;EAA6X,0BAAA;EAA0B,6BAAA;AD+6Gzz1D;;AC/6Gs11D;EAA+W,yBAAA;EAAyB,4BAAA;ADo7G9t2D;;ACp7G0v2D;EAAgB,kBAAA;EAAkB,cAAA;EAAc,kBAAA;EAAkB,oBAAA;AD27G5z2D;;AC37Gg12D;EAAkD,oBAAA;EAAoB,kBAAA;ADi8Gt52D;;ACj8Gw62D;EAAsB,kBAAA;EAAkB,OAAA;EAAO,WAAA;EAAW,WAAA;EAAW,eAAA;EAAe,UAAA;AD08G5/2D;;AC18Gsg3D;EAA4D,WAAA;EAAW,qBAAA;EAAqB,yBAAA;ADg9Glm3D;;ACh9G2n3D;EAA0D,gDAAA;ADo9Grr3D;;ACp9Ggu3D;EAAwE,qBAAA;ADw9Gxy3D;;ACx9G6z3D;EAA0E,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD89G363D;;AC99Gg83D;EAA2G,cAAA;ADk+G3i4D;;ACl+Gyj4D;EAA2H,yBAAA;ADs+Gpr4D;;ACt+G6s4D;EAAsB,kBAAA;EAAkB,gBAAA;EAAgB,mBAAA;AD4+Grw4D;;AC5+Gwx4D;EAA8B,kBAAA;EAAkB,YAAA;EAAW,aAAA;EAAa,cAAA;EAAc,WAAA;EAAW,YAAA;EAAY,oBAAA;EAAoB,WAAA;EAAW,sBAAA;EAAsB,yBAAA;ADy/G174D;;ACz/Gm94D;EAA6B,kBAAA;EAAkB,YAAA;EAAW,aAAA;EAAa,cAAA;EAAc,WAAA;EAAW,YAAA;EAAY,WAAA;EAAW,iCAAA;ADogH1k5D;;ACpgH2m5D;EAA+C,sBAAA;ADwgH1p5D;;ACxgH+q5D;EAA4E,yDAAA;AD4gH3v5D;;AC5gH695D;EAAmF,qBAAA;EAAqB,yBAAA;ADihHrk6D;;ACjhH8l6D;EAAkF,yDAAA;ADqhHhr6D;;ACrhH+16D;EAAsF,wCAAA;ADyhHr76D;;ACzhHy96D;EAA4F,wCAAA;AD6hHrj7D;;AC7hHyl7D;EAA4C,kBAAA;ADiiHro7D;;ACjiHup7D;EAAyE,yDAAA;ADqiHhu7D;;ACriH847D;EAAmF,wCAAA;ADyiHj+7D;;ACziHqg8D;EAAe,qBAAA;AD6iHph8D;;AC7iHyi8D;EAA6C,cAAA;EAAc,cAAA;EAAc,mBAAA;EAAmB,qBAAA;ADojHro8D;;ACpjHyp8D;EAA4C,wBAAA;EAAuB,0BAAA;EAA0B,uBAAA;EAAuB,wBAAA;EAAwB,yBAAA;EAAyB,qBAAA;EAA8J,yIAAA;ADgkH598D;;AChkHmw9D;EAAuC;IAA4C,gBAAA;EDqkHp19D;AACF;ACtkHu29D;EAA0E,sBAAA;EAA2D,8BAAA;AD2kH5+9D;;AC3kHyg+D;EAAoF,wCAAA;AD+kH7l+D;;AC/kHio+D;EAAe,qBAAA;EAAqB,WAAA;EAAW,mCAAA;EAAkC,0CAAA;EAAuC,eAAA;EAAe,gBAAA;EAAgB,gBAAA;EAAgB,cAAA;EAAc,sBAAA;EAAsB,gGAAA;EAAsO,yBAAA;EAAyB,sBAAA;EAAkE,gBAAA;ADimH7o/D;;ACjmH6p/D;EAAqB,qBAAA;EAAqB,UAAA;EAAU,gDAAA;ADumHjt/D;;ACvmH4v/D;EAAgC,cAAA;EAAc,sBAAA;AD4mH1y/D;;AC5mHg0/D;EAA8D,YAAA;EAAY,sBAAA;EAAqB,sBAAA;ADknH/5/D;;AClnHq7/D;EAAwB,cAAA;EAAc,yBAAA;ADunH39/D;;ACvnHo//D;EAA2B,aAAA;AD2nH/ggE;;AC3nH4hgE;EAA8B,kBAAA;EAAkB,0BAAA;ADgoH5kgE;;AChoHsmgE;EAAkB,kCAAA;EAAiC,oBAAA;EAAmB,uBAAA;EAAsB,oBAAA;EAAmB,mBAAA;ADwoHrtgE;;ACxoHuugE;EAAkB,gCAAA;EAAgC,mBAAA;EAAkB,sBAAA;EAAqB,kBAAA;EAAkB,kBAAA;ADgpHl1gE;;AChpHo2gE;EAAa,kBAAA;EAAkB,qBAAA;EAAqB,WAAA;EAAW,mCAAA;EAAkC,gBAAA;ADwpHr8gE;;ACxpHq9gE;EAAmB,kBAAA;EAAkB,UAAA;EAAU,WAAA;EAAW,mCAAA;EAAkC,SAAA;EAAS,UAAA;ADiqH1jhE;;ACjqHokhE;EAA4C,qBAAA;EAAqB,gDAAA;ADsqHrohE;;ACtqHgrhE;EAA+F,yBAAA;AD0qH/whE;;AC1qHwyhE;EAAsD,iBAAA;AD8qH91hE;;AC9qH+2hE;EAA0D,0BAAA;ADkrHz6hE;;AClrHm8hE;EAAmB,kBAAA;EAAkB,MAAA;EAAM,QAAA;EAAQ,OAAA;EAAO,UAAA;EAAU,mCAAA;EAAkC,yBAAA;EAAuB,gBAAA;EAAgB,gBAAA;EAAgB,cAAA;EAAc,sBAAA;EAAsB,yBAAA;EAAyB,sBAAA;ADksH7piE;;AClsHkriE;EAA0B,kBAAA;EAAkB,MAAA;EAAM,QAAA;EAAQ,SAAA;EAAS,UAAA;EAAU,cAAA;EAAc,6BAAA;EAA4B,yBAAA;EAAuB,gBAAA;EAAgB,cAAA;EAAc,iBAAA;EAAiB,yBAAA;EAAyB,oBAAA;EAAoB,kCAAA;ADmtH55iE;;ACntH47iE;EAAc,WAAA;EAAW,cAAA;EAAc,UAAA;EAAU,6BAAA;EAA0E,gBAAA;AD6tHvjjE;;AC7tHukjE;EAAoB,UAAA;ADiuH3ljE;;ACjuHqmjE;EAA0C,gEAAA;ADquH/ojE;;ACruHysjE;EAAsC,gEAAA;ADyuH/ujE;;ACzuHyyjE;EAA+B,gEAAA;AD6uHx0jE;;AC7uHk4jE;EAAgC,SAAA;ADivHl6jE;;ACjvH26jE;EAAoC,WAAA;EAAW,YAAA;EAAY,oBAAA;EAAmB,yBAAA;EAAyB,SAAA;EAAS,mBAAA;EAAkI,oHAAA;EAAA,4GAAA;EAA+H,gBAAA;AD8vH5xkE;;AC9vH4ykE;EAAuC;IAA4D,wBAAA;IAAA,gBAAA;EDowH74kE;AACF;ACrwHg6kE;EAA2C,yBAAA;ADwwH38kE;;ACxwHo+kE;EAA6C,WAAA;EAAW,cAAA;EAAa,kBAAA;EAAkB,eAAA;EAAe,yBAAA;EAAyB,yBAAA;EAAyB,mBAAA;ADkxH5nlE;;AClxH+olE;EAAgC,WAAA;EAAW,YAAA;EAAY,yBAAA;EAAyB,SAAA;EAAS,mBAAA;EAA+H,iHAAA;EAAA,4GAAA;EAA4H,gBAAA;AD8xHn+lE;;AC9xHm/lE;EAAuC;IAAqD,qBAAA;IAAA,gBAAA;EDoyH7kmE;AACF;ACryHgmmE;EAAuC,yBAAA;ADwyHvomE;;ACxyHgqmE;EAAgC,WAAA;EAAW,cAAA;EAAa,kBAAA;EAAkB,eAAA;EAAe,yBAAA;EAAyB,yBAAA;EAAyB,mBAAA;ADkzH3ymE;;AClzH8zmE;EAAyB,WAAA;EAAW,YAAA;EAAY,aAAA;EAAa,oBAAA;EAAmB,mBAAA;EAAkB,yBAAA;EAAyB,SAAA;EAAS,mBAAA;EAA8H,gHAAA;EAAA,4GAAA;EAAuG,gBAAA;ADg0HvqnE;;ACh0HurnE;EAAuC;IAA6C,oBAAA;IAAA,gBAAA;EDs0HzwnE;AACF;ACv0H4xnE;EAAgC,yBAAA;AD00H5znE;;AC10Hq1nE;EAAyB,WAAA;EAAW,cAAA;EAAa,kBAAA;EAAkB,eAAA;EAAe,6BAAA;EAA6B,yBAAA;EAAyB,oBAAA;ADo1H79nE;;ACp1Hg/nE;EAA8B,yBAAA;EAAyB,mBAAA;ADy1HvioE;;ACz1H0joE;EAA8B,kBAAA;EAAkB,yBAAA;EAAyB,mBAAA;AD+1HnooE;;AC/1HspoE;EAA6C,yBAAA;ADm2HnsoE;;ACn2H4toE;EAAsD,eAAA;ADu2HlxoE;;ACv2HiyoE;EAAyC,yBAAA;AD22H10oE;;AC32Hm2oE;EAAyC,eAAA;AD+2H54oE;;AC/2H25oE;EAAkC,yBAAA;ADm3H77oE;;ACn3Hs9oE;EAAgE,4GAAA;ADu3HthpE;;ACv3H6npE;EAAuC;IAAgE,gBAAA;ED43HlupE;AACF;AC73HqvpE;EAAyB,aAAA;EAAgC,eAAA;EAAe,eAAA;EAAe,gBAAA;EAAgB,gBAAA;ADs4H51pE;;ACt4H42pE;EAAU,cAAA;EAAc,oBAAA;AD24Hp4pE;;AC34Hu5pE;EAAgC,qBAAA;AD+4Hv7pE;;AC/4H48pE;EAAmB,cAAA;EAAc,oBAAA;EAAoB,eAAA;ADq5HjgqE;;ACr5HghqE;EAAU,gCAAA;ADy5H1hqE;;ACz5H0jqE;EAAoB,mBAAA;AD65H9kqE;;AC75HimqE;EAAoB,6BAAA;EAA6B,+BAAA;EAA8B,gCAAA;ADm6HhrqE;;ACn6H+sqE;EAAoD,qCAAA;ADu6HnwqE;;ACv6HwyqE;EAA6B,cAAA;EAAc,6BAAA;EAA6B,yBAAA;AD66Hh3qE;;AC76Hy4qE;EAA8D,cAAA;EAAc,sBAAA;EAAsB,kCAAA;ADm7H3+qE;;ACn7H6grE;EAAyB,gBAAA;EAAgB,yBAAA;EAAyB,0BAAA;ADy7H/krE;;ACz7HymrE;EAAqB,sBAAA;AD67H9nrE;;AC77HmprE;EAAuD,WAAA;EAAW,yBAAA;ADk8HrtrE;;ACl8H8urE;EAAsC,cAAA;EAAc,kBAAA;ADw8HlyrE;;ACx8HozrE;EAAmD,aAAA;EAAiC,YAAA;EAAY,kBAAA;ADg9Hp5rE;;ACh9Hs6rE;EAAuB,aAAA;ADo9H77rE;;ACp9H08rE;EAAqB,cAAA;ADw9H/9rE;;ACx9H6+rE;EAAQ,kBAAA;EAAsC,aAAA;EAAgC,eAAA;EAAqC,mBAAA;EAAyC,8BAAA;EAA8B,oBAAA;ADq+HvqsE;;ACr+H0rsE;EAAwJ,aAAA;EAAgC,eAAA;EAAqC,mBAAA;EAAyC,8BAAA;ADg/Hh8sE;;ACh/H89sE;EAAc,qBAAA;EAAqB,sBAAA;EAAqB,yBAAA;EAAwB,kBAAA;EAAkB,kBAAA;EAAkB,oBAAA;EAAoB,mBAAA;AD0/HtmtE;;AC1/HyntE;EAAwC,qBAAA;AD8/HjqtE;;AC9/HsrtE;EAAgC,aAAA;EAAuC,sBAAA;EAAsB,eAAA;EAAe,gBAAA;EAAgB,gBAAA;ADwgIlztE;;ACxgIk0tE;EAAsB,gBAAA;EAAgB,eAAA;AD6gIx2tE;;AC7gIu3tE;EAA2B,gBAAA;EAAgB,WAAA;ADkhIl6tE;;AClhI66tE;EAAa,qBAAA;EAAqB,mBAAA;EAAkB,sBAAA;ADwhIj+tE;;ACxhIs/tE;EAA8C,gBAAA;EAAoC,YAAA;EAAkC,mBAAA;ADiiI1muE;;ACjiI6nuE;EAAgB,wBAAA;EAAsB,kBAAA;EAAkB,cAAA;EAAc,6BAAA;EAA6B,6BAAA;EAA6B,sBAAA;AD0iI7vuE;;AC1iIkxuE;EAA4C,qBAAA;AD8iI9zuE;;AC9iIm1uE;EAAqB,qBAAA;EAAqB,YAAA;EAAY,aAAA;EAAa,sBAAA;EAAsB,WAAA;EAAW,mCAAA;EAAmC,0BAAA;ADwjI19uE;;ACxjIo/uE;EAA4B;IAAgM,gBAAA;IAAgB,eAAA;ED8jI9tvE;AACF;AC/jIgvvE;EAAyB;IAA2C,qBAAA;IAAyC,2BAAA;EDskI31vE;ECtkIs3vE;IAAqD,mBAAA;ED0kI36vE;EC1kI87vE;IAA6C,kBAAA;ED6kI3+vE;EC7kI6/vE;IAAwC,qBAAA;IAAoB,oBAAA;EDilIzjwE;ECjlI4kwE;IAAqN,iBAAA;EDqlIjywE;ECrlIkzwE;IAAiE,wBAAA;IAAoD,gBAAA;ED2lIv6wE;EC3lIu7wE;IAAkC,aAAA;ED8lIz9wE;AACF;AC/lIy+wE;EAA4B;IAAgM,gBAAA;IAAgB,eAAA;EDomIntxE;AACF;ACrmIquxE;EAAyB;IAA2C,qBAAA;IAAyC,2BAAA;ED4mIh1xE;EC5mI22xE;IAAqD,mBAAA;EDgnIh6xE;EChnIm7xE;IAA6C,kBAAA;EDmnIh+xE;ECnnIk/xE;IAAwC,qBAAA;IAAoB,oBAAA;EDunI9iyE;ECvnIikyE;IAAqN,iBAAA;ED2nItxyE;EC3nIuyyE;IAAiE,wBAAA;IAAoD,gBAAA;EDioI55yE;ECjoI46yE;IAAkC,aAAA;EDooI98yE;AACF;ACroI89yE;EAA4B;IAAgM,gBAAA;IAAgB,eAAA;ED0oIxszE;AACF;AC3oI0tzE;EAAyB;IAA2C,qBAAA;IAAyC,2BAAA;EDkpIr0zE;EClpIg2zE;IAAqD,mBAAA;EDspIr5zE;ECtpIw6zE;IAA6C,kBAAA;EDypIr9zE;ECzpIu+zE;IAAwC,qBAAA;IAAoB,oBAAA;ED6pIni0E;EC7pIsj0E;IAAqN,iBAAA;EDiqI3w0E;ECjqI4x0E;IAAiE,wBAAA;IAAoD,gBAAA;EDuqIj50E;ECvqIi60E;IAAkC,aAAA;ED0qIn80E;AACF;AC3qIm90E;EAA6B;IAAgM,gBAAA;IAAgB,eAAA;EDgrI9r1E;AACF;ACjrIgt1E;EAA0B;IAA2C,qBAAA;IAAyC,2BAAA;EDwrI5z1E;ECxrIu11E;IAAqD,mBAAA;ED4rI541E;EC5rI+51E;IAA6C,kBAAA;ED+rI581E;EC/rI891E;IAAwC,qBAAA;IAAoB,oBAAA;EDmsI1h2E;ECnsI6i2E;IAAqN,iBAAA;EDusIlw2E;ECvsImx2E;IAAiE,wBAAA;IAAoD,gBAAA;ED6sIx42E;EC7sIw52E;IAAkC,aAAA;EDgtI172E;AACF;ACjtI082E;EAAwC,qBAAA;EAAyC,2BAAA;ADutI3h3E;;ACvtIsj3E;EAA8K,gBAAA;EAAgB,eAAA;AD4tIpv3E;;AC5tImw3E;EAAkD,mBAAA;ADiuIrz3E;;ACjuIw03E;EAA0C,kBAAA;ADquIl33E;;ACruIo43E;EAAqC,qBAAA;EAAoB,oBAAA;AD0uI773E;;AC1uIg93E;EAAmM,iBAAA;AD+uInp4E;;AC/uIoq4E;EAA8D,wBAAA;EAAoD,gBAAA;ADsvItx4E;;ACtvIsy4E;EAA+B,aAAA;AD0vIr04E;;AC1vIk14E;EAA4B,yBAAA;AD8vI924E;;AC9vIm44E;EAAoE,yBAAA;ADkwIv84E;;AClwI494E;EAAoC,yBAAA;ADswIhg5E;;ACtwIqh5E;EAAoF,yBAAA;AD0wIzm5E;;AC1wI8n5E;EAA6C,yBAAA;AD8wI3q5E;;AC9wIgs5E;EAA0K,yBAAA;ADkxI125E;;AClxI+35E;EAA8B,yBAAA;EAAqB,gCAAA;ADuxIl75E;;ACvxI885E;EAAmC,yDAAA;AD2xIj/5E;;AC3xIgw6E;EAA2B,yBAAA;AD+xI3x6E;;AC/xIgz6E;EAA6B,yBAAA;ADmyI706E;;ACnyIk26E;EAAsE,yBAAA;ADuyIx66E;;ACvyI676E;EAA2B,WAAA;AD2yIx96E;;AC3yIm+6E;EAAkE,WAAA;AD+yIri7E;;AC/yIgj7E;EAAmC,+BAAA;ADmzInl7E;;ACnzI8m7E;EAAkF,gCAAA;ADuzIhs7E;;ACvzI4t7E;EAA4C,gCAAA;AD2zIxw7E;;AC3zIoy7E;EAAsK,WAAA;AD+zI187E;;AC/zIq97E;EAA6B,+BAAA;EAA2B,sCAAA;ADo0I7g8E;;ACp0I+i8E;EAAkC,yDAAA;ADw0Ijl8E;;ACx0Is28E;EAA0B,+BAAA;AD40Ih48E;;AC50I258E;EAA4B,WAAA;ADg1Iv78E;;ACh1Ik88E;EAAoE,WAAA;ADo1Itg9E;;ACp1Iih9E;EAAM,kBAAA;EAAsC,aAAA;EAAuC,sBAAA;EAAsB,YAAA;EAAY,qBAAA;EAAqB,sBAAA;EAAsB,2BAAA;EAA2B,sCAAA;EAAkC,sBAAA;ADk2I9u9E;;ACl2Imw9E;EAAS,eAAA;EAAe,cAAA;ADu2I3x9E;;ACv2Iyy9E;EAA2D,+BAAA;EAA8B,gCAAA;AD42Il49E;;AC52Ii69E;EAAyD,mCAAA;EAAkC,kCAAA;ADi3I5/9E;;ACj3I6h+E;EAA6B,cAAA;EAAc,eAAA;EAAe,gBAAA;ADw3Ivl+E;;ACx3Ium+E;EAAY,sBAAA;AD43Inn+E;;AC53Iwo+E;EAAe,qBAAA;EAAoB,gBAAA;ADi4I3q+E;;ACj4I2r+E;EAAsB,gBAAA;ADq4Ijt+E;;ACr4Iiu+E;EAAiB,qBAAA;ADy4Ilv+E;;ACz4Iuw+E;EAAsB,oBAAA;AD64I7x+E;;AC74Iiz+E;EAAa,wBAAA;EAAuB,gBAAA;EAAgB,qCAAA;EAAiC,6CAAA;ADo5It4+E;;ACp5I+6+E;EAAyB,0DAAA;ADw5Ix8+E;;ACx5Igg/E;EAAsD,aAAA;AD45Itj/E;;AC55Imk/E;EAAa,wBAAA;EAAuB,qCAAA;EAAiC,0CAAA;ADk6Ixo/E;;ACl6I8q/E;EAAwB,0DAAA;ADs6Its/E;;ACt6I8v/E;EAAkB,uBAAA;EAAsB,uBAAA;EAAsB,sBAAA;EAAqB,gBAAA;AD66Ij1/E;;AC76Ii2/E;EAAmB,uBAAA;EAAsB,sBAAA;ADk7I14/E;;ACl7I+5/E;EAAkB,kBAAA;EAAkB,MAAA;EAAM,QAAA;EAAQ,SAAA;EAAS,OAAA;EAAO,gBAAA;AD27Ij+/E;;AC37Ii//E;EAA6D,cAAA;EAAc,WAAA;ADi8I5jgF;;ACj8IukgF;EAAwB,2CAAA;EAA0C,4CAAA;ADs8IzogF;;ACt8IorgF;EAA2B,+CAAA;EAA8C,8CAAA;AD28I7vgF;;AC38I0ygF;EAAiB,mBAAA;AD+8I3zgF;;AC/8I80gF;EAAyB;IAA+B,aAAA;IAAoC,mBAAA;IAAmB,mBAAA;IAAmB,kBAAA;EDy9I98gF;ECz9Ig+gF;IAAiC,SAAA;IAAY,kBAAA;IAAkB,gBAAA;IAAgB,iBAAA;EDg+I/ihF;AACF;ACj+ImkhF;EAAkB,mBAAA;ADo+IrlhF;;ACp+IwmhF;EAAyB;IAAgC,aAAA;IAAoC,mBAAA;ED4+InshF;EC5+IsthF;IAAkC,SAAA;IAAY,gBAAA;EDi/IpwhF;ECj/IoxhF;IAAwB,cAAA;IAAc,cAAA;EDq/I1zhF;ECr/Iw0hF;IAAmC,0BAAA;IAA0B,6BAAA;EDy/Ir4hF;ECz/Ik6hF;IAAiG,0BAAA;ED4/IngiF;EC5/I6hiF;IAAoG,6BAAA;ED+/IjoiF;EC//I8piF;IAAoC,yBAAA;IAAyB,4BAAA;EDmgJ3tiF;ECngJuviF;IAAmG,yBAAA;EDsgJ11iF;ECtgJm3iF;IAAsG,4BAAA;EDygJz9iF;AACF;AC1gJw/iF;EAAoB,sBAAA;AD6gJ5gjF;;AC7gJiijF;EAAyB;IAAyD,eAAA;IAAkE,mBAAA;IAAmB,UAAA;IAAU,SAAA;EDyhJhtjF;ECzhJytjF;IAAoB,qBAAA;IAAqB,WAAA;ED6hJlwjF;AACF;AC9hJgxjF;EAAiB,gBAAA;ADiiJjyjF;;ACjiJizjF;EAAoC,gBAAA;EAAgB,6BAAA;EAA6B,4BAAA;ADuiJl4jF;;ACviJ85jF;EAAqC,yBAAA;EAAyB,0BAAA;AD4iJ59jF;;AC5iJs/jF;EAA8B,gBAAA;EAAgB,mBAAA;ADijJpikF;;ACjjJujkF;EAAgC,aAAA;EAAgC,eAAA;EAAe,qBAAA;EAAoB,mBAAA;EAAmB,gBAAA;EAAgB,yBAAA;EAAyB,sBAAA;AD6jJttkF;;AC7jJ2ukF;EAAkC,oBAAA;ADikJ7wkF;;ACjkJgykF;EAA0C,qBAAA;EAAqB,qBAAA;EAAoB,cAAA;EAAc,YAAA;ADwkJj4kF;;ACxkJ64kF;EAAgD,0BAAA;AD4kJ77kF;;AC5kJu9kF;EAAgD,qBAAA;ADglJvglF;;AChlJ4hlF;EAAwB,cAAA;ADolJpjlF;;ACplJkklF;EAAgC,aAAA;EAAa,eAAA;EAAe,gBAAA;EAAgB,sBAAA;AD4lJ9olF;;AC5lJmqlF;EAAW,kBAAA;EAAkB,cAAA;EAAc,uBAAA;EAAqB,iBAAA;EAAiB,iBAAA;EAAiB,cAAA;EAAc,sBAAA;EAAsB,yBAAA;ADumJzylF;;ACvmJk0lF;EAAiB,UAAA;EAAU,cAAA;EAAc,qBAAA;EAAqB,yBAAA;EAAyB,qBAAA;AD+mJz5lF;;AC/mJ86lF;EAAiB,UAAA;EAAU,UAAA;EAAU,gDAAA;ADqnJn9lF;;ACrnJ8/lF;EAAkC,cAAA;EAAc,+BAAA;EAA8B,kCAAA;AD2nJ5kmF;;AC3nJ6mmF;EAAiC,gCAAA;EAA+B,mCAAA;ADgoJ7qmF;;AChoJ+smF;EAA6B,UAAA;EAAU,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADuoJ1xmF;;ACvoJ+ymF;EAA+B,cAAA;EAAc,oBAAA;EAAoB,YAAA;EAAY,sBAAA;EAAsB,qBAAA;AD+oJl5mF;;AC/oJu6mF;EAA0B,uBAAA;EAAsB,kBAAA;EAAkB,gBAAA;ADqpJz+mF;;ACrpJy/mF;EAAiD,8BAAA;EAA6B,iCAAA;AD0pJvknF;;AC1pJumnF;EAAgD,+BAAA;EAA8B,kCAAA;AD+pJrrnF;;AC/pJstnF;EAA0B,uBAAA;EAAqB,mBAAA;EAAkB,gBAAA;ADqqJvxnF;;ACrqJuynF;EAAiD,8BAAA;EAA6B,iCAAA;AD0qJr3nF;;AC1qJq5nF;EAAgD,+BAAA;EAA8B,kCAAA;AD+qJn+nF;;AC/qJogoF;EAAO,qBAAA;EAAqB,qBAAA;EAAmB,cAAA;EAAc,gBAAA;EAAgB,cAAA;EAAc,kBAAA;EAAkB,mBAAA;EAAmB,wBAAA;EAAwB,sBAAA;EAAqB,qIAAA;AD4rJjroF;;AC5rJ+yoF;EAAuC;IAAO,gBAAA;EDisJ31oF;AACF;AClsJ82oF;EAA4B,qBAAA;ADqsJ14oF;;ACrsJ+5oF;EAAa,aAAA;ADysJ56oF;;ACzsJy7oF;EAAY,kBAAA;EAAkB,SAAA;AD8sJv9oF;;AC9sJg+oF;EAAY,oBAAA;EAAmB,mBAAA;EAAkB,oBAAA;ADotJjhpF;;ACptJqipF;EAAe,WAAA;EAAW,yBAAA;ADytJ/jpF;;ACztJwlpF;EAA4C,WAAA;EAAW,yBAAA;AD8tJ/opF;;AC9tJwqpF;EAA4C,UAAA;EAAU,+CAAA;ADmuJ9tpF;;ACnuJwwpF;EAAiB,WAAA;EAAW,yBAAA;ADwuJpypF;;ACxuJ6zpF;EAAgD,WAAA;EAAW,yBAAA;AD6uJx3pF;;AC7uJi5pF;EAAgD,UAAA;EAAU,iDAAA;ADkvJ38pF;;AClvJu/pF;EAAe,WAAA;EAAW,yBAAA;ADuvJjhqF;;ACvvJ0iqF;EAA4C,WAAA;EAAW,yBAAA;AD4vJjmqF;;AC5vJ0nqF;EAA4C,UAAA;EAAU,+CAAA;ADiwJhrqF;;ACjwJ0tqF;EAAY,WAAA;EAAW,yBAAA;ADswJjvqF;;ACtwJ0wqF;EAAsC,WAAA;EAAW,yBAAA;AD2wJ3zqF;;AC3wJo1qF;EAAsC,UAAA;EAAU,gDAAA;ADgxJp4qF;;AChxJ+6qF;EAAe,cAAA;EAAc,yBAAA;ADqxJ58qF;;ACrxJq+qF;EAA4C,cAAA;EAAc,yBAAA;AD0xJ/hrF;;AC1xJwjrF;EAA4C,UAAA;EAAU,+CAAA;AD+xJ9mrF;;AC/xJwprF;EAAc,WAAA;EAAW,yBAAA;ADoyJjrrF;;ACpyJ0srF;EAA0C,WAAA;EAAW,yBAAA;ADyyJ/vrF;;ACzyJwxrF;EAA0C,UAAA;EAAU,+CAAA;AD8yJ50rF;;AC9yJs3rF;EAAa,cAAA;EAAc,yBAAA;ADmzJj5rF;;ACnzJ06rF;EAAwC,cAAA;EAAc,yBAAA;ADwzJh+rF;;ACxzJy/rF;EAAwC,UAAA;EAAU,iDAAA;AD6zJ3isF;;AC7zJulsF;EAAY,WAAA;EAAW,yBAAA;ADk0J9msF;;ACl0JuosF;EAAsC,WAAA;EAAW,yBAAA;ADu0JxrsF;;ACv0JitsF;EAAsC,UAAA;EAAU,8CAAA;AD40JjwsF;;AC50J0ysF;EAAW,kBAAA;EAAkB,mBAAA;EAAmB,yBAAA;EAAyB,qBAAA;ADm1Jn3sF;;ACn1Ju4sF;EAAyB;IAAW,kBAAA;EDw1Jz6sF;AACF;ACz1J87sF;EAAiB,gBAAA;EAAgB,eAAA;EAAe,gBAAA;AD81J9+sF;;AC91J8/sF;EAAO,kBAAA;EAAkB,wBAAA;EAAuB,mBAAA;EAAmB,6BAAA;EAA6B,sBAAA;ADs2J9ltF;;ACt2JmntF;EAAe,cAAA;AD02JlotF;;AC12JgptF;EAAY,gBAAA;AD82J5ptF;;AC92J4qtF;EAAmB,mBAAA;ADk3J/rtF;;ACl3JkttF;EAA0B,kBAAA;EAAkB,MAAA;EAAM,QAAA;EAAQ,wBAAA;EAAuB,cAAA;AD03JnytF;;AC13JiztF;EAAe,cAAA;EAAc,yBAAA;EAAyB,qBAAA;ADg4Jv2tF;;ACh4J43tF;EAAkB,yBAAA;ADo4J94tF;;ACp4Ju6tF;EAA2B,cAAA;ADw4Jl8tF;;ACx4Jg9tF;EAAiB,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD84JxguF;;AC94J6huF;EAAoB,yBAAA;ADk5JjjuF;;ACl5J0kuF;EAA6B,cAAA;ADs5JvmuF;;ACt5JqnuF;EAAe,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD45J3quF;;AC55JgsuF;EAAkB,yBAAA;ADg6JltuF;;ACh6J2uuF;EAA2B,cAAA;ADo6JtwuF;;ACp6JoxuF;EAAY,cAAA;EAAc,yBAAA;EAAyB,qBAAA;AD06Jv0uF;;AC16J41uF;EAAe,yBAAA;AD86J32uF;;AC96Jo4uF;EAAwB,cAAA;ADk7J55uF;;ACl7J06uF;EAAe,cAAA;EAAc,yBAAA;EAAyB,qBAAA;ADw7Jh+uF;;ACx7Jq/uF;EAAkB,yBAAA;AD47JvgvF;;AC57JgivF;EAA2B,cAAA;ADg8J3jvF;;ACh8JykvF;EAAc,cAAA;EAAc,yBAAA;EAAyB,qBAAA;ADs8J9nvF;;ACt8JmpvF;EAAiB,yBAAA;AD08JpqvF;;AC18J6rvF;EAA0B,cAAA;AD88JvtvF;;AC98JquvF;EAAa,cAAA;EAAc,yBAAA;EAAyB,qBAAA;ADo9JzxvF;;ACp9J8yvF;EAAgB,yBAAA;ADw9J9zvF;;ACx9Ju1vF;EAAyB,cAAA;AD49Jh3vF;;AC59J83vF;EAAY,cAAA;EAAc,yBAAA;EAAyB,qBAAA;ADk+Jj7vF;;ACl+Js8vF;EAAe,yBAAA;ADs+Jr9vF;;ACt+J8+vF;EAAwB,cAAA;AD0+JtgwF;AC1+JwnwF;EAAgC;IAAK,2BAAA;EDu/J3pwF;ECv/JsrwF;IAAG,wBAAA;ED0/JzrwF;AACF;AC3/JotwF;EAA8B,aAAA;EAAa,YAAA;EAAY,gBAAA;EAAgB,kBAAA;EAAiB,yBAAA;EAAyB,sBAAA;ADogKr0wF;;ACpgK01wF;EAAkC,aAAA;EAAuC,sBAAA;EAA2C,uBAAA;EAAuB,gBAAA;EAAgB,WAAA;EAAW,kBAAA;EAAkB,mBAAA;EAAmB,yBAAA;EAAyB,2BAAA;ADmhK9jxF;;ACnhKwlxF;EAAuC;IAAc,gBAAA;EDwhK3oxF;AACF;ACzhK8pxF;EAAsB,qMAAA;EAAkL,0BAAA;AD6hKt2xF;;AC7hKg4xF;EAAiF,kDAAA;ADkiKj9xF;;ACliKmgyF;EAAuC;IAA8C,eAAA;EDwiKtlyF;AACF;ACziKwmyF;EAA2B,aAAA;EAAkC,uBAAA;AD+iKrqyF;;AC/iK4ryF;EAAuB,SAAA;ADojKntyF;;ACpjK0tyF;EAAgC,aAAA;EAAuC,sBAAA;EAAsB,eAAA;EAAe,gBAAA;AD6jKt0yF;;AC7jKs1yF;EAAwB,WAAA;EAAW,cAAA;EAAc,mBAAA;ADmkKv4yF;;ACnkK05yF;EAA4D,UAAA;EAAU,cAAA;EAAc,qBAAA;EAAqB,yBAAA;AD0kKngzF;;AC1kK4hzF;EAA+B,cAAA;EAAc,yBAAA;AD+kKzkzF;;AC/kKkmzF;EAAiB,kBAAA;EAAkB,cAAA;EAAc,wBAAA;EAAuB,sBAAA;EAAsB,sCAAA;ADulKhszF;;ACvlKkuzF;EAA6B,+BAAA;EAA8B,gCAAA;AD4lK7xzF;;AC5lK4zzF;EAA4B,mCAAA;EAAkC,kCAAA;ADimK13zF;;ACjmK25zF;EAAoD,cAAA;EAAc,oBAAA;EAAoB,sBAAA;ADumKj/zF;;ACvmKug0F;EAAwB,UAAA;EAAU,WAAA;EAAW,yBAAA;EAAyB,qBAAA;AD8mK7k0F;;AC9mKkm0F;EAAkC,mBAAA;ADknKpo0F;;AClnKup0F;EAAyC,gBAAA;EAAgB,qBAAA;ADunKht0F;;ACvnKqu0F;EAA8C,mBAAA;AD4nKnx0F;;AC5nKsy0F;EAAoD,kCAAA;EAAiC,0BAAA;ADioK330F;;ACjoKq50F;EAAmD,gCAAA;EAA+B,4BAAA;ADsoKv+0F;;ACtoKmg1F;EAA+C,aAAA;AD0oKlj1F;;AC1oK+j1F;EAAyD,qBAAA;EAAqB,oBAAA;AD+oK7o1F;;AC/oKiq1F;EAAgE,iBAAA;EAAiB,sBAAA;ADopKlv1F;;ACppKww1F;EAAyB;IAAiD,mBAAA;ED0pKh11F;EC1pKm21F;IAAuD,kCAAA;IAAiC,0BAAA;ED8pK371F;EC9pKq91F;IAAsD,gCAAA;IAA+B,4BAAA;EDkqK1i2F;EClqKsk2F;IAAkD,aAAA;EDqqKxn2F;ECrqKqo2F;IAA4D,qBAAA;IAAqB,oBAAA;EDyqKtt2F;ECzqK0u2F;IAAmE,iBAAA;IAAiB,sBAAA;ED6qK9z2F;AACF;AC9qKu12F;EAAyB;IAAiD,mBAAA;EDmrK/52F;ECnrKk72F;IAAuD,kCAAA;IAAiC,0BAAA;EDurK1g3F;ECvrKoi3F;IAAsD,gCAAA;IAA+B,4BAAA;ED2rKzn3F;EC3rKqp3F;IAAkD,aAAA;ED8rKvs3F;EC9rKot3F;IAA4D,qBAAA;IAAqB,oBAAA;EDksKry3F;EClsKyz3F;IAAmE,iBAAA;IAAiB,sBAAA;EDssK743F;AACF;ACvsKs63F;EAAyB;IAAiD,mBAAA;ED4sK9+3F;EC5sKig4F;IAAuD,kCAAA;IAAiC,0BAAA;EDgtKzl4F;EChtKmn4F;IAAsD,gCAAA;IAA+B,4BAAA;EDotKxs4F;ECptKou4F;IAAkD,aAAA;EDutKtx4F;ECvtKmy4F;IAA4D,qBAAA;IAAqB,oBAAA;ED2tKp34F;EC3tKw44F;IAAmE,iBAAA;IAAiB,sBAAA;ED+tK594F;AACF;AChuKq/4F;EAA0B;IAAiD,mBAAA;EDquK9j5F;ECruKil5F;IAAuD,kCAAA;IAAiC,0BAAA;EDyuKzq5F;ECzuKms5F;IAAsD,gCAAA;IAA+B,4BAAA;ED6uKxx5F;EC7uKoz5F;IAAkD,aAAA;EDgvKt25F;EChvKm35F;IAA4D,qBAAA;IAAqB,oBAAA;EDovKp85F;ECpvKw95F;IAAmE,iBAAA;IAAiB,sBAAA;EDwvK5i6F;AACF;ACzvKqk6F;EAAmC,qBAAA;EAAqB,oBAAA;EAAoB,gBAAA;AD8vKjp6F;;AC9vKiq6F;EAA+C,mBAAA;ADkwKht6F;;AClwKmu6F;EAAyD,sBAAA;ADswK5x6F;;ACtwKkz6F;EAAyB,cAAA;EAAc,yBAAA;AD2wKz16F;;AC3wKk36F;EAA4G,cAAA;EAAc,yBAAA;ADgxK5+6F;;AChxKqg7F;EAAuD,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADsxKhm7F;;ACtxKqn7F;EAA2B,cAAA;EAAc,yBAAA;AD2xK9p7F;;AC3xKur7F;EAAgH,cAAA;EAAc,yBAAA;ADgyKrz7F;;AChyK807F;EAAyD,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADsyK367F;;ACtyKg87F;EAAyB,cAAA;EAAc,yBAAA;AD2yKv+7F;;AC3yKgg8F;EAA4G,cAAA;EAAc,yBAAA;ADgzK1n8F;;AChzKmp8F;EAAuD,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADszK9u8F;;ACtzKmw8F;EAAsB,cAAA;EAAc,yBAAA;AD2zKvy8F;;AC3zKg08F;EAAsG,cAAA;EAAc,yBAAA;ADg0Kp78F;;ACh0K688F;EAAoD,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADs0Kri9F;;ACt0K0j9F;EAAyB,cAAA;EAAc,yBAAA;AD20Kjm9F;;AC30K0n9F;EAA4G,cAAA;EAAc,yBAAA;ADg1Kpv9F;;ACh1K6w9F;EAAuD,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADs1Kx29F;;ACt1K639F;EAAwB,cAAA;EAAc,yBAAA;AD21Kn69F;;AC31K479F;EAA0G,cAAA;EAAc,yBAAA;ADg2Kpj+F;;ACh2K6k+F;EAAsD,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADs2Kvq+F;;ACt2K4r+F;EAAuB,cAAA;EAAc,yBAAA;AD22Kju+F;;AC32K0v+F;EAAwG,cAAA;EAAc,yBAAA;ADg3Kh3+F;;ACh3Ky4+F;EAAqD,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADs3Kl++F;;ACt3Ku/+F;EAAsB,cAAA;EAAc,yBAAA;AD23K3h/F;;AC33Koj/F;EAAsG,cAAA;EAAc,yBAAA;ADg4Kxq/F;;ACh4Kis/F;EAAoD,WAAA;EAAW,yBAAA;EAAyB,qBAAA;ADs4Kzx/F;;ACt4K8y/F;EAAO,YAAA;EAAY,iBAAA;EAAiB,gBAAA;EAAgB,cAAA;EAAc,WAAA;EAAW,yBAAA;EAAyB,YAAA;ADg5Kp5/F;;ACh5K+5/F;EAAa,WAAA;EAAW,qBAAA;ADq5Kv7/F;;ACr5K48/F;EAAsF,aAAA;ADy5KligG;;ACz5K8igG;EAAa,UAAA;EAAU,6BAAA;EAA6B,SAAA;EAAsD,gBAAA;ADk6KxpgG;;ACl6KwqgG;EAAiB,oBAAA;ADs6KzrgG;;ACt6K6sgG;EAAO,gBAAA;EAAgB,gBAAA;EAAgB,mBAAA;EAAkB,2CAAA;EAAuC,4BAAA;EAA4B,oCAAA;EAAgC,gDAAA;EAA6E,2BAAA;EAA2B,UAAA;EAAU,sBAAA;ADo7K39gG;;ACp7Kg/gG;EAAwB,sBAAA;ADw7KxghG;;ACx7K6hhG;EAAe,UAAA;AD47K5ihG;;AC57KsjhG;EAAY,cAAA;EAAc,UAAA;ADi8KhlhG;;ACj8K0lhG;EAAY,aAAA;ADq8KtmhG;;ACr8KmnhG;EAAkC,aAAA;EAAmC,mBAAA;EAAmB,wBAAA;EAAsB,cAAA;EAAc,2CAAA;EAAuC,4BAAA;EAA4B,4CAAA;ADi9KlzhG;;ACj9K01hG;EAAY,gBAAA;ADq9Kt2hG;;ACr9Kq3hG;EAAY,gBAAA;ADy9Kj4hG;;ACz9Ki5hG;EAAmB,kBAAA;EAAkB,gBAAA;AD89Kt7hG;;AC99Ks8hG;EAAO,eAAA;EAAe,MAAA;EAAM,OAAA;EAAO,aAAA;EAAa,aAAA;EAAa,WAAA;EAAW,YAAA;EAAY,gBAAA;EAAgB,UAAA;AD0+K1iiG;;AC1+KojiG;EAAc,kBAAA;EAAkB,WAAA;EAAW,cAAA;EAAa,oBAAA;ADi/K5miG;;ACj/KgoiG;EAAoE,mCAAA;EAAwI,8BAAA;ADy/K50iG;;ACz/Ky2iG;EAAuC;IAA0B,gBAAA;ED8/Kx6iG;AACF;AC//K27iG;EAAiD,eAAA;ADmgL5+iG;;ACngL2/iG;EAAgE,sBAAA;ADwgL3jjG;;ACxgLiljG;EAA6C,aAAA;EAAa,6BAAA;AD8gL3ojG;;AC9gLwqjG;EAAwC,8BAAA;EAA8B,gBAAA;ADmhL9ujG;;ACnhL8vjG;EAAkG,cAAA;ADwhLh2jG;;ACxhL82jG;EAAqC,gBAAA;AD4hLn5jG;;AC5hLm6jG;EAA2C,aAAA;EAAmC,mBAAA;EAAmB,6BAAA;ADoiLpgkG;;ACpiLiikG;EAA+B,cAAA;EAAc,0BAAA;EAA0B,WAAA;AD0iLxmkG;;AC1iLmnkG;EAAyE,sBAAA;EAA2C,uBAAA;EAAuB,YAAA;ADkjL9vkG;;ACljL0wkG;EAA8D,gBAAA;ADsjLx0kG;;ACtjLw1kG;EAAuD,aAAA;AD0jL/4kG;;AC1jL45kG;EAAe,kBAAA;EAAsC,aAAA;EAAuC,sBAAA;EAAsB,WAAA;EAAW,oBAAA;EAAoB,sBAAA;EAAsB,4BAAA;EAA4B,oCAAA;EAAgC,qBAAA;EAAoB,UAAA;ADykLnplG;;ACzkL6plG;EAAgB,eAAA;EAAe,MAAA;EAAM,OAAA;EAAO,aAAA;EAAa,YAAA;EAAY,aAAA;EAAa,sBAAA;ADmlL/ulG;;ACnlLqwlG;EAAqB,UAAA;ADulL1xlG;;ACvlLoylG;EAAqB,YAAA;AD2lLzzlG;;AC3lLo0lG;EAAkC,aAAA;EAAkC,uBAAA;EAA6C,8BAAA;EAA8B,kBAAA;EAAkB,gCAAA;EAAgC,0CAAA;EAAyC,2CAAA;ADwmL9imG;;ACxmLwlmG;EAAqB,kBAAA;EAAkB,8BAAA;AD6mL/nmG;;AC7mL6pmG;EAAa,gBAAA;EAAgB,gBAAA;ADknL1rmG;;AClnL0smG;EAAY,kBAAA;EAAoC,cAAA;EAAc,aAAA;ADynLxwmG;;ACznLqxmG;EAAkC,aAAA;EAAgC,eAAA;EAAqC,mBAAA;EAAqC,yBAAA;EAAyB,gBAAA;EAAe,6BAAA;EAA6B,8CAAA;EAA6C,6CAAA;ADwoLnhnG;;ACxoL+jnG;EAAgB,eAAA;AD4oL/knG;;AC5oL6lnG;EAAyB,kBAAA;EAAkB,YAAA;EAAY,WAAA;EAAW,YAAA;EAAY,gBAAA;ADopL3qnG;;ACppL2rnG;EAAyB;IAAc,gBAAA;IAAgB,oBAAA;ED0pLhvnG;EC1pLownG;IAAyB,+BAAA;ED6pL7xnG;EC7pL4znG;IAAwC,gCAAA;EDgqLp2nG;EChqLo4nG;IAAuB,+BAAA;EDmqL35nG;ECnqL07nG;IAA+B,4BAAA;EDsqLz9nG;ECtqLq/nG;IAAU,gBAAA;EDyqL//nG;AACF;AC1qLkhoG;EAAyB;IAAoB,gBAAA;ED8qL7joG;AACF;AC/qLgloG;EAA0B;IAAU,iBAAA;EDmrLlnoG;AACF;ACprLsooG;EAAS,kBAAA;EAAkB,aAAA;EAAa,cAAA;EAAc,SAAA;EAAS,kMAAA;EAAuL,kBAAA;EAAkB,gBAAA;EAAgB,gBAAA;EAAgB,gBAAA;EAAgB,iBAAA;EAAiB,qBAAA;EAAqB,iBAAA;EAAiB,oBAAA;EAAoB,sBAAA;EAAsB,kBAAA;EAAkB,oBAAA;EAAoB,mBAAA;EAAmB,gBAAA;EAAgB,mBAAA;EAAkB,qBAAA;EAAqB,UAAA;AD2sL/opG;;AC3sLyppG;EAAc,YAAA;AD+sLvqpG;;AC/sLkrpG;EAAgB,kBAAA;EAAkB,cAAA;EAAc,aAAA;EAAY,cAAA;ADstL9upG;;ACttL2vpG;EAAwB,kBAAA;EAAkB,WAAA;EAAW,yBAAA;EAAyB,mBAAA;AD6tLz0pG;;AC7tL41pG;EAAmD,iBAAA;ADiuL/4pG;;ACjuL+5pG;EAAiE,SAAA;ADquLh+pG;;ACruLy+pG;EAAiF,MAAA;EAAM,6BAAA;EAA2B,sBAAA;AD2uL3lqG;;AC3uLinqG;EAAuD,iBAAA;AD+uLxqqG;;AC/uLwrqG;EAAqE,OAAA;EAAO,aAAA;EAAY,cAAA;ADqvLhxqG;;ACrvL6xqG;EAAqF,QAAA;EAAQ,oCAAA;EAAiC,wBAAA;AD2vL35qG;;AC3vLm7qG;EAAyD,iBAAA;AD+vL5+qG;;AC/vL4/qG;EAAuE,MAAA;ADmwLnkrG;;ACnwLykrG;EAAuF,SAAA;EAAS,6BAAA;EAA2B,yBAAA;ADywLpsrG;;ACzwL6trG;EAAqD,iBAAA;AD6wLlxrG;;AC7wLkyrG;EAAmE,QAAA;EAAQ,aAAA;EAAY,cAAA;ADmxLz3rG;;ACnxLs4rG;EAAmF,OAAA;EAAO,oCAAA;EAAiC,uBAAA;ADyxLjgsG;;ACzxLwhsG;EAAe,gBAAA;EAAgB,uBAAA;EAAqB,WAAA;EAAW,kBAAA;EAAkB,sBAAA;EAAsB,sBAAA;ADkyL/nsG;;AClyLopsG;EAAS,kBAAA;EAAkB,MAAA;EAAM,OAAA;EAAO,aAAA;EAAa,cAAA;EAAc,gBAAA;EAAgB,kMAAA;EAAuL,kBAAA;EAAkB,gBAAA;EAAgB,gBAAA;EAAgB,gBAAA;EAAgB,iBAAA;EAAiB,qBAAA;EAAqB,iBAAA;EAAiB,oBAAA;EAAoB,sBAAA;EAAsB,kBAAA;EAAkB,oBAAA;EAAoB,mBAAA;EAAmB,gBAAA;EAAgB,mBAAA;EAAkB,qBAAA;EAAqB,sBAAA;EAAsB,4BAAA;EAA4B,oCAAA;EAAgC,qBAAA;AD+zLnwtG;;AC/zLuxtG;EAAgB,kBAAA;EAAkB,cAAA;EAAc,WAAA;EAAW,cAAA;EAAa,gBAAA;ADu0L/1tG;;ACv0L82tG;EAA+C,kBAAA;EAAkB,cAAA;EAAc,WAAA;EAAW,yBAAA;EAAyB,mBAAA;AD+0Lj+tG;;AC/0Lo/tG;EAAmD,qBAAA;ADm1LviuG;;ACn1L2juG;EAAiE,2BAAA;ADu1L5nuG;;ACv1LspuG;EAAiF,SAAA;EAAS,6BAAA;EAA2B,qCAAA;AD61L3wuG;;AC71L4yuG;EAA+E,WAAA;EAAW,6BAAA;EAA2B,sBAAA;ADm2Lj6uG;;ACn2Lu7uG;EAAuD,mBAAA;ADu2L9+uG;;ACv2LggvG;EAAqE,yBAAA;EAAwB,aAAA;EAAY,YAAA;EAAY,gBAAA;AD82LrnvG;;AC92LoovG;EAAqF,OAAA;EAAO,oCAAA;EAAiC,uCAAA;ADo3LjwvG;;ACp3LoyvG;EAAmF,SAAA;EAAS,oCAAA;EAAiC,wBAAA;AD03Lj6vG;;AC13Ly7vG;EAAyD,kBAAA;AD83Ll/vG;;AC93LmgwG;EAAuE,wBAAA;ADk4L1kwG;;ACl4LimwG;EAAuF,MAAA;EAAM,oCAAA;EAAiC,wCAAA;ADw4L/twG;;ACx4LmwwG;EAAqF,QAAA;EAAQ,oCAAA;EAAiC,yBAAA;AD84Lj4wG;;AC94L05wG;EAAyG,kBAAA;EAAkB,MAAA;EAAM,SAAA;EAAS,cAAA;EAAc,WAAA;EAAW,oBAAA;EAAmB,WAAA;EAAW,gCAAA;ADy5L3lxG;;ACz5L2nxG;EAAqD,oBAAA;AD65LhrxG;;AC75LmsxG;EAAmE,0BAAA;EAAyB,aAAA;EAAY,YAAA;EAAY,gBAAA;ADo6LvzxG;;ACp6Ls0xG;EAAmF,QAAA;EAAQ,oCAAA;EAAiC,sCAAA;AD06Ll8xG;;AC16Lo+xG;EAAiF,UAAA;EAAU,oCAAA;EAAiC,uBAAA;ADg7LhmyG;;ACh7LunyG;EAAgB,uBAAA;EAAqB,gBAAA;EAAgB,eAAA;EAAe,yBAAA;EAAyB,gCAAA;EAAgC,0CAAA;EAAyC,2CAAA;AD07L7xyG;;AC17Lu0yG;EAAsB,aAAA;AD87L71yG;;AC97L02yG;EAAc,uBAAA;EAAqB,cAAA;ADm8L74yG;;ACn8L25yG;EAAU,kBAAA;ADu8Lr6yG;;ACv8Lu7yG;EAA+C,mBAAA;AD48Lt+yG;;AC58Ly/yG;EAAgB,kBAAA;EAAkB,WAAA;EAAW,gBAAA;ADk9LtizG;;ACl9LsjzG;EAAuB,cAAA;EAAc,WAAA;EAAW,WAAA;ADw9LtmzG;;ACx9LinzG;EAAe,kBAAA;EAAkB,aAAA;EAAa,WAAA;EAAW,WAAA;EAAW,mBAAA;EAAsD,2BAAA;EAAwE,sCAAA;ADq+LnzzG;;ACr+L+5zG;EAAuC;IAAe,gBAAA;ED0+Ln9zG;AACF;AC3+Ls+zG;EAA8D,cAAA;AD8+Lpi0G;;AC9+Lkj0G;EAA4G,2BAAA;ADm/L9p0G;;ACn/Lyr0G;EAA6G,4BAAA;ADw/Lty0G;;ACx/Lk00G;EAA8B,UAAA;EAAU,4BAAA;EAAmD,eAAA;AD+/L750G;;AC//L460G;EAAkJ,UAAA;EAAU,UAAA;ADogMxk1G;;ACpgMkl1G;EAAqF,UAAA;EAAU,UAAA;EAAU,2BAAA;AD0gM3r1G;;AC1gMqt1G;EAAuC;IAAqF,gBAAA;ED+gM/01G;AACF;AChhMk21G;EAA8C,kBAAA;EAAkB,MAAA;EAAM,SAAA;EAAS,UAAA;EAA8B,aAAA;EAAmC,mBAAA;EAAwC,uBAAA;EAAuB,UAAA;EAAU,WAAA;EAAW,kBAAA;EAAkB,YAAA;EAAW,8BAAA;ADiiMnm2G;;ACjiMgo2G;EAAuC;IAA8C,gBAAA;EDsiMnt2G;AACF;ACviMsu2G;EAAoH,WAAA;EAAW,qBAAA;EAAqB,UAAA;EAAU,YAAA;AD6iMp42G;;AC7iM+42G;EAAuB,OAAA;ADijMt62G;;ACjjM662G;EAAuB,QAAA;ADqjMp82G;;ACrjM482G;EAAwD,qBAAA;EAAqB,WAAA;EAAW,YAAA;EAAY,mCAAA;AD4jMhj3G;;AC5jMml3G;EAA4B,yDAAA;ADgkM/m3G;;AChkMq03G;EAA4B,yDAAA;ADokMj23G;;ACpkMwj4G;EAAqB,kBAAA;EAAkB,QAAA;EAAQ,SAAA;EAAS,OAAA;EAAO,WAAA;EAA+B,aAAA;EAAkC,uBAAA;EAAuB,eAAA;EAAe,iBAAA;EAAiB,gBAAA;EAAgB,gBAAA;ADolM/v4G;;ACplM+w4G;EAAwB,uBAAA;EAAyC,cAAA;EAAc,WAAA;EAAW,WAAA;EAAW,iBAAA;EAAiB,gBAAA;EAAgB,mBAAA;EAAmB,eAAA;EAAe,sBAAA;EAAsB,4BAAA;EAA4B,kCAAA;EAAkC,qCAAA;EAAqC,YAAA;EAAW,6BAAA;ADsmM3j5G;;ACtmMul5G;EAAuC;IAAwB,gBAAA;ED2mMpp5G;AACF;AC5mMuq5G;EAA6B,UAAA;AD+mMps5G;;AC/mM8s5G;EAAkB,kBAAA;EAAkB,UAAA;EAAU,YAAA;EAAY,SAAA;EAAS,WAAA;EAAW,iBAAA;EAAiB,oBAAA;EAAoB,WAAA;EAAW,kBAAA;AD2nM505G;AC3nM875G;EAA0B;IAAoC,yBAAA;EDuoM1/5G;AACF;ACxoMsh6G;EAAgB,qBAAA;EAAqB,WAAA;EAAW,YAAA;EAAY,2BAAA;EAA2B,iCAAA;EAAgC,+BAAA;EAA+B,kBAAA;EAAwE,+CAAA;ADmpMpv6G;;ACnpMky6G;EAAmB,WAAA;EAAW,YAAA;EAAY,mBAAA;ADypM506G;ACzpM876G;EAAwB;IAA8B,mBAAA;EDwqMl/6G;ECxqMqg7G;IAAI,UAAA;ED2qMzg7G;AACF;AC5qMsh7G;EAAc,qBAAA;EAAqB,WAAA;EAAW,YAAA;EAAY,2BAAA;EAA2B,8BAAA;EAA8B,kBAAA;EAAkB,UAAA;EAA8D,6CAAA;ADurMzt7G;;ACvrMqw7G;EAAiB,WAAA;EAAW,YAAA;AD4rMjy7G;;AC5rM6y7G;EAAgB,mCAAA;ADgsM7z7G;;AChsM+17G;EAAW,8BAAA;ADosM127G;;ACpsMu47G;EAAc,iCAAA;ADwsMr57G;;ACxsMq77G;EAAc,iCAAA;AD4sMn87G;;AC5sMm+7G;EAAmB,sCAAA;ADgtMt/7G;;AChtM2h8G;EAAgB,mCAAA;ADotM3i8G;;ACptM6k8G;EAAY,oCAAA;ADwtMzl8G;;ACxtM4n8G;EAAsF,oCAAA;AD4tMlt8G;;AC5tMqv8G;EAAc,oCAAA;ADguMnw8G;;AChuMsy8G;EAA8F,oCAAA;ADouMp48G;;ACpuMu68G;EAAY,oCAAA;ADwuMn78G;;ACxuMs98G;EAAsF,oCAAA;AD4uM5i9G;;AC5uM+k9G;EAAS,oCAAA;ADgvMxl9G;;AChvM2n9G;EAA0E,oCAAA;ADovMrs9G;;ACpvMwu9G;EAAY,oCAAA;ADwvMpv9G;;ACxvMux9G;EAAsF,oCAAA;AD4vM729G;;AC5vMg59G;EAAW,oCAAA;ADgwM359G;;AChwM879G;EAAkF,oCAAA;ADowMhh+G;;ACpwMmj+G;EAAU,oCAAA;ADwwM7j+G;;ACxwMgm+G;EAA8E,oCAAA;AD4wM9q+G;;AC5wMit+G;EAAS,oCAAA;ADgxM1t+G;;AChxM6v+G;EAA0E,oCAAA;ADoxMv0+G;;ACpxM02+G;EAAU,iCAAA;ADwxMp3+G;;ACxxMo5+G;EAAgB,wCAAA;AD4xMp6+G;;AC5xM28+G;EAAQ,oCAAA;ADgyMn9+G;;AChyMs/+G;EAAY,wCAAA;ADoyMlg/G;;ACpyMyi/G;EAAc,0CAAA;ADwyMvj/G;;ACxyMgm/G;EAAe,2CAAA;AD4yM/m/G;;AC5yMyp/G;EAAa,yCAAA;ADgzMtq/G;;AChzM8s/G;EAAU,oBAAA;ADozMxt/G;;ACpzM2u/G;EAAc,wBAAA;ADwzMzv/G;;ACxzMgx/G;EAAgB,0BAAA;AD4zMhy/G;;AC5zMyz/G;EAAiB,2BAAA;ADg0M10/G;;ACh0Mo2/G;EAAe,yBAAA;ADo0Mn3/G;;ACp0M24/G;EAAgB,gCAAA;ADw0M35/G;;ACx0M07/G;EAAkB,gCAAA;AD40M58/G;;AC50M2+/G;EAAgB,gCAAA;ADg1M3//G;;ACh1M0hgH;EAAa,gCAAA;ADo1MvigH;;ACp1MskgH;EAAgB,gCAAA;ADw1MtlgH;;ACx1MqngH;EAAe,gCAAA;AD41MpogH;;AC51MmqgH;EAAc,gCAAA;ADg2MjrgH;;ACh2MgtgH;EAAa,gCAAA;ADo2M7tgH;;ACp2M4vgH;EAAc,6BAAA;ADw2M1wgH;;ACx2MsygH;EAAY,gCAAA;AD42MlzgH;;AC52Mg1gH;EAAS,iCAAA;ADg3Mz1gH;;ACh3Mw3gH;EAAa,0CAAA;EAAwC,2CAAA;ADq3M76gH;;ACr3Ms9gH;EAAe,2CAAA;EAAyC,8CAAA;AD03M9ghH;;AC13M0jhH;EAAgB,8CAAA;EAA4C,6CAAA;AD+3MtnhH;;AC/3MiqhH;EAAc,0CAAA;EAAwC,6CAAA;ADo4MvthH;;ACp4MkwhH;EAAY,gCAAA;ADw4M9whH;;ACx4M4yhH;EAAgB,6BAAA;AD44M5zhH;;AC54Mw1hH;EAAc,+BAAA;ADg5Mt2hH;;ACh5Mo4hH;EAAW,2BAAA;ADo5M/4hH;;ACp5My6hH;EAAiB,cAAA;EAAc,WAAA;EAAW,WAAA;AD05Mn9hH;;AC15M89hH;EAAQ,wBAAA;AD85Mt+hH;;AC95M6/hH;EAAU,0BAAA;ADk6MvgiH;;ACl6MgiiH;EAAgB,gCAAA;ADs6MhjiH;;ACt6M+kiH;EAAS,yBAAA;AD06MxliH;;AC16MgniH;EAAS,yBAAA;AD86MzniH;;AC96MipiH;EAAa,6BAAA;ADk7M9piH;;ACl7M0riH;EAAc,8BAAA;ADs7MxsiH;;ACt7MquiH;EAAsC,wBAAA;AD27M3wiH;;AC37MkyiH;EAAoD,+BAAA;ADg8Mt1iH;;ACh8Mo3iH;EAAyB;IAAW,wBAAA;EDq8Mt5iH;ECr8M66iH;IAAa,0BAAA;EDw8M17iH;ECx8Mm9iH;IAAmB,gCAAA;ED28Mt+iH;EC38MqgjH;IAAY,yBAAA;ED88MjhjH;EC98MyijH;IAAY,yBAAA;EDi9MrjjH;ECj9M6kjH;IAAgB,6BAAA;EDo9M7ljH;ECp9MynjH;IAAiB,8BAAA;EDu9M1ojH;ECv9MuqjH;IAAyC,wBAAA;ED29MhtjH;EC39MuujH;IAAuD,+BAAA;ED+9M9xjH;AACF;ACh+M+zjH;EAAyB;IAAW,wBAAA;EDo+Mj2jH;ECp+Mw3jH;IAAa,0BAAA;EDu+Mr4jH;ECv+M85jH;IAAmB,gCAAA;ED0+Mj7jH;EC1+Mg9jH;IAAY,yBAAA;ED6+M59jH;EC7+Mo/jH;IAAY,yBAAA;EDg/MhgkH;ECh/MwhkH;IAAgB,6BAAA;EDm/MxikH;ECn/MokkH;IAAiB,8BAAA;EDs/MrlkH;ECt/MknkH;IAAyC,wBAAA;ED0/M3pkH;EC1/MkrkH;IAAuD,+BAAA;ED8/MzukH;AACF;AC//M0wkH;EAAyB;IAAW,wBAAA;EDmgN5ykH;ECngNm0kH;IAAa,0BAAA;EDsgNh1kH;ECtgNy2kH;IAAmB,gCAAA;EDygN53kH;ECzgN25kH;IAAY,yBAAA;ED4gNv6kH;EC5gN+7kH;IAAY,yBAAA;ED+gN38kH;EC/gNm+kH;IAAgB,6BAAA;EDkhNn/kH;EClhN+glH;IAAiB,8BAAA;EDqhNhilH;ECrhN6jlH;IAAyC,wBAAA;EDyhNtmlH;ECzhN6nlH;IAAuD,+BAAA;ED6hNprlH;AACF;AC9hNqtlH;EAA0B;IAAW,wBAAA;EDkiNxvlH;ECliN+wlH;IAAa,0BAAA;EDqiN5xlH;ECriNqzlH;IAAmB,gCAAA;EDwiNx0lH;ECxiNu2lH;IAAY,yBAAA;ED2iNn3lH;EC3iN24lH;IAAY,yBAAA;ED8iNv5lH;EC9iN+6lH;IAAgB,6BAAA;EDijN/7lH;ECjjN29lH;IAAiB,8BAAA;EDojN5+lH;ECpjNygmH;IAAyC,wBAAA;EDwjNljmH;ECxjNykmH;IAAuD,+BAAA;ED4jNhomH;AACF;AC7jNiqmH;EAAa;IAAc,wBAAA;EDikN1rmH;ECjkNitmH;IAAgB,0BAAA;EDokNjumH;ECpkN0vmH;IAAsB,gCAAA;EDukNhxmH;ECvkN+ymH;IAAe,yBAAA;ED0kN9zmH;EC1kNs1mH;IAAe,yBAAA;ED6kNr2mH;EC7kN63mH;IAAmB,6BAAA;EDglNh5mH;EChlN46mH;IAAoB,8BAAA;EDmlNh8mH;ECnlN69mH;IAA4C,wBAAA;EDulNzgnH;ECvlNginH;IAA0D,+BAAA;ED2lN1lnH;AACF;AC5lN2nnH;EAAkB,kBAAA;EAAkB,cAAA;EAAc,WAAA;EAAW,UAAA;EAAU,gBAAA;ADmmNlsnH;;ACnmNktnH;EAA0B,cAAA;EAAc,WAAA;ADwmN1vnH;;ACxmNqwnH;EAA2I,kBAAA;EAAkB,MAAA;EAAM,SAAA;EAAS,OAAA;EAAO,WAAA;EAAW,YAAA;EAAY,SAAA;ADknN/8nH;;AClnNw9nH;EAAgC,uBAAA;ADsnNx/nH;;ACtnN+goH;EAAgC,mBAAA;AD0nN/ioH;;AC1nNkkoH;EAA+B,gBAAA;AD8nNjmoH;;AC9nNinoH;EAA+B,iBAAA;ADkoNhpoH;;ACloNiqoH;EAA2C,8BAAA;ADuoN5soH;;ACvoNyuoH;EAAiD,iCAAA;AD4oN1xoH;;AC5oN0zoH;EAA2D,sCAAA;ADipNr3oH;;ACjpN05oH;EAAiE,yCAAA;ADspN39oH;;ACtpNmgpH;EAAwC,0BAAA;AD2pN3ipH;;AC3pNokpH;EAA4C,4BAAA;ADgqNhnpH;;AChqN2opH;EAAwD,kCAAA;ADqqNnspH;;ACrqNoupH;EAAuC,yBAAA;AD0qN3wpH;;AC1qNmypH;EAA2C,uBAAA;AD+qN90pH;;AC/qNo2pH;EAA2C,uBAAA;ADorN/4pH;;ACprNq6pH;EAA6C,yBAAA;ADyrNl9pH;;ACzrN0+pH;EAA6C,yBAAA;AD8rNvhqH;;AC9rN+iqH;EAAqD,sCAAA;ADmsNpmqH;;ACnsNyoqH;EAAiD,oCAAA;ADwsN1rqH;;ACxsN6tqH;EAAuD,kCAAA;AD6sNpxqH;;AC7sNqzqH;EAAyD,yCAAA;ADktN92qH;;ACltNs5qH;EAA2D,wCAAA;ADutNj9qH;;ACvtNw/qH;EAAkD,kCAAA;AD4tN1irH;;AC5tN2krH;EAA8C,gCAAA;ADiuNznrH;;ACjuNwprH;EAAoD,8BAAA;ADsuN5srH;;ACtuNyurH;EAAwD,gCAAA;AD2uNjyrH;;AC3uNg0rH;EAAsD,+BAAA;ADgvNt3rH;;AChvNo5rH;EAAwD,oCAAA;ADqvN58rH;;ACrvN++rH;EAAoD,kCAAA;AD0vNnisH;;AC1vNoksH;EAA0D,gCAAA;AD+vN9nsH;;AC/vN6psH;EAA4D,uCAAA;ADowNztsH;;ACpwN+vsH;EAA8D,sCAAA;ADywN7zsH;;ACzwNk2sH;EAA4D,iCAAA;AD8wN95sH;;AC9wN87sH;EAAoD,2BAAA;ADmxNl/sH;;ACnxN4gtH;EAAsD,iCAAA;ADwxNlktH;;ACxxNkmtH;EAAkD,+BAAA;AD6xNpptH;;AC7xNkrtH;EAAwD,6BAAA;ADkyN1utH;;AClyNswtH;EAA4D,+BAAA;ADuyNl0tH;;ACvyNg2tH;EAA0D,8BAAA;AD4yN15tH;;AC5yNu7tH;EAAyB;IAA8C,8BAAA;EDkzN5/tH;EClzNyhuH;IAAoD,iCAAA;EDszN7kuH;ECtzN6muH;IAA8D,sCAAA;ED0zN3quH;EC1zNgtuH;IAAoE,yCAAA;ED8zNpxuH;EC9zN4zuH;IAA2C,0BAAA;EDk0Nv2uH;ECl0Ng4uH;IAA+C,4BAAA;EDs0N/6uH;ECt0N08uH;IAA2D,kCAAA;ED00NrgvH;EC10NsivH;IAA0C,yBAAA;ED80NhlvH;EC90NwmvH;IAA8C,uBAAA;EDk1NtpvH;ECl1N4qvH;IAA8C,uBAAA;EDs1N1tvH;ECt1NgvvH;IAAgD,yBAAA;ED01NhyvH;EC11NwzvH;IAAgD,yBAAA;ED81Nx2vH;EC91Ng4vH;IAAwD,sCAAA;EDk2Nx7vH;ECl2N69vH;IAAoD,oCAAA;EDs2NjhwH;ECt2NojwH;IAA0D,kCAAA;ED02N9mwH;EC12N+owH;IAA4D,yCAAA;ED82N3swH;EC92NmvwH;IAA8D,wCAAA;EDk3NjzwH;ECl3Nw1wH;IAAqD,kCAAA;EDs3N74wH;ECt3N86wH;IAAiD,gCAAA;ED03N/9wH;EC13N8/wH;IAAuD,8BAAA;ED83NrjxH;EC93NklxH;IAA2D,gCAAA;EDk4N7oxH;ECl4N4qxH;IAAyD,+BAAA;EDs4NruxH;ECt4NmwxH;IAA2D,oCAAA;ED04N9zxH;EC14Ni2xH;IAAuD,kCAAA;ED84Nx5xH;EC94Ny7xH;IAA6D,gCAAA;EDk5Nt/xH;ECl5NqhyH;IAA+D,uCAAA;EDs5NplyH;ECt5N0nyH;IAAiE,sCAAA;ED05N3ryH;EC15NguyH;IAA+D,iCAAA;ED85N/xyH;EC95N+zyH;IAAuD,2BAAA;EDk6Nt3yH;ECl6Ng5yH;IAAyD,iCAAA;EDs6Nz8yH;ECt6Ny+yH;IAAqD,+BAAA;ED06N9hzH;EC16N4jzH;IAA2D,6BAAA;ED86NvnzH;EC96NmpzH;IAA+D,+BAAA;EDk7NltzH;ECl7NgvzH;IAA6D,8BAAA;EDs7N7yzH;AACF;ACv7N60zH;EAAyB;IAA8C,8BAAA;ED47Nl5zH;EC57N+6zH;IAAoD,iCAAA;EDg8Nn+zH;ECh8Nmg0H;IAA8D,sCAAA;EDo8Njk0H;ECp8Nsm0H;IAAoE,yCAAA;EDw8N1q0H;ECx8Nkt0H;IAA2C,0BAAA;ED48N7v0H;EC58Nsx0H;IAA+C,4BAAA;EDg9Nr00H;ECh9Ng20H;IAA2D,kCAAA;EDo9N350H;ECp9N470H;IAA0C,yBAAA;EDw9Nt+0H;ECx9N8/0H;IAA8C,uBAAA;ED49N5i1H;EC59Nkk1H;IAA8C,uBAAA;EDg+Nhn1H;ECh+Nso1H;IAAgD,yBAAA;EDo+Ntr1H;ECp+N8s1H;IAAgD,yBAAA;EDw+N9v1H;ECx+Nsx1H;IAAwD,sCAAA;ED4+N901H;EC5+Nm31H;IAAoD,oCAAA;EDg/Nv61H;ECh/N081H;IAA0D,kCAAA;EDo/Npg2H;ECp/Nqi2H;IAA4D,yCAAA;EDw/Njm2H;ECx/Nyo2H;IAA8D,wCAAA;ED4/Nvs2H;EC5/N8u2H;IAAqD,kCAAA;EDggOny2H;EChgOo02H;IAAiD,gCAAA;EDogOr32H;ECpgOo52H;IAAuD,8BAAA;EDwgO382H;ECxgOw+2H;IAA2D,gCAAA;ED4gOni3H;EC5gOkk3H;IAAyD,+BAAA;EDghO3n3H;EChhOyp3H;IAA2D,oCAAA;EDohOpt3H;ECphOuv3H;IAAuD,kCAAA;EDwhO9y3H;ECxhO+03H;IAA6D,gCAAA;ED4hO543H;EC5hO263H;IAA+D,uCAAA;EDgiO1+3H;EChiOgh4H;IAAiE,sCAAA;EDoiOjl4H;ECpiOsn4H;IAA+D,iCAAA;EDwiOrr4H;ECxiOqt4H;IAAuD,2BAAA;ED4iO5w4H;EC5iOsy4H;IAAyD,iCAAA;EDgjO/14H;EChjO+34H;IAAqD,+BAAA;EDojOp74H;ECpjOk94H;IAA2D,6BAAA;EDwjO7g5H;ECxjOyi5H;IAA+D,+BAAA;ED4jOxm5H;EC5jOso5H;IAA6D,8BAAA;EDgkOns5H;AACF;ACjkOmu5H;EAAyB;IAA8C,8BAAA;EDskOxy5H;ECtkOq05H;IAAoD,iCAAA;ED0kOz35H;EC1kOy55H;IAA8D,sCAAA;ED8kOv95H;EC9kO4/5H;IAAoE,yCAAA;EDklOhk6H;ECllOwm6H;IAA2C,0BAAA;EDslOnp6H;ECtlO4q6H;IAA+C,4BAAA;ED0lO3t6H;EC1lOsv6H;IAA2D,kCAAA;ED8lOjz6H;EC9lOk16H;IAA0C,yBAAA;EDkmO536H;EClmOo56H;IAA8C,uBAAA;EDsmOl86H;ECtmOw96H;IAA8C,uBAAA;ED0mOtg7H;EC1mO4h7H;IAAgD,yBAAA;ED8mO5k7H;EC9mOom7H;IAAgD,yBAAA;EDknOpp7H;EClnO4q7H;IAAwD,sCAAA;EDsnOpu7H;ECtnOyw7H;IAAoD,oCAAA;ED0nO7z7H;EC1nOg27H;IAA0D,kCAAA;ED8nO157H;EC9nO277H;IAA4D,yCAAA;EDkoOv/7H;ECloO+h8H;IAA8D,wCAAA;EDsoO7l8H;ECtoOoo8H;IAAqD,kCAAA;ED0oOzr8H;EC1oO0t8H;IAAiD,gCAAA;ED8oO3w8H;EC9oO0y8H;IAAuD,8BAAA;EDkpOj28H;EClpO838H;IAA2D,gCAAA;EDspOz78H;ECtpOw98H;IAAyD,+BAAA;ED0pOjh9H;EC1pO+i9H;IAA2D,oCAAA;ED8pO1m9H;EC9pO6o9H;IAAuD,kCAAA;EDkqOps9H;EClqOqu9H;IAA6D,gCAAA;EDsqOly9H;ECtqOi09H;IAA+D,uCAAA;ED0qOh49H;EC1qOs69H;IAAiE,sCAAA;ED8qOv+9H;EC9qO4g+H;IAA+D,iCAAA;EDkrO3k+H;EClrO2m+H;IAAuD,2BAAA;EDsrOlq+H;ECtrO4r+H;IAAyD,iCAAA;ED0rOrv+H;EC1rOqx+H;IAAqD,+BAAA;ED8rO10+H;EC9rOw2+H;IAA2D,6BAAA;EDksOn6+H;EClsO+7+H;IAA+D,+BAAA;EDssO9/+H;ECtsO4h/H;IAA6D,8BAAA;ED0sOzl/H;AACF;AC3sOyn/H;EAA0B;IAA8C,8BAAA;EDgtO/r/H;EChtO4t/H;IAAoD,iCAAA;EDotOhx/H;ECptOgz/H;IAA8D,sCAAA;EDwtO92/H;ECxtOm5/H;IAAoE,yCAAA;ED4tOv9/H;EC5tO+//H;IAA2C,0BAAA;EDguO1igI;EChuOmkgI;IAA+C,4BAAA;EDouOlngI;ECpuO6ogI;IAA2D,kCAAA;EDwuOxsgI;ECxuOyugI;IAA0C,yBAAA;ED4uOnxgI;EC5uO2ygI;IAA8C,uBAAA;EDgvOz1gI;EChvO+2gI;IAA8C,uBAAA;EDovO75gI;ECpvOm7gI;IAAgD,yBAAA;EDwvOn+gI;ECxvO2/gI;IAAgD,yBAAA;ED4vO3ihI;EC5vOmkhI;IAAwD,sCAAA;EDgwO3nhI;EChwOgqhI;IAAoD,oCAAA;EDowOpthI;ECpwOuvhI;IAA0D,kCAAA;EDwwOjzhI;ECxwOk1hI;IAA4D,yCAAA;ED4wO94hI;EC5wOs7hI;IAA8D,wCAAA;EDgxOp/hI;EChxO2hiI;IAAqD,kCAAA;EDoxOhliI;ECpxOiniI;IAAiD,gCAAA;EDwxOlqiI;ECxxOisiI;IAAuD,8BAAA;ED4xOxviI;EC5xOqxiI;IAA2D,gCAAA;EDgyOh1iI;EChyO+2iI;IAAyD,+BAAA;EDoyOx6iI;ECpyOs8iI;IAA2D,oCAAA;EDwyOjgjI;ECxyOoijI;IAAuD,kCAAA;ED4yO3ljI;EC5yO4njI;IAA6D,gCAAA;EDgzOzrjI;EChzOwtjI;IAA+D,uCAAA;EDozOvxjI;ECpzO6zjI;IAAiE,sCAAA;EDwzO93jI;ECxzOm6jI;IAA+D,iCAAA;ED4zOl+jI;EC5zOkgkI;IAAuD,2BAAA;EDg0OzjkI;ECh0OmlkI;IAAyD,iCAAA;EDo0O5okI;ECp0O4qkI;IAAqD,+BAAA;EDw0OjukI;ECx0O+vkI;IAA2D,6BAAA;ED40O1zkI;EC50Os1kI;IAA+D,+BAAA;EDg1Or5kI;ECh1Om7kI;IAA6D,8BAAA;EDo1Oh/kI;AACF;ACr1OghlI;EAAY,sBAAA;ADw1O5hlI;;ACx1OijlI;EAAa,uBAAA;AD41O9jlI;;AC51OollI;EAAY,sBAAA;ADg2OhmlI;;ACh2OqnlI;EAAyB;IAAe,sBAAA;EDq2O3plI;ECr2OgrlI;IAAgB,uBAAA;EDw2OhslI;ECx2OstlI;IAAe,sBAAA;ED22OrulI;AACF;AC52O6vlI;EAAyB;IAAe,sBAAA;EDg3OnylI;ECh3OwzlI;IAAgB,uBAAA;EDm3Ox0lI;ECn3O81lI;IAAe,sBAAA;EDs3O72lI;AACF;ACv3Oq4lI;EAAyB;IAAe,sBAAA;ED23O36lI;EC33Og8lI;IAAgB,uBAAA;ED83Oh9lI;EC93Os+lI;IAAe,sBAAA;EDi4Or/lI;AACF;ACl4O6gmI;EAA0B;IAAe,sBAAA;EDs4OpjmI;ECt4OykmI;IAAgB,uBAAA;EDy4OzlmI;ECz4O+mmI;IAAe,sBAAA;ED44O9nmI;AACF;AC74OspmI;EAAe,yBAAA;ADg5OrqmI;;ACh5O6rmI;EAAiB,2BAAA;ADo5O9smI;;ACp5OwumI;EAAiB,2BAAA;ADw5OzvmI;;ACx5OmxmI;EAAmB,6BAAA;AD45OtymI;;AC55Ok0mI;EAAmB,6BAAA;ADg6Or1mI;;ACh6Oi3mI;EAAgB,0BAAA;ADo6Oj4mI;;ACp6O05mI;EAAmD,2BAAA;ADy6O78mI;;ACz6Ou+mI;EAAW,eAAA;EAAe,MAAA;EAAM,QAAA;EAAQ,OAAA;EAAO,aAAA;ADi7OthnI;;ACj7OminI;EAAc,eAAA;EAAe,QAAA;EAAQ,SAAA;EAAS,OAAA;EAAO,aAAA;ADy7OxlnI;;ACz7OqmnI;EAA2D;IAAoC,gBAAA;IAAgB,MAAA;IAAM,aAAA;EDi8OxtnI;AACF;ACl8OwunI;EAAS,kBAAA;EAAkB,UAAA;EAAU,WAAA;EAAW,UAAA;EAAU,YAAA;EAAY,gBAAA;EAAgB,sBAAA;EAAmB,mBAAA;EAAmB,SAAA;AD68Op2nI;;AC78O62nI;EAAmD,gBAAA;EAAgB,WAAA;EAAW,YAAA;EAAY,iBAAA;EAAiB,UAAA;EAAU,mBAAA;ADs9Ol+nI;;ACt9Oq/nI;EAAW,8DAAA;AD09OhgoI;;AC19OujoI;EAAQ,wDAAA;AD89O/joI;;AC99OinoI;EAAW,uDAAA;ADk+O5noI;;ACl+O8qoI;EAAa,2BAAA;ADs+O3roI;;ACt+OqtoI;EAAM,qBAAA;AD0+O3toI;;AC1+O+uoI;EAAM,qBAAA;AD8+OrvoI;;AC9+OywoI;EAAM,qBAAA;ADk/O/woI;;ACl/OmyoI;EAAO,sBAAA;ADs/O1yoI;;ACt/O+zoI;EAAQ,sBAAA;AD0/Ov0oI;;AC1/O41oI;EAAM,sBAAA;AD8/Ol2oI;;AC9/Ou3oI;EAAM,sBAAA;ADkgP73oI;;AClgPk5oI;EAAM,sBAAA;ADsgPx5oI;;ACtgP66oI;EAAO,uBAAA;AD0gPp7oI;;AC1gP08oI;EAAQ,uBAAA;AD8gPl9oI;;AC9gPw+oI;EAAQ,0BAAA;ADkhPh/oI;;AClhPygpI;EAAQ,2BAAA;ADshPjhpI;;ACthP2ipI;EAAY,2BAAA;AD0hPvjpI;;AC1hPilpI;EAAY,4BAAA;AD8hP7lpI;;AC9hPwnpI;EAAQ,uBAAA;ADkiPhopI;;ACliPsppI;EAAQ,wBAAA;ADsiP9ppI;;ACtiPqrpI;EAAuB,kBAAA;EAAkB,MAAA;EAAM,QAAA;EAAQ,SAAA;EAAS,OAAA;EAAO,UAAA;EAAU,oBAAA;EAAoB,WAAA;EAAW,kCAAA;ADkjPrypI;;ACljPo0pI;EAAK,oBAAA;ADsjPz0pI;;ACtjP41pI;EAAY,wBAAA;AD0jPx2pI;;AC1jP+3pI;EAAY,0BAAA;AD8jP34pI;;AC9jPo6pI;EAAY,2BAAA;ADkkPh7pI;;AClkP08pI;EAAY,yBAAA;ADskPt9pI;;ACtkP8+pI;EAAK,0BAAA;AD0kPn/pI;;AC1kP2gqI;EAAY,8BAAA;AD8kPvhqI;;AC9kPmjqI;EAAY,gCAAA;ADklP/jqI;;ACllP6lqI;EAAY,iCAAA;ADslPzmqI;;ACtlPwoqI;EAAY,+BAAA;AD0lPppqI;;AC1lPirqI;EAAK,yBAAA;AD8lPtrqI;;AC9lP6sqI;EAAY,6BAAA;ADkmPztqI;;AClmPovqI;EAAY,+BAAA;ADsmPhwqI;;ACtmP6xqI;EAAY,gCAAA;AD0mPzyqI;;AC1mPu0qI;EAAY,8BAAA;AD8mPn1qI;;AC9mP+2qI;EAAK,uBAAA;ADknPp3qI;;AClnP04qI;EAAY,2BAAA;ADsnPt5qI;;ACtnPg7qI;EAAY,6BAAA;AD0nP57qI;;AC1nPw9qI;EAAY,8BAAA;AD8nPp+qI;;AC9nPigrI;EAAY,4BAAA;ADkoP7grI;;ACloPwirI;EAAK,yBAAA;ADsoP7irI;;ACtoPqkrI;EAAY,6BAAA;AD0oPjlrI;;AC1oP6mrI;EAAY,+BAAA;AD8oPznrI;;AC9oPuprI;EAAY,gCAAA;ADkpPnqrI;;AClpPksrI;EAAY,8BAAA;ADspP9srI;;ACtpP2urI;EAAK,uBAAA;AD0pPhvrI;;AC1pPswrI;EAAY,2BAAA;AD8pPlxrI;;AC9pP4yrI;EAAY,6BAAA;ADkqPxzrI;;AClqPo1rI;EAAY,8BAAA;ADsqPh2rI;;ACtqP63rI;EAAY,4BAAA;AD0qPz4rI;;AC1qPo6rI;EAAK,qBAAA;AD8qPz6rI;;AC9qP67rI;EAAY,yBAAA;ADkrPz8rI;;AClrPi+rI;EAAY,2BAAA;ADsrP7+rI;;ACtrPugsI;EAAY,4BAAA;AD0rPnhsI;;AC1rP8isI;EAAY,0BAAA;AD8rP1jsI;;AC9rPmlsI;EAAK,2BAAA;ADksPxlsI;;AClsPinsI;EAAY,+BAAA;ADssP7nsI;;ACtsP0psI;EAAY,iCAAA;AD0sPtqsI;;AC1sPqssI;EAAY,kCAAA;AD8sPjtsI;;AC9sPivsI;EAAY,gCAAA;ADktP7vsI;;ACltP2xsI;EAAK,0BAAA;ADstPhysI;;ACttPwzsI;EAAY,8BAAA;AD0tPp0sI;;AC1tPg2sI;EAAY,gCAAA;AD8tP52sI;;AC9tP04sI;EAAY,iCAAA;ADkuPt5sI;;ACluPq7sI;EAAY,+BAAA;ADsuPj8sI;;ACtuP89sI;EAAK,wBAAA;AD0uPn+sI;;AC1uP0/sI;EAAY,4BAAA;AD8uPtgtI;;AC9uPiitI;EAAY,8BAAA;ADkvP7itI;;AClvP0ktI;EAAY,+BAAA;ADsvPtltI;;ACtvPontI;EAAY,6BAAA;AD0vPhotI;;AC1vP4ptI;EAAK,0BAAA;AD8vPjqtI;;AC9vP0rtI;EAAY,8BAAA;ADkwPtstI;;AClwPmutI;EAAY,gCAAA;ADswP/utI;;ACtwP8wtI;EAAY,iCAAA;AD0wP1xtI;;AC1wP0ztI;EAAY,+BAAA;AD8wPt0tI;;AC9wPo2tI;EAAK,wBAAA;ADkxPz2tI;;AClxPg4tI;EAAY,4BAAA;ADsxP54tI;;ACtxPu6tI;EAAY,8BAAA;AD0xPn7tI;;AC1xPg9tI;EAAY,+BAAA;AD8xP59tI;;AC9xP0/tI;EAAY,6BAAA;ADkyPtguI;;AClyPkiuI;EAAM,2BAAA;ADsyPxiuI;;ACtyPikuI;EAAc,+BAAA;AD0yP/kuI;;AC1yP4muI;EAAc,iCAAA;AD8yP1nuI;;AC9yPypuI;EAAc,kCAAA;ADkzPvquI;;AClzPusuI;EAAc,gCAAA;ADszPrtuI;;ACtzPmvuI;EAAM,0BAAA;AD0zPzvuI;;AC1zPixuI;EAAc,8BAAA;AD8zP/xuI;;AC9zP2zuI;EAAc,gCAAA;ADk0Pz0uI;;ACl0Pu2uI;EAAc,iCAAA;ADs0Pr3uI;;ACt0Po5uI;EAAc,+BAAA;AD00Pl6uI;;AC10P+7uI;EAAM,wBAAA;AD80Pr8uI;;AC90P49uI;EAAc,4BAAA;ADk1P1+uI;;ACl1PqgvI;EAAc,8BAAA;ADs1PnhvI;;ACt1PgjvI;EAAc,+BAAA;AD01P9jvI;;AC11P4lvI;EAAc,6BAAA;AD81P1mvI;;AC91PsovI;EAAM,0BAAA;ADk2P5ovI;;ACl2PqqvI;EAAc,8BAAA;ADs2PnrvI;;ACt2PgtvI;EAAc,gCAAA;AD02P9tvI;;AC12P6vvI;EAAc,iCAAA;AD82P3wvI;;AC92P2yvI;EAAc,+BAAA;ADk3PzzvI;;ACl3Pu1vI;EAAM,wBAAA;ADs3P71vI;;ACt3Po3vI;EAAc,4BAAA;AD03Pl4vI;;AC13P65vI;EAAc,8BAAA;AD83P36vI;;AC93Pw8vI;EAAc,+BAAA;ADk4Pt9vI;;ACl4Po/vI;EAAc,6BAAA;ADs4PlgwI;;ACt4P8hwI;EAAQ,uBAAA;AD04PtiwI;;AC14P4jwI;EAAkB,2BAAA;AD84P9kwI;;AC94PwmwI;EAAkB,6BAAA;ADk5P1nwI;;ACl5PspwI;EAAkB,8BAAA;ADs5PxqwI;;ACt5PqswI;EAAkB,4BAAA;AD05PvtwI;;AC15PkvwI;EAAyB;IAAQ,oBAAA;ED+5PjxwI;EC/5PoywI;IAAkB,wBAAA;EDk6PtzwI;ECl6P60wI;IAAkB,0BAAA;EDq6P/1wI;ECr6Pw3wI;IAAkB,2BAAA;EDw6P14wI;ECx6Po6wI;IAAkB,yBAAA;ED26Pt7wI;EC36P88wI;IAAQ,0BAAA;ED86Pt9wI;EC96P8+wI;IAAkB,8BAAA;EDi7PhgxI;ECj7P4hxI;IAAkB,gCAAA;EDo7P9ixI;ECp7P4kxI;IAAkB,iCAAA;EDu7P9lxI;ECv7P6nxI;IAAkB,+BAAA;ED07P/oxI;EC17P4qxI;IAAQ,yBAAA;ED67PprxI;EC77P2sxI;IAAkB,6BAAA;EDg8P7txI;ECh8PwvxI;IAAkB,+BAAA;EDm8P1wxI;ECn8PuyxI;IAAkB,gCAAA;EDs8PzzxI;ECt8Pu1xI;IAAkB,8BAAA;EDy8Pz2xI;ECz8Pq4xI;IAAQ,uBAAA;ED48P74xI;EC58Pm6xI;IAAkB,2BAAA;ED+8Pr7xI;EC/8P+8xI;IAAkB,6BAAA;EDk9Pj+xI;ECl9P6/xI;IAAkB,8BAAA;EDq9P/gyI;ECr9P4iyI;IAAkB,4BAAA;EDw9P9jyI;ECx9PylyI;IAAQ,yBAAA;ED29PjmyI;EC39PynyI;IAAkB,6BAAA;ED89P3oyI;EC99PuqyI;IAAkB,+BAAA;EDi+PzryI;ECj+PutyI;IAAkB,gCAAA;EDo+PzuyI;ECp+PwwyI;IAAkB,8BAAA;EDu+P1xyI;ECv+PuzyI;IAAQ,uBAAA;ED0+P/zyI;EC1+Pq1yI;IAAkB,2BAAA;ED6+Pv2yI;EC7+Pi4yI;IAAkB,6BAAA;EDg/Pn5yI;ECh/P+6yI;IAAkB,8BAAA;EDm/Pj8yI;ECn/P89yI;IAAkB,4BAAA;EDs/Ph/yI;ECt/P2gzI;IAAQ,qBAAA;EDy/PnhzI;ECz/PuizI;IAAkB,yBAAA;ED4/PzjzI;EC5/PilzI;IAAkB,2BAAA;ED+/PnmzI;EC//P6nzI;IAAkB,4BAAA;EDkgQ/ozI;EClgQ0qzI;IAAkB,0BAAA;EDqgQ5rzI;ECrgQqtzI;IAAQ,2BAAA;EDwgQ7tzI;ECxgQsvzI;IAAkB,+BAAA;ED2gQxwzI;EC3gQqyzI;IAAkB,iCAAA;ED8gQvzzI;EC9gQs1zI;IAAkB,kCAAA;EDihQx2zI;ECjhQw4zI;IAAkB,gCAAA;EDohQ15zI;ECphQw7zI;IAAQ,0BAAA;EDuhQh8zI;ECvhQw9zI;IAAkB,8BAAA;ED0hQ1+zI;EC1hQsg0I;IAAkB,gCAAA;ED6hQxh0I;EC7hQsj0I;IAAkB,iCAAA;EDgiQxk0I;EChiQum0I;IAAkB,+BAAA;EDmiQzn0I;ECniQsp0I;IAAQ,wBAAA;EDsiQ9p0I;ECtiQqr0I;IAAkB,4BAAA;EDyiQvs0I;ECziQku0I;IAAkB,8BAAA;ED4iQpv0I;EC5iQix0I;IAAkB,+BAAA;ED+iQny0I;EC/iQi00I;IAAkB,6BAAA;EDkjQn10I;ECljQ+20I;IAAQ,0BAAA;EDqjQv30I;ECrjQg50I;IAAkB,8BAAA;EDwjQl60I;ECxjQ+70I;IAAkB,gCAAA;ED2jQj90I;EC3jQg/0I;IAAkB,iCAAA;ED8jQlg1I;EC9jQki1I;IAAkB,+BAAA;EDikQpj1I;ECjkQkl1I;IAAQ,wBAAA;EDokQ1l1I;ECpkQin1I;IAAkB,4BAAA;EDukQno1I;ECvkQ8p1I;IAAkB,8BAAA;ED0kQhr1I;EC1kQ6s1I;IAAkB,+BAAA;ED6kQ/t1I;EC7kQ6v1I;IAAkB,6BAAA;EDglQ/w1I;EChlQ2y1I;IAAS,2BAAA;EDmlQpz1I;ECnlQ601I;IAAoB,+BAAA;EDslQj21I;ECtlQ831I;IAAoB,iCAAA;EDylQl51I;ECzlQi71I;IAAoB,kCAAA;ED4lQr81I;EC5lQq+1I;IAAoB,gCAAA;ED+lQz/1I;EC/lQuh2I;IAAS,0BAAA;EDkmQhi2I;EClmQwj2I;IAAoB,8BAAA;EDqmQ5k2I;ECrmQwm2I;IAAoB,gCAAA;EDwmQ5n2I;ECxmQ0p2I;IAAoB,iCAAA;ED2mQ9q2I;EC3mQ6s2I;IAAoB,+BAAA;ED8mQju2I;EC9mQ8v2I;IAAS,wBAAA;EDinQvw2I;ECjnQ8x2I;IAAoB,4BAAA;EDonQlz2I;ECpnQ602I;IAAoB,8BAAA;EDunQj22I;ECvnQ832I;IAAoB,+BAAA;ED0nQl52I;EC1nQg72I;IAAoB,6BAAA;ED6nQp82I;EC7nQg+2I;IAAS,0BAAA;EDgoQz+2I;EChoQkg3I;IAAoB,8BAAA;EDmoQth3I;ECnoQmj3I;IAAoB,gCAAA;EDsoQvk3I;ECtoQsm3I;IAAoB,iCAAA;EDyoQ1n3I;ECzoQ0p3I;IAAoB,+BAAA;ED4oQ9q3I;EC5oQ4s3I;IAAS,wBAAA;ED+oQrt3I;EC/oQ4u3I;IAAoB,4BAAA;EDkpQhw3I;EClpQ2x3I;IAAoB,8BAAA;EDqpQ/y3I;ECrpQ403I;IAAoB,+BAAA;EDwpQh23I;ECxpQ833I;IAAoB,6BAAA;ED2pQl53I;EC3pQ863I;IAAW,uBAAA;ED8pQz73I;EC9pQ+83I;IAAwB,2BAAA;EDiqQv+3I;ECjqQig4I;IAAwB,6BAAA;EDoqQzh4I;ECpqQqj4I;IAAwB,8BAAA;EDuqQ7k4I;ECvqQ0m4I;IAAwB,4BAAA;ED0qQlo4I;AACF;AC3qQgq4I;EAAyB;IAAQ,oBAAA;ED+qQ/r4I;EC/qQkt4I;IAAkB,wBAAA;EDkrQpu4I;EClrQ2v4I;IAAkB,0BAAA;EDqrQ7w4I;ECrrQsy4I;IAAkB,2BAAA;EDwrQxz4I;ECxrQk14I;IAAkB,yBAAA;ED2rQp24I;EC3rQ434I;IAAQ,0BAAA;ED8rQp44I;EC9rQ454I;IAAkB,8BAAA;EDisQ964I;ECjsQ084I;IAAkB,gCAAA;EDosQ594I;ECpsQ0/4I;IAAkB,iCAAA;EDusQ5g5I;ECvsQ2i5I;IAAkB,+BAAA;ED0sQ7j5I;EC1sQ0l5I;IAAQ,yBAAA;ED6sQlm5I;EC7sQyn5I;IAAkB,6BAAA;EDgtQ3o5I;EChtQsq5I;IAAkB,+BAAA;EDmtQxr5I;ECntQqt5I;IAAkB,gCAAA;EDstQvu5I;ECttQqw5I;IAAkB,8BAAA;EDytQvx5I;ECztQmz5I;IAAQ,uBAAA;ED4tQ3z5I;EC5tQi15I;IAAkB,2BAAA;ED+tQn25I;EC/tQ635I;IAAkB,6BAAA;EDkuQ/45I;ECluQ265I;IAAkB,8BAAA;EDquQ775I;ECruQ095I;IAAkB,4BAAA;EDwuQ5+5I;ECxuQug6I;IAAQ,yBAAA;ED2uQ/g6I;EC3uQui6I;IAAkB,6BAAA;ED8uQzj6I;EC9uQql6I;IAAkB,+BAAA;EDivQvm6I;ECjvQqo6I;IAAkB,gCAAA;EDovQvp6I;ECpvQsr6I;IAAkB,8BAAA;EDuvQxs6I;ECvvQqu6I;IAAQ,uBAAA;ED0vQ7u6I;EC1vQmw6I;IAAkB,2BAAA;ED6vQrx6I;EC7vQ+y6I;IAAkB,6BAAA;EDgwQj06I;EChwQ616I;IAAkB,8BAAA;EDmwQ/26I;ECnwQ446I;IAAkB,4BAAA;EDswQ956I;ECtwQy76I;IAAQ,qBAAA;EDywQj86I;ECzwQq96I;IAAkB,yBAAA;ED4wQv+6I;EC5wQ+/6I;IAAkB,2BAAA;ED+wQjh7I;EC/wQ2i7I;IAAkB,4BAAA;EDkxQ7j7I;EClxQwl7I;IAAkB,0BAAA;EDqxQ1m7I;ECrxQmo7I;IAAQ,2BAAA;EDwxQ3o7I;ECxxQoq7I;IAAkB,+BAAA;ED2xQtr7I;EC3xQmt7I;IAAkB,iCAAA;ED8xQru7I;EC9xQow7I;IAAkB,kCAAA;EDiyQtx7I;ECjyQsz7I;IAAkB,gCAAA;EDoyQx07I;ECpyQs27I;IAAQ,0BAAA;EDuyQ927I;ECvyQs47I;IAAkB,8BAAA;ED0yQx57I;EC1yQo77I;IAAkB,gCAAA;ED6yQt87I;EC7yQo+7I;IAAkB,iCAAA;EDgzQt/7I;EChzQqh8I;IAAkB,+BAAA;EDmzQvi8I;ECnzQok8I;IAAQ,wBAAA;EDszQ5k8I;ECtzQmm8I;IAAkB,4BAAA;EDyzQrn8I;ECzzQgp8I;IAAkB,8BAAA;ED4zQlq8I;EC5zQ+r8I;IAAkB,+BAAA;ED+zQjt8I;EC/zQ+u8I;IAAkB,6BAAA;EDk0Qjw8I;ECl0Q6x8I;IAAQ,0BAAA;EDq0Qry8I;ECr0Q8z8I;IAAkB,8BAAA;EDw0Qh18I;ECx0Q628I;IAAkB,gCAAA;ED20Q/38I;EC30Q858I;IAAkB,iCAAA;ED80Qh78I;EC90Qg98I;IAAkB,+BAAA;EDi1Ql+8I;ECj1Qgg9I;IAAQ,wBAAA;EDo1Qxg9I;ECp1Q+h9I;IAAkB,4BAAA;EDu1Qjj9I;ECv1Q4k9I;IAAkB,8BAAA;ED01Q9l9I;EC11Q2n9I;IAAkB,+BAAA;ED61Q7o9I;EC71Q2q9I;IAAkB,6BAAA;EDg2Q7r9I;ECh2Qyt9I;IAAS,2BAAA;EDm2Qlu9I;ECn2Q2v9I;IAAoB,+BAAA;EDs2Q/w9I;ECt2Q4y9I;IAAoB,iCAAA;EDy2Qh09I;ECz2Q+19I;IAAoB,kCAAA;ED42Qn39I;EC52Qm59I;IAAoB,gCAAA;ED+2Qv69I;EC/2Qq89I;IAAS,0BAAA;EDk3Q989I;ECl3Qs+9I;IAAoB,8BAAA;EDq3Q1/9I;ECr3Qsh+I;IAAoB,gCAAA;EDw3Q1i+I;ECx3Qwk+I;IAAoB,iCAAA;ED23Q5l+I;EC33Q2n+I;IAAoB,+BAAA;ED83Q/o+I;EC93Q4q+I;IAAS,wBAAA;EDi4Qrr+I;ECj4Q4s+I;IAAoB,4BAAA;EDo4Qhu+I;ECp4Q2v+I;IAAoB,8BAAA;EDu4Q/w+I;ECv4Q4y+I;IAAoB,+BAAA;ED04Qh0+I;EC14Q81+I;IAAoB,6BAAA;ED64Ql3+I;EC74Q84+I;IAAS,0BAAA;EDg5Qv5+I;ECh5Qg7+I;IAAoB,8BAAA;EDm5Qp8+I;ECn5Qi++I;IAAoB,gCAAA;EDs5Qr/+I;ECt5Qoh/I;IAAoB,iCAAA;EDy5Qxi/I;ECz5Qwk/I;IAAoB,+BAAA;ED45Q5l/I;EC55Q0n/I;IAAS,wBAAA;ED+5Qno/I;EC/5Q0p/I;IAAoB,4BAAA;EDk6Q9q/I;ECl6Qys/I;IAAoB,8BAAA;EDq6Q7t/I;ECr6Q0v/I;IAAoB,+BAAA;EDw6Q9w/I;ECx6Q4y/I;IAAoB,6BAAA;ED26Qh0/I;EC36Q41/I;IAAW,uBAAA;ED86Qv2/I;EC96Q63/I;IAAwB,2BAAA;EDi7Qr5/I;ECj7Q+6/I;IAAwB,6BAAA;EDo7Qv8/I;ECp7Qm+/I;IAAwB,8BAAA;EDu7Q3//I;ECv7QwhgJ;IAAwB,4BAAA;ED07QhjgJ;AACF;AC37Q8kgJ;EAAyB;IAAQ,oBAAA;ED+7Q7mgJ;EC/7QgogJ;IAAkB,wBAAA;EDk8QlpgJ;ECl8QyqgJ;IAAkB,0BAAA;EDq8Q3rgJ;ECr8QotgJ;IAAkB,2BAAA;EDw8QtugJ;ECx8QgwgJ;IAAkB,yBAAA;ED28QlxgJ;EC38Q0ygJ;IAAQ,0BAAA;ED88QlzgJ;EC98Q00gJ;IAAkB,8BAAA;EDi9Q51gJ;ECj9Qw3gJ;IAAkB,gCAAA;EDo9Q14gJ;ECp9Qw6gJ;IAAkB,iCAAA;EDu9Q17gJ;ECv9Qy9gJ;IAAkB,+BAAA;ED09Q3+gJ;EC19QwghJ;IAAQ,yBAAA;ED69QhhhJ;EC79QuihJ;IAAkB,6BAAA;EDg+QzjhJ;ECh+QolhJ;IAAkB,+BAAA;EDm+QtmhJ;ECn+QmohJ;IAAkB,gCAAA;EDs+QrphJ;ECt+QmrhJ;IAAkB,8BAAA;EDy+QrshJ;ECz+QiuhJ;IAAQ,uBAAA;ED4+QzuhJ;EC5+Q+vhJ;IAAkB,2BAAA;ED++QjxhJ;EC/+Q2yhJ;IAAkB,6BAAA;EDk/Q7zhJ;ECl/Qy1hJ;IAAkB,8BAAA;EDq/Q32hJ;ECr/Qw4hJ;IAAkB,4BAAA;EDw/Q15hJ;ECx/Qq7hJ;IAAQ,yBAAA;ED2/Q77hJ;EC3/Qq9hJ;IAAkB,6BAAA;ED8/Qv+hJ;EC9/QmgiJ;IAAkB,+BAAA;EDigRrhiJ;ECjgRmjiJ;IAAkB,gCAAA;EDogRrkiJ;ECpgRomiJ;IAAkB,8BAAA;EDugRtniJ;ECvgRmpiJ;IAAQ,uBAAA;ED0gR3piJ;EC1gRiriJ;IAAkB,2BAAA;ED6gRnsiJ;EC7gR6tiJ;IAAkB,6BAAA;EDghR/uiJ;EChhR2wiJ;IAAkB,8BAAA;EDmhR7xiJ;ECnhR0ziJ;IAAkB,4BAAA;EDshR50iJ;ECthRu2iJ;IAAQ,qBAAA;EDyhR/2iJ;ECzhRm4iJ;IAAkB,yBAAA;ED4hRr5iJ;EC5hR66iJ;IAAkB,2BAAA;ED+hR/7iJ;EC/hRy9iJ;IAAkB,4BAAA;EDkiR3+iJ;ECliRsgjJ;IAAkB,0BAAA;EDqiRxhjJ;ECriRijjJ;IAAQ,2BAAA;EDwiRzjjJ;ECxiRkljJ;IAAkB,+BAAA;ED2iRpmjJ;EC3iRiojJ;IAAkB,iCAAA;ED8iRnpjJ;EC9iRkrjJ;IAAkB,kCAAA;EDijRpsjJ;ECjjRoujJ;IAAkB,gCAAA;EDojRtvjJ;ECpjRoxjJ;IAAQ,0BAAA;EDujR5xjJ;ECvjRozjJ;IAAkB,8BAAA;ED0jRt0jJ;EC1jRk2jJ;IAAkB,gCAAA;ED6jRp3jJ;EC7jRk5jJ;IAAkB,iCAAA;EDgkRp6jJ;EChkRm8jJ;IAAkB,+BAAA;EDmkRr9jJ;ECnkRk/jJ;IAAQ,wBAAA;EDskR1/jJ;ECtkRihkJ;IAAkB,4BAAA;EDykRnikJ;ECzkR8jkJ;IAAkB,8BAAA;ED4kRhlkJ;EC5kR6mkJ;IAAkB,+BAAA;ED+kR/nkJ;EC/kR6pkJ;IAAkB,6BAAA;EDklR/qkJ;ECllR2skJ;IAAQ,0BAAA;EDqlRntkJ;ECrlR4ukJ;IAAkB,8BAAA;EDwlR9vkJ;ECxlR2xkJ;IAAkB,gCAAA;ED2lR7ykJ;EC3lR40kJ;IAAkB,iCAAA;ED8lR91kJ;EC9lR83kJ;IAAkB,+BAAA;EDimRh5kJ;ECjmR86kJ;IAAQ,wBAAA;EDomRt7kJ;ECpmR68kJ;IAAkB,4BAAA;EDumR/9kJ;ECvmR0/kJ;IAAkB,8BAAA;ED0mR5glJ;EC1mRyilJ;IAAkB,+BAAA;ED6mR3jlJ;EC7mRyllJ;IAAkB,6BAAA;EDgnR3mlJ;EChnRuolJ;IAAS,2BAAA;EDmnRhplJ;ECnnRyqlJ;IAAoB,+BAAA;EDsnR7rlJ;ECtnR0tlJ;IAAoB,iCAAA;EDynR9ulJ;ECznR6wlJ;IAAoB,kCAAA;ED4nRjylJ;EC5nRi0lJ;IAAoB,gCAAA;ED+nRr1lJ;EC/nRm3lJ;IAAS,0BAAA;EDkoR53lJ;ECloRo5lJ;IAAoB,8BAAA;EDqoRx6lJ;ECroRo8lJ;IAAoB,gCAAA;EDwoRx9lJ;ECxoRs/lJ;IAAoB,iCAAA;ED2oR1gmJ;EC3oRyimJ;IAAoB,+BAAA;ED8oR7jmJ;EC9oR0lmJ;IAAS,wBAAA;EDipRnmmJ;ECjpR0nmJ;IAAoB,4BAAA;EDopR9omJ;ECppRyqmJ;IAAoB,8BAAA;EDupR7rmJ;ECvpR0tmJ;IAAoB,+BAAA;ED0pR9umJ;EC1pR4wmJ;IAAoB,6BAAA;ED6pRhymJ;EC7pR4zmJ;IAAS,0BAAA;EDgqRr0mJ;EChqR81mJ;IAAoB,8BAAA;EDmqRl3mJ;ECnqR+4mJ;IAAoB,gCAAA;EDsqRn6mJ;ECtqRk8mJ;IAAoB,iCAAA;EDyqRt9mJ;ECzqRs/mJ;IAAoB,+BAAA;ED4qR1gnJ;EC5qRwinJ;IAAS,wBAAA;ED+qRjjnJ;EC/qRwknJ;IAAoB,4BAAA;EDkrR5lnJ;EClrRunnJ;IAAoB,8BAAA;EDqrR3onJ;ECrrRwqnJ;IAAoB,+BAAA;EDwrR5rnJ;ECxrR0tnJ;IAAoB,6BAAA;ED2rR9unJ;EC3rR0wnJ;IAAW,uBAAA;ED8rRrxnJ;EC9rR2ynJ;IAAwB,2BAAA;EDisRn0nJ;ECjsR61nJ;IAAwB,6BAAA;EDosRr3nJ;ECpsRi5nJ;IAAwB,8BAAA;EDusRz6nJ;ECvsRs8nJ;IAAwB,4BAAA;ED0sR99nJ;AACF;AC3sR4/nJ;EAA0B;IAAQ,oBAAA;ED+sR5hoJ;EC/sR+ioJ;IAAkB,wBAAA;EDktRjkoJ;ECltRwloJ;IAAkB,0BAAA;EDqtR1moJ;ECrtRmooJ;IAAkB,2BAAA;EDwtRrpoJ;ECxtR+qoJ;IAAkB,yBAAA;ED2tRjsoJ;EC3tRytoJ;IAAQ,0BAAA;ED8tRjuoJ;EC9tRyvoJ;IAAkB,8BAAA;EDiuR3woJ;ECjuRuyoJ;IAAkB,gCAAA;EDouRzzoJ;ECpuRu1oJ;IAAkB,iCAAA;EDuuRz2oJ;ECvuRw4oJ;IAAkB,+BAAA;ED0uR15oJ;EC1uRu7oJ;IAAQ,yBAAA;ED6uR/7oJ;EC7uRs9oJ;IAAkB,6BAAA;EDgvRx+oJ;EChvRmgpJ;IAAkB,+BAAA;EDmvRrhpJ;ECnvRkjpJ;IAAkB,gCAAA;EDsvRpkpJ;ECtvRkmpJ;IAAkB,8BAAA;EDyvRpnpJ;ECzvRgppJ;IAAQ,uBAAA;ED4vRxppJ;EC5vR8qpJ;IAAkB,2BAAA;ED+vRhspJ;EC/vR0tpJ;IAAkB,6BAAA;EDkwR5upJ;EClwRwwpJ;IAAkB,8BAAA;EDqwR1xpJ;ECrwRuzpJ;IAAkB,4BAAA;EDwwRz0pJ;ECxwRo2pJ;IAAQ,yBAAA;ED2wR52pJ;EC3wRo4pJ;IAAkB,6BAAA;ED8wRt5pJ;EC9wRk7pJ;IAAkB,+BAAA;EDixRp8pJ;ECjxRk+pJ;IAAkB,gCAAA;EDoxRp/pJ;ECpxRmhqJ;IAAkB,8BAAA;EDuxRriqJ;ECvxRkkqJ;IAAQ,uBAAA;ED0xR1kqJ;EC1xRgmqJ;IAAkB,2BAAA;ED6xRlnqJ;EC7xR4oqJ;IAAkB,6BAAA;EDgyR9pqJ;EChyR0rqJ;IAAkB,8BAAA;EDmyR5sqJ;ECnyRyuqJ;IAAkB,4BAAA;EDsyR3vqJ;ECtyRsxqJ;IAAQ,qBAAA;EDyyR9xqJ;ECzyRkzqJ;IAAkB,yBAAA;ED4yRp0qJ;EC5yR41qJ;IAAkB,2BAAA;ED+yR92qJ;EC/yRw4qJ;IAAkB,4BAAA;EDkzR15qJ;EClzRq7qJ;IAAkB,0BAAA;EDqzRv8qJ;ECrzRg+qJ;IAAQ,2BAAA;EDwzRx+qJ;ECxzRigrJ;IAAkB,+BAAA;ED2zRnhrJ;EC3zRgjrJ;IAAkB,iCAAA;ED8zRlkrJ;EC9zRimrJ;IAAkB,kCAAA;EDi0RnnrJ;ECj0RmprJ;IAAkB,gCAAA;EDo0RrqrJ;ECp0RmsrJ;IAAQ,0BAAA;EDu0R3srJ;ECv0RmurJ;IAAkB,8BAAA;ED00RrvrJ;EC10RixrJ;IAAkB,gCAAA;ED60RnyrJ;EC70Ri0rJ;IAAkB,iCAAA;EDg1Rn1rJ;ECh1Rk3rJ;IAAkB,+BAAA;EDm1Rp4rJ;ECn1Ri6rJ;IAAQ,wBAAA;EDs1Rz6rJ;ECt1Rg8rJ;IAAkB,4BAAA;EDy1Rl9rJ;ECz1R6+rJ;IAAkB,8BAAA;ED41R//rJ;EC51R4hsJ;IAAkB,+BAAA;ED+1R9isJ;EC/1R4ksJ;IAAkB,6BAAA;EDk2R9lsJ;ECl2R0nsJ;IAAQ,0BAAA;EDq2RlosJ;ECr2R2psJ;IAAkB,8BAAA;EDw2R7qsJ;ECx2R0ssJ;IAAkB,gCAAA;ED22R5tsJ;EC32R2vsJ;IAAkB,iCAAA;ED82R7wsJ;EC92R6ysJ;IAAkB,+BAAA;EDi3R/zsJ;ECj3R61sJ;IAAQ,wBAAA;EDo3Rr2sJ;ECp3R43sJ;IAAkB,4BAAA;EDu3R94sJ;ECv3Ry6sJ;IAAkB,8BAAA;ED03R37sJ;EC13Rw9sJ;IAAkB,+BAAA;ED63R1+sJ;EC73RwgtJ;IAAkB,6BAAA;EDg4R1htJ;ECh4RsjtJ;IAAS,2BAAA;EDm4R/jtJ;ECn4RwltJ;IAAoB,+BAAA;EDs4R5mtJ;ECt4RyotJ;IAAoB,iCAAA;EDy4R7ptJ;ECz4R4rtJ;IAAoB,kCAAA;ED44RhttJ;EC54RgvtJ;IAAoB,gCAAA;ED+4RpwtJ;EC/4RkytJ;IAAS,0BAAA;EDk5R3ytJ;ECl5Rm0tJ;IAAoB,8BAAA;EDq5Rv1tJ;ECr5Rm3tJ;IAAoB,gCAAA;EDw5Rv4tJ;ECx5Rq6tJ;IAAoB,iCAAA;ED25Rz7tJ;EC35Rw9tJ;IAAoB,+BAAA;ED85R5+tJ;EC95RyguJ;IAAS,wBAAA;EDi6RlhuJ;ECj6RyiuJ;IAAoB,4BAAA;EDo6R7juJ;ECp6RwluJ;IAAoB,8BAAA;EDu6R5muJ;ECv6RyouJ;IAAoB,+BAAA;ED06R7puJ;EC16R2ruJ;IAAoB,6BAAA;ED66R/suJ;EC76R2uuJ;IAAS,0BAAA;EDg7RpvuJ;ECh7R6wuJ;IAAoB,8BAAA;EDm7RjyuJ;ECn7R8zuJ;IAAoB,gCAAA;EDs7Rl1uJ;ECt7Ri3uJ;IAAoB,iCAAA;EDy7Rr4uJ;ECz7Rq6uJ;IAAoB,+BAAA;ED47Rz7uJ;EC57Ru9uJ;IAAS,wBAAA;ED+7Rh+uJ;EC/7Ru/uJ;IAAoB,4BAAA;EDk8R3gvJ;ECl8RsivJ;IAAoB,8BAAA;EDq8R1jvJ;ECr8RulvJ;IAAoB,+BAAA;EDw8R3mvJ;ECx8RyovJ;IAAoB,6BAAA;ED28R7pvJ;EC38RyrvJ;IAAW,uBAAA;ED88RpsvJ;EC98R0tvJ;IAAwB,2BAAA;EDi9RlvvJ;ECj9R4wvJ;IAAwB,6BAAA;EDo9RpyvJ;ECp9Rg0vJ;IAAwB,8BAAA;EDu9Rx1vJ;ECv9Rq3vJ;IAAwB,4BAAA;ED09R74vJ;AACF;AC39R26vJ;EAAgB,4GAAA;AD89R37vJ;;AC99RgiwJ;EAAc,8BAAA;ADk+R9iwJ;;ACl+R2kwJ;EAAW,8BAAA;ADs+RtlwJ;;ACt+RmnwJ;EAAa,8BAAA;AD0+RhowJ;;AC1+R6pwJ;EAAe,gBAAA;EAAgB,uBAAA;EAAuB,mBAAA;ADg/RntwJ;;ACh/RsuwJ;EAAW,2BAAA;ADo/RjvwJ;;ACp/R2wwJ;EAAY,4BAAA;ADw/RvxwJ;;ACx/RkzwJ;EAAa,6BAAA;AD4/R/zwJ;;AC5/R21wJ;EAAyB;IAAc,2BAAA;EDigSh4wJ;ECjgS05wJ;IAAe,4BAAA;EDogSz6wJ;ECpgSo8wJ;IAAgB,6BAAA;EDugSp9wJ;AACF;ACxgSm/wJ;EAAyB;IAAc,2BAAA;ED4gSxhxJ;EC5gSkjxJ;IAAe,4BAAA;ED+gSjkxJ;EC/gS4lxJ;IAAgB,6BAAA;EDkhS5mxJ;AACF;ACnhS2oxJ;EAAyB;IAAc,2BAAA;EDuhShrxJ;ECvhS0sxJ;IAAe,4BAAA;ED0hSztxJ;EC1hSovxJ;IAAgB,6BAAA;ED6hSpwxJ;AACF;AC9hSmyxJ;EAA0B;IAAc,2BAAA;EDkiSz0xJ;ECliSm2xJ;IAAe,4BAAA;EDqiSl3xJ;ECriS64xJ;IAAgB,6BAAA;EDwiS75xJ;AACF;ACziS47xJ;EAAgB,oCAAA;AD4iS58xJ;;AC5iS++xJ;EAAgB,oCAAA;ADgjS//xJ;;AChjSkiyJ;EAAiB,qCAAA;ADojSnjyJ;;ACpjSulyJ;EAAmB,2BAAA;ADwjS1myJ;;ACxjSooyJ;EAAqB,+BAAA;AD4jSzpyJ;;AC5jSuryJ;EAAoB,2BAAA;ADgkS3syJ;;AChkSquyJ;EAAkB,2BAAA;ADokSvvyJ;;ACpkSixyJ;EAAoB,8BAAA;ADwkSryyJ;;ACxkSk0yJ;EAAa,6BAAA;AD4kS/0yJ;;AC5kS22yJ;EAAY,sBAAA;ADglSv3yJ;;AChlS44yJ;EAAc,yBAAA;ADolS15yJ;;ACplSk7yJ;EAA0C,yBAAA;ADwlS59yJ;;ACxlSo/yJ;EAAgB,yBAAA;AD4lSpgzJ;;AC5lS4hzJ;EAA8C,yBAAA;ADgmS1kzJ;;AChmSkmzJ;EAAc,yBAAA;ADomShnzJ;;ACpmSwozJ;EAA0C,yBAAA;ADwmSlrzJ;;ACxmS0szJ;EAAW,yBAAA;AD4mSrtzJ;;AC5mS6uzJ;EAAoC,yBAAA;ADgnSjxzJ;;AChnSyyzJ;EAAc,yBAAA;ADonSvzzJ;;ACpnS+0zJ;EAA0C,yBAAA;ADwnSz3zJ;;ACxnSi5zJ;EAAa,yBAAA;AD4nS95zJ;;AC5nSs7zJ;EAAwC,yBAAA;ADgoS99zJ;;AChoSs/zJ;EAAY,yBAAA;ADooSlg0J;;ACpoS0h0J;EAAsC,yBAAA;ADwoShk0J;;ACxoSwl0J;EAAW,yBAAA;AD4oSnm0J;;AC5oS2n0J;EAAoC,yBAAA;ADgpS/p0J;;AChpSur0J;EAAW,yBAAA;ADopSls0J;;ACppS0t0J;EAAY,yBAAA;ADwpStu0J;;ACxpS8v0J;EAAe,oCAAA;AD4pS7w0J;;AC5pS4y0J;EAAe,0CAAA;ADgqS3z0J;;AChqSg20J;EAAW,WAAA;EAAW,kBAAA;EAAkB,iBAAA;EAAiB,6BAAA;EAA6B,SAAA;ADwqSt70J;;ACxqS+70J;EAAsB,gCAAA;AD4qSr90J;;AC5qSo/0J;EAAY,iCAAA;EAAgC,oCAAA;ADirShi1J;;ACjrSmk1J;EAAY,yBAAA;ADqrS/k1J;;ACrrSum1J;EAAS,8BAAA;ADyrShn1J;;ACzrS6o1J;EAAW,6BAAA;AD6rSxp1J;;AC7rSor1J;EAAa;IAAmB,4BAAA;IAA2B,2BAAA;EDmsS7u1J;ECnsSuw1J;IAAY,0BAAA;EDssSnx1J;ECtsS6y1J;IAAmB,6BAAA;EDysSh01J;ECzsS611J;IAAI,gCAAA;ED4sSj21J;EC5sSg41J;IAAe,yBAAA;IAAyB,wBAAA;EDgtSx61J;EChtSg81J;IAAM,2BAAA;EDmtSt81J;ECntSi+1J;IAAO,wBAAA;EDstSx+1J;ECttSgg2J;IAAQ,UAAA;IAAU,SAAA;ED0tSlh2J;EC1tS2h2J;IAAM,uBAAA;ED6tSji2J;EC7tSwj2J;IAAM,QAAA;EDguS9j2J;EChuSsk2J;IAAK,2BAAA;EDmuS3k2J;ECnuSqm2J;IAAW,2BAAA;EDsuShn2J;ECtuS0o2J;IAAQ,aAAA;EDyuSlp2J;ECzuS+p2J;IAAO,sBAAA;ED4uStq2J;EC5uS4r2J;IAAO,oCAAA;ED+uSns2J;EC/uSsu2J;IAAoB,iCAAA;EDkvS1v2J;EClvS0x2J;IAAsC,oCAAA;EDqvSh02J;ECrvSm22J;IAAY,cAAA;EDwvS/22J;ECxvS632J;IAA2E,qBAAA;ED2vSx82J;EC3vS692J;IAAsB,cAAA;IAAc,qBAAA;ED+vSjg3J;AACF;;AErwSA;;EAEC,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,gBAAA;AFwwSD;;AErwSA;EACC,kBAAA;EACA,gBAAA;EACA,cAAA;AFwwSD;;AEtwSA;;EAEE,wBAAA;EACC,SAAA;AFywSH;;AEvwSA;EAGE,aAAA;AF0wSF;;AEvwSA;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;AF0wSF;;AEtwSA,eAAA;AAEA;EACC,oBAAA;EACA,cAAA;AFwwSD;;AErwSA;EACC,qBAAA;AFwwSD;;AErwSA;EACC,UAAA;AFwwSD;;AErwSA;EACC,UAAA;AFwwSD;;AErwSA;EACC,uBAAA;AFwwSD;;AErwSA;;GAAA;AAIA;;;EAGC,qBAAA;AFuwSD;;AEpwSA;EACC,gBAAA;EACA,qBAAA;AFuwSD;;AEpwSA;EACC,YAAA;AFuwSD;;AEpwSA;EACC,aAAA;EACA,gBAAA;AFuwSD;;AEpwSA;EACC,aAAA;EACA,gBAAA;AFuwSD;;AEpwSA;;EAEC,gBAAA;AFuwSD;;AEpwSA;EACC,yBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AFuwSD;;AEpwSA;EACC,yBAAA;EACA,iCAAA;AFuwSD;;AEpwSA;EACC,WAAA;AFuwSD;;AEpwSA;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AFuwSD;;AErwSA;EACC,6BAAA;EACA,qBAAA;EACA,wBAAA;AFwwSD;;AEpwSA;EACC,sBAAA;AFuwSD;;AEpwSA;EAEC,wBAAA;EACA,8BAAA;AFswSD;;AEjwSA;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AFowSJ;;AElwSA;EACI,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,4BAAA;AFqwSJ;;AEnwSA;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;AFswSJ;;AElwSA;;EAEG,uBAAA;AFqwSH;;AElwSA;EACG,uBAAA;AFqwSH;;AEnwSA;EACC,YAAA;EACA,wCAAA;AFswSD;;AEpwSA;EACC;IACC,cAAA;EFuwSA;AACF;AEpwSE;EACE;IACI,uBAAA;EFswSN;AACF;AG/6SA;EACI,WAAA;EACA,0BAAA;EACA,6BAAA;EACA,0BAAA;AHi7SJ;;AG96SE;;EAGE,uBAAA;AHi7SJ;;AG76SE;;EAEE,kBAAA;AHg7SJ;;AG96SE;;EAEE,mBAAA;AHi7SJ;;AG96SE;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AHi7SJ;;AG/6SE;EACE,WAAA;EACA,qBAAA;AHk7SJ;;AGh7SE;EACE,iBAAA;AHm7SJ;;AGj7SE;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;AHo7SJ;;AGl7SE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AHq7SJ;;AGn7SE;EACE,mBAAA;EACA,mBAAA;AHs7SJ;;AGp7SE;EACE,SAAA;EACA,mBAAA;EACA,iBAAA;AHu7SJ;;AGr7SE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AHw7SJ;;AGt7SE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AHy7SJ;;AGt7SE;;;;EAIE,mBAAA;AHy7SJ;;AGv7SE;;EAEE,aAAA;AH07SJ;;AGx7SE;;;;;EAKE,eAAA;EACA,kBAAA;AH27SJ;;AGz7SE;;;;;;;;;EASE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;AH47SJ;;AG17SE;;;;;EAKE,UAAA;EACA,YAAA;AH67SJ;;AG37SE;;;;;EAKE,YAAA;EACA,YAAA;AH87SJ;;AG57SE;;EAEE,UAAA;AH+7SJ;;AG77SE;;EAEE,UAAA;AHg8SJ;;AG77SE;EACE,2BAAA;AHg8SJ;;AG77SE;EACE,gBAAA;EACA,wBAAA;EACA,2BAAA;AHg8SJ;;AG97SE;;;EAGE,aAAA;AHi8SJ;;AG/7SE;;EAEE,gBAAA;AHk8SJ;;AG/7SE;EACE,uBAAA;AHk8SJ;;AGh8SE;EACE,wBAAA;EACA,gBAAA;AHm8SJ;;AGh8SE;EACE;;;;IAIE,kBAAA;EHm8SJ;AACF;AGj8SE;EACE,mBAAA;AHm8SJ;;AGj8SE;;;EAGE,QAAA;EACA,aAAA;AHo8SJ;;AGl8SE;;;EAGE,QAAA;AHq8SJ;;AGl8SE;;EAEE,oBAAA;AHq8SJ;;AGn8SE;;;EAGE,qBAAA;AHs8SJ;;AGp8SE;;EAEE,sBAAA;AHu8SJ;;AGp8SE;EACE,sBAAA;AHu8SJ;;AGp8SE;EACE,SAAA;AHu8SJ;;AGr8SE;EACE,eAAA;AHw8SJ;;AGt8SE;EACE,gBAAA;AHy8SJ;;AGv8SE;;;;;CAAA;AAKC;EAA4C,wBAAA;AH48S/C;;AG58SsE;EAAkB,eAAA;AHg9SxF;;AGh9SsG;EAAmC,WAAA;EAAW,mBAAA;EAAmB,UAAA;AHs9SvK;;AGt9SiL;EAA2N,WAAA;AH09S5Y;;AG19SuZ;EAAyB,6BAAA;EAA4B,SAAA;EAAS,SAAA;EAAS,yBAAA;EAAwB,uBAAA;EAAqB,uBAAA;EAAsB,qBAAA;EAAoB,qBAAA;EAAoB,YAAA;AHs+SzkB;;AGt+SqlB;EAAuC,MAAA;EAAM,OAAA;EAAO,yBAAA;EAAwB,sBAAA;EAAqB,UAAA;AH8+StrB;;AG9+SgsB;EAAwF,qBAAA;AHk/SxxB;;AGl/S6yB;EAA4B,sBAAA;AHs/Sz0B;;AGt/S81B;EAAsF,YAAA;AH0/Sp7B;;AG1/Sg8B;EAAyC,oCAAA;EAAmC,qDAAA;EAAoD,oBAAA;AHggThkC;;AGhgTolC;EAA+B,gBAAA;EAAgB,UAAA;EAAU,YAAA;AHsgT7oC;;AGtgTypC;EAAkD,WAAA;AH0gT3sC;;AG1gTstC;EAA+C,aAAA;AH8gTrwC;;AG9gTkxC;EAAuF,gBAAA;AHkhTz2C;;AGlhTy3C;EAA2F,WAAA;EAAW,qBAAA;EAAqB,cAAA;AHwhTp/C;;AGxhTkgD;EAA+K,YAAA;AH4hTjrD;;AG5hT6rD;EAA8H,gBAAA;AHgiT3zD;;AGhiT20D;EAAgH,UAAA;AHoiT37D;;AGpiTq8D;EAAkJ,YAAA;EAAY,kBAAA;EAAkB,oBAAA;EAAoB,sBAAA;AH2iTzoE;;AG3iT+pE;EAAuD,WAAA;AH+iTttE;;AG/iTiuE;EAA2E,mBAAA;AHmjT5yE;;AGnjT+zE;EAAuF,qBAAA;AHujTt5E;;AGvjT06E;EAAyC,kBAAA;EAAkB,oBAAA;EAAmB,qBAAA;AH6jTx/E;;AG7jT4gF;EAAwD,aAAA;AHikTpkF;;AGjkTilF;EAA4D,qBAAA;EAAqB,gBAAA;EAAgB,WAAA;EAAW,gBAAA;AHwkT7rF;;AGxkT6sF;EAAoD,kBAAA;EAAkB,QAAA;EAAQ,WAAA;EAAW,gBAAA;EAAgB,sBAAA;AHglTtzF;;AGhlT40F;EAA0D,WAAA;AHolTt4F;;AGplTi5F;EAA2C,eAAA;EAAwE,sBAAA;AH2lTpgG;;AG3lT0hG;EAAiD,gBAAA;EAAgB,WAAA;EAAW,SAAA;EAAS,UAAA;EAAU,SAAA;EAAS,gBAAA;EAAwC,gBAAA;AHsmT1qG;;AGtmT0rG;EAA8C,kBAAA;AH0mTxuG;;AG1mT0vG;EAA2D,WAAA;AH8mTrzG;;AG9mTg0G;EAAyD,mBAAA;AHknTz3G;;AGlnT44G;EAAgD,eAAA;EAAe,yBAAA;EAAoE,iBAAA;AH0nT/gH;;AG1nTgiH;EAAoD,kBAAA;EAAkB,oBAAA;AH+nTtmH;;AG/nT0nH;EAAgE,aAAA;AHmoT1rH;;AGnoTusH;EAA0D,qBAAA;AHuoTjwH;;AGvoTsxH;EAAoD,mBAAA;AH2oT10H;;AG3oT41H;EAAmD,kBAAA;EAAkB,WAAA;EAAW,UAAA;EAAU,YAAA;EAAY,gBAAA;EAAgB,gBAAA;EAAgB,mBAAA;EAAmB,yBAAA;EAA4E,+CAAA;EAA2C,oBAAA;EAAoB,YAAA;EAAoE,sBAAA;AH6pTpsI;;AG7pT0tI;EAAwC,YAAA;EAAY,mBAAA;EAAmB,aAAA;EAAa,mBAAA;AHoqT9yI;;AGpqTi0I;EAAsE,gBAAA;AHwqTv4I;;AGxqTu5I;EAA8D,gBAAA;EAAgB,SAAA;EAAS,gBAAA;AH8qT9+I;;AG9qT8/I;EAAmF,kBAAA;EAAkB,qBAAA;EAAqB,WAAA;EAAW,eAAA;AHqrTnoJ;;AGrrTkpJ;EAAoE,kBAAA;AHyrTttJ;;AGzrTwuJ;EAAwD,aAAA;AH6rThyJ;;AG7rT6yJ;EAA0D,WAAA;EAAW,kCAAA;EAAkC,mCAAA;EAAmC,iDAAA;EAA6C,kBAAA;EAAkB,YAAA;EAAY,SAAA;EAAS,aAAA;AHwsT3gK;;AGxsTwhK;EAAyD,WAAA;EAAW,kCAAA;EAAkC,mCAAA;EAAmC,6BAAA;EAA6B,kBAAA;EAAkB,YAAA;EAAY,UAAA;EAAU,aAAA;AHmtTtuK;;AGntTmvK;EAAiE,YAAA;EAAY,SAAA;EAAS,8CAAA;EAA0C,gBAAA;AH0tTn3K;;AG1tTm4K;EAAgE,YAAA;EAAY,SAAA;EAAS,0BAAA;EAA0B,gBAAA;AHiuTl/K;;AGjuTkgL;EAAqE,WAAA;EAAW,UAAA;AHsuTllL;;AGtuT4lL;EAAoE,WAAA;EAAW,UAAA;AH2uT3qL;;AG3uTqrL;EAA6H,cAAA;AH+uTlzL;;AG/uTg0L;EAA4C,gBAAA;AHmvT52L;;AGnvT43L;EAAe,WAAA;EAAoE,sBAAA;AH0vT/8L;;AG1vTq+L;EAAiC,UAAA;AH8vTtgM;;AG9vTghM;EAAe,WAAA;EAAW,WAAA;EAAoE,sBAAA;AHswT9mM;;AGtwTooM;EAAiC,WAAA;AH0wTrqM;;AG1wTgrM;EAA6B,kBAAA;AH8wT7sM;;AG9wT+tM;EAA4B,gBAAA;EAAgB,WAAA;EAAW,WAAA;AHoxTtxM;;AGlxTC;EAAgL,0BAAA;AHsxTjL;;AGtxT2M;EAAqM,wBAAA;AH0xThZ;;AG1xTwa;EAAkJ,kBAAA;EAAkB,kBAAA;EAAkB,eAAA;AHgyT9lB;;AGhyT6mB;EAAgK,SAAA;EAAS,SAAA;EAAS,YAAA;EAAY,WAAA;EAAW,cAAA;EAAc,kBAAA;EAAkB,YAAA;EAAY,uBAAA;EAAuB,mBAAA;EAAmB,wBAAA;EAAwB,uBAAA;EAAuB,kBAAA;EAAkB,yBAAA;EAAyB,8CAAA;EAA8C,iBAAA;EAAiB,YAAA;EAAY,yBAAA;AHozTjjC;;AGpzT0kC;EAAsJ,YAAA;EAAY,yBAAA;AHyzT5uC;;AGzzTqwC;EAA0I,kBAAA;AH6zT/4C;;AG7zTi6C;EAAwJ,QAAA;EAAQ,SAAA;EAAS,YAAA;EAAY,WAAA;EAAW,mBAAA;EAAmB,iBAAA;EAAiB,gBAAA;AHu0TroD;;AGv0TqpD;EAA8F,kBAAA;EAAkB,eAAA;AH40TrwD;;AG50ToxD;EAA4G,QAAA;EAAQ,SAAA;EAAS,YAAA;EAAY,WAAA;EAAW,iBAAA;EAAiB,kBAAA;EAAkB,cAAA;EAAc,kBAAA;EAAkB,YAAA;EAAY,uBAAA;EAAuB,mBAAA;EAAmB,wBAAA;EAAwB,uBAAA;EAAuB,kBAAA;EAAkB,yBAAA;EAAyB,8CAAA;EAA8C,iBAAA;EAAiB,YAAA;EAAY,yBAAA;AHk2TtsE;;AGl2T+tE;EAA0H,YAAA;EAAY,yBAAA;AHu2Tr2E;;AGv2T83E;EAA+B,kBAAA;AH22T75E;;AG32T+6E;EAAqC,kCAAA;AH+2Tp9E;;AG/2Ts/E;EAA8C,qBAAA;EAAqB,qBAAA;EAAqB,SAAA;EAAS,UAAA;AHs3TvlF;;AGt3TimF;EAAiD,gCAAA;EAAgC,gBAAA;AH23TlrF;;AG33TksF;EAA6D,cAAA;AH+3T/vF;;AG/3T6wF;EAA4D,mBAAA;AHm4Tz0F;;AGn4T41F;EAA8C,qBAAA;EAAqB,eAAA;EAAe,iBAAA;AHy4T96F;;AGz4T+7F;EAAc,eAAA;EAAe,sBAAA;EAAsB,MAAA;EAAM,OAAA;EAAO,YAAA;EAAY,WAAA;EAAW,YAAA;EAAY,iBAAA;AHo5TliG;;AGp5TmjG;EAAoC,kBAAA;EAAkB,MAAA;EAAM,OAAA;EAAO,SAAA;EAAS,QAAA;EAAQ,UAAA;EAAU,WAAA;EAAW,cAAA;EAAc,YAAA;EAAY,YAAA;EAAY,cAAA;EAAc,yBAAA;EAAyB,uBAAA;EAAuB,oBAAA;EAAoB,0CAAA;AHs6TpxG;;AGt6T2zG;EAAoC,kBAAA;EAAkB,YAAA;AH26Tj3G;;AG36T63G;EAAkC,kBAAA;EAAkB,QAAA;EAAQ,UAAA;EAAU,WAAA;EAAW,YAAA;EAAY,yBAAA;EAAyB,yBAAA;EAAyB,kBAAA;EAAkB,kBAAA;EAAkB,eAAA;EAAe,WAAA;AHy7T/jH;;AGz7T0kH;EAAwC,yBAAA;AH67TlnH;;AG77T2oH;EAAuC,eAAA;EAAe,MAAA;EAAM,OAAA;EAAO,QAAA;EAAQ,SAAA;EAAS,YAAA;EAAY,8BAAA;AHu8T3uH;;AGv8TswH;EAAqC;IAAoC,UAAA;EH48T70H;AACF;AG78T01H;EAA+C,gBAAA;AHg9Tz4H;;AG98TA;EAAqE,yBAAA;AHk9TrE;;AGl9T8F;EAAwL,yBAAA;AHs9TtR;;AGt9T+S;EAA8L,yBAAA;AH09T7e;;AG19TsgB;EAAwa,yBAAA;AH89T96B;;AG99Tu8B;EAA8H,yBAAA;AHk+TrkC;;AGl+T8lC;EAA8H,yBAAA;AHs+T5tC;;AGt+TqvC;EAA8H,yBAAA;AH0+Tn3C;;AG1+T44C;EAAgI,yBAAA;AH8+T5gD;;AG9+TqiD;EAAgI,yBAAA;AHk/TrqD;;AGl/T8rD;EAAgI,yBAAA;AHs/T9zD;;AGt/Tu1D;EAA0G,yBAAA;AH0/Tj8D;;AG1/T09D;EAA4G,yBAAA;AH8/TtkE;;AG9/T+lE;EAAiI,yBAAA;AHkgUhuE;;AGlgUyvE;EAAiI,yBAAA;AHsgU13E;;AGtgUm5E;EAAiI,yBAAA;AH0gUphF;;AG1gU6iF;EAA0N,yBAAA;AH8gUvwF;;AG9gUgyF;EAAsE,kBAAA;AHkhUt2F;;AGlhUw3F;EAAsK,cAAA;EAAc,kBAAA;EAAkB,UAAA;EAAU,SAAA;EAAS,WAAA;EAAW,YAAA;EAAY,sBAAA;AH4hUxmG;;AG5hU8nG;EAAoF,YAAA;EAAY,gBAAA;EAAgB,iBAAA;EAAiB,uBAAA;EAAuB,kBAAA;AHoiUtxG;;AGpiUwyG;EAA0G,YAAA;EAAgB,iBAAA;EAAiB,iBAAA;EAAiB,kBAAA;EAAkB,mFAAA;AH4iUt9G;;AG5iUyiH;EAAgF,kBAAA;AHgjUznH;;AGhjU2oH;EAAqC;IAAgF,cAAA;IAAc,cAAA;EHsjU5wH;AACF;AGtjUA;EACE,iBAAA;EACA,eAAA;AHwjUF;;AI1xUA,gBAAA;AACA;EACC,gBAAA;AJ6xUD;;AI1xUA;EACC,WAAA;EACA,YAAA;AJ6xUD;;AI1xUA;EACC,kBAAA;EACA,gBAAA;AJ6xUD;;AI1xUA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AJ6xUD;;AI1xUA;EACC,kBAAA;AJ6xUD;;AI1xUA;EACC,eAAA;EACA,YAAA;EACA,qBAAA;AJ6xUD;;AI1xUA;EACC,gBAAA;AJ6xUD;;AI1xUA;EACC,yBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;AJ6xUD;;AI1xUA;EACC,6BAAA;EACA,0BAAA;EACA,6BAAA;AJ6xUD;;AI1xUA;EACC,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AJ6xUD;;AI1xUA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;AJ6xUD;;AI1xUA;EACC,eAAA;EACA,gBAAA;AJ6xUD;;AI1xUA;;EAEC,aAAA;AJ6xUD;;AI1xUA,eAAA;AACA;EACC,mBAAA;AJ6xUD;;AIzxUA;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;AJ4xUD;;AIzxUA;EACC,cAAA;EACA,WAAA;AJ4xUD;;AIzxUA;EACC,WAAA;AJ4xUD;;AIzxUA;EACC,6BAAA;EACA,4BAAA;EACA,0BAAA;AJ4xUD;;AIzxUA;EACC,yBAAA;AJ4xUD;;AIzxUA;EACC,WAAA;EACA,qBAAA;EACA,yBAAA;AJ4xUD;;AIzxUA;EACC,gBAAA;AJ4xUD;;AIzxUA;EACC,qBAAA;AJ4xUD;;AIzxUA;EACC,cAAA;AJ4xUD;;AIzxUA;EACC,cAAA;AJ4xUD;;AIzxUA;EACC,cAAA;AJ4xUD;;AIzxUA,eAAA;AACA;EACC,WAAA;AJ4xUD;;AIzxUA,cAAA;AAEA;EACC,kBAAA;EAEA,YAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AJ0xUD;;AIxxUA;EACC,gBAAA;AJ2xUD;;AIxxUA;EACC,gBAAA;AJ2xUD;;AK57UA,0BAAA;AACA;EACC,mBAAA;AL+7UD;;AK37UA;EACC,yBAAA;EACA,iBAAA;EACA,kBAAA;AL87UD;;AK37UA;EACC,gBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,wBAAA;AL87UD;;AK37UA;EACC,cAAA;AL87UD;;AK37UA;EACC,yBAAA;AL87UD;;AK37UA;EACC,eAAA;AL87UD;;AK37UA;EACC,6BAAA;EACA,eAAA;AL87UD;;AK37UA;EAEC,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;AL67UD;;AK17UA;EACI,WAAA;EACA,6BAAA;EACD,yBAAA;AL67UH;;AK17UA;EACI,WAAA;EACA,6BAAA;EACD,yBAAA;AL67UH;;AK17UA;EACI,WAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;AL67UJ;;AK17UA;EACG,2BAAA;EACA,eAAA;AL67UH;;AKn7UA;EACC,cAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;ALs7UD;;AKn7UA;EACC,cAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;ALs7UD;;AKn7UA;EACC,WAAA;EACA,UAAA;ALs7UD;;AKn7UA;EACC,WAAA;EACA,UAAA;ALs7UD;;AKn7UA;;EAEC,UAAA;ALs7UD;;AKn7UA;EACC,aAAA;ALs7UD;;AKn7UA;EACC,gBAAA;ALs7UD;;AKn7UA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;ALs7UD;;AKn7UA;;EAEC,cAAA;EACA,eAAA;ALs7UD;;AKl7UA;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;ALq7UD;;AKl7UA;EACC,oBAAA;ALq7UD;;AKl7UA;EACC,kBAAA;EACA,mDAAA;EACA,WAAA;ALq7UD;;AKl7UA;EACC,gBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;ALq7UD;;AKl7UA;EACC,eAAA;EACA,iBAAA;ALq7UD;;AKl7UA;EACC,gBAAA;ALq7UD;;AM3lVA,oBAAA;AAGA;EACC,oBAAA;AN4lVD;;AM1lVA;EACC,YAAA;AN6lVD;;AMzlVA;EACC,UAAA;EACA,eAAA;EACA,cAAA;AN4lVD;;AMzlVA;EACC,qBAAA;AN4lVD;;AMzlVA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AN4lVD;;AMzlVA;EACC,eAAA;EACA,gBAAA;AN4lVD;;AMzlVA;EACC,cAAA;AN4lVD;;AMzlVA;EACC,cAAA;EACA,eAAA;EACA,iBAAA;AN4lVD;;AMzlVA;EACC,cAAA;AN4lVD;;AMzlVA;EACC,cAAA;EACA,eAAA;EACA,iBAAA;AN4lVD;;AMzlVA;EACC,cAAA;EACA,eAAA;EACA,iBAAA;AN4lVD;;AMzlVA;;;EAGC,aAAA;AN4lVD;;AMzlVA;EACC,mBAAA;AN4lVD;;AMzlVA;EACC,6BAAA;AN4lVD;;AMzlVA;EACC,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AN4lVD;;AMzlVA;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AN4lVD;;AMzlVA;EACC,gBAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;AN4lVD;;AMzlVA;EACC,WAAA;EACA,eAAA;EACA,cAAA;AN4lVD;;AMzlVA;EACC,cAAA;EACA,eAAA;AN4lVD;;AMzlVA;EACC,aAAA;AN4lVD;;AMzlVA;;GAAA;AAGA;EACC,eAAA;EACA,gBAAA;AN4lVD;;AMzlVA;EACC,eAAA;AN4lVD;;AMxlVA;EACC,eAAA;EACA,gBAAA;AN2lVD;;AMxlVA;EACC,yBAAA;EACA,0BAAA;AN2lVD;;AMxlVA;EACC,YAAA;AN2lVD;;AMxlVA;;EAEC,sBAAA;AN2lVD;;AMxlVA;EACC,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AN2lVD;;AMxlVA;;;;EAIC,cAAA;EACA,eAAA;AN2lVD;;AMvlVA;EACC,yBAAA;AN0lVD;;AMvlVA;EACC,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AN0lVD;;AMvlVA,kBAAA;AACA;EACC,YAAA;AN0lVD;;AMxlVA;EACC,UAAA;AN2lVD;;AMzlVA;EACC,YAAA;AN4lVD;;AM1lVA;EACC,UAAA;AN6lVD;;AM3lVA;EACC,YAAA;AN8lVD;;AM5lVA;EACC,UAAA;AN+lVD;;AOhyVA,uBAAA;AACA;;GAAA;AAGA;EACC,4BAAA;APmyVD;;AOhyVA;EACC,yBAAA;EACA,YAAA;EACA,sBAAA;APmyVD;;AOhyVA;EACC,cAAA;APmyVD;;AOhyVA;EACC,cAAA;EACA,eAAA;APmyVD;;AOhyVA;;EAEC,6BAAA;EACA,iBAAA;EACA,eAAA;APmyVD;;AOhyVA;EACC,yBAAA;EACA,cAAA;APmyVD;;AOjyVA;EACC,yBAAA;EACA,cAAA;APoyVD;;AOhyVA;EACC,yBAAA;EACA,cAAA;APmyVD;;AOhyVA;EACC,gBAAA;EACA,iBAAA;APmyVD;;AOhyVA;EAEC,uDAAA;EACA,oBAAA;APkyVD;;AO/xVA;EACC,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;APkyVD;;AO/xVA;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;APkyVD;;AO/xVA;EACC,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;APkyVD;;AOhyVA;EACC,WAAA;APmyVD;;AOjyVA;EACC,yBAAA;EACA,yBAAA;APoyVD;;AOlyVA;EACC,eAAA;APqyVD;;AOnyVA;;EAEC,4BAAA;APsyVD;;AOnyVA;EACC,cAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;APsyVD;;AOnyVA;EACC,cAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;APsyVD;;AOhyVA;EACC,UAAA;APmyVD;;AOhyVA,UAAA;AACA;EACC,+CAAA;EACA,mBAAA;APmyVD;;AOhyVA,WAAA;AACA;EACC,+CAAA;EACA,mBAAA;APmyVD;;AOhyVA,oBAAA;AACA;EACC,gBAAA;APmyVD;;AOhyVA;EACC,SAAA;APmyVD;;AOhyVA;EACC,cAAA;EACA,eAAA;APmyVD;;AOhyVA;EACC,cAAA;EACA,eAAA;APmyVD;;AOhyVA;EACC,uBAAA;APmyVD;;AOjyVA;EACC,qBAAA;APoyVD;;AQ97VA,kBAAA;AACA;EACC,WAAA;ARi8VD;;AQ97VA;EACC,gBAAA;ARi8VD;;AQ97VA;EACC,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,WAAA;ARi8VD;;AQ97VA;EACC,eAAA;ARi8VD;;AQ97VA;EACC,UAAA;ARi8VD;;AQ97VA;;EAEC,yBAAA;EACA,eAAA;EACA,cAAA;ARi8VD;;AQ97VA;EACC,cAAA;EAEA,eAAA;ARg8VD;;AQ77VA;EACC,eAAA;EACA,cAAA;ARg8VD;;AQ77VA,oBAAA;AAEA;EACC,mBAAA;EACA,aAAA;EACA,cAAA;AR+7VD;;AQ57VA;EACC,eAAA;EACA,cAAA;AR+7VD;;AQ57VA;EACC,eAAA;EACA,cAAA;EACA,mBAAA;AR+7VD;;AQ57VA;EACC,aAAA;AR+7VD;;AQ57VA;EACC,aAAA;AR+7VD;;AQ57VA;EACC,iBAAA;AR+7VD;;AQ57VA;EACC,qBAAA;AR+7VD;;AQ57VA;EACC,eAAA;AR+7VD;;AQ57VA;EACC,YAAA;EACA,yBAAA;AR+7VD;;AQ57VA;EACC,mBAAA;AR+7VD;;AQ57VA;EACC,eAAA;EACA,oBAAA;AR+7VD;;AQ57VA;EACC,oCAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;AR+7VD;;AQ57VA;EACC,qBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AR+7VD;;AQ57VA;EACC,gBAAA;EACA,cAAA;AR+7VD;;AQ57VA,gBAAA;AACA;EACC,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AR+7VD;;AQ57VA;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AR+7VD;;AQ57VA;EACC,cAAA;EACA,eAAA;AR+7VD;;AQ57VA;EACC,eAAA;AR+7VD;;AQ57VA;EACC,YAAA;EACA,cAAA;AR+7VD;;AQ57VA;EACC,iCAAA;EACA,6BAAA;AR+7VD;;AQ57VA,cAAA;AChKA;EACC,cAAA;EACA,eAAA;ATgmWD;;AS7lWA;EACC,yBAAA;EACA,cAAA;ATgmWD;;AS7lWA;EACC,uBAAA;ATgmWD;;AS7lWA;EACC,eAAA;ATgmWD;;AS7lWA;EACC,eAAA;ATgmWD;;AS7lWA;EACC,cAAA;ATgmWD;;AS7lWA;EACC,WAAA;ATgmWD;;AS7lWA,aAAA;AACA;EACC,wBAAA;EACA,eAAA;ATgmWD;;AS7lWA;EACC,WAAA;EACA,YAAA;ATgmWD;;AS7lWA;EACC,WAAA;EACA,YAAA;ATgmWD;;AS7lWA;EACC,6BAAA;EACA,qBAAA;ATgmWD;;AS7lWA;EACC,gBAAA;ATgmWD;;AS7lWA;EACC,qBAAA;ATgmWD;;AS7lWA;EACC,WAAA;EACA,qBAAA;EACA,yBAAA;ATgmWD;;AS7lWA,iBAAA;ACjEA;EACC;IACC,aAAA;EVkqWA;AACF;AU/pWA;EACC;IACC,cAAA;EViqWA;AACF;AU9pWA;EAEC;;IAEC,WAAA;EV+pWA;EU5pWD;IACC,uBAAA;EV8pWA;EU3pWD;IACC,gBAAA;IACA,cAAA;EV6pWA;EU1pWD;IACC,kBAAA;IACA,gBAAA;EV4pWA;EUzpWD;IACC,UAAA;IACA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,UAAA;IACA,iBAAA;EV2pWA;EUxpWD;IACC,WAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,WAAA;IACA,iBAAA;EV0pWA;EUvpWD;IACC,YAAA;EVypWA;EUtpWD;IACC,wBAAA;EVwpWA;EUrpWD;IACC,yBAAA;EVupWA;EUppWD;IACC,uBAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EVspWA;EUnpWD;IACC,aAAA;EVqpWA;EUlpWD;IACC,kBAAA;EVopWA;EUjpWD;IACC,iBAAA;EVmpWA;EUhpWD;IACC,6BAAA;IACA,eAAA;IACA,sBAAA;IACA,aAAA;IACA,gBAAA;EVkpWA;EU/oWD,oBAAA;EAEA;IACC,UAAA;IACA,WAAA;IACA,uBAAA;EVgpWA;EU7oWD;IACC,iBAAA;IACA,iBAAA;EV+oWA;EU5oWD;IACC,kBAAA;IACA,YAAA;IAEA,SAAA;IACA,aAAA;EV6oWA;EU1oWD;IACC,qBAAA;IACA,gBAAA;IACA,cAAA;EV4oWA;EUzoWD;IACC,gBAAA;EV2oWA;EUxoWD;IACC,mBAAA;EV0oWA;EUxoWD,gBAAA;EACD;IAEC,sBAAA;IACA,6BAAA;EVyoWC;EUvoWF;IAEC,sBAAA;IACA,6BAAA;EVwoWC;AACF;AUroWA,WAAA;AACA;;;EAGC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AVuoWD;;AUpoWA;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,WAAA;AVuoWD;;AUpoWA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;AVuoWD;;AUpoWA;EACC,qBAAA;EACA,eAAA;AVuoWD;;AUpoWA;EACC,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AVuoWD;;AUpoWA;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AVuoWD;;AUpoWA;EACC,mBAAA;EACA,gBAAA;AVuoWD;;AUpoWA;;EAEC,gBAAA;AVuoWD;;AUpoWA;EACC,gCAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AVuoWD;;AUpoWA;EACC,cAAA;EACA,gBAAA;EACA,WAAA;AVuoWD;;AUpoWA;EACC,gBAAA;EACA,cAAA;AVuoWD;;AUpoWA;;;EAGC,cAAA;AVuoWD;;AUpoWA;;EAEC,mBAAA;AVuoWD;;AUpoWA;EACC,mBAAA;AVuoWD;;AUpoWA;EACC,qBAAA;AVuoWD;;AUpoWA;EACC,eAAA;AVuoWD;;AUpoWA;;EAEC,yBAAA;EACA,kBAAA;AVuoWD;;AUpoWA;EACC,YAAA;EACA,gBAAA;EACA,WAAA;AVuoWD;;AUpoWA;EACC,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AVuoWD;;AUpoWA;EACC,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AVuoWD;;AUpoWA;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;AVuoWD;;AUpoWA;EACC,eAAA;EACA,WAAA;EACA,iBAAA;AVuoWD;;AUpoWA;EACC,YAAA;EACA,uBAAA;AVuoWD;;AUpoWA;EACC,mBAAA;EACA,qBAAA;AVuoWD;;AUpoWA,kBAAA;AAGA,MAAA;AACA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;AVqoWD;;AUloWA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;AVqoWD;;AUloWA;EACC,kBAAA;AVqoWD;;AUloWA;EACC,kBAAA;AVqoWD;;AUloWA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AVqoWD;;AU9nWA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;AVioWD;;AU9nWA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;AVioWD;;AU9nWA;EACC,kBAAA;AVioWD;;AU9nWA;EACC,kBAAA;AVioWD;;AU9nWA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;AVioWD;;AU9nWA;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;AVioWD;;AU9nWA;EACC,kBAAA;AVioWD;;AU9nWA;EACC,kBAAA;AVioWD;;AU9nWA;;EAEC,aAAA;AVioWD;;AU7nWA,UAAA;AACA;EAEC,YAAA;AV+nWD;;AU7nWA;EAEC,WAAA;AV+nWD;;AWrgXA;EAA2B,aAAA;EAAa,qCAAA;EAAqC,eAAA;EAAe,YAAA;EAAY,YAAA;EAAY,sBAAA;EAAsB,WAAA;AX+gX1I;;AW/gXqJ;EAAqC,QAAA;EAAQ,SAAA;AXohXlM;;AWphX2M;EAAuC,QAAA;EAAQ,SAAA;EAAS,2BAAA;AX0hXnQ;;AW1hX8R;EAAsC,QAAA;EAAQ,UAAA;AX+hX5U;;AW/hXsV;EAAwC,WAAA;EAAW,SAAA;AXoiXzY;;AWpiXkZ;EAA0C,WAAA;EAAW,SAAA;EAAS,2BAAA;AX0iXhd;;AW1iX2e;EAAyC,WAAA;EAAW,UAAA;AX+iX/hB;;AW/iXyiB;EAAyC;IAA2B,YAAA;IAAY,UAAA;IAAU,OAAA;IAAO,SAAA;EXujXxoB;EWvjXipB;IAAkH,MAAA;IAAM,wBAAA;EX2jXzwB;EW3jXiyB;IAA2H,SAAA;IAAS,wBAAA;EX+jXr6B;EW/jX67B;IAAgC,QAAA;IAAQ,UAAA;EXmkXr+B;AACF;AWpkXk/B;EAAiB,kBAAA;EAAkB,gBAAA;EAAgB,sBAAA;EAAsB,mBAAA;EAAmB,YAAA;EAAY,kBAAA;EAAkB,6EAAA;EAAwF,aAAA;EAAmC,8BAAA;EAA8B,iBAAA;EAAiB,gBAAA;EAAgB,uBAAA;EAAuB,eAAA;EAAe,cAAA;AXslX50C;;AWtlX01C;EAAsB,cAAA;AX0lXh3C;;AW1lX83C;EAAuB,mBAAA;EAAmB,WAAA;AX+lXx6C;;AW/lXm7C;EAA0B,gBAAA;EAAgB,WAAA;AXomX79C;;AWpmXw+C;EAAuB,mBAAA;AXwmX//C;;AWxmXkhD;EAA0B,mBAAA;AX4mX5iD;;AW5mX+jD;EAA0B,mBAAA;AXgnXzlD;;AWhnX4mD;EAAwB,mBAAA;AXonXpoD;;AWpnXupD;EAAsB,cAAA;EAAgC,cAAA;AX0nX7sD;;AW1nX2tD;EAAyC;IAAiB,gBAAA;EX+nXnxD;AACF;AWhoXsyD;EAAwB,WAAA;EAAW,uBAAA;EAAuB,aAAA;EAAa,YAAA;EAAY,UAAA;EAAU,eAAA;EAAe,YAAA;EAAW,qBAAA;EAA8C,sBAAA;AX4oX38D;;AW5oXi+D;EAAiC,WAAA;EAAW,YAAA;AXipX7gE;;AWjpXwhE;EAA4B,kBAAA;EAAkB,YAAA;EAAY,WAAA;AXupXllE;;AWvpX6lE;EAA4D,UAAA;AX2pXzpE;;AW3pXmqE;EAAmC;IAAG,oBAAA;EXgqXvsE;EWhqX2tE;IAAG,oBAAA;EXmqX9tE;AACF;AWpqXqvE;EAAwB,kBAAA;EAAkB,SAAA;EAAS,OAAA;EAAO,WAAA;EAAW,WAAA;EAAW,aAAA;EAAa,YAAA;EAAW,wCAAA;EAAoC,sBAAA;AX+qXj4E;;AW/qXu5E;EAAkC,oDAAA;AXmrXz7E;;AWnrX6+E;EAAoC,0BAAA;AXurXjhF;;AWvrX0iF;EAA6B,QAAA;EAAQ,UAAA;EAAU,uBAAA;AX6rXzlF;;AW7rXgnF;EAAiC,wFAAA;AXisXjpF;;AWjsXmuF;EAA8B,mBAAA;AXqsXjwF;;AWrsXoxF;EAAmC;IAAkB,8DAAA;EX0sXv0F;EW1sX+3F;IAAG,UAAA;IAAU,oCAAA;EX8sX54F;EW9sX86F;IAAI,UAAA;IAAU,mCAAA;EXktX57F;EWltX69F;IAAI,kCAAA;EXqtXj+F;EWrtXigG;IAAI,kCAAA;EXwtXrgG;EWxtXqiG;IAAG,eAAA;EX2tXxiG;AACF;AW5tX0jG;EAAoC;IAAI,UAAA;IAAU,mCAAA;EXiuX1mG;EWjuX2oG;IAAG,UAAA;IAAU,oCAAA;EXquXxpG;AACF;AWtuX6rG;EAAkC;IAAkB,8DAAA;EX0uX/uG;EW1uXuyG;IAAG,UAAA;IAAU,qCAAA;EX8uXpzG;EW9uXu1G;IAAI,UAAA;IAAU,kCAAA;EXkvXr2G;EWlvXq4G;IAAI,mCAAA;EXqvXz4G;EWrvX06G;IAAI,iCAAA;EXwvX96G;EWxvX68G;IAAG,eAAA;EX2vXh9G;AACF;AW5vXk+G;EAAmC;IAAI,UAAA;IAAU,kCAAA;EXiwXjhH;EWjwXijH;IAAG,UAAA;IAAU,qCAAA;EXqwX9jH;AACF;AWtwXomH;EAAgC;IAAkB,8DAAA;EX0wXppH;EW1wX4sH;IAAG,UAAA;IAAU,oCAAA;EX8wXztH;EW9wX2vH;IAAI,UAAA;IAAU,mCAAA;EXkxXzwH;EWlxX0yH;IAAI,kCAAA;EXqxX9yH;EWrxX80H;IAAI,kCAAA;EXwxXl1H;EWxxXk3H;IAAG,wBAAA;EX2xXr3H;AACF;AW5xXg5H;EAAiC;IAAI,mCAAA;EXgyXn7H;EWhyXo9H;IAAQ,UAAA;IAAU,kCAAA;EXoyXt+H;EWpyXsgI;IAAG,UAAA;IAAU,qCAAA;EXwyXnhI;AACF;AWzyXyjI;EAAkC;IAAkB,8DAAA;EX6yX3mI;EW7yXmqI;IAAG,UAAA;IAAU,qCAAA;EXizXhrI;EWjzXmtI;IAAI,UAAA;IAAU,kCAAA;EXqzXjuI;EWrzXiwI;IAAI,mCAAA;EXwzXrwI;EWxzXsyI;IAAI,iCAAA;EX2zX1yI;EW3zXy0I;IAAG,eAAA;EX8zX50I;AACF;AW/zX81I;EAAmC;IAAI,kCAAA;EXm0Xn4I;EWn0Xm6I;IAAQ,UAAA;IAAU,mCAAA;EXu0Xr7I;EWv0Xs9I;IAAG,UAAA;IAAU,oCAAA;EX20Xn+I;AACF;AW50XwgJ;EAAuE,sCAAA;AX+0X/kJ;;AW/0XqnJ;EAAyE,uCAAA;AXm1X9rJ;;AWn1XquJ;EAAoC,sCAAA;AXu1XzwJ;;AWv1X+yJ;EAAuC,oCAAA;AX21Xt1J;;AW31X03J;EAAqE,uCAAA;AX+1X/7J;;AW/1Xs+J;EAAuE,wCAAA;AXm2X7iK;;AWn2XqlK;EAAmC,qCAAA;AXu2XxnK;;AWv2X6pK;EAAsC,uCAAA;AX22XnsK;;AW32X0uK;EAA4B;IAAG,UAAA;IAAU,iCAAA;EXi3XjxK;EWj3X6yK;IAAI,UAAA;EXo3XjzK;AACF;AWr3X8zK;EAA6B;IAAG,UAAA;EXy3X51K;EWz3Xs2K;IAAI,UAAA;IAAU,iCAAA;EX63Xp3K;EW73Xg5K;IAAG,UAAA;EXg4Xn5K;AACF;AWj4Xg6K;EAAsB,gCAAA;AXo4Xt7K;;AWp4Xs9K;EAAqB,iCAAA;AXw4X3+K;;AWx4X4gL;EAA4B;IAAG,4CAAA;IAA4C,kCAAA;IAAkC,UAAA;EX+4XvnL;EW/4XioL;IAAI,6CAAA;IAA6C,kCAAA;EXm5XlrL;EWn5XotL;IAAI,4CAAA;IAA4C,UAAA;EXu5XpwL;EWv5X8wL;IAAI,4CAAA;EX05XlxL;EW15X8zL;IAAG,6BAAA;EX65Xj0L;AACF;AW95Xi2L;EAA6B;IAAG,6BAAA;EXk6X/3L;EWl6X45L;IAAI,6CAAA;IAA6C,UAAA;EXs6X78L;EWt6Xu9L;IAAG,4CAAA;IAA4C,UAAA;EX06XtgM;AACF;AW36XmhM;EAAsB,gCAAA;AX86XziM;;AW96XykM;EAAqB,iCAAA;AXk7X9lM;;AWl7X+nM;EAAkC;IAAG,kCAAA;IAAgC,mBAAA;EXw7XlsM;EWx7XqtM;IAAG,wBAAA;EX27XxtM;AACF;AW57XmvM;EAAiC;IAAG,mCAAA;IAAiC,mBAAA;EXi8XtzM;EWj8Xy0M;IAAG,wBAAA;EXo8X50M;AACF;AWr8Xu2M;EAA+B;IAAG,kCAAA;IAAgC,mBAAA;EX08Xv6M;EW18X07M;IAAG,wBAAA;EX68X77M;AACF;AW98Xw9M;EAAiC;IAAG,mCAAA;IAAiC,mBAAA;EXm9X3hN;EWn9X8iN;IAAG,wBAAA;EXs9XjjN;AACF;AWv9X4kN;EAAmC;IAAG,wBAAA;EX29XhnN;EW39XwoN;IAAG,kBAAA;IAAkB,kCAAA;EX+9X7pN;AACF;AWh+XgsN;EAAkC;IAAG,wBAAA;EXo+XnuN;EWp+X2vN;IAAG,kBAAA;IAAkB,mCAAA;EXw+XhxN;AACF;AWz+XozN;EAAkC;IAAG,wBAAA;EX6+Xv1N;EW7+X+2N;IAAG,kBAAA;IAAkB,mCAAA;EXi/Xp4N;AACF;AWl/Xw6N;EAAgC;IAAG,wBAAA;EXs/Xz8N;EWt/Xi+N;IAAG,kBAAA;IAAkB,oCAAA;EX0/Xt/N;AACF;AW3/X2hO;EAAqE,qCAAA;AX8/XhmO;;AW9/XqoO;EAAuE,sCAAA;AXkgY5sO;;AWlgYkvO;EAAmC,qCAAA;AXsgYrxO;;AWtgY0zO;EAAsC,mCAAA;AX0gYh2O;;AW1gYm4O;EAAmE,sCAAA;AX8gYt8O;;AW9gY4+O;EAAqE,uCAAA;AXkhYjjP;;AWlhYwlP;EAAkC,oCAAA;AXshY1nP;;AWthY8pP;EAAqC,sCAAA;AX0hYnsP;;AY1hYA;EACC,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;AZ6hYD","sourcesContent":["@use '../src/styles/bootstrap' as *;\n@use '../src/styles/GlobalStyles' as *;\n@use '../src/styles/DataTable' as *;\n@use '../src/styles/Login_Form' as *;\n@use '../src/styles/Nav_SIdebar' as *;\n@use '../src/styles/Dashboard' as *;\n@use '../src/styles/New_Design' as *;\n@use '../src/styles/Products_Modal' as *;\n@use '../src/styles/Sub_Checkbox' as *;\n@use '../src/styles/Media' as *;\n@use '../src/styles/toast' as *;\n@use '../src/styles/passwordToggle' as *;\n\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');\n@import url('https://cdn.jsdelivr.net/npm/boxicons@2.0.5/css/boxicons.min.css');\n@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');\n","/*!\n * Bootstrap v4.4.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 The Bootstrap Authors\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#007bff;--secondary:#6c757d;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,::after,::before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}article,aside,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus:not(:focus-visible){outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}dl,ol,ul{margin-top:0;margin-bottom:1rem}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent}a:hover{color:#0056b3;text-decoration:underline}a:not([href]){color:inherit;text-decoration:none}a:not([href]):hover{color:inherit;text-decoration:none}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg{overflow:hidden;vertical-align:middle}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}select{word-wrap:normal}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1,h1{font-size:2.5rem}.h2,h2{font-size:2rem}.h3,h3{font-size:1.75rem}.h4,h4{font-size:1.5rem}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem;font-weight:300;line-height:1.2}.display-2{font-size:5.5rem;font-weight:300;line-height:1.2}.display-3{font-size:4.5rem;font-weight:300;line-height:1.2}.display-4{font-size:3.5rem;font-weight:300;line-height:1.2}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-unstyled{padding-left:0;list-style:none}.list-inline{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#6c757d}.blockquote-footer::before{content:\"\\2014\\00A0\"}.img-fluid{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#6c757d}code{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid,.container-lg,.container-md,.container-sm,.container-xl{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container,.container-sm{max-width:540px}}@media (min-width:768px){.container,.container-md,.container-sm{max-width:720px}}@media (min-width:992px){.container,.container-lg,.container-md,.container-sm{max-width:960px}}@media (min-width:1200px){.container,.container-lg,.container-md,.container-sm,.container-xl{max-width:1140px}}.row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-10,.col-11,.col-12,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-auto,.col-lg,.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-auto,.col-md,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-auto,.col-sm,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-auto{position:relative;width:100%;padding-right:15px;padding-left:15px}.col{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-first{-ms-flex-order:-1;order:-1}.order-last{-ms-flex-order:13;order:13}.order-0{-ms-flex-order:0;order:0}.order-1{-ms-flex-order:1;order:1}.order-2{-ms-flex-order:2;order:2}.order-3{-ms-flex-order:3;order:3}.order-4{-ms-flex-order:4;order:4}.order-5{-ms-flex-order:5;order:5}.order-6{-ms-flex-order:6;order:6}.order-7{-ms-flex-order:7;order:7}.order-8{-ms-flex-order:8;order:8}.order-9{-ms-flex-order:9;order:9}.order-10{-ms-flex-order:10;order:10}.order-11{-ms-flex-order:11;order:11}.order-12{-ms-flex-order:12;order:12}.offset-1{margin-left:8.333333%}.offset-2{margin-left:16.666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.333333%}.offset-5{margin-left:41.666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.333333%}.offset-8{margin-left:66.666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.333333%}.offset-11{margin-left:91.666667%}@media (min-width:576px){.col-sm{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-sm-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-sm-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-sm-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-sm-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-sm-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-sm-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-sm-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-sm-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-sm-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-sm-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-sm-first{-ms-flex-order:-1;order:-1}.order-sm-last{-ms-flex-order:13;order:13}.order-sm-0{-ms-flex-order:0;order:0}.order-sm-1{-ms-flex-order:1;order:1}.order-sm-2{-ms-flex-order:2;order:2}.order-sm-3{-ms-flex-order:3;order:3}.order-sm-4{-ms-flex-order:4;order:4}.order-sm-5{-ms-flex-order:5;order:5}.order-sm-6{-ms-flex-order:6;order:6}.order-sm-7{-ms-flex-order:7;order:7}.order-sm-8{-ms-flex-order:8;order:8}.order-sm-9{-ms-flex-order:9;order:9}.order-sm-10{-ms-flex-order:10;order:10}.order-sm-11{-ms-flex-order:11;order:11}.order-sm-12{-ms-flex-order:12;order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.333333%}.offset-sm-2{margin-left:16.666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.333333%}.offset-sm-5{margin-left:41.666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.333333%}.offset-sm-8{margin-left:66.666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.333333%}.offset-sm-11{margin-left:91.666667%}}@media (min-width:768px){.col-md{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-md-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-md-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-md-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-md-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-md-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-md-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-md-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-md-first{-ms-flex-order:-1;order:-1}.order-md-last{-ms-flex-order:13;order:13}.order-md-0{-ms-flex-order:0;order:0}.order-md-1{-ms-flex-order:1;order:1}.order-md-2{-ms-flex-order:2;order:2}.order-md-3{-ms-flex-order:3;order:3}.order-md-4{-ms-flex-order:4;order:4}.order-md-5{-ms-flex-order:5;order:5}.order-md-6{-ms-flex-order:6;order:6}.order-md-7{-ms-flex-order:7;order:7}.order-md-8{-ms-flex-order:8;order:8}.order-md-9{-ms-flex-order:9;order:9}.order-md-10{-ms-flex-order:10;order:10}.order-md-11{-ms-flex-order:11;order:11}.order-md-12{-ms-flex-order:12;order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.333333%}.offset-md-2{margin-left:16.666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.333333%}.offset-md-5{margin-left:41.666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.333333%}.offset-md-8{margin-left:66.666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.333333%}.offset-md-11{margin-left:91.666667%}}@media (min-width:992px){.col-lg{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-lg-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-lg-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-lg-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-lg-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-lg-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-lg-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-lg-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-lg-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-lg-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-lg-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-lg-first{-ms-flex-order:-1;order:-1}.order-lg-last{-ms-flex-order:13;order:13}.order-lg-0{-ms-flex-order:0;order:0}.order-lg-1{-ms-flex-order:1;order:1}.order-lg-2{-ms-flex-order:2;order:2}.order-lg-3{-ms-flex-order:3;order:3}.order-lg-4{-ms-flex-order:4;order:4}.order-lg-5{-ms-flex-order:5;order:5}.order-lg-6{-ms-flex-order:6;order:6}.order-lg-7{-ms-flex-order:7;order:7}.order-lg-8{-ms-flex-order:8;order:8}.order-lg-9{-ms-flex-order:9;order:9}.order-lg-10{-ms-flex-order:10;order:10}.order-lg-11{-ms-flex-order:11;order:11}.order-lg-12{-ms-flex-order:12;order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.333333%}.offset-lg-2{margin-left:16.666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.333333%}.offset-lg-5{margin-left:41.666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.333333%}.offset-lg-8{margin-left:66.666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.333333%}.offset-lg-11{margin-left:91.666667%}}@media (min-width:1200px){.col-xl{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-xl-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-xl-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-xl-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-xl-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-xl-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-xl-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-xl-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-xl-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-xl-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-xl-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-xl-first{-ms-flex-order:-1;order:-1}.order-xl-last{-ms-flex-order:13;order:13}.order-xl-0{-ms-flex-order:0;order:0}.order-xl-1{-ms-flex-order:1;order:1}.order-xl-2{-ms-flex-order:2;order:2}.order-xl-3{-ms-flex-order:3;order:3}.order-xl-4{-ms-flex-order:4;order:4}.order-xl-5{-ms-flex-order:5;order:5}.order-xl-6{-ms-flex-order:6;order:6}.order-xl-7{-ms-flex-order:7;order:7}.order-xl-8{-ms-flex-order:8;order:8}.order-xl-9{-ms-flex-order:9;order:9}.order-xl-10{-ms-flex-order:10;order:10}.order-xl-11{-ms-flex-order:11;order:11}.order-xl-12{-ms-flex-order:12;order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.333333%}.offset-xl-2{margin-left:16.666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.333333%}.offset-xl-5{margin-left:41.666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.333333%}.offset-xl-8{margin-left:66.666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.333333%}.offset-xl-11{margin-left:91.666667%}}.table{width:100%;margin-bottom:1rem;color:#212529}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table-sm td,.table-sm th{padding:.3rem}.table-bordered{border:1px solid #dee2e6}.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-borderless tbody+tbody,.table-borderless td,.table-borderless th,.table-borderless thead th{border:0}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{color:#212529;background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#b8daff}.table-primary tbody+tbody,.table-primary td,.table-primary th,.table-primary thead th{border-color:#7abaff}.table-hover .table-primary:hover{background-color:#9fcdff}.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#d6d8db}.table-secondary tbody+tbody,.table-secondary td,.table-secondary th,.table-secondary thead th{border-color:#b3b7bb}.table-hover .table-secondary:hover{background-color:#c8cbcf}.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#c8cbcf}.table-success,.table-success>td,.table-success>th{background-color:#c3e6cb}.table-success tbody+tbody,.table-success td,.table-success th,.table-success thead th{border-color:#8fd19e}.table-hover .table-success:hover{background-color:#b1dfbb}.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>td,.table-info>th{background-color:#bee5eb}.table-info tbody+tbody,.table-info td,.table-info th,.table-info thead th{border-color:#86cfda}.table-hover .table-info:hover{background-color:#abdde5}.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffeeba}.table-warning tbody+tbody,.table-warning td,.table-warning th,.table-warning thead th{border-color:#ffdf7e}.table-hover .table-warning:hover{background-color:#ffe8a1}.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>td,.table-danger>th{background-color:#f5c6cb}.table-danger tbody+tbody,.table-danger td,.table-danger th,.table-danger thead th{border-color:#ed969e}.table-hover .table-danger:hover{background-color:#f1b0b7}.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>td,.table-light>th{background-color:#fdfdfe}.table-light tbody+tbody,.table-light td,.table-light th,.table-light thead th{border-color:#fbfcfc}.table-hover .table-light:hover{background-color:#ececf6}.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#95999c}.table-hover .table-dark:hover{background-color:#b9bbbe}.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#343a40;border-color:#454d55}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#343a40}.table-dark td,.table-dark th,.table-dark thead th{border-color:#454d55}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,.05)}.table-dark.table-hover tbody tr:hover{color:#fff;background-color:rgba(255,255,255,.075)}@media (max-width:575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.98px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.98px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.98px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control{transition:none}}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#6c757d;opacity:1}.form-control::-moz-placeholder{color:#6c757d;opacity:1}.form-control:-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm{padding-right:0;padding-left:0}.form-control-sm{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.form-control-lg{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}select.form-control[multiple],select.form-control[size]{height:auto}textarea.form-control{height:auto}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label,.form-check-input[disabled]~.form-check-label{color:#6c757d}.form-check-label{margin-bottom:0}.form-check-inline{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(40,167,69,.9);border-radius:.25rem}.is-valid~.valid-feedback,.is-valid~.valid-tooltip,.was-validated :valid~.valid-feedback,.was-validated :valid~.valid-tooltip{display:block}.form-control.is-valid,.was-validated .form-control:valid{border-color:#28a745;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.was-validated textarea.form-control:valid,textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-valid,.was-validated .custom-select:valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)}.custom-select.is-valid:focus,.was-validated .custom-select:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.form-check-input.is-valid~.valid-feedback,.form-check-input.is-valid~.valid-tooltip,.was-validated .form-check-input:valid~.valid-feedback,.was-validated .form-check-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.was-validated .custom-control-input:valid~.custom-control-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label::before,.was-validated .custom-control-input:valid~.custom-control-label::before{border-color:#28a745}.custom-control-input.is-valid:checked~.custom-control-label::before,.was-validated .custom-control-input:valid:checked~.custom-control-label::before{border-color:#34ce57;background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label::before,.was-validated .custom-control-input:valid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback,.is-invalid~.invalid-tooltip,.was-validated :invalid~.invalid-feedback,.was-validated :invalid~.invalid-tooltip{display:block}.form-control.is-invalid,.was-validated .form-control:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.was-validated textarea.form-control:invalid,textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-invalid,.was-validated .custom-select:invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)}.custom-select.is-invalid:focus,.was-validated .custom-select:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.form-check-input.is-invalid~.invalid-feedback,.form-check-input.is-invalid~.invalid-tooltip,.was-validated .form-check-input:invalid~.invalid-feedback,.was-validated .form-check-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.was-validated .custom-control-input:invalid~.custom-control-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label::before,.was-validated .custom-control-input:invalid~.custom-control-label::before{border-color:#dc3545}.custom-control-input.is-invalid:checked~.custom-control-label::before,.was-validated .custom-control-input:invalid:checked~.custom-control-label::before{border-color:#e4606d;background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin-bottom:0}.form-inline .form-group{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center;margin-bottom:0}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .custom-select,.form-inline .input-group{width:auto}.form-inline .form-check{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;-ms-flex-negative:0;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn{transition:none}}.btn:hover{color:#212529;text-decoration:none}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}a.btn.disabled,fieldset:disabled a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#0069d9;border-color:#0062cc;box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-primary.disabled,.btn-primary:disabled{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:not(:disabled):not(.disabled).active,.btn-primary:not(:disabled):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not(:disabled):not(.disabled).active:focus,.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-secondary{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.btn-secondary.focus,.btn-secondary:focus{color:#fff;background-color:#5a6268;border-color:#545b62;box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-secondary.disabled,.btn-secondary:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#545b62;border-color:#4e555b}.btn-secondary:not(:disabled):not(.disabled).active:focus,.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#218838;border-color:#1e7e34;box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-success.disabled,.btn-success:disabled{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:not(:disabled):not(.disabled).active,.btn-success:not(:disabled):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not(:disabled):not(.disabled).active:focus,.btn-success:not(:disabled):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#138496;border-color:#117a8b;box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-info.disabled,.btn-info:disabled{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:not(:disabled):not(.disabled).active,.btn-info:not(:disabled):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not(:disabled):not(.disabled).active:focus,.btn-info:not(:disabled):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus,.btn-warning:focus{color:#212529;background-color:#e0a800;border-color:#d39e00;box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-warning.disabled,.btn-warning:disabled{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:not(:disabled):not(.disabled).active,.btn-warning:not(:disabled):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not(:disabled):not(.disabled).active:focus,.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c82333;border-color:#bd2130;box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-danger.disabled,.btn-danger:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:not(:disabled):not(.disabled).active,.btn-danger:not(:disabled):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not(:disabled):not(.disabled).active:focus,.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus,.btn-light:focus{color:#212529;background-color:#e2e6ea;border-color:#dae0e5;box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-light.disabled,.btn-light:disabled{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not(:disabled):not(.disabled).active,.btn-light:not(:disabled):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not(:disabled):not(.disabled).active:focus,.btn-light:not(:disabled):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{color:#fff;background-color:#23272b;border-color:#1d2124;box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-dark.disabled,.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:not(:disabled):not(.disabled).active,.btn-dark:not(:disabled):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not(:disabled):not(.disabled).active:focus,.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-outline-primary{color:#007bff;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus,.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not(:disabled):not(.disabled).active,.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#6c757d;border-color:#6c757d}.btn-outline-secondary:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary.focus,.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#6c757d;background-color:transparent}.btn-outline-secondary:not(:disabled):not(.disabled).active,.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-success{color:#28a745;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus,.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not(:disabled):not(.disabled).active,.btn-outline-success:not(:disabled):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success:not(:disabled):not(.disabled).active:focus,.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus,.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not(:disabled):not(.disabled).active,.btn-outline-info:not(:disabled):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info:not(:disabled):not(.disabled).active:focus,.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus,.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not(:disabled):not(.disabled).active,.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus,.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not(:disabled):not(.disabled).active,.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus,.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not(:disabled):not(.disabled).active,.btn-outline-light:not(:disabled):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:not(:disabled):not(.disabled).active:focus,.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not(:disabled):not(.disabled).active,.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;text-decoration:none}.btn-link:hover{color:#0056b3;text-decoration:underline}.btn-link.focus,.btn-link:focus{text-decoration:underline;box-shadow:none}.btn-link.disabled,.btn-link:disabled{color:#6c757d;pointer-events:none}.btn-group-lg>.btn,.btn-lg{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{position:relative;height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing{transition:none}}.dropdown,.dropleft,.dropright,.dropup{position:relative}.dropdown-toggle{white-space:nowrap}.dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty::after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu-left{right:auto;left:0}.dropdown-menu-right{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-left{right:auto;left:0}.dropdown-menu-sm-right{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-left{right:auto;left:0}.dropdown-menu-md-right{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-left{right:auto;left:0}.dropdown-menu-lg-right{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-left{right:auto;left:0}.dropdown-menu-xl-right{right:0;left:auto}}.dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-toggle::after{vertical-align:0}.dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.dropleft .dropdown-toggle::after{display:none}.dropleft .dropdown-toggle::before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty::after{margin-left:0}.dropleft .dropdown-toggle::before{vertical-align:0}.dropdown-menu[x-placement^=bottom],.dropdown-menu[x-placement^=left],.dropdown-menu[x-placement^=right],.dropdown-menu[x-placement^=top]{right:auto;bottom:auto}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#6c757d;pointer-events:none;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text{display:block;padding:.25rem 1.5rem;color:#212529}.btn-group,.btn-group-vertical{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.btn-group-vertical>.btn:hover,.btn-group>.btn:hover{z-index:1}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus{z-index:1}.btn-toolbar{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:start;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn-group:not(:first-child),.btn-group>.btn:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after,.dropright .dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after{margin-left:0}.dropleft .dropdown-toggle-split::before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:center;justify-content:center}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{width:100%}.btn-group-vertical>.btn-group:not(:first-child),.btn-group-vertical>.btn:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio],.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;width:100%}.input-group>.custom-file,.input-group>.custom-select,.input-group>.form-control,.input-group>.form-control-plaintext{position:relative;-ms-flex:1 1 0%;flex:1 1 0%;min-width:0;margin-bottom:0}.input-group>.custom-file+.custom-file,.input-group>.custom-file+.custom-select,.input-group>.custom-file+.form-control,.input-group>.custom-select+.custom-file,.input-group>.custom-select+.custom-select,.input-group>.custom-select+.form-control,.input-group>.form-control+.custom-file,.input-group>.form-control+.custom-select,.input-group>.form-control+.form-control,.input-group>.form-control-plaintext+.custom-file,.input-group>.form-control-plaintext+.custom-select,.input-group>.form-control-plaintext+.form-control{margin-left:-1px}.input-group>.custom-file .custom-file-input:focus~.custom-file-label,.input-group>.custom-select:focus,.input-group>.form-control:focus{z-index:3}.input-group>.custom-file .custom-file-input:focus{z-index:4}.input-group>.custom-select:not(:last-child),.input-group>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-select:not(:first-child),.input-group>.form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.custom-file{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group>.custom-file:not(:last-child) .custom-file-label,.input-group>.custom-file:not(:last-child) .custom-file-label::after{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-file:not(:first-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append,.input-group-prepend{display:-ms-flexbox;display:flex}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn:focus,.input-group-prepend .btn:focus{z-index:3}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group-lg>.custom-select,.input-group-lg>.form-control:not(textarea){height:calc(1.5em + 1rem + 2px)}.input-group-lg>.custom-select,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-sm>.custom-select,.input-group-sm>.form-control:not(textarea){height:calc(1.5em + .5rem + 2px)}.input-group-sm>.custom-select,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-lg>.custom-select,.input-group-sm>.custom-select{padding-right:1.75rem}.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-append:not(:last-child)>.btn,.input-group>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.custom-control-inline{display:-ms-inline-flexbox;display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;left:0;z-index:-1;width:1rem;height:1.25rem;opacity:0}.custom-control-input:checked~.custom-control-label::before{color:#fff;border-color:#007bff;background-color:#007bff}.custom-control-input:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:focus:not(:checked)~.custom-control-label::before{border-color:#80bdff}.custom-control-input:not(:disabled):active~.custom-control-label::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label,.custom-control-input[disabled]~.custom-control-label{color:#6c757d}.custom-control-input:disabled~.custom-control-label::before,.custom-control-input[disabled]~.custom-control-label::before{background-color:#e9ecef}.custom-control-label{position:relative;margin-bottom:0;vertical-align:top}.custom-control-label::before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";background-color:#fff;border:#adb5bd solid 1px}.custom-control-label::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\";background:no-repeat 50%/50% 50%}.custom-checkbox .custom-control-label::before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before{border-color:#007bff;background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label::before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-switch{padding-left:2.25rem}.custom-switch .custom-control-label::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.custom-switch .custom-control-label::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-switch .custom-control-label::after{transition:none}}.custom-switch .custom-control-input:checked~.custom-control-label::after{background-color:#fff;-webkit-transform:translateX(.75rem);transform:translateX(.75rem)}.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{display:none}.custom-select:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.custom-select-sm{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.custom-select-lg{height:calc(1.5em + 1rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.custom-file{position:relative;display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);margin-bottom:0}.custom-file-input{position:relative;z-index:2;width:100%;height:calc(1.5em + .75rem + 2px);margin:0;opacity:0}.custom-file-input:focus~.custom-file-label{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:disabled~.custom-file-label,.custom-file-input[disabled]~.custom-file-label{background-color:#e9ecef}.custom-file-input:lang(en)~.custom-file-label::after{content:\"Browse\"}.custom-file-input~.custom-file-label[data-browse]::after{content:attr(data-browse)}.custom-file-label{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:calc(1.5em + .75rem);padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.custom-range{width:100%;height:1.4rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-range:focus{outline:0}.custom-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range::-moz-focus-outer{border:0}.custom-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.custom-range::-webkit-slider-thumb:active{background-color:#b3d7ff}.custom-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-moz-range-thumb{-moz-transition:none;transition:none}}.custom-range::-moz-range-thumb:active{background-color:#b3d7ff}.custom-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;-ms-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-ms-thumb{-ms-transition:none;transition:none}}.custom-range::-ms-thumb:active{background-color:#b3d7ff}.custom-range::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.custom-range::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.custom-range::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.custom-range:disabled::-webkit-slider-thumb{background-color:#adb5bd}.custom-range:disabled::-webkit-slider-runnable-track{cursor:default}.custom-range:disabled::-moz-range-thumb{background-color:#adb5bd}.custom-range:disabled::-moz-range-track{cursor:default}.custom-range:disabled::-ms-thumb{background-color:#adb5bd}.custom-control-label::before,.custom-file-label,.custom-select{transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-control-label::before,.custom-file-label,.custom-select{transition:none}}.nav{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-item{margin-bottom:-1px}.nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item{-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.nav-justified .nav-item{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;padding:.5rem 1rem}.navbar .container,.navbar .container-fluid,.navbar .container-lg,.navbar .container-md,.navbar .container-sm,.navbar .container-xl{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat center center;background-size:100% 100%}@media (max-width:575.98px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-sm .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-sm .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}}@media (max-width:767.98px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-md .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-md .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}}@media (max-width:991.98px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-lg .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-lg .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}}@media (max-width:1199.98px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-xl .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-xl .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}}.navbar-expand{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-lg,.navbar-expand>.container-md,.navbar-expand>.container-sm,.navbar-expand>.container-xl{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-lg,.navbar-expand>.container-md,.navbar-expand>.container-sm,.navbar-expand>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-light .navbar-brand{color:rgba(0,0,0,.9)}.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a{color:rgba(0,0,0,.9)}.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand{color:#fff}.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:rgba(255,255,255,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:rgba(255,255,255,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:rgba(255,255,255,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-dark .navbar-text{color:rgba(255,255,255,.5)}.navbar-dark .navbar-text a{color:#fff}.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-body{-ms-flex:1 1 auto;flex:1 1 auto;min-height:1px;padding:1.25rem}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem;margin-bottom:0}.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-header+.list-group .list-group-item:first-child{border-top:0}.card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.card-img,.card-img-bottom,.card-img-top{-ms-flex-negative:0;flex-shrink:0;width:100%}.card-img,.card-img-top{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img,.card-img-bottom{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{-ms-flex:1 0 0%;flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.card-group>.card{-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header,.card-group>.card:not(:last-child) .card-img-top{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer,.card-group>.card:not(:last-child) .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header,.card-group>.card:not(:first-child) .card-img-top{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer,.card-group>.card:not(:first-child) .card-img-bottom{border-bottom-left-radius:0}}.card-columns .card{margin-bottom:.75rem}@media (min-width:576px){.card-columns{-webkit-column-count:3;-moz-column-count:3;column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.card-columns .card{display:inline-block;width:100%}}.accordion>.card{overflow:hidden}.accordion>.card:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.accordion>.card:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.accordion>.card>.card-header{border-radius:0;margin-bottom:-1px}.breadcrumb{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item+.breadcrumb-item{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item::before{display:inline-block;padding-right:.5rem;color:#6c757d;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:underline}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:none}.breadcrumb-item.active{color:#6c757d}.pagination{display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:3;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.badge{transition:none}}a.badge:focus,a.badge:hover{text-decoration:none}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}a.badge-primary:focus,a.badge-primary:hover{color:#fff;background-color:#0062cc}a.badge-primary.focus,a.badge-primary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.badge-secondary{color:#fff;background-color:#6c757d}a.badge-secondary:focus,a.badge-secondary:hover{color:#fff;background-color:#545b62}a.badge-secondary.focus,a.badge-secondary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.badge-success{color:#fff;background-color:#28a745}a.badge-success:focus,a.badge-success:hover{color:#fff;background-color:#1e7e34}a.badge-success.focus,a.badge-success:focus{outline:0;box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.badge-info{color:#fff;background-color:#17a2b8}a.badge-info:focus,a.badge-info:hover{color:#fff;background-color:#117a8b}a.badge-info.focus,a.badge-info:focus{outline:0;box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.badge-warning{color:#212529;background-color:#ffc107}a.badge-warning:focus,a.badge-warning:hover{color:#212529;background-color:#d39e00}a.badge-warning.focus,a.badge-warning:focus{outline:0;box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.badge-danger{color:#fff;background-color:#dc3545}a.badge-danger:focus,a.badge-danger:hover{color:#fff;background-color:#bd2130}a.badge-danger.focus,a.badge-danger:focus{outline:0;box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.badge-light{color:#212529;background-color:#f8f9fa}a.badge-light:focus,a.badge-light:hover{color:#212529;background-color:#dae0e5}a.badge-light.focus,a.badge-light:focus{outline:0;box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.badge-dark{color:#fff;background-color:#343a40}a.badge-dark:focus,a.badge-dark:hover{color:#fff;background-color:#1d2124}a.badge-dark.focus,a.badge-dark:focus{outline:0;box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#383d41;background-color:#e2e3e5;border-color:#d6d8db}.alert-secondary hr{border-top-color:#c8cbcf}.alert-secondary .alert-link{color:#202326}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@-webkit-keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}.progress{display:-ms-flexbox;display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar{transition:none}}.progress-bar-striped{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.progress-bar-animated{-webkit-animation:progress-bar-stripes 1s linear infinite;animation:progress-bar-stripes 1s linear infinite}@media (prefers-reduced-motion:reduce){.progress-bar-animated{-webkit-animation:none;animation:none}}.media{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.media-body{-ms-flex:1;flex:1}.list-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.list-group-item.disabled,.list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-item+.list-group-item{border-top-width:0}.list-group-item+.list-group-item.active{margin-top:-1px;border-top-width:1px}.list-group-horizontal{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal .list-group-item.active{margin-top:0}.list-group-horizontal .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-sm .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm .list-group-item.active{margin-top:0}.list-group-horizontal-sm .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-md .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md .list-group-item.active{margin-top:0}.list-group-horizontal-md .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-md .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-lg .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg .list-group-item.active{margin-top:0}.list-group-horizontal-lg .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-xl .list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl .list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl .list-group-item.active{margin-top:0}.list-group-horizontal-xl .list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl .list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}.list-group-flush .list-group-item{border-right-width:0;border-left-width:0;border-radius:0}.list-group-flush .list-group-item:first-child{border-top-width:0}.list-group-flush:last-child .list-group-item:last-child{border-bottom-width:0}.list-group-item-primary{color:#004085;background-color:#b8daff}.list-group-item-primary.list-group-item-action:focus,.list-group-item-primary.list-group-item-action:hover{color:#004085;background-color:#9fcdff}.list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#383d41;background-color:#d6d8db}.list-group-item-secondary.list-group-item-action:focus,.list-group-item-secondary.list-group-item-action:hover{color:#383d41;background-color:#c8cbcf}.list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#383d41;border-color:#383d41}.list-group-item-success{color:#155724;background-color:#c3e6cb}.list-group-item-success.list-group-item-action:focus,.list-group-item-success.list-group-item-action:hover{color:#155724;background-color:#b1dfbb}.list-group-item-success.list-group-item-action.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}.list-group-item-info.list-group-item-action:focus,.list-group-item-info.list-group-item-action:hover{color:#0c5460;background-color:#abdde5}.list-group-item-info.list-group-item-action.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}.list-group-item-warning.list-group-item-action:focus,.list-group-item-warning.list-group-item-action:hover{color:#856404;background-color:#ffe8a1}.list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}.list-group-item-danger.list-group-item-action:focus,.list-group-item-danger.list-group-item-action:hover{color:#721c24;background-color:#f1b0b7}.list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}.list-group-item-light.list-group-item-action:focus,.list-group-item-light.list-group-item-action:hover{color:#818182;background-color:#ececf6}.list-group-item-light.list-group-item-action.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action:focus,.list-group-item-dark.list-group-item-action:hover{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:hover{color:#000;text-decoration:none}.close:not(:disabled):not(.disabled):focus,.close:not(:disabled):not(.disabled):hover{opacity:.75}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}a.close.disabled{pointer-events:none}.toast{max-width:350px;overflow:hidden;font-size:.875rem;background-color:rgba(255,255,255,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem rgba(0,0,0,.1);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);opacity:0;border-radius:.25rem}.toast:not(:last-child){margin-bottom:.75rem}.toast.showing{opacity:1}.toast.show{display:block;opacity:1}.toast.hide{display:none}.toast-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:rgba(255,255,255,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05)}.toast-body{padding:.75rem}.modal-open{overflow:hidden}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translate(0,-50px);transform:translate(0,-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog{transition:none}}.modal.show .modal-dialog{-webkit-transform:none;transform:none}.modal.modal-static .modal-dialog{-webkit-transform:scale(1.02);transform:scale(1.02)}.modal-dialog-scrollable{display:-ms-flexbox;display:flex;max-height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 1rem);overflow:hidden}.modal-dialog-scrollable .modal-footer,.modal-dialog-scrollable .modal-header{-ms-flex-negative:0;flex-shrink:0}.modal-dialog-scrollable .modal-body{overflow-y:auto}.modal-dialog-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.modal-dialog-centered::before{display:block;height:calc(100vh - 1rem);content:\"\"}.modal-dialog-centered.modal-dialog-scrollable{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.modal-dialog-centered.modal-dialog-scrollable .modal-content{max-height:none}.modal-dialog-centered.modal-dialog-scrollable::before{content:none}.modal-content{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:1rem 1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .close{padding:1rem 1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem}.modal-footer{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>*{margin:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 3.5rem)}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-dialog-centered::before{height:calc(100vh - 3.5rem)}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg,.modal-xl{max-width:800px}}@media (min-width:1200px){.modal-xl{max-width:1140px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow::before,.bs-tooltip-top .arrow::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow::before,.bs-tooltip-right .arrow::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow::before,.bs-tooltip-bottom .arrow::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow::before,.bs-tooltip-left .arrow::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.popover .arrow::after,.popover .arrow::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top]>.arrow,.bs-popover-top>.arrow{bottom:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=top]>.arrow::before,.bs-popover-top>.arrow::before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top]>.arrow::after,.bs-popover-top>.arrow::after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:.5rem}.bs-popover-auto[x-placement^=right]>.arrow,.bs-popover-right>.arrow{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=right]>.arrow::before,.bs-popover-right>.arrow::before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right]>.arrow::after,.bs-popover-right>.arrow::after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom]>.arrow,.bs-popover-bottom>.arrow{top:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=bottom]>.arrow::before,.bs-popover-bottom>.arrow::before{top:0;border-width:0 .5rem .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom]>.arrow::after,.bs-popover-bottom>.arrow::after{top:1px;border-width:0 .5rem .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header::before,.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:.5rem}.bs-popover-auto[x-placement^=left]>.arrow,.bs-popover-left>.arrow{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=left]>.arrow::before,.bs-popover-left>.arrow::before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left]>.arrow::after,.bs-popover-left>.arrow::after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel.pointer-event{-ms-touch-action:pan-y;touch-action:pan-y}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-inner::after{display:block;clear:both;content:\"\"}.carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out,-webkit-transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item{transition:none}}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.active.carousel-item-right,.carousel-item-next:not(.carousel-item-left){-webkit-transform:translateX(100%);transform:translateX(100%)}.active.carousel-item-left,.carousel-item-prev:not(.carousel-item-right){-webkit-transform:translateX(-100%);transform:translateX(-100%)}.carousel-fade .carousel-item{opacity:0;transition-property:opacity;-webkit-transform:none;transform:none}.carousel-fade .carousel-item-next.carousel-item-left,.carousel-fade .carousel-item-prev.carousel-item-right,.carousel-fade .carousel-item.active{z-index:1;opacity:1}.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{transition:none}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;z-index:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next,.carousel-control-prev{transition:none}}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:no-repeat 50%/100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")}.carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:15;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{box-sizing:content-box;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators li{transition:none}}.carousel-indicators .active{opacity:1}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}@-webkit-keyframes spinner-border{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinner-border{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.spinner-border{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:spinner-border .75s linear infinite;animation:spinner-border .75s linear infinite}.spinner-border-sm{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1}}@keyframes spinner-grow{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1}}.spinner-grow{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:spinner-grow .75s linear infinite;animation:spinner-grow .75s linear infinite}.spinner-grow-sm{width:1rem;height:1rem}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#0062cc!important}.bg-secondary{background-color:#6c757d!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#545b62!important}.bg-success{background-color:#28a745!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#6c757d!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded-sm{border-radius:.2rem!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-right{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-lg{border-radius:.3rem!important}.rounded-circle{border-radius:50%!important}.rounded-pill{border-radius:50rem!important}.rounded-0{border-radius:0!important}.clearfix::after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:-ms-flexbox!important;display:flex!important}.d-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:-ms-flexbox!important;display:flex!important}.d-sm-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:-ms-flexbox!important;display:flex!important}.d-md-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:-ms-flexbox!important;display:flex!important}.d-lg-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:-ms-flexbox!important;display:flex!important}.d-xl-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:-ms-flexbox!important;display:flex!important}.d-print-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive::before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9::before{padding-top:42.857143%}.embed-responsive-16by9::before{padding-top:56.25%}.embed-responsive-4by3::before{padding-top:75%}.embed-responsive-1by1::before{padding-top:100%}.flex-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-center{-ms-flex-align:center!important;align-items:center!important}.align-items-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.flex-sm-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-sm-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-sm-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-sm-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-sm-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-sm-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-sm-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-sm-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-sm-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-sm-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-sm-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-sm-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-sm-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-sm-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-sm-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-sm-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-sm-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-sm-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-sm-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-sm-center{-ms-flex-align:center!important;align-items:center!important}.align-items-sm-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-sm-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-sm-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-sm-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-sm-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-sm-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-sm-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-sm-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-sm-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-sm-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-sm-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-sm-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-sm-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-sm-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.flex-md-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-md-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-md-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-md-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-md-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-md-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-md-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-md-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-md-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-md-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-md-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-md-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-md-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-md-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-md-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-md-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-md-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-md-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-md-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-md-center{-ms-flex-align:center!important;align-items:center!important}.align-items-md-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-md-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-md-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-md-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-md-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-md-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-md-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-md-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-md-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-md-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-md-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-md-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-md-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-md-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-lg-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-lg-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-lg-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-lg-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-lg-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-lg-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-lg-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-lg-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-lg-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-lg-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-lg-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-lg-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-lg-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-lg-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-lg-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-lg-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-lg-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-lg-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-lg-center{-ms-flex-align:center!important;align-items:center!important}.align-items-lg-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-lg-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-lg-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-lg-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-lg-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-lg-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-lg-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-lg-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-lg-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-lg-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-lg-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-lg-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-lg-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-lg-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-xl-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-xl-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-xl-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-xl-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-xl-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-xl-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-xl-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-xl-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-xl-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-xl-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-xl-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-xl-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-xl-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-xl-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-xl-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-xl-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-xl-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-xl-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-xl-center{-ms-flex-align:center!important;align-items:center!important}.align-items-xl-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-xl-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-xl-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-xl-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-xl-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-xl-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-xl-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-xl-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-xl-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-xl-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-xl-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-xl-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-xl-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-xl-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports ((position:-webkit-sticky) or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.shadow-sm{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none{box-shadow:none!important}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.w-auto{width:auto!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.h-auto{height:auto!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.min-vw-100{min-width:100vw!important}.min-vh-100{min-height:100vh!important}.vw-100{width:100vw!important}.vh-100{height:100vh!important}.stretched-link::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:\"\";background-color:rgba(0,0,0,0)}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-n1{margin:-.25rem!important}.mt-n1,.my-n1{margin-top:-.25rem!important}.mr-n1,.mx-n1{margin-right:-.25rem!important}.mb-n1,.my-n1{margin-bottom:-.25rem!important}.ml-n1,.mx-n1{margin-left:-.25rem!important}.m-n2{margin:-.5rem!important}.mt-n2,.my-n2{margin-top:-.5rem!important}.mr-n2,.mx-n2{margin-right:-.5rem!important}.mb-n2,.my-n2{margin-bottom:-.5rem!important}.ml-n2,.mx-n2{margin-left:-.5rem!important}.m-n3{margin:-1rem!important}.mt-n3,.my-n3{margin-top:-1rem!important}.mr-n3,.mx-n3{margin-right:-1rem!important}.mb-n3,.my-n3{margin-bottom:-1rem!important}.ml-n3,.mx-n3{margin-left:-1rem!important}.m-n4{margin:-1.5rem!important}.mt-n4,.my-n4{margin-top:-1.5rem!important}.mr-n4,.mx-n4{margin-right:-1.5rem!important}.mb-n4,.my-n4{margin-bottom:-1.5rem!important}.ml-n4,.mx-n4{margin-left:-1.5rem!important}.m-n5{margin:-3rem!important}.mt-n5,.my-n5{margin-top:-3rem!important}.mr-n5,.mx-n5{margin-right:-3rem!important}.mb-n5,.my-n5{margin-bottom:-3rem!important}.ml-n5,.mx-n5{margin-left:-3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-n1{margin:-.25rem!important}.mt-sm-n1,.my-sm-n1{margin-top:-.25rem!important}.mr-sm-n1,.mx-sm-n1{margin-right:-.25rem!important}.mb-sm-n1,.my-sm-n1{margin-bottom:-.25rem!important}.ml-sm-n1,.mx-sm-n1{margin-left:-.25rem!important}.m-sm-n2{margin:-.5rem!important}.mt-sm-n2,.my-sm-n2{margin-top:-.5rem!important}.mr-sm-n2,.mx-sm-n2{margin-right:-.5rem!important}.mb-sm-n2,.my-sm-n2{margin-bottom:-.5rem!important}.ml-sm-n2,.mx-sm-n2{margin-left:-.5rem!important}.m-sm-n3{margin:-1rem!important}.mt-sm-n3,.my-sm-n3{margin-top:-1rem!important}.mr-sm-n3,.mx-sm-n3{margin-right:-1rem!important}.mb-sm-n3,.my-sm-n3{margin-bottom:-1rem!important}.ml-sm-n3,.mx-sm-n3{margin-left:-1rem!important}.m-sm-n4{margin:-1.5rem!important}.mt-sm-n4,.my-sm-n4{margin-top:-1.5rem!important}.mr-sm-n4,.mx-sm-n4{margin-right:-1.5rem!important}.mb-sm-n4,.my-sm-n4{margin-bottom:-1.5rem!important}.ml-sm-n4,.mx-sm-n4{margin-left:-1.5rem!important}.m-sm-n5{margin:-3rem!important}.mt-sm-n5,.my-sm-n5{margin-top:-3rem!important}.mr-sm-n5,.mx-sm-n5{margin-right:-3rem!important}.mb-sm-n5,.my-sm-n5{margin-bottom:-3rem!important}.ml-sm-n5,.mx-sm-n5{margin-left:-3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-n1{margin:-.25rem!important}.mt-md-n1,.my-md-n1{margin-top:-.25rem!important}.mr-md-n1,.mx-md-n1{margin-right:-.25rem!important}.mb-md-n1,.my-md-n1{margin-bottom:-.25rem!important}.ml-md-n1,.mx-md-n1{margin-left:-.25rem!important}.m-md-n2{margin:-.5rem!important}.mt-md-n2,.my-md-n2{margin-top:-.5rem!important}.mr-md-n2,.mx-md-n2{margin-right:-.5rem!important}.mb-md-n2,.my-md-n2{margin-bottom:-.5rem!important}.ml-md-n2,.mx-md-n2{margin-left:-.5rem!important}.m-md-n3{margin:-1rem!important}.mt-md-n3,.my-md-n3{margin-top:-1rem!important}.mr-md-n3,.mx-md-n3{margin-right:-1rem!important}.mb-md-n3,.my-md-n3{margin-bottom:-1rem!important}.ml-md-n3,.mx-md-n3{margin-left:-1rem!important}.m-md-n4{margin:-1.5rem!important}.mt-md-n4,.my-md-n4{margin-top:-1.5rem!important}.mr-md-n4,.mx-md-n4{margin-right:-1.5rem!important}.mb-md-n4,.my-md-n4{margin-bottom:-1.5rem!important}.ml-md-n4,.mx-md-n4{margin-left:-1.5rem!important}.m-md-n5{margin:-3rem!important}.mt-md-n5,.my-md-n5{margin-top:-3rem!important}.mr-md-n5,.mx-md-n5{margin-right:-3rem!important}.mb-md-n5,.my-md-n5{margin-bottom:-3rem!important}.ml-md-n5,.mx-md-n5{margin-left:-3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-n1{margin:-.25rem!important}.mt-lg-n1,.my-lg-n1{margin-top:-.25rem!important}.mr-lg-n1,.mx-lg-n1{margin-right:-.25rem!important}.mb-lg-n1,.my-lg-n1{margin-bottom:-.25rem!important}.ml-lg-n1,.mx-lg-n1{margin-left:-.25rem!important}.m-lg-n2{margin:-.5rem!important}.mt-lg-n2,.my-lg-n2{margin-top:-.5rem!important}.mr-lg-n2,.mx-lg-n2{margin-right:-.5rem!important}.mb-lg-n2,.my-lg-n2{margin-bottom:-.5rem!important}.ml-lg-n2,.mx-lg-n2{margin-left:-.5rem!important}.m-lg-n3{margin:-1rem!important}.mt-lg-n3,.my-lg-n3{margin-top:-1rem!important}.mr-lg-n3,.mx-lg-n3{margin-right:-1rem!important}.mb-lg-n3,.my-lg-n3{margin-bottom:-1rem!important}.ml-lg-n3,.mx-lg-n3{margin-left:-1rem!important}.m-lg-n4{margin:-1.5rem!important}.mt-lg-n4,.my-lg-n4{margin-top:-1.5rem!important}.mr-lg-n4,.mx-lg-n4{margin-right:-1.5rem!important}.mb-lg-n4,.my-lg-n4{margin-bottom:-1.5rem!important}.ml-lg-n4,.mx-lg-n4{margin-left:-1.5rem!important}.m-lg-n5{margin:-3rem!important}.mt-lg-n5,.my-lg-n5{margin-top:-3rem!important}.mr-lg-n5,.mx-lg-n5{margin-right:-3rem!important}.mb-lg-n5,.my-lg-n5{margin-bottom:-3rem!important}.ml-lg-n5,.mx-lg-n5{margin-left:-3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-n1{margin:-.25rem!important}.mt-xl-n1,.my-xl-n1{margin-top:-.25rem!important}.mr-xl-n1,.mx-xl-n1{margin-right:-.25rem!important}.mb-xl-n1,.my-xl-n1{margin-bottom:-.25rem!important}.ml-xl-n1,.mx-xl-n1{margin-left:-.25rem!important}.m-xl-n2{margin:-.5rem!important}.mt-xl-n2,.my-xl-n2{margin-top:-.5rem!important}.mr-xl-n2,.mx-xl-n2{margin-right:-.5rem!important}.mb-xl-n2,.my-xl-n2{margin-bottom:-.5rem!important}.ml-xl-n2,.mx-xl-n2{margin-left:-.5rem!important}.m-xl-n3{margin:-1rem!important}.mt-xl-n3,.my-xl-n3{margin-top:-1rem!important}.mr-xl-n3,.mx-xl-n3{margin-right:-1rem!important}.mb-xl-n3,.my-xl-n3{margin-bottom:-1rem!important}.ml-xl-n3,.mx-xl-n3{margin-left:-1rem!important}.m-xl-n4{margin:-1.5rem!important}.mt-xl-n4,.my-xl-n4{margin-top:-1.5rem!important}.mr-xl-n4,.mx-xl-n4{margin-right:-1.5rem!important}.mb-xl-n4,.my-xl-n4{margin-bottom:-1.5rem!important}.ml-xl-n4,.mx-xl-n4{margin-left:-1.5rem!important}.m-xl-n5{margin:-3rem!important}.mt-xl-n5,.my-xl-n5{margin-top:-3rem!important}.mr-xl-n5,.mx-xl-n5{margin-right:-3rem!important}.mb-xl-n5,.my-xl-n5{margin-bottom:-3rem!important}.ml-xl-n5,.mx-xl-n5{margin-left:-3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace!important}.text-justify{text-align:justify!important}.text-wrap{white-space:normal!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-lighter{font-weight:lighter!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-weight-bolder{font-weight:bolder!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:focus,a.text-primary:hover{color:#0056b3!important}.text-secondary{color:#6c757d!important}a.text-secondary:focus,a.text-secondary:hover{color:#494f54!important}.text-success{color:#28a745!important}a.text-success:focus,a.text-success:hover{color:#19692c!important}.text-info{color:#17a2b8!important}a.text-info:focus,a.text-info:hover{color:#0f6674!important}.text-warning{color:#ffc107!important}a.text-warning:focus,a.text-warning:hover{color:#ba8b00!important}.text-danger{color:#dc3545!important}a.text-danger:focus,a.text-danger:hover{color:#a71d2a!important}.text-light{color:#f8f9fa!important}a.text-light:focus,a.text-light:hover{color:#cbd3da!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#121416!important}.text-body{color:#212529!important}.text-muted{color:#6c757d!important}.text-black-50{color:rgba(0,0,0,.5)!important}.text-white-50{color:rgba(255,255,255,.5)!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.text-decoration-none{text-decoration:none!important}.text-break{word-break:break-word!important;overflow-wrap:break-word!important}.text-reset{color:inherit!important}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,::after,::before{text-shadow:none!important;box-shadow:none!important}a:not(.btn){text-decoration:underline}abbr[title]::after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #adb5bd;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}body{min-width:992px!important}.container{min-width:992px!important}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #dee2e6!important}.table-dark{color:inherit}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#dee2e6}.table .thead-dark th{color:inherit;border-color:#dee2e6}}\n/*# sourceMappingURL=bootstrap.min.css.map */","html,\nbody {\n\tmargin: 0px;\n\tpadding: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tfont-family: 'Source Sans Pro', sans-serif;\n\tfont-weight: 400;\n}\n\nbody {\n\toverflow-x: hidden;\n\tbackground: #fff;\n\tcolor: #4D4F5C;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n   margin: 0;\n}\n#wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n#wrapper #content-wrapper {\n  overflow-x: hidden;\n  width: 100%;\n  /* padding: 35px 20px; */\n}\n\n\n/* section {} */\n\nbody * {\n\t/* color: #000000; */\n\tcolor: #555B6D;\n}\n\nul li {\n\tlist-style-type: none;\n}\n\nul {\n\tpadding: 0;\n}\n\nbutton:focus {\n\toutline: 0;\n}\n\n.nopadding {\n\tpadding: 0px !important;\n}\n\n/* a {\n\ttransition: all 0.3s;\n} */\n\na,\na:hover,\na:active {\n\ttext-decoration: none;\n}\n\n.form-control:focus {\n\tbox-shadow: none;\n\tborder-color: #dedede;\n}\n\n.form-control {\n\theight: 38px;\n}\n\ninput:focus {\n\toutline: none;\n\tbox-shadow: none;\n}\n\n*:focus {\n\toutline: none;\n\tbox-shadow: none;\n}\n\n.btn.focus,\n.btn:focus {\n\tbox-shadow: none;\n}\n\n.btn {\n\tbackground-color: #43425D;\n\tfont-size: 18px;\n\tcolor: #fff;\n\tpadding: 12px 15px;\n\tfont-weight: 500;\n\tborder: 1px solid #43425D;\n\tborder-radius: 5px;\n}\n\n.btn-default {\n\tcolor: #43425D !important;\n\tbackground-color: #fff !important;\n}\n\n.btn:hover {\n\tcolor: #fff;\n}\n\n.new-btn {\n\tposition: absolute;\n\tright: 15px;\n\ttop: -10px;\n\tmin-width: 130px;\n\tpadding: 8px 10px;\n\tfont-size: 12px;\n}\n.my-new-button{\n\tposition:absolute !important;\n\ttop:162px !important;\n\tright:1035px !important;\n}\n\n////////////// view-btn\n.ViewButton{\n\twidth: 50px!important;\n\t// background: #007bff!important;\n}\n.Total{\n\t// border: 1px solid;\n\tdisplay: flex!important;\n\talign-items: center!important;\n\t// justify-content: space-between;\n}\n\n//for UI Issues\n.table thead th {\n    border: 0px;\n    color: #A3A6B4;\n    font-size: 13px;\n    font-weight: 700;\n    color: #495057;\n}\ntable.dataTable tr th.select-checkbox.selected::after, table.dataTable tr.selected td.select-checkbox:after {\n    margin-top: -10px !important;\n    margin-left: -6px !important;\n    text-align: center;\n    text-shadow: none !important;\n}\ntable.dataTable td.select-checkbox:before, table.dataTable th.select-checkbox:before {\n    content: ' ';\n    margin-top: -6px;\n    margin-left: -6px;\n    border: 1px solid black;\n    border-radius: 3px;\n}\n\n\nth.sorting_asc::after,\nth.sorting_desc::after {\n   content:' ' !important;\n}\n\nth.selected::after {\n   content:'✔' !important;\n}\n.listButton{\n\tborder:none;\n\tbackground-color: #ffffff00;\n}\n@media only screen and (max-width: 767px) {\n\t.imgRes {\n\t\tmax-width: 25%;\n\t}\n  }\n\n  @media (min-width: 768px) {\n    .sidebar {\n        width: 250px !important;\n    }\n}\n\n\n","/////\n// .add-ellip{\n//     // border: 1px solid red;\n//     white-space: nowrap;\n//     overflow: hidden;\n//     text-overflow: ellipsis;\n//     display: inline-block;\n//     width: 100px;   \n// }\n/////\ntable.dataTable {\n    clear: both;\n    margin-top: 6px !important;\n    margin-bottom: 6px !important;\n    max-width: none !important;\n    // border-collapse: separate !important;\n  }\n  table.dataTable td,\n  table.dataTable th {\n    -webkit-box-sizing: content-box;\n    box-sizing: content-box;\n    // border: 1px solid red!important;\n    // text-align: center!important;\n  }\n  table.dataTable td.dataTables_empty,\n  table.dataTable th.dataTables_empty {\n    text-align: center;\n  }\n  table.dataTable.nowrap th,\n  table.dataTable.nowrap td {\n    white-space: nowrap;\n  }\n  \n  div.dataTables_wrapper div.dataTables_length label {\n    font-weight: normal;\n    text-align: left;\n    white-space: nowrap;\n  }\n  div.dataTables_wrapper div.dataTables_length select {\n    width: 75px;\n    display: inline-block;\n  }\n  div.dataTables_wrapper div.dataTables_filter {\n    text-align: right;\n  }\n  div.dataTables_wrapper div.dataTables_filter label {\n    font-weight: normal;\n    white-space: nowrap;\n    text-align: left;\n  }\n  div.dataTables_wrapper div.dataTables_filter input {\n    margin-left: 0.5em;\n    display: inline-block;\n    width: auto;\n  }\n  div.dataTables_wrapper div.dataTables_info {\n    padding-top: 0.85em;\n    white-space: nowrap;\n  }\n  div.dataTables_wrapper div.dataTables_paginate {\n    margin: 0;\n    white-space: nowrap;\n    text-align: right;\n  }\n  div.dataTables_wrapper div.dataTables_paginate ul.pagination {\n    margin: 2px 0;\n    white-space: nowrap;\n    justify-content: flex-end;\n  }\n  div.dataTables_wrapper div.dataTables_processing {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 200px;\n    margin-left: -100px;\n    margin-top: -26px;\n    text-align: center;\n    padding: 1em 0;\n  }\n  \n  table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,\n  table.dataTable thead > tr > td.sorting_asc,\n  table.dataTable thead > tr > td.sorting_desc,\n  table.dataTable thead > tr > td.sorting {\n    padding-right: 30px;\n  }\n  table.dataTable thead > tr > th:active,\n  table.dataTable thead > tr > td:active {\n    outline: none;\n  }\n  table.dataTable thead .sorting,\n  table.dataTable thead .sorting_asc,\n  table.dataTable thead .sorting_desc,\n  table.dataTable thead .sorting_asc_disabled,\n  table.dataTable thead .sorting_desc_disabled {\n    cursor: pointer;\n    position: relative;\n  }\n  table.dataTable thead .sorting:before, table.dataTable thead .sorting:after,\n  table.dataTable thead .sorting_asc:before,\n  table.dataTable thead .sorting_asc:after,\n  table.dataTable thead .sorting_desc:before,\n  table.dataTable thead .sorting_desc:after,\n  table.dataTable thead .sorting_asc_disabled:before,\n  table.dataTable thead .sorting_asc_disabled:after,\n  table.dataTable thead .sorting_desc_disabled:before,\n  table.dataTable thead .sorting_desc_disabled:after {\n    position: absolute;\n    bottom: 0.9em;\n    display: block;\n    opacity: 0.3;\n  }\n  table.dataTable thead .sorting:before,\n  table.dataTable thead .sorting_asc:before,\n  table.dataTable thead .sorting_desc:before,\n  table.dataTable thead .sorting_asc_disabled:before,\n  table.dataTable thead .sorting_desc_disabled:before {\n    right: 1em;\n    content: \"\\2191\";\n  }\n  table.dataTable thead .sorting:after,\n  table.dataTable thead .sorting_asc:after,\n  table.dataTable thead .sorting_desc:after,\n  table.dataTable thead .sorting_asc_disabled:after,\n  table.dataTable thead .sorting_desc_disabled:after {\n    right: 0.5em;\n    content: \"\\2193\";\n  }\n  table.dataTable thead .sorting_asc:before,\n  table.dataTable thead .sorting_desc:after {\n    opacity: 1;\n  }\n  table.dataTable thead .sorting_asc_disabled:before,\n  table.dataTable thead .sorting_desc_disabled:after {\n    opacity: 0;\n  }\n  \n  div.dataTables_scrollHead table.dataTable {\n    margin-bottom: 0 !important;\n  }\n  \n  div.dataTables_scrollBody table {\n    border-top: none;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  div.dataTables_scrollBody table thead .sorting:after,\n  div.dataTables_scrollBody table thead .sorting_asc:after,\n  div.dataTables_scrollBody table thead .sorting_desc:after {\n    display: none;\n  }\n  div.dataTables_scrollBody table tbody tr:first-child th,\n  div.dataTables_scrollBody table tbody tr:first-child td {\n    border-top: none;\n  }\n  \n  div.dataTables_scrollFoot > .dataTables_scrollFootInner {\n    box-sizing: content-box;\n  }\n  div.dataTables_scrollFoot > .dataTables_scrollFootInner > table {\n    margin-top: 0 !important;\n    border-top: none;\n  }\n  \n  @media screen and (max-width: 767px) {\n    div.dataTables_wrapper div.dataTables_length,\n    div.dataTables_wrapper div.dataTables_filter,\n    div.dataTables_wrapper div.dataTables_info,\n    div.dataTables_wrapper div.dataTables_paginate {\n      text-align: center;\n    }\n  }\n  table.dataTable.table-sm > thead > tr > th {\n    padding-right: 20px;\n  }\n  table.dataTable.table-sm .sorting:before,\n  table.dataTable.table-sm .sorting_asc:before,\n  table.dataTable.table-sm .sorting_desc:before {\n    top: 5px;\n    right: 0.85em;\n  }\n  table.dataTable.table-sm .sorting:after,\n  table.dataTable.table-sm .sorting_asc:after,\n  table.dataTable.table-sm .sorting_desc:after {\n    top: 5px;\n  }\n  \n  table.table-bordered.dataTable th,\n  table.table-bordered.dataTable td {\n    border-left-width: 0;\n  }\n  table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,\n  table.table-bordered.dataTable td:last-child,\n  table.table-bordered.dataTable td:last-child {\n    border-right-width: 0;\n  }\n  table.table-bordered.dataTable tbody th,\n  table.table-bordered.dataTable tbody td {\n    border-bottom-width: 0;\n  }\n  \n  div.dataTables_scrollHead table.table-bordered {\n    border-bottom-width: 0;\n  }\n  \n  div.table-responsive > div.dataTables_wrapper > div.row {\n    margin: 0;\n  }\n  div.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:first-child {\n    padding-left: 0;\n  }\n  div.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:last-child {\n    padding-right: 0;\n  }\n  /*!\n * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)\n *\n * Copyright 2013-2017 bootstrap-select\n * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)\n */select.bs-select-hidden,select.selectpicker{display:none!important}.bootstrap-select{width:220px\\9}.bootstrap-select>.dropdown-toggle{width:100%;padding-right:25px;z-index:1}.bootstrap-select>.dropdown-toggle.bs-placeholder,.bootstrap-select>.dropdown-toggle.bs-placeholder:active,.bootstrap-select>.dropdown-toggle.bs-placeholder:focus,.bootstrap-select>.dropdown-toggle.bs-placeholder:hover{color:#999}.bootstrap-select>select{position:absolute!important;bottom:0;left:50%;display:block!important;width:.5px!important;height:100%!important;padding:0!important;opacity:0!important;border:none}.bootstrap-select>select.mobile-device{top:0;left:0;display:block!important;width:100%!important;z-index:2}.error .bootstrap-select .dropdown-toggle,.has-error .bootstrap-select .dropdown-toggle{border-color:#b94a48}.bootstrap-select.fit-width{width:auto!important}.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn){width:220px}.bootstrap-select .dropdown-toggle:focus{outline:thin dotted #333!important;outline:5px auto -webkit-focus-ring-color!important;outline-offset:-2px}.bootstrap-select.form-control{margin-bottom:0;padding:0;border:none}.bootstrap-select.form-control:not([class*=col-]){width:100%}.bootstrap-select.form-control.input-group-btn{z-index:auto}.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child)>.btn{border-radius:0}.bootstrap-select.btn-group:not(.input-group-btn),.bootstrap-select.btn-group[class*=col-]{float:none;display:inline-block;margin-left:0}.bootstrap-select.btn-group.dropdown-menu-right,.bootstrap-select.btn-group[class*=col-].dropdown-menu-right,.row .bootstrap-select.btn-group[class*=col-].dropdown-menu-right{float:right}.form-group .bootstrap-select.btn-group,.form-horizontal .bootstrap-select.btn-group,.form-inline .bootstrap-select.btn-group{margin-bottom:0}.form-group-lg .bootstrap-select.btn-group.form-control,.form-group-sm .bootstrap-select.btn-group.form-control{padding:0}.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle{height:100%;font-size:inherit;line-height:inherit;border-radius:inherit}.form-inline .bootstrap-select.btn-group .form-control{width:100%}.bootstrap-select.btn-group.disabled,.bootstrap-select.btn-group>.disabled{cursor:not-allowed}.bootstrap-select.btn-group.disabled:focus,.bootstrap-select.btn-group>.disabled:focus{outline:0!important}.bootstrap-select.btn-group.bs-container{position:absolute;height:0!important;padding:0!important}.bootstrap-select.btn-group.bs-container .dropdown-menu{z-index:1060}.bootstrap-select.btn-group .dropdown-toggle .filter-option{display:inline-block;overflow:hidden;width:100%;text-align:left}.bootstrap-select.btn-group .dropdown-toggle .caret{position:absolute;top:50%;right:12px;margin-top:-2px;vertical-align:middle}.bootstrap-select.btn-group[class*=col-] .dropdown-toggle{width:100%}.bootstrap-select.btn-group .dropdown-menu{min-width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bootstrap-select.btn-group .dropdown-menu.inner{position:static;float:none;border:0;padding:0;margin:0;border-radius:0;-webkit-box-shadow:none;box-shadow:none}.bootstrap-select.btn-group .dropdown-menu li{position:relative}.bootstrap-select.btn-group .dropdown-menu li.active small{color:#fff}.bootstrap-select.btn-group .dropdown-menu li.disabled a{cursor:not-allowed}.bootstrap-select.btn-group .dropdown-menu li a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bootstrap-select.btn-group .dropdown-menu li a.opt{position:relative;padding-left:2.25em}.bootstrap-select.btn-group .dropdown-menu li a span.check-mark{display:none}.bootstrap-select.btn-group .dropdown-menu li a span.text{display:inline-block}.bootstrap-select.btn-group .dropdown-menu li small{padding-left:.5em}.bootstrap-select.btn-group .dropdown-menu .notify{position:absolute;bottom:5px;width:96%;margin:0 2%;min-height:26px;padding:3px 5px;background:#f5f5f5;border:1px solid #e3e3e3;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05);pointer-events:none;opacity:.9;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bootstrap-select.btn-group .no-results{padding:3px;background:#f5f5f5;margin:0 5px;white-space:nowrap}.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option{position:static}.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret{position:static;top:auto;margin-top:-1px}.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark{position:absolute;display:inline-block;right:15px;margin-top:5px}.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text{margin-right:34px}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle{z-index:1061}.bootstrap-select.show-menu-arrow .dropdown-toggle:before{content:'';border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid rgba(204,204,204,.2);position:absolute;bottom:-4px;left:9px;display:none}.bootstrap-select.show-menu-arrow .dropdown-toggle:after{content:'';border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;position:absolute;bottom:-4px;left:10px;display:none}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before{bottom:auto;top:-3px;border-top:7px solid rgba(204,204,204,.2);border-bottom:0}.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after{bottom:auto;top:-3px;border-top:6px solid #fff;border-bottom:0}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before{right:12px;left:auto}.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after{right:13px;left:auto}.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:after,.bootstrap-select.show-menu-arrow.open>.dropdown-toggle:before{display:block}.bs-actionsbox,.bs-donebutton,.bs-searchbox{padding:4px 8px}.bs-actionsbox{width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bs-actionsbox .btn-group button{width:50%}.bs-donebutton{float:left;width:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.bs-donebutton .btn-group button{width:100%}.bs-searchbox+.bs-actionsbox{padding:0 8px 4px}.bs-searchbox .form-control{margin-bottom:0;width:100%;float:none}\n//datatable-responsive\n table.dataTable.dtr-inline.collapsed>tbody>tr>td.child,table.dataTable.dtr-inline.collapsed>tbody>tr>th.child,table.dataTable.dtr-inline.collapsed>tbody>tr>td.dataTables_empty{cursor:default !important}table.dataTable.dtr-inline.collapsed>tbody>tr>td.child:before,table.dataTable.dtr-inline.collapsed>tbody>tr>th.child:before,table.dataTable.dtr-inline.collapsed>tbody>tr>td.dataTables_empty:before{display:none !important}table.dataTable.dtr-inline.collapsed>tbody>tr[role=\"row\"]>td:first-child,table.dataTable.dtr-inline.collapsed>tbody>tr[role=\"row\"]>th:first-child{position:relative;padding-left:30px;cursor:pointer}table.dataTable.dtr-inline.collapsed>tbody>tr[role=\"row\"]>td:first-child:before,table.dataTable.dtr-inline.collapsed>tbody>tr[role=\"row\"]>th:first-child:before{top:12px;left:4px;height:14px;width:14px;display:block;position:absolute;color:white;border:2px solid white;border-radius:14px;box-shadow:0 0 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier, monospace;line-height:14px;content:'+';background-color:#0275d8}table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before{content:'-';background-color:#d33333}table.dataTable.dtr-inline.collapsed.compact>tbody>tr>td:first-child,table.dataTable.dtr-inline.collapsed.compact>tbody>tr>th:first-child{padding-left:27px}table.dataTable.dtr-inline.collapsed.compact>tbody>tr>td:first-child:before,table.dataTable.dtr-inline.collapsed.compact>tbody>tr>th:first-child:before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;text-indent:3px}table.dataTable.dtr-column>tbody>tr>td.control,table.dataTable.dtr-column>tbody>tr>th.control{position:relative;cursor:pointer}table.dataTable.dtr-column>tbody>tr>td.control:before,table.dataTable.dtr-column>tbody>tr>th.control:before{top:50%;left:50%;height:16px;width:16px;margin-top:-10px;margin-left:-10px;display:block;position:absolute;color:white;border:2px solid white;border-radius:14px;box-shadow:0 0 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier, monospace;line-height:14px;content:'+';background-color:#0275d8}table.dataTable.dtr-column>tbody>tr.parent td.control:before,table.dataTable.dtr-column>tbody>tr.parent th.control:before{content:'-';background-color:#d33333}table.dataTable>tbody>tr.child{padding:0.5em 1em}table.dataTable>tbody>tr.child:hover{background:transparent !important}table.dataTable>tbody>tr.child ul.dtr-details{display:inline-block;list-style-type:none;margin:0;padding:0}table.dataTable>tbody>tr.child ul.dtr-details>li{border-bottom:1px solid #efefef;padding:0.5em 0}table.dataTable>tbody>tr.child ul.dtr-details>li:first-child{padding-top:0}table.dataTable>tbody>tr.child ul.dtr-details>li:last-child{border-bottom:none}table.dataTable>tbody>tr.child span.dtr-title{display:inline-block;min-width:75px;font-weight:bold}div.dtr-modal{position:fixed;box-sizing:border-box;top:0;left:0;height:100%;width:100%;z-index:100;padding:10em 1em}div.dtr-modal div.dtr-modal-display{position:absolute;top:0;left:0;bottom:0;right:0;width:50%;height:50%;overflow:auto;margin:auto;z-index:102;overflow:auto;background-color:#f5f5f7;border:1px solid black;border-radius:0.5em;box-shadow:0 12px 30px rgba(0,0,0,0.6)}div.dtr-modal div.dtr-modal-content{position:relative;padding:1em}div.dtr-modal div.dtr-modal-close{position:absolute;top:6px;right:6px;width:22px;height:22px;border:1px solid #eaeaea;background-color:#f9f9f9;text-align:center;border-radius:3px;cursor:pointer;z-index:12}div.dtr-modal div.dtr-modal-close:hover{background-color:#eaeaea}div.dtr-modal div.dtr-modal-background{position:fixed;top:0;left:0;right:0;bottom:0;z-index:101;background:rgba(0,0,0,0.6)}@media screen and (max-width: 767px){div.dtr-modal div.dtr-modal-display{width:95%}}div.dtr-bs-modal table.table tr:first-child td{border-top:none}\n//datatable-select\ntable.dataTable tbody>tr.selected,table.dataTable tbody>tr>.selected{background-color:#B0BED9}table.dataTable.stripe tbody>tr.odd.selected,table.dataTable.stripe tbody>tr.odd>.selected,table.dataTable.display tbody>tr.odd.selected,table.dataTable.display tbody>tr.odd>.selected{background-color:#acbad4}table.dataTable.hover tbody>tr.selected:hover,table.dataTable.hover tbody>tr>.selected:hover,table.dataTable.display tbody>tr.selected:hover,table.dataTable.display tbody>tr>.selected:hover{background-color:#aab7d1}table.dataTable.order-column tbody>tr.selected>.sorting_1,table.dataTable.order-column tbody>tr.selected>.sorting_2,table.dataTable.order-column tbody>tr.selected>.sorting_3,table.dataTable.order-column tbody>tr>.selected,table.dataTable.display tbody>tr.selected>.sorting_1,table.dataTable.display tbody>tr.selected>.sorting_2,table.dataTable.display tbody>tr.selected>.sorting_3,table.dataTable.display tbody>tr>.selected{background-color:#acbad5}table.dataTable.display tbody>tr.odd.selected>.sorting_1,table.dataTable.order-column.stripe tbody>tr.odd.selected>.sorting_1{background-color:#a6b4cd}table.dataTable.display tbody>tr.odd.selected>.sorting_2,table.dataTable.order-column.stripe tbody>tr.odd.selected>.sorting_2{background-color:#a8b5cf}table.dataTable.display tbody>tr.odd.selected>.sorting_3,table.dataTable.order-column.stripe tbody>tr.odd.selected>.sorting_3{background-color:#a9b7d1}table.dataTable.display tbody>tr.even.selected>.sorting_1,table.dataTable.order-column.stripe tbody>tr.even.selected>.sorting_1{background-color:#acbad5}table.dataTable.display tbody>tr.even.selected>.sorting_2,table.dataTable.order-column.stripe tbody>tr.even.selected>.sorting_2{background-color:#aebcd6}table.dataTable.display tbody>tr.even.selected>.sorting_3,table.dataTable.order-column.stripe tbody>tr.even.selected>.sorting_3{background-color:#afbdd8}table.dataTable.display tbody>tr.odd>.selected,table.dataTable.order-column.stripe tbody>tr.odd>.selected{background-color:#a6b4cd}table.dataTable.display tbody>tr.even>.selected,table.dataTable.order-column.stripe tbody>tr.even>.selected{background-color:#acbad5}table.dataTable.display tbody>tr.selected:hover>.sorting_1,table.dataTable.order-column.hover tbody>tr.selected:hover>.sorting_1{background-color:#a2aec7}table.dataTable.display tbody>tr.selected:hover>.sorting_2,table.dataTable.order-column.hover tbody>tr.selected:hover>.sorting_2{background-color:#a3b0c9}table.dataTable.display tbody>tr.selected:hover>.sorting_3,table.dataTable.order-column.hover tbody>tr.selected:hover>.sorting_3{background-color:#a5b2cb}table.dataTable.display tbody>tr:hover>.selected,table.dataTable.display tbody>tr>.selected:hover,table.dataTable.order-column.hover tbody>tr:hover>.selected,table.dataTable.order-column.hover tbody>tr>.selected:hover{background-color:#a2aec7}table.dataTable td.select-checkbox,table.dataTable th.select-checkbox{position:relative}table.dataTable td.select-checkbox:before,table.dataTable td.select-checkbox:after,table.dataTable th.select-checkbox:before,table.dataTable th.select-checkbox:after{display:block;position:absolute;top:1.7em;left:50%;width:12px;height:12px;box-sizing:border-box}table.dataTable td.select-checkbox:before,table.dataTable th.select-checkbox:before{content:' ';margin-top:-6px;margin-left:-6px;border:1px solid black;border-radius:3px}table.dataTable tr.selected td.select-checkbox:after,table.dataTable tr.selected th.select-checkbox:after{content:'\\2714';margin-top:-11px;margin-left:-4px;text-align:center;text-shadow:1px 1px #B0BED9, -1px -1px #B0BED9, 1px -1px #B0BED9, -1px 1px #B0BED9}div.dataTables_wrapper span.select-info,div.dataTables_wrapper span.select-item{margin-left:0.5em}@media screen and (max-width: 640px){div.dataTables_wrapper span.select-info,div.dataTables_wrapper span.select-item{margin-left:0;display:block}}\n.paginate_button{\n  padding:5px 10px;\n  cursor: pointer;\n}","/* Login start */\n.login-row {\n\toverflow: hidden;\n}\n\n.login-leftimg {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.login-right {\n\tposition: relative;\n\tbackground: #fff;\n}\n\n.login-main {\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\tmargin: auto;\n\tpadding: 0px;\n\twidth: 60%;\n\tmax-width: 450px;\n}\n\n.login {\n\ttext-align: center;\n}\n\n.login-main h6 {\n\tfont-size: 18px;\n\topacity: 0.5;\n\tmargin: 26px 0px 30px;\n}\n\n.login-main form {\n\tmargin-top: 30px;\n}\n\n.login-main .btn {\n\tbackground-color: #43425D;\n\tfont-size: 13px;\n\tcolor: #fefefe;\n\t/* padding:10px 15px; */\n\twidth: 100%;\n\tmargin: 0px 0px 10px;\n}\n\n.form-check-label {\n\tline-height: unset !important;\n\tfont-size: 14px !important;\n\tmargin-bottom: 0px !important;\n}\n\n.forgot-password {\n\tfloat: right;\n\tcolor: #524fa1;\n\tcursor: pointer;\n\tfont-size: 14px;\n}\n\n.copy-text {\n\tposition: absolute;\n\tbottom: 25px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tfont-size: 13px;\n\ttext-align: center;\n}\n\n.forget-pass p {\n\tfont-size: 14px;\n\tfont-weight: 300;\n}\n\n.forget-pass,\n.reset-pass {\n\tdisplay: none;\n}\n\n/* form start */\n.login-main .form-group {\n\tmargin-bottom: 25px;\n    // position: relative;\n}\n\n.login-main .form-control {\n\tborder-color: #e9e9f0 !important;\n\tfont-size: 15px;\n\tpadding: 23px 5px;\n\tborder: 0px;\n\tborder-bottom: 1px solid;\n\tborder-radius: 0;\n}\n\n.login-check {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.login-main .custom-checkbox {\n\tfloat: left;\n}\n\n.login-check .custom-control-label {\n\tmargin-bottom: 0px !important;\n\tline-height: 23px !important;\n\tfont-size: 14px !important;\n}\n\n.login-check .custom-control-label::before {\n\tbackground-color: #e0ebed;\n}\n\n.login-check .custom-control-input:checked~.custom-control-label::before {\n\tcolor: #fff;\n\tborder-color: #adb5bd;\n\tbackground-color: #adb5bd;\n}\n\n.login-check .custom-control-input:focus~.custom-control-label::before {\n\tbox-shadow: none;\n}\n\n.login-check .custom-control-input:focus:not(:checked)~.custom-control-label::before {\n\tborder-color: #adb5bd;\n}\n\n.login-main input::placeholder {\n\tcolor: #2d2d2d;\n}\n\n.login-main input:-ms-input-placeholder {\n\tcolor: #2d2d2d;\n}\n\n.login-main input::-ms-input-placeholder {\n\tcolor: #2d2d2d;\n}\n\n/* form start */\n.login .btn {\n\tmargin: 5px;\n}\n\n/* Login end */\n\n.register-main {\n\tposition: relative;\n\n\tmargin: auto;\n\tpadding: 0px;\n\twidth: 60%;\n\tmax-width: 650px;\n}\n.regreqbox{\n\tmargin-top:30px;\n}\n\n.register-main .form-control {\n\tline-height: 1.1;\n}\n","/* nav and sidebar start */\n#wrapper {\n\tbackground: #F4F4F4;\n\t// height: 100vh;\n}\n\n.sidebar {\n\tbackground-color: #5C2E91;\n\tpadding-top: 15px;\n\tmin-height: 1000px;\n}\n\n.profile-name {\n\tbackground: #000;\n\tcolor: #fff;\n\tfont-size: 12px;\n\twidth: 40px;\n\theight: 40px;\n\ttext-align: center;\n\tborder-radius: 40px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tline-height: 40px;\n\tmargin: 0px 20px 0px 0px;\n}\n\n.navbar-nav .fa {\n\tcolor: #666666;\n}\n\ni.fas.fa.fa-bell-o {\n\tmargin: 10px 15px 0px 0px;\n}\n\n.fa-angle-down {\n\tfont-size: 18px;\n}\n\n.sidebar .nav-item .nav-link {\n\tpadding: 15px 20px !important;\n\tfont-size: 16px;\n}\n\n.sidebar .menu-text {\n\t// .menu-text\n\tfloat: left;\n\tcolor: #FFFFFF;\n\tline-height: 16px;\n\tfont-weight: 600;\n\tfont-size: 13px;\n\topacity: 50%;\n\tmargin: 15px 20px 6px;\n}\n\n.btn-secondary:focus {\n    color: #fff;\n    background-color: transparent;\n   border-color: transparent; \n}\n\n.btn-secondary:hover {\n    color: #fff;\n    background-color: transparent;\n   border-color: transparent; \n}\n\n.btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: transparent;\n    border-color: transparent;\n    border: none !important;\n    border-width: 0;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n   box-shadow: none !important;\n   border-width: 0;\n\n}\n\n// .dropdown-menu-show {\n// \tcolor: #fff;\n// \tbackground-color: transparent;\n// \tborder-color: transparent;\n// }\n\n.sidebar span {\n\tcolor: #FFFFFF;\n\topacity: 0.5;\n\tdisplay: inline-block !important;\n\tfont-size: 13px;\n}\n\n.sidebar .bx {\n\tcolor: #FFFFFF;\n\topacity: 0.5;\n\tdisplay: inline-block;\n\tfont-size: 18px;\n}\n\n.sidebar .active span {\n\tcolor: #fff;\n\topacity: 1;\n}\n\n.sidebar .active .bx {\n\tcolor: #fff;\n\topacity: 1;\n}\n\n.sidebar .nav-link:hover span,\n.sidebar .nav-link:hover .bx {\n\topacity: 1;\n}\n\n.dropdown-toggle::after {\n\tdisplay: none;\n}\n\n.static-top {\n\tbackground: #fff;\n}\n\n.nav-right-ul li {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n}\n\n.nav-right-ul li .bx-bell,\n.nav-right-ul li .bx-cog {\n\tcolor: #555B6D;\n\tfont-size: 18px;\n}\n\n// //////////////////\n.sec-header {\n\tfont-size: 15px;\n\tfont-weight: 700;\n\tmargin: 5px 0px 20px;\n\tcolor: #555B6D;\n}\n\n.box-row {\n\tmargin: 0px 0px 25px;\n}\n\n.box-row .card {\n\tborder-radius: 0px;\n\tbox-shadow: 0px 2px 6px #0000000A;\n\tborder: 0px;\n}\n\n.box-row .card-header {\n\tbackground: #fff;\n\tborder: 0px;\n\tcolor: #4D4F5C;\n\t/* font-size:18px; */\n}\n\n.card-header-title {\n\tfont-size: 15px;\n\tfont-weight: bold;\n}\n\n.box-row .card-body.gatepass-saveoutput {\n\tpadding-top: 5px;\n}\n\n","/* DASHBOARD start */\n\n// / changes / \n.navbar {\n\tpadding: .7rem 1rem;\n}\n.dropdown-divider{\n\tborder: none;\n}\n//\n\n.dash-num-card p {\n\topacity: 1;\n\tfont-size: 13px;\n\tcolor: #495057\n}\n\n.dash-num-card i img {\n\tmargin-bottom: 1.3rem;\n}\n\n.number {\n\tcolor: #495057;\n\tfont-size: 20px;\n\tfont-weight: 700;\n\tmargin-top: 16px;\n}\n\n.number-txt {\n\tfont-size: 11px;\n\tfont-weight: 700;\n}\n\n.rate-up {\n\tcolor: #3CC480;\n}\n\n.rate-up1 {\n\tcolor: #00B6BD;\n\tfont-size: 14px;\n\tfont-weight: bold;\n}\n\n.rate-down {\n\tcolor: #FF4141;\n}\n\n.number-txt .fa-arrow-up {\n\tcolor: #3CC480;\n\tfont-size: 11px;\n\tmargin-right: 5px;\n}\n\n.number-txt .fa-arrow-down {\n\tcolor: #FF4141;\n\tfont-size: 11px;\n\tmargin-right: 5px;\n}\n\ndiv#published-table_length,\ndiv#published-table_filter,\ndiv#published-table_info {\n\tdisplay: none;\n}\n\nthead {\n\tbackground: #F5F6FA;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n\tbackground-color: transparent;\n}\n\n.table thead th {\n\tborder: 0px;\n\t/* color:#A3A6B4; */\n\tfont-size: 13px;\n\tfont-weight: 700;\n\tcolor: #495057;\n}\n\n.table td {\n\t/* color:#4D4F5C; */\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tcolor: #495057;\n}\n\n.card-profile {\n\t/* width: 30%; */\n\tbackground-color: #5C2E9133;\n\tpadding: 10px;\n\tborder-radius: 5px;\n\tpadding-bottom: 17px;\n\theight: 100%;\n\t/* position: absolute; */\n\t/* left: 15px; */\n}\n\n.card-profile p {\n\tmargin: 0px;\n\tfont-size: 11px;\n\tcolor: #5C2E91;\n}\n\n.designation {\n\tcolor: #495057;\n\tfont-size: 10px;\n}\n\n.custom-card {\n\tpadding: 1rem;\n}\n\n/* .dash-num-card .card-body{\n\tpadding:0px !important;\n} */\n.card1 {\n\tfont-size: 14px;\n\tpadding: 1.25rem;\n}\n\n.card1 p {\n\tfont-size: 14px;\n}\n\n\n.card1 div {\n\tfont-size: 13px;\n\tmargin-top: 16px;\n}\n\n.active1 {\n\tcolor: #00B6BD !important;\n\tfont-size: 14px !important;\n}\n\n.search-box input {\n\theight: 30px;\n}\n\n.reports #brands-table_length,\n.reports #product-table_length {\n\tfloat: left !important;\n}\n\n.reports select {\n\tbackground: #FFFFFF 0% 0% no-repeat padding-box;\n\tborder: 1px solid #CED4DA;\n\tborder-radius: 3px;\n\topacity: 1;\n\tmargin: 0px 10px;\n\tfont-size: 13px;\n}\n\n.reports label,\n#product-table_info,\n.paginate_button,\n.reports input {\n\tcolor: #495057;\n\tfont-size: 13px;\n}\n\n\n.reports input {\n\tborder: 1px solid #CED4DA;\n}\n\n.current {\n\tbackground-color: #5C2E91;\n\tcolor: #fff !important;\n\tpadding: 5px 10px;\n\tborder-radius: 15px;\n\tmargin: 0px 10px;\n}\n\n/* DASHBOARD end */\n.product-active{\n\tcolor: green;\n}\n.product-inactive{\n\tcolor: red;\n}\n.brand-active{\n\tcolor: green;\n}\n.brand-inactive{\n\tcolor: red;\n}\n.merchant-active{\n\tcolor: green;\n}\n.merchant-inactive{\n\tcolor: red;\n}","/* Preethi new design */\n/* .sidebar li:first-child{\n\n} */\n.bold {\n\tfont-weight: bold !important;\n}\n\n.file-active {\n\tbackground-color: #5C2E91;\n\topacity: .1;\n\tcolor: #000 !important;\n}\n\n.dropdown-list1 a {\n\tcolor: #495057;\n}\n\n.user-name {\n\tcolor: #555B6D;\n\tfont-size: 13px;\n}\n\n.pink-alert,\n.green-alert,.info-alert {\n\tborder-radius: 5px !important;\n\tmargin-right: 8px;\n\tfont-size: 13px;\n}\n\n.pink-alert {\n\tbackground-color: #FDE1E1;\n\tcolor: #7F3737;\n}\n.info-alert {\n\tbackground-color: #5c2e91;\n\tcolor: #ffffff;\n}\n\n\n.green-alert {\n\tbackground-color: #D6F3E9;\n\tcolor: #1B654A;\n}\n\n.scrollable {\n\toverflow-y: auto;\n\tmax-height: 300px;\n}\n\n.card-height {\n\t// min-height: 300px;\n\tbox-shadow: 0px 3px 6px #5C2E911A;\n\tborder: 0 !important;\n}\n\n.report-btn ul li {\n\tdisplay: inline-block;\n\tmargin: 0px 10px;\n\tfont-size: 13px;\n\tcolor: #495057;\n}\n\n.report-btn .btn-active {\n\tbackground-color: #5C2E91;\n\tcolor: #fff;\n\tpadding: 8px;\n\tborder-radius: 3px;\n}\n\n.view-btn p,.btn {\n\tbackground-color: #5C2E91;\n\tpadding: 5px;\n\tborder-radius: 20px;\n\tfont-size: 12px;\n\tcolor: #fff;\n\tmargin: 0px;\n\ttext-align: center;\n\twidth: 99px;\n\tcursor: pointer;\n}\n.btn {\n\twidth: auto;\n}\n.btn-danger{\n\tbackground-color: #c54040;\n\tborder-color: transparent;\n}\n.view-btn i {\n\tcursor: pointer;\n}\n.pay-status-pending,\n.pay-complete {\n\tpadding-top: 17px !important;\n}\n\n.pay-status-pending span {\n\tcolor: #F46A6A;\n\tbackground-color: #FDE4E4;\n\tpadding: 8px;\n\tborder-radius: 25px;\n\tfont-size: 12px;\n}\n\n.pay-complete span {\n\tcolor: #34C38F;\n\tbackground-color: #DAF4EB;\n\tpadding: 8px;\n\tborder-radius: 25px;\n\tfont-size: 12px;\n\n}\n\n\n\n.scrollable::-webkit-scrollbar {\n\twidth: 4px;\n}\n\n/* Track */\n.scrollable::-webkit-scrollbar-track {\n\tbackground: #E9E9E9 0% 0% no-repeat padding-box;\n\tborder-radius: 10px;\n}\n\n/* Handle */\n.scrollable::-webkit-scrollbar-thumb {\n\tbackground: #E9E9E9 0% 0% no-repeat padding-box;\n\tborder-radius: 10px;\n}\n\n/* Handle on hover */\n.scrollable::-webkit-scrollbar-thumb:hover {\n\tbackground: #555;\n}\n\np {\n\tmargin: 0;\n}\n\n.show-more p {\n\tcolor: #3B86FF;\n\tfont-size: 13px;\n}\n\nfooter p {\n\tcolor: #74788D;\n\tfont-size: 13px;\n}\n\n.Active span{\n\tcolor: green !important;\n}\n.Inactive span{\n\tcolor: red !important;\n}","/* Products.html */\n.card-table {\n\twidth: 100%;\n}\n\n.table-head {\n\tmargin-top: 20px;\n}\n\n.new-btn-top {\n\tfont-size: 13px;\n\tbackground-color: #5C2E91;\n\tmargin-bottom: 15px;\n\tpadding: 5px 10px !important;\n\tborder-radius: 3px;\n\twidth: auto;\n}\n\n.font-size {\n\tfont-size: 18px;\n}\n\n#ReportInput {\n\twidth: 20%;\n}\n\n#ReportInput option,\n#ReportInput {\n\tborder: 1px solid #B1BBC4;\n\tfont-size: 13px;\n\tcolor: #555B6D;\n}\n\n.arrow-up {\n\tcolor: #00CF37;\n\n\tfont-size: 16px;\n}\n\n.arrow-down {\n\tfont-size: 16px;\n\tcolor: #FF0000;\n}\n\n/* Login new usman */\n\n.welcome {\n\tbackground: #ded5e9;\n\tpadding: 25px;\n\tcolor: #5C2E91;\n}\n\n.welcome h5 {\n\tfont-size: 16px;\n\tcolor: #5C2E91;\n}\n\n.welcome p {\n\tfont-size: 13px;\n\tcolor: #5C2E91;\n\tmargin-bottom: 20px;\n}\n\n.login-main .card-body {\n\tpadding: 25px;\n}\n\n.login-main .card-body {\n\tpadding: 25px;\n}\n\n.login-logo {\n\tmargin-top: -50px;\n}\n\n.login-main .form-horizontal {\n\tmargin: 25px 0px 10px\n}\n\n.login-main label {\n\tfont-size: 13px;\n}\n\n.login-main .form-control {\n\theight: 36px;\n\tborder: 1px solid #B1BBC4;\n}\n\n.login-main .form-group {\n\tmargin-bottom: 15px;\n}\n\n.copy-text1 {\n\tfont-size: 13px;\n\tmargin: 0px auto 0px;\n}\n\n.login-btn1 {\n\tbackground-color: #5C2E91 !important;\n\tfont-size: 13px;\n\tcolor: #fff;\n\t/* height: 36px; */\n\tpadding: 5px 12px;\n\tfont-weight: 400;\n\tborder: 1px solid #5C2E91 !important;\n\tborder-radius: 3px;\n}\n\n.forgot a {\n\tmargin: 25px auto 0px;\n\tcolor: #74788D;\n\tfont-size: 13px;\n\tdisplay: table;\n}\n\n.forgot .bx:before {\n\tcontent: \"\\edbf\";\n\tcolor: #74788D;\n}\n\n/* modal start */\n.modal-header {\n\tbackground: #5C2E91;\n\tcolor: #fff;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\theight: 50px;\n\tpadding: 18px 20px;\n\tline-height: 14px;\n}\n\nbutton.close {\n\tposition: absolute;\n\tright: 25px;\n\ttop: 7px;\n\tcolor: #fff;\n\topacity: 1;\n\tfont-size: 30px;\n\tfont-weight: 300;\n}\n\n.modal-up div {\n\tcolor: #495057;\n\tfont-size: 14px;\n}\n\n#Restock input {\n\tfont-size: 13px;\n}\n\n.model-box {\n\twidth: 602px;\n\tmargin: 0 auto;\n}\n\n.card-header-title1 {\n\tbackground-color: #fff !important;\n\tborder-bottom: 0px !important;\n}\n\n/* modal end */",".sub-heading {\n\tcolor: #495057;\n\tfont-size: 13px;\n}\n\n.dropdown-active1 {\n\tbackground-color: #F6F6F6;\n\tcolor: #495057;\n}\n\n.dropdown-menu-right ul {\n\tlist-style-type: circle;\n}\n\n.dropdown-menu-right ul li {\n\tfont-size: 10px;\n}\n\n.change-property {\n\tfont-size: 12px;\n}\n\n.gatepass-saveoutput .table-responsive {\n\tdisplay: table;\n}\n\n#log-table_wrapper .dataTables_length {\n\tfloat: left;\n}\n\n/* Chekcbox */\n.custom-control-label {\n\tpadding: 3px 0px 0px 5px;\n\tfont-size: 12px;\n}\n\n.custom-control-label::before {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.custom-control-label::after {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.custom-control-input:not(:disabled):active~.custom-control-label::before {\n\tbackground-color: transparent;\n\tborder-color: #adb5bd;\n}\n\n.custom-control-input:focus~.custom-control-label::before {\n\tbox-shadow: none;\n}\n\n.custom-control-input:focus:not(:checked)~.custom-control-label::before {\n\tborder-color: #adb5bd;\n}\n\n.custom-control-input:checked~.custom-control-label::before {\n\tcolor: #fff;\n\tborder-color: #5C2E91;\n\tbackground-color: #5C2E91;\n}\n\n/* checkbox end */","@media (min-width: 992px) {\n\t#sidebarToggle {\n\t\tdisplay: none;\n\t}\n}\n\n@media(max-width:991px) {\n\t.gatepass-saveoutput .table-responsive {\n\t\tdisplay: block;\n\t}\n}\n\n@media (max-width: 767px) {\n\n\t#product-table_filter label,\n\t#log-table_filter label {\n\t\tfloat: left;\n\t}\n\n\t.login-row .h-100 {\n\t\theight: auto !important;\n\t}\n\n\t.login-row {\n\t\tbackground: #fff;\n\t\toverflow: auto;\n\t}\n\n\t.login-right {\n\t\tposition: relative;\n\t\tbackground: #fff;\n\t}\n\n\t.login-main {\n\t\twidth: 90%;\n\t\tposition: relative;\n\t\ttransform: unset;\n\t\tleft: unset;\n\t\ttop: unset;\n\t\tmargin: 25px auto;\n\t}\n\n\t.copy-text {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\ttransform: unset;\n\t\tbottom: unset;\n\t\tleft: unset;\n\t\tpadding: 25px 0px;\n\t}\n\n\t.navbar-brand img {\n\t\twidth: 100px;\n\t}\n\n\t.profile-name {\n\t\tmargin: 0px 15px 0px 0px;\n\t}\n\n\ti.fas.fa.fa-bell-o {\n\t\tmargin: 10px 10px 0px 0px;\n\t}\n\n\tbutton#sidebarToggle {\n\t\tbackground: transparent;\n\t\tpadding: 5px;\n\t\tborder-radius: 0px;\n\t\tline-height: 0px;\n\t\tmargin-right: 5px;\n\t}\n\n\t.navbar-brand {\n\t\tdisplay: none;\n\t}\n\n\t.navbar-expand {\n\t\tpadding: 10px 10px;\n\t}\n\n\t.sidebar {\n\t\tpadding-top: 10px;\n\t}\n\n\t.sidebar .nav-item .nav-link {\n\t\tpadding: 13px 20px !important;\n\t\tfont-size: 13px;\n\t\twidth: 100% !important;\n\t\tdisplay: flex;\n\t\ttext-align: left;\n\t}\n\n\t/* .sidebar .bx {} */\n\n\t.sidebar .dot {\n\t\twidth: 7px;\n\t\theight: 7px;\n\t\tmargin: 3px 5px 0px 0px;\n\t}\n\n\t.sidebar div {\n\t\tline-height: 14px;\n\t\tmargin: 15px 20px;\n\t}\n\n\t.sidebar {\n\t\tposition: absolute;\n\t\tz-index: 999;\n\t\t// top: 76px;\n\t\ttop: 55px;\n\t\tdisplay: none;\n\t}\n\n\t.sidebar.toggled {\n\t\twidth: 90% !important;\n\t\toverflow: hidden;\n\t\tdisplay: block;\n\t}\n\n\t#wrapper #content-wrapper {\n\t\tpadding: 0px 0px;\n\t}\n\n\t.dashboard-row .col-sm-6 {\n\t\tmargin-bottom: 15px;\n\t}\n\t/*New Medai CSS*/\n.card1 .float-rgt\n{\n\tfloat: none!important;\n\ttext-align: center!important;\n}\n.card1 .float-lft\n{\n\tfloat: none!important;\n\ttext-align: center!important;\n}\n}\n\n/* style1 */\n.box-row .new-merchant .form-group label,\n.box-row .new-merchant .form-group input,\n.box-row .new-merchant .form-group select {\n\tfont-size: 13px;\n\tline-height: 25px;\n\tletter-spacing: 0;\n\tcolor: #495057;\n\tborder-radius: 0;\n}\n\n.box-row .section-header {\n\tfont-size: 15px;\n\tfont-weight: 700;\n\tmargin: 5px 0px 20px;\n\tcolor: #555B6D;\n\twidth: 100%;\n}\n\n.box-row .new-merchant .form-control {\n\tfont-size: 13px;\n\tline-height: 25px;\n\tcolor: #495057;\n\twidth: 95%;\n\theight: 36px;\n}\n\n.custom-file-upload {\n\tdisplay: inline-block;\n\tcursor: pointer;\n}\n\n::-webkit-file-upload-button {\n\tbackground-color: #555B6D;\n\tcolor: #fff;\n\tpadding: 2px 28px;\n\tborder-color: #555B6D;\n\tbox-shadow: none;\n\tborder-radius: 25px;\n}\n\n.submit-btn {\n\tfont-size: 13px;\n\tline-height: 25px;\n\tpadding: 6px 25px;\n\tbackground: #5C2E91;\n}\n\n#chart {\n\t/* height: 300px; */\n\tmargin-top: 65px;\n}\n\n.highcharts-figure,\n.highcharts-data-table table {\n\tmargin: 1em auto;\n}\n\n.highcharts-data-table table {\n\tfont-family: Verdana, sans-serif;\n\tborder-collapse: collapse;\n\tborder: 1px solid #EBEBEB;\n\tmargin: 10px auto;\n\ttext-align: center;\n\twidth: 100%;\n}\n\n.highcharts-data-table caption {\n\tpadding: 1em 0;\n\tfont-size: 1.2em;\n\tcolor: #555;\n}\n\n.highcharts-data-table th {\n\tfont-weight: 600;\n\tpadding: 0.5em;\n}\n\n.highcharts-data-table td,\n.highcharts-data-table th,\n.highcharts-data-table caption {\n\tpadding: 0.5em;\n}\n\n.highcharts-data-table thead tr,\n.highcharts-data-table tr:nth-child(even) {\n\tbackground: #f8f8f8;\n}\n\n.highcharts-data-table tr:hover {\n\tbackground: #f1f7ff;\n}\n\n.select2-container {\n\twidth: 95% !important;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__rendered li {\n\tfont-size: 11px;\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple,\n.select2-container--default .select2-selection--multiple {\n\tborder: 1px solid #ced4da;\n\tborder-radius: 0px;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n\tfloat: right;\n\tmargin-left: 5px;\n\tcolor: #fff;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n\tbackground-color: #5C2E91;\n\tborder: 1px solid #5C2E91;\n\tcolor: #fff;\n\tborder-radius: 0px;\n}\n\n.fileUpload {\n\tposition: relative;\n\toverflow: hidden;\n\tmargin: 10px;\n\tpadding: 2px 28px;\n\tborder-radius: 25px;\n}\n\n.fileUpload input.upload {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 20px;\n\tcursor: pointer;\n\topacity: 0;\n\tfilter: alpha(opacity=0);\n}\n\n.fileUpload span {\n\tfont-size: 13px;\n\tcolor: #fff;\n\tline-height: 25px;\n}\n\n#uploadFile {\n\tborder: none;\n\tbackground: transparent;\n}\n\n.fileUpload:hover {\n\tbackground: #555B6D;\n\tborder-color: #555B6D;\n}\n\n/* End of style1 */\n\n\n/*new*/\n.box-row .settings-form label {\n\tfont-size: 15px;\n\tline-height: 25px;\n\tcolor: #43425D;\n}\n\n.box-row .settings-form .form-control {\n\tfont-size: 13px;\n\tline-height: 13px;\n\tcolor: #000000;\n\twidth: 95%;\n\theight: 40px;\n}\n\n.box-row .settings-form {\n\tpadding-left: 10px;\n}\n\n.box-row .settings-form .btn {\n\tpadding: 10px 65px;\n}\n\n.edit-btn {\n\tposition: absolute;\n\tright: 15px;\n\ttop: 14px;\n\tmin-width: 130px;\n\tpadding: 8px 10px;\n\tfont-size: 12px;\n}\n\n// .box-row .fa {\n// \tcolor: #fff;\n// }\n\n.box-row .vendor-form label {\n\tfont-size: 15px;\n\tline-height: 25px;\n\tcolor: #43425D;\n}\n\n.box-row .vendor-form .form-control {\n\tfont-size: 13px;\n\tline-height: 13px;\n\tcolor: #000000;\n\twidth: 95%;\n\theight: 40px;\n}\n\n.box-row .vendor-form {\n\tpadding-left: 10px;\n}\n\n.box-row .vendor-form .btn {\n\tpadding: 10px 65px;\n}\n\n.box-row .new-agent label {\n\tfont-size: 15px;\n\tline-height: 25px;\n\tcolor: #43425D;\n}\n\n.box-row .new-agent .form-control {\n\tfont-size: 13px;\n\tline-height: 13px;\n\tcolor: #000000;\n\twidth: 95%;\n\theight: 40px;\n}\n\n.box-row .new-agent {\n\tpadding-left: 10px;\n}\n\n.box-row .new-agent .btn {\n\tpadding: 10px 65px;\n}\n\n#report-table_filter,\n#report-table_length {\n\tdisplay: none;\n}\n\n\n/*New CSS*/\n.card1 .float-rgt\n{\n\tfloat: right;\n}\n.card1 .float-lft\n{\n\tfloat: left;\n}",".Toastify__toast-container{z-index:9999;-webkit-transform:translateZ(9999px);position:fixed;padding:4px;width:320px;box-sizing:border-box;color:#fff}.Toastify__toast-container--top-left{top:1em;left:1em}.Toastify__toast-container--top-center{top:1em;left:50%;transform:translateX(-50%)}.Toastify__toast-container--top-right{top:1em;right:1em}.Toastify__toast-container--bottom-left{bottom:1em;left:1em}.Toastify__toast-container--bottom-center{bottom:1em;left:50%;transform:translateX(-50%)}.Toastify__toast-container--bottom-right{bottom:1em;right:1em}@media only screen and (max-width:480px){.Toastify__toast-container{width:100vw;padding:0;left:0;margin:0}.Toastify__toast-container--top-center,.Toastify__toast-container--top-left,.Toastify__toast-container--top-right{top:0;transform:translateX(0)}.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-right{bottom:0;transform:translateX(0)}.Toastify__toast-container--rtl{right:0;left:auto}}.Toastify__toast{position:relative;min-height:64px;box-sizing:border-box;margin-bottom:1rem;padding:8px;border-radius:1px;box-shadow:0 1px 10px 0 rgba(0,0,0,.1),0 2px 15px 0 rgba(0,0,0,.05);display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;max-height:800px;overflow:hidden;font-family:sans-serif;cursor:pointer;direction:ltr}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--dark{background:#121212;color:#fff}.Toastify__toast--default{background:#fff;color:#aaa}.Toastify__toast--info{background:#3498db}.Toastify__toast--success{background:#07bc0c}.Toastify__toast--warning{background:#f1c40f}.Toastify__toast--error{background:#e74c3c}.Toastify__toast-body{margin:auto 0;-ms-flex:1 1 auto;flex:1 1 auto}@media only screen and (max-width:480px){.Toastify__toast{margin-bottom:0}}.Toastify__close-button{color:#fff;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;-ms-flex-item-align:start;align-self:flex-start}.Toastify__close-button--default{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:focus,.Toastify__close-button:hover{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:5px;z-index:9999;opacity:.7;background-color:hsla(0,0%,100%,.7);transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:auto;transform-origin:right}.Toastify__progress-bar--default{background:linear-gradient(90deg,#4cd964,#5ac8fa,#007aff,#34aadc,#5856d6,#ff2d55)}.Toastify__progress-bar--dark{background:#bb86fc}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--bottom-left,.Toastify__bounce-enter--top-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--bottom-right,.Toastify__bounce-enter--top-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--bottom-left,.Toastify__bounce-exit--top-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--bottom-right,.Toastify__bounce-exit--top-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateX(-20deg);opacity:1}to{transform:perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideOutRight{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(110%,0,0)}}@keyframes Toastify__slideOutLeft{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(-110%,0,0)}}@keyframes Toastify__slideOutDown{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--bottom-left,.Toastify__slide-enter--top-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--bottom-right,.Toastify__slide-enter--top-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--bottom-left,.Toastify__slide-exit--top-left{animation-name:Toastify__slideOutLeft}.Toastify__slide-exit--bottom-right,.Toastify__slide-exit--top-right{animation-name:Toastify__slideOutRight}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown}",".password-toggle{\n cursor: pointer;\n position: absolute;\n top: 50%;\n left: 90%;\n z-index: 3;\n transform: translate(-50%, -50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
